
/*
 * -------------------------------------------------------
 * THIS FILE WAS AUTOMATICALLY GENERATED (DO NOT MODIFY)
 * -------------------------------------------------------
 */
/* eslint-disable */


import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';


export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends {
    [key: string]: unknown;
}> = {
    [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
    [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
    [SubKey in K]: Maybe<T[SubKey]>;
};
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
    ID: string;
    String: string;
    Boolean: boolean;
    Int: number;
    Float: number;
    ACFJson: any;
    Date: string;
    DateTime: any;
    Datetime: any;
    Decimal: any;
    Duration: any;
    EmailAddress: any;
    GraphQLDouble: any;
    GraphQLLong: any;
    GridColumnTemplate: any;
    JSON: any;
    JSONObject: any;
    Json: any;
    LocalDate: any;
    LocalDateTime: any;
    LocalTime: any;
    Long: any;
    Map: any;
    NonEmptyString: any;
    NonNegativeFloat: any;
    NonNegativeInt: any;
    PhoneNumber: any;
    SbcV2ConvUuid: any;
    SbcV2EmailAddress: any;
    SbcV2Json: any;
    SbcV2NonEmptyString: any;
    SbcV2ObjMap: any;
    SbcV2Url: any;
    SbcV2Uuid: any;
    SbcV2Void: any;
    Time: any;
    Timestamp: any;
    URL: any;
    USCurrency: any;
    UUID: any;
    Void: any;
    ZipCode: any;
    _FieldSet: any;
};
export type ActivateBlendLoanOutput = {
    __typename: "ActivateBlendLoanOutput";
    blend_activation_url: Maybe<Scalars["String"]>;
    success: Maybe<Scalars["Boolean"]>;
};
/** Address information for the property associated with pricing. */
export type AddressDetails = {
    __typename: "AddressDetails";
    /** The city of the property associated with the scenario. */
    city: Scalars["String"];
    /** The FIPS code of the county of the property associated with the scenario. */
    countyFips: Scalars["String"];
    /** The county of the property associated with the scenario. */
    countyName: Scalars["String"];
    /** The state of the property associated with the scenario. */
    state: Scalars["String"];
    /** The street of the property associated with the scenario. */
    street: Maybe<Scalars["String"]>;
    /** The unit of the property associated with the scenario. */
    unit: Maybe<Scalars["String"]>;
    /** The zip code of the property associated with the scenario. */
    zipCode: Scalars["String"];
};
export type AdjustmentDetail = {
    __typename: "AdjustmentDetail";
    /** Description on why the adjustment was applied. */
    description: Maybe<Scalars["String"]>;
    /** Amount that the price was affected by this adjustment. */
    priceAdjustment: Maybe<Scalars["Float"]>;
    /** Amount that the rate was affected by this adjustment. */
    rateAdjustment: Maybe<Scalars["Float"]>;
};
/** Amortization options for pricing. */
export enum AmortizationType {
    /** Adjustable rate mortgage. */
    AdjustableRate = "AdjustableRate",
    /** Fixed rate mortgage. */
    Fixed = "Fixed"
}
export type ArmDetails = {
    __typename: "ArmDetails";
    /** The ARM index rate.  This will be 0 for fixed products */
    armIndex: Maybe<Scalars["Float"]>;
    /** The name of the type of ARM index used in pricing. */
    armIndexType: Maybe<Scalars["String"]>;
    /** The ARM margin. This will be 0 for fixed products */
    armMargin: Maybe<Scalars["Float"]>;
    /** The initial rate adjustment cap for an ARM loan.  This will be 0 for fixed products. */
    initialArmCap: Maybe<Scalars["Int"]>;
    /** The initial ARM term in months.  This will be 0 for fixed products. */
    initialArmTerm: Maybe<Scalars["Int"]>;
    /** The lifetime rate adjustment cap for an ARM loan.  This will be 0 for fixed products. */
    lifetimeARMCap: Maybe<Scalars["Int"]>;
    /** The qualifying rate for an ARM loan. */
    qualifyingRate: Maybe<Scalars["Float"]>;
    /** The subsequent rate adjustment cap for an ARM loan.  This will be 0 for fixed products. */
    subsequentARMCap: Maybe<Scalars["Int"]>;
};
/** Attachment options for pricing. */
export enum AttachmentType {
    /** Attached property. */
    Attached = "Attached",
    /** Detached property. */
    Detached = "Detached",
    /** Semi-detached property. */
    SemiDetached = "SemiDetached"
}
export type BeginZHLSelfServiceRecoveryToolAttempt = {
    __typename: "BeginZHLSelfServiceRecoveryToolAttempt";
    id: Scalars["ID"];
};
export enum BeginZHLSelfServiceRecoveryToolAttemptError {
    FEATURE_DISABLED = "FEATURE_DISABLED",
    RATE_LIMITED = "RATE_LIMITED",
    UNKNOWN_ERROR = "UNKNOWN_ERROR",
    /** The access failure cause is not supported by the self service recovery tool */
    UNSUPPORTED_ACCESS_FAILURE_CAUSE = "UNSUPPORTED_ACCESS_FAILURE_CAUSE"
}
export type BeginZHLSelfServiceRecoveryToolAttemptErrorDetail = {
    __typename: "BeginZHLSelfServiceRecoveryToolAttemptErrorDetail";
    errorCode: BeginZHLSelfServiceRecoveryToolAttemptError;
    errorMessage: Scalars["String"];
};
export type BeginZHLSelfServiceRecoveryToolAttemptInput = {
    accountEmail?: InputMaybe<Scalars["String"]>;
    blendAccessFailureCause?: InputMaybe<BlendAccessFailureCause>;
    contactEmail: Scalars["String"];
    firstName: Scalars["String"];
    lastName: Scalars["String"];
    trackingId: Scalars["String"];
};
/** The reported cause of the blend access failure by Blend */
export enum BlendAccessFailureCause {
    /** The borrower tried to login without activating their account using the 3rd party activation email sent by Blend */
    ACTIVATION_REQUIRED = "ACTIVATION_REQUIRED",
    /** The borrower used an activation link that was outside of the timeframe to activate an account. */
    ACTIVATION_WINDOW_EXPIRED = "ACTIVATION_WINDOW_EXPIRED",
    /** Borrower attempted to use an unsupported authentication method for SSO */
    BORROWER_SSO_INVALID_METHOD = "BORROWER_SSO_INVALID_METHOD",
    /** One of the sharing borrowers clicked an activation link meant for the other borrower's account. */
    CANNOT_SHARE_USER = "CANNOT_SHARE_USER",
    /** Blend could not find a loan for the user by ZUID or by email. */
    DISABLED_FEATURE = "DISABLED_FEATURE",
    /** This is a generic error with many potential causes. */
    INTERNAL_SERVER_ERROR = "INTERNAL_SERVER_ERROR",
    /** This is a generic error with many potential causes. */
    INVALID_REQUEST = "INVALID_REQUEST",
    /** SAML Login was unsuccessful */
    LOGIN_FAILED = "LOGIN_FAILED",
    /** Blend users can be created using the same email address, but are expected to update the username (which matches the email) on one of them before the second borrower attempts to access the loan. Failing to do so causes this error */
    SSO_EMAIL_NOT_UNIQUE = "SSO_EMAIL_NOT_UNIQUE",
    /** Blend received a SAML Assertion that was improperly encrypted when attempting to SSO a user */
    UNENCRYPTED_SAML_ASSERTION = "UNENCRYPTED_SAML_ASSERTION",
    /** Beth has an activation key, but the Blend user associated with that activation key no longer exists. */
    USER_NOT_FOUND = "USER_NOT_FOUND"
}
export enum BlendApplicationStatus {
    Created = "Created",
    InApplication = "InApplication",
    Invited = "Invited",
    Submitted = "Submitted"
}
/** Borrower details associated with pricing. */
export type BorrowerDetails = {
    __typename: "BorrowerDetails";
    /** The aggregate credit score for the loan's borrowers. */
    creditScore: Maybe<Scalars["Int"]>;
    /** The earnest money credit of the borrower associated with the scenario. */
    earnestMoneyCredit: Maybe<Scalars["Float"]>;
    /** Whether the borrower is a first time homebuyer. */
    isFirstTimeHomebuyer: Maybe<Scalars["Boolean"]>;
    /** Does URLA comprises of more than 1 borrowers. This value impacts on how Mortgage Insurance is calculated. */
    isMultipleBorrowers: Maybe<Scalars["Boolean"]>;
    /** Is at least one of the borrowers self-employed and owns 25% or more of that business. */
    isSelfEmployed: Maybe<Scalars["Boolean"]>;
    /** The lead source type of the borrower associated with the scenario. */
    leadSourceType: Maybe<Scalars["String"]>;
    /** The monthly income of the borrower associated with the scenario. */
    monthlyIncome: Maybe<Scalars["Float"]>;
    /** The monthly liabilities of the borrower associated with the scenario. */
    monthlyLiabilities: Maybe<Scalars["Float"]>;
    /** The total assets of the borrower associated with the scenario. */
    totalAssets: Maybe<Scalars["Float"]>;
    /**
     * The total pay off liabilities of the borrower - PaidOffThroughLoan, PaidAtClosing, liabilities with payoff as true and not excluded
     * from the liabilities list associated with the scenario.
     */
    totalPayOffLiabilities: Maybe<Scalars["Float"]>;
};
export type BridgeLoanOfficerParticipantDetails = {
    branchNMLSID: Maybe<Scalars["Int"]>;
    email: Maybe<Scalars["String"]>;
    fullName: Maybe<Scalars["String"]>;
    nmlsID: Maybe<Scalars["Int"]>;
    officePhone: Maybe<Scalars["String"]>;
    title: Maybe<Scalars["String"]>;
};
/** Enumeration for the call direction values */
export enum CallDirection {
    /** When Beth initiates the call */
    INBOUND = "INBOUND",
    /** When Beth receives the call */
    OUTBOUND = "OUTBOUND",
    /** When the call direction can't be determined */
    UNKNOWN = "UNKNOWN"
}
export type CallSchedulerAppointmentScheduled = {
    __typename: "CallSchedulerAppointmentScheduled";
    id: Scalars["ID"];
    leadId: Maybe<Scalars["ID"]>;
    leadPhoneNumber: Scalars["String"];
    scheduledSlot: Scalars["String"];
    scheduledSlotTimezone: Scalars["String"];
};
export type CallSchedulerEligibility = {
    __typename: "CallSchedulerEligibility";
    isEligible: Scalars["Boolean"];
};
export enum CallSchedulerEligibilityError {
    APPOINTMENT_ALREADY_EXISTS = "APPOINTMENT_ALREADY_EXISTS",
    DUPLICATE_LEAD = "DUPLICATE_LEAD",
    FEATURE_DISABLED = "FEATURE_DISABLED",
    FINANCIAL_PROFILE_INTEGRITY_ERROR = "FINANCIAL_PROFILE_INTEGRITY_ERROR",
    FINANCIAL_PROFILE_NOT_FOUND = "FINANCIAL_PROFILE_NOT_FOUND",
    INELIGIBLE_LEAD_OUTCOME = "INELIGIBLE_LEAD_OUTCOME",
    INELIGIBLE_PROPERTY_STATE = "INELIGIBLE_PROPERTY_STATE",
    LEAD_ACTIVE_IN_PA_OR_SELLER_FUNNEL = "LEAD_ACTIVE_IN_PA_OR_SELLER_FUNNEL",
    LEAD_CLOSED_BAD_INFORMATION = "LEAD_CLOSED_BAD_INFORMATION",
    LEAD_FLOOR_NOT_MET = "LEAD_FLOOR_NOT_MET",
    LOAN_DATA_INTEGRITY_ERROR = "LOAN_DATA_INTEGRITY_ERROR",
    LOAN_NOT_FOUND = "LOAN_NOT_FOUND",
    LOAN_OFFICER_ALREADY_ASSIGNED = "LOAN_OFFICER_ALREADY_ASSIGNED",
    NOT_IMPLEMENTED = "NOT_IMPLEMENTED",
    PEARL_INELIGIBLE = "PEARL_INELIGIBLE",
    UNKNOWN_ERROR = "UNKNOWN_ERROR",
    USER_NOT_PRIMARY_BORROWER = "USER_NOT_PRIMARY_BORROWER"
}
export type CallSchedulerEligibilityErrorDetails = {
    __typename: "CallSchedulerEligibilityErrorDetails";
    errorCode: CallSchedulerEligibilityError;
    errorMessage: Scalars["String"];
};
export type CallSchedulerEligibilityResult = CallSchedulerAppointmentScheduled | CallSchedulerEligibility | CallSchedulerEligibilityErrorDetails;
/** Success response when a callback appointment is scheduled */
export type CallbackAppointmentScheduled = {
    __typename: "CallbackAppointmentScheduled";
    leadPhoneNumber: Scalars["String"];
    scheduledSlot: Scalars["String"];
};
export type CallbackSchedulerDay = {
    __typename: "CallbackSchedulerDay";
    /** The date the timeslot is for in ISO 8601 without TZD information */
    date: Scalars["Date"];
    /**
     * Deprecated: Use date instead
     * @deprecated Use date
     */
    datestring: Scalars["String"];
    /** The time slots available for this day (may be null if includeTimeSlotsOnlyForFirstDay=true and this is not the first day) */
    timeSlots: Maybe<Array<CallbackSchedulerTimeSlot>>;
    /** The IANA timezone identifier for this day (e.g., 'America/Los_Angeles') */
    timezone: Scalars["String"];
};
export type CallbackSchedulerTimeSlot = {
    __typename: "CallbackSchedulerTimeSlot";
    /** Duration of the slot in minutes (always 30) */
    durationInMinutes: Scalars["Int"];
    /**
     * Deprecated: Use startTimeUTCISO instead
     * @deprecated Use startTimeUTCISO
     */
    startTime: Scalars["String"];
    /** The time slot start time in UTC according to the ISO-8601 format (yyyy-mm-ddThh:mm:ssZ) */
    startTimeUTCISO: Scalars["String"];
};
export type CashOutDetails = {
    __typename: "CashOutDetails";
    /** The dollar amount paid out to the borrower in a refinance transaction. */
    cashOutAmount: Maybe<Scalars["Float"]>;
    /** Where the cash in a cash-out refinance will be used. */
    reason: Maybe<CashOutReason>;
};
/** Cash out reason options for pricing. */
export enum CashOutReason {
    Other = "Other",
    StudentLoanRepayment = "StudentLoanRepayment"
}
/** Federated interface for describing clickstream metadata */
export type ClickstreamMetadata = {
    /** data governance taxonomic name for the event */
    analyticsTag: Maybe<Scalars["String"]>;
};
/** Compliance section details associated with pricing. */
export type ComplianceSection = {
    __typename: "ComplianceSection";
    /** Tells whether the section was successful or not. */
    status: Maybe<Scalars["String"]>;
    /** A collection of results for specific compliance tests. */
    testSections: Maybe<Array<Maybe<TestSection>>>;
    /** Identifies which section these results are for. */
    type: Maybe<ComplianceSectionCategory>;
};
/** Compliance section categories for pricing. */
export enum ComplianceSectionCategory {
    /** Compliance section type. */
    Base = "Base",
    /** HOEPA compliance section. */
    HOEPA = "HOEPA",
    /** QM compliance section. */
    QM = "QM"
}
/** Computed rate data containing derived/computed fields. */
export type ComputedRateData = {
    __typename: "ComputedRateData";
    /** Indicates whether the bundled pricing adjustment has been applied to this rate. */
    isBundledPricingAdjustmentApplied: Maybe<Scalars["Boolean"]>;
};
/** Conventional loan details associated with pricing. */
export type ConventionalLoanDetails = {
    __typename: "ConventionalLoanDetails";
    /** The mortgage insurance coverage type. */
    miType: Maybe<PricingMortgageInsurance>;
};
export type DedicatedRelationship = {
    __typename: "DedicatedRelationship";
    agentLeadZuid: Maybe<Scalars["String"]>;
    nmlsID: Maybe<Scalars["Int"]>;
    state: Maybe<Scalars["String"]>;
};
export enum DocumentType {
    DOCUMENT_TYPE_BLEND_UPLOADED_DOCUMENTS = "DOCUMENT_TYPE_BLEND_UPLOADED_DOCUMENTS",
    DOCUMENT_TYPE_CUSTOMIZED_PRE_APPROVAL_LETTER = "DOCUMENT_TYPE_CUSTOMIZED_PRE_APPROVAL_LETTER",
    DOCUMENT_TYPE_DIGITAL_ASSET_REPORT = "DOCUMENT_TYPE_DIGITAL_ASSET_REPORT",
    DOCUMENT_TYPE_DIGITAL_INCOME_REPORT = "DOCUMENT_TYPE_DIGITAL_INCOME_REPORT",
    DOCUMENT_TYPE_DIGITAL_PRE_APPROVAL_UPLOADED_DOCUMENT = "DOCUMENT_TYPE_DIGITAL_PRE_APPROVAL_UPLOADED_DOCUMENT",
    DOCUMENT_TYPE_ECONSENT = "DOCUMENT_TYPE_ECONSENT",
    DOCUMENT_TYPE_LOAN_COMPARISON_WORKSHEET = "DOCUMENT_TYPE_LOAN_COMPARISON_WORKSHEET",
    DOCUMENT_TYPE_PRE_APPROVAL_LETTER = "DOCUMENT_TYPE_PRE_APPROVAL_LETTER",
    DOCUMENT_TYPE_UNSPECIFIED = "DOCUMENT_TYPE_UNSPECIFIED"
}
/** Escrow details associated with pricing. */
export type EscrowDetails = {
    __typename: "EscrowDetails";
    /** The HOA amount of the property associated with the scenario. */
    hoaAmount: Maybe<Scalars["Float"]>;
    /** The HOI amount of the property associated with the scenario. */
    hoiAmount: Maybe<Scalars["Float"]>;
    /** The HOI due date of the property associated with the scenario. */
    hoiDueDate: Maybe<Scalars["String"]>;
    /** The HOI percentage of the property associated with the scenario. */
    hoiPercentage: Maybe<Scalars["Float"]>;
    /** The other monthly payments of the property associated with the scenario. */
    otherMonthlyPayments: Maybe<Scalars["Float"]>;
    /** Whether the escrow should be included in the pricing. */
    shouldIncludeEscrow: Maybe<Scalars["Boolean"]>;
    /** The tax amount of the property associated with the scenario. */
    taxAmount: Maybe<Scalars["Float"]>;
    /** The tax percentage of the property associated with the scenario. */
    taxPercentage: Maybe<Scalars["Float"]>;
};
export enum ExecutionType {
    CadenceTaskWorkflow = "CadenceTaskWorkflow",
    DeleteTask = "DeleteTask",
    DocumentUpload = "DocumentUpload",
    EncompassCreateLoan = "EncompassCreateLoan",
    EncompassDocumentUpload = "EncompassDocumentUpload",
    ExecutionTypeUnspecified = "ExecutionTypeUnspecified",
    SyncToEncompass = "SyncToEncompass",
    TaskDocumentProcessingFlow = "TaskDocumentProcessingFlow",
    TaskFromLop = "TaskFromLop",
    TaskPreApprovalFlow = "TaskPreApprovalFlow",
    TriggerAutomatedTasks = "TriggerAutomatedTasks"
}
/** Fee vendor source options for pricing. */
export enum FeeVendorSource {
    /** Closing Corp */
    ClosingCorp = "ClosingCorp",
    /** Mortech */
    Mortech = "Mortech"
}
/** FHA loan details associated with pricing. */
export type FhaLoanDetails = {
    __typename: "FhaLoanDetails";
    /** Whether the Upfront Mortgage Insurance Premium is financed. */
    isUFMIPFinanced: Maybe<Scalars["Boolean"]>;
};
/**
 * Feature flags and configuration for Full App experience.
 * Provides eligibility checks, CTA URLs, and task status for Full App flows.
 */
export type FullAppFeatures = {
    __typename: "FullAppFeatures";
    borrowerId: Maybe<Scalars["ID"]>;
    /**
     * Relative URL to Full App L1 (landing) page with auth_hint parameter.
     * Use this for navigation within the same domain.
     */
    ctaFullAppL1Url: Scalars["String"];
    /**
     * Absolute URL to Full App L1 (landing) page with auth_hint parameter and domain.
     * Use this for cross-domain navigation or external links.
     */
    ctaFullAppL1UrlWithDomain: Scalars["String"];
    /**
     * Relative URL to Full App tasks page with auth_hint parameter.
     * Use this for navigation within the same domain.
     */
    ctaFullAppTasksUrl: Scalars["String"];
    /**
     * Absolute URL to Full App tasks page with auth_hint parameter and domain.
     * Use this for cross-domain navigation or external links.
     */
    ctaFullAppTasksUrlWithDomain: Scalars["String"];
    /**
     * Indicates whether the loan has outstanding todo tasks.
     * Used to determine if task-related CTAs should be displayed.
     */
    hasOutstandingTasks: Scalars["Boolean"];
    /**
     * Whether the borrower is eligible for Full App experience.
     * Derived from isFullAppEnabled VFS fact.
     */
    isFullApp: Scalars["Boolean"];
    /** The loan identifier (entity key) */
    loanId: Scalars["ID"];
};
export type HomeLoansDashboard = {
    __typename: "HomeLoansDashboard";
    currentlySelectedLoan: Maybe<ZHLLoan>;
    id: Scalars["ID"];
    personalizedNextSteps: ZHLPersonalizedNextSteps;
};
/** Shared error details type from mac-graph */
export type HomeLoansDashboardBaseErrorDetails = HomeLoansDashboardErrorDetails & {
    __typename: "HomeLoansDashboardBaseErrorDetails";
    errorCode: HomeLoansDashboardError;
    message: Scalars["String"];
};
export type HomeLoansDashboardCallbackScheduler = {
    __typename: "HomeLoansDashboardCallbackScheduler";
    callbackSchedulerAvailability: HomeLoansDashboardCallbackSchedulerAvailabilityResult;
    /**
     * Checks if a user is from buyability chip ingress is eligible for call scheduler.
     * Checks eligibility based on:
     *
     * 1. Validating if the service is available in the given state.
     * 2. Verifying that the user doesn't already have an existing appointment
     *
     * Returns a CallSchedulerEligibilityResult which can be:
     * - CallSchedulerEligibility: When the eligibility check is successful
     * - CallSchedulerAppointmentScheduled: When the user already has a scheduled appointment
     * - CallSchedulerEligibilityErrorDetails: When there's an error during the eligibility check
     */
    eligibilityCheckForBuyability: CallSchedulerEligibilityResult;
    leadStatusForCallbackScheduler: LeadStatusForHomeLoansDashboardCallbackScheduler;
};
export type HomeLoansDashboardCallbackSchedulerAvailability = {
    __typename: "HomeLoansDashboardCallbackSchedulerAvailability";
    callbackSchedulerDays: Maybe<Array<CallbackSchedulerDay>>;
};
export enum HomeLoansDashboardCallbackSchedulerAvailabilityError {
    CALLBACK_SCHEDULER_CALLBACK_APPOINTMENT_REQUEST_NOT_FOUND = "CALLBACK_SCHEDULER_CALLBACK_APPOINTMENT_REQUEST_NOT_FOUND",
    CALLBACK_SCHEDULER_L3_LEAD_ID_MISSING_ERROR = "CALLBACK_SCHEDULER_L3_LEAD_ID_MISSING_ERROR",
    CALLBACK_SCHEDULER_L3_LEAD_NOT_FOUND_ERROR = "CALLBACK_SCHEDULER_L3_LEAD_NOT_FOUND_ERROR",
    INVALID_INPUTS = "INVALID_INPUTS",
    L3_LEAD_DATA_INTEGRITY_ERROR = "L3_LEAD_DATA_INTEGRITY_ERROR",
    UNKNOWN_OR_UNEXPECTED_ERROR = "UNKNOWN_OR_UNEXPECTED_ERROR"
}
export type HomeLoansDashboardCallbackSchedulerAvailabilityErrorDetails = {
    __typename: "HomeLoansDashboardCallbackSchedulerAvailabilityErrorDetails";
    errorCode: HomeLoansDashboardCallbackSchedulerAvailabilityError;
    errorMessage: Scalars["String"];
};
export type HomeLoansDashboardCallbackSchedulerAvailabilityResult = HomeLoansDashboardCallbackSchedulerAvailability | HomeLoansDashboardCallbackSchedulerAvailabilityErrorDetails;
export enum HomeLoansDashboardCallbackSchedulerError {
    INVALID_ZUID = "INVALID_ZUID",
    MISSING_PERMISSION = "MISSING_PERMISSION",
    UNKNOWN_OR_UNEXPECTED_ERROR = "UNKNOWN_OR_UNEXPECTED_ERROR"
}
export type HomeLoansDashboardCallbackSchedulerErrorDetails = {
    __typename: "HomeLoansDashboardCallbackSchedulerErrorDetails";
    errorCode: HomeLoansDashboardCallbackSchedulerError;
    errorMessage: Scalars["String"];
};
/** Shared error enum from mac-graph */
export enum HomeLoansDashboardError {
    CALLBACK_SCHEDULER_APPOINTMENT_ALREADY_SUBMITTED_ERROR = "CALLBACK_SCHEDULER_APPOINTMENT_ALREADY_SUBMITTED_ERROR",
    /** @deprecated Use UNKNOWN_OR_UNEXPECTED_ERROR */
    CALLBACK_SCHEDULER_APPOINTMENT_BOOKING_ERROR = "CALLBACK_SCHEDULER_APPOINTMENT_BOOKING_ERROR",
    CALLBACK_SCHEDULER_CALLBACK_APPOINTMENT_REQUEST_NOT_FOUND = "CALLBACK_SCHEDULER_CALLBACK_APPOINTMENT_REQUEST_NOT_FOUND",
    /** @deprecated Replaced with INVALID_INPUT_ERROR */
    CALLBACK_SCHEDULER_INVALID_APPOINTMENT_DATE_FORMAT_ERROR = "CALLBACK_SCHEDULER_INVALID_APPOINTMENT_DATE_FORMAT_ERROR",
    CALLBACK_SCHEDULER_L3_LEAD_DATA_INTEGRITY_ERROR = "CALLBACK_SCHEDULER_L3_LEAD_DATA_INTEGRITY_ERROR",
    CALLBACK_SCHEDULER_L3_LEAD_ID_MISSING_ERROR = "CALLBACK_SCHEDULER_L3_LEAD_ID_MISSING_ERROR",
    CALLBACK_SCHEDULER_L3_LEAD_NOT_FOUND_ERROR = "CALLBACK_SCHEDULER_L3_LEAD_NOT_FOUND_ERROR",
    /** @deprecated No longer needed. */
    CALLBACK_SCHEDULER_LEAD_ALREADY_RELEASED_ERROR = "CALLBACK_SCHEDULER_LEAD_ALREADY_RELEASED_ERROR",
    CALLBACK_SCHEDULER_LEAD_ERROR = "CALLBACK_SCHEDULER_LEAD_ERROR",
    CALLBACK_SCHEDULER_LEAD_NO_LONGER_AVAILABLE_FOR_APPOINTMENT_ERROR = "CALLBACK_SCHEDULER_LEAD_NO_LONGER_AVAILABLE_FOR_APPOINTMENT_ERROR",
    CALLBACK_SCHEDULER_MISSING_PERMISSION = "CALLBACK_SCHEDULER_MISSING_PERMISSION",
    CALLBACK_SCHEDULER_NO_CALLBACK_LEAD_ONBOARDED_ERROR = "CALLBACK_SCHEDULER_NO_CALLBACK_LEAD_ONBOARDED_ERROR",
    CALLBACK_SCHEDULER_ONBOARD_ERROR_APPOINTMENT_REQUEST_ALREADY_EXISTS_FOR_ZUID = "CALLBACK_SCHEDULER_ONBOARD_ERROR_APPOINTMENT_REQUEST_ALREADY_EXISTS_FOR_ZUID",
    CALLBACK_SCHEDULER_ONBOARD_ERROR_INELIGIBLE_PROPERTY_STATE = "CALLBACK_SCHEDULER_ONBOARD_ERROR_INELIGIBLE_PROPERTY_STATE",
    CALLBACK_SCHEDULER_ONBOARD_ERROR_LEAD_NOT_IN_EXPERIMENT = "CALLBACK_SCHEDULER_ONBOARD_ERROR_LEAD_NOT_IN_EXPERIMENT",
    CALLBACK_SCHEDULER_ONBOARD_ERROR_SHAREABLE_LO_LEAD = "CALLBACK_SCHEDULER_ONBOARD_ERROR_SHAREABLE_LO_LEAD",
    CALLBACK_SCHEDULER_ONBOARD_ERROR_UNKNOWN_OR_UNEXPECTED_ERROR = "CALLBACK_SCHEDULER_ONBOARD_ERROR_UNKNOWN_OR_UNEXPECTED_ERROR",
    CALLBACK_SCHEDULER_TIME_SLOT_NOT_AVAILABLE_ERROR = "CALLBACK_SCHEDULER_TIME_SLOT_NOT_AVAILABLE_ERROR",
    INVALID_INPUT_ERROR = "INVALID_INPUT_ERROR",
    INVALID_ZUID_ERROR = "INVALID_ZUID_ERROR",
    /** @deprecated Replaced with more meaningful values. */
    L3_LEAD_INVALID = "L3_LEAD_INVALID",
    UNKNOWN_OR_UNEXPECTED_ERROR = "UNKNOWN_OR_UNEXPECTED_ERROR"
}
export type HomeLoansDashboardErrorDetails = {
    errorCode: HomeLoansDashboardError;
    message: Scalars["String"];
};
export enum LeadStatusForHomeLoansDashboardCallbackScheduler {
    INITIATED = "INITIATED",
    NOT_FOUND = "NOT_FOUND",
    SUBMITTED = "SUBMITTED",
    TIMED_OUT = "TIMED_OUT"
}
/**
 * The type of participant in the activation workflow.
 * Determines the role of the user on the loan.
 */
export enum LfsParticipantType {
    /** Standard borrower on the loan */
    BORROWER = "BORROWER",
    /** Non-borrowing owner (e.g., spouse who owns the property but is not on the loan) */
    NON_BORROWING_OWNER = "NON_BORROWING_OWNER"
}
export type LoanOfficer = {
    __typename: "LoanOfficer";
    email: Scalars["String"];
    name: Scalars["String"];
    officePhone: Scalars["String"];
    title: Maybe<Scalars["String"]>;
};
/** Loan program options for pricing. */
export enum LoanProgram {
    /** Home Possible loan program. */
    HomePossible = "HomePossible",
    /** HomeReady loan program. */
    HomeReady = "HomeReady"
}
/** Loan purpose options for pricing. */
export enum LoanPurposeType {
    /** Cash out refinance loan. */
    CashOutRefinance = "CashOutRefinance",
    /** Purchase loan. */
    Purchase = "Purchase",
    /** Rate term refinance loan. */
    RateTermRefinance = "RateTermRefinance",
    /** Refinance loan. */
    Refinance = "Refinance"
}
/** Mortgage type options for pricing. */
export enum MortgageType {
    /** Conventional mortgage. */
    Conventional = "Conventional",
    /** FHA mortgage. */
    FHA = "FHA",
    /** VA mortgage. */
    VA = "VA"
}
/** The base interface for any Neutron action */
export type NeutronAction = {
    /** An identifier for the action that must match a corresponding block identifier or module identifier */
    id: Scalars["String"];
};
/** A generic analytic event for a Neutron module */
export type NeutronAnalyticEvent = {
    /** The id of the block or module who's interaction is associated with this event */
    id: Scalars["String"];
};
/** Supported icon colors in Android Constellation 8 for ZHL Experience Graph */
export enum NeutronAndroidConstellation8IconColor {
    /** ACCENT_AQUA_HERO maps to an equivalent Android Constellation 8 color token supported by the Icon component */
    ACCENT_AQUA_HERO = "ACCENT_AQUA_HERO",
    /** ACCENT_AQUA_STRONG maps to an equivalent Android Constellation 8 color token supported by the Icon component */
    ACCENT_AQUA_STRONG = "ACCENT_AQUA_STRONG",
    /** ACCENT_BLUE_HERO maps to an equivalent Android Constellation 8 color token supported by the Icon component */
    ACCENT_BLUE_HERO = "ACCENT_BLUE_HERO",
    /** ACCENT_BLUE_STRONG maps to an equivalent Android Constellation 8 color token supported by the Icon component */
    ACCENT_BLUE_STRONG = "ACCENT_BLUE_STRONG",
    /** ACCENT_BRAND_HERO maps to an equivalent Android Constellation 8 color token supported by the Icon component */
    ACCENT_BRAND_HERO = "ACCENT_BRAND_HERO",
    /** ACCENT_GRAY_HERO maps to an equivalent Android Constellation 8 color token supported by the Icon component */
    ACCENT_GRAY_HERO = "ACCENT_GRAY_HERO",
    /** ACCENT_GRAY_STRONG maps to an equivalent Android Constellation 8 color token supported by the Icon component */
    ACCENT_GRAY_STRONG = "ACCENT_GRAY_STRONG",
    /** ACCENT_GREEN_HERO maps to an equivalent Android Constellation 8 color token supported by the Icon component */
    ACCENT_GREEN_HERO = "ACCENT_GREEN_HERO",
    /** ACCENT_GREEN_STRONG maps to an equivalent Android Constellation 8 color token supported by the Icon component */
    ACCENT_GREEN_STRONG = "ACCENT_GREEN_STRONG",
    /** ACCENT_ORANGE_HERO maps to an equivalent Android Constellation 8 color token supported by the Icon component */
    ACCENT_ORANGE_HERO = "ACCENT_ORANGE_HERO",
    /** ACCENT_ORANGE_STRONG maps to an equivalent Android Constellation 8 color token supported by the Icon component */
    ACCENT_ORANGE_STRONG = "ACCENT_ORANGE_STRONG",
    /** ACCENT_PURPLE_HERO maps to an equivalent Android Constellation 8 color token supported by the Icon component */
    ACCENT_PURPLE_HERO = "ACCENT_PURPLE_HERO",
    /** ACCENT_PURPLE_STRONG maps to an equivalent Android Constellation 8 color token supported by the Icon component */
    ACCENT_PURPLE_STRONG = "ACCENT_PURPLE_STRONG",
    /** ACCENT_RED_HERO maps to an equivalent Android Constellation 8 color token supported by the Icon component */
    ACCENT_RED_HERO = "ACCENT_RED_HERO",
    /** ACCENT_RED_STRONG maps to an equivalent Android Constellation 8 color token supported by the Icon component */
    ACCENT_RED_STRONG = "ACCENT_RED_STRONG",
    /** ACCENT_TEAL_HERO maps to an equivalent Android Constellation 8 color token supported by the Icon component */
    ACCENT_TEAL_HERO = "ACCENT_TEAL_HERO",
    /** ACCENT_TEAL_STRONG maps to an equivalent Android Constellation 8 color token supported by the Icon component */
    ACCENT_TEAL_STRONG = "ACCENT_TEAL_STRONG",
    /** ACCENT_YELLOW_HERO maps to an equivalent Android Constellation 8 color token supported by the Icon component */
    ACCENT_YELLOW_HERO = "ACCENT_YELLOW_HERO",
    /** ACCENT_YELLOW_STRONG maps to an equivalent Android Constellation 8 color token supported by the Icon component */
    ACCENT_YELLOW_STRONG = "ACCENT_YELLOW_STRONG",
    /** ACTION_CRITICAL_HERO maps to an equivalent Android Constellation 8 color token supported by the Icon component */
    ACTION_CRITICAL_HERO = "ACTION_CRITICAL_HERO",
    /** ACTION_CRITICAL_STRONG maps to an equivalent Android Constellation 8 color token supported by the Icon component */
    ACTION_CRITICAL_STRONG = "ACTION_CRITICAL_STRONG",
    /** ACTION_HERO maps to an equivalent Android Constellation 8 color token supported by the Icon component */
    ACTION_HERO = "ACTION_HERO",
    /** ACTION_NEUTRAL maps to an equivalent Android Constellation 8 color token supported by the Icon component */
    ACTION_NEUTRAL = "ACTION_NEUTRAL",
    /** ACTION_STRONG maps to an equivalent Android Constellation 8 color token supported by the Icon component */
    ACTION_STRONG = "ACTION_STRONG",
    /** INVISIBLE maps to an equivalent Android Constellation 8 color token supported by the Icon component */
    INVISIBLE = "INVISIBLE",
    /** NEUTRAL maps to an equivalent Android Constellation 8 color token supported by the Icon component */
    NEUTRAL = "NEUTRAL",
    /** SUBTLE maps to an equivalent Android Constellation 8 color token supported by the Icon component */
    SUBTLE = "SUBTLE"
}
/** Supported icon sizes in Android Constellation 8 for ZHL Experience Graph */
export enum NeutronAndroidConstellation8IconSize {
    /** Large icon size */
    LG = "LG",
    /** Medium icon size */
    MD = "MD",
    /** Small icon size */
    SM = "SM"
}
/** Supported Android configurations for text in ZHL Experience Graph */
export enum NeutronAndroidConstellation8Typography {
    /** Regular Text */
    BODY = "BODY",
    /** Bolded Text */
    BODY_BOLD = "BODY_BOLD",
    /** Extra Small Text */
    BODY_EXTRA_SMALL = "BODY_EXTRA_SMALL",
    /** Bolded Extra Small Text */
    BODY_EXTRA_SMALL_BOLD = "BODY_EXTRA_SMALL_BOLD",
    /** Semi Bolded Text */
    BODY_SEMI_BOLD = "BODY_SEMI_BOLD",
    /** Small Text */
    BODY_SMALL = "BODY_SMALL",
    /** Bolded Small Text */
    BODY_SMALL_BOLD = "BODY_SMALL_BOLD",
    /** Fineprint */
    FINEPRINT = "FINEPRINT",
    /** Bolded Fineprint */
    FINEPRINT_BOLD = "FINEPRINT_BOLD",
    /** Small Fineprint */
    FINEPRINT_SMALL = "FINEPRINT_SMALL",
    /** Bolded Small Fineprint */
    FINEPRINT_SMALL_BOLD = "FINEPRINT_SMALL_BOLD",
    /** Alternate Extra Large Heading Text Style */
    HEADING_ALT_EXTRA_LARGE = "HEADING_ALT_EXTRA_LARGE",
    /** Alternate Extra Small Heading Text Style */
    HEADING_ALT_EXTRA_SMALL = "HEADING_ALT_EXTRA_SMALL",
    /** Alternate Large Heading Text Style */
    HEADING_ALT_LARGE = "HEADING_ALT_LARGE",
    /** Alternate Medium Heading Text Style */
    HEADING_ALT_MEDIUM = "HEADING_ALT_MEDIUM",
    /** Alternate Small Heading Text Style */
    HEADING_ALT_SMALL = "HEADING_ALT_SMALL",
    /** Extra Large Heading Text Style */
    HEADING_EXTRA_LARGE = "HEADING_EXTRA_LARGE",
    /** Extra Small Heading Text Style */
    HEADING_EXTRA_SMALL = "HEADING_EXTRA_SMALL",
    /** Large Heading Text Style */
    HEADING_LARGE = "HEADING_LARGE",
    /** Medium Heading Text Style */
    HEADING_MEDIUM = "HEADING_MEDIUM",
    /** Small Heading Text Style */
    HEADING_SMALL = "HEADING_SMALL"
}
/**
 * A Neutron block represents an atomic or molecular user interface element. By requirement, neutron blocks must
 * have an ID associated to them, so that they can be wired to actions, analytics, and other blocks.
 */
export type NeutronBlock = {
    /**
     * The ID of a block does not have to be globally unique within the ZG space, and does not have to be semantically meaningful
     * from a business domain. It only needs to be unique within the context of a Neutron module
     */
    id: Scalars["String"];
};
/** Supported Border Radius values in Constellation 10 for Neutron */
export enum NeutronWebConstellation10ButtonBorderRadius {
    /** CAPSULE maps to an equivalent token in Constellation 10 */
    CAPSULE = "CAPSULE",
    /** ELLIPSE maps to an equivalent token in Constellation 10 */
    ELLIPSE = "ELLIPSE",
    /** LG maps to an equivalent token in Constellation 10 */
    LG = "LG",
    /** MD maps to an equivalent token in Constellation 10 */
    MD = "MD",
    /** PILL maps to an equivalent token in Constellation 10 */
    PILL = "PILL",
    /** SM maps to an equivalent token in Constellation 10 */
    SM = "SM",
    /** ZERO maps to an equivalent token in Constellation 10 */
    ZERO = "ZERO"
}
/** Occupancy options for pricing. */
export enum OccupancyType {
    /** Investment property. */
    InvestmentProperty = "InvestmentProperty",
    /** Primary residence. */
    PrimaryResidence = "PrimaryResidence",
    /** Second home. */
    SecondHome = "SecondHome"
}
export enum Persona {
    CoBorrower = "CoBorrower",
    LoanOfficer = "LoanOfficer",
    LoanOfficerManager = "LoanOfficerManager",
    NonBorrowingOwner = "NonBorrowingOwner",
    PersonaUnspecified = "PersonaUnspecified",
    PrimaryBorrower = "PrimaryBorrower",
    Processor = "Processor",
    ProcessorManager = "ProcessorManager",
    SupportLoanOfficer = "SupportLoanOfficer",
    TasksEngine = "TasksEngine",
    Underwriter = "Underwriter",
    UnderwriterManager = "UnderwriterManager",
    /** @deprecated Use ZhlEmployee to match proto Persona enum */
    ZHLEmployee = "ZHLEmployee",
    ZhlEmployee = "ZhlEmployee"
}
export type PreApprovalCondition = {
    __typename: "PreApprovalCondition";
    conditionDescription: Scalars["String"];
    conditionName: Scalars["String"];
    conditionTypeName: Scalars["String"];
};
/** Pricing configuration for a loan. */
export type PricingConfiguration = {
    __typename: "PricingConfiguration";
    /** The address details associated with the pricing. */
    addressDetails: Maybe<AddressDetails>;
    /** The appraised value of the property associated with the pricing. */
    appraisedValue: Maybe<Scalars["Float"]>;
    /**
     * The base loan amount associated with the pricing.
     * This is a legacy pricing field to support migration and will be removed in the future.
     * @deprecated This field is deprecated. Use baseLoanAmount and totalLoanAmount on the Rate object instead.
     */
    baseLoanAmount: Maybe<Scalars["Float"]>;
    /** The borrower details associated with the pricing. */
    borrowerDetails: Maybe<BorrowerDetails>;
    /** The closing date associated with the pricing. */
    closingDate: Maybe<Scalars["String"]>;
    /** The conventional loan details associated with the pricing. */
    conventionalLoanDetails: Maybe<ConventionalLoanDetails>;
    /** The date and time the pricing configuration was created in UTC. */
    createdAt: Maybe<Scalars["String"]>;
    /** The escrow details associated with the pricing. */
    escrowDetails: Maybe<EscrowDetails>;
    /** The FHA loan details associated with the pricing. */
    fhaLoanDetails: Maybe<FhaLoanDetails>;
    /** The ID of the pricing configuration. */
    id: Maybe<Scalars["ID"]>;
    /** Whether the pricing configuration is from legacy ZGM pricing. */
    isLegacy: Maybe<Scalars["Boolean"]>;
    /** Whether the Pricing Configuration is using Minimum Down Payment. */
    isMinimumDown: Maybe<Scalars["Boolean"]>;
    /** Whether the pricing configuration is read only. */
    isReadOnly: Scalars["Boolean"];
    /** The loan purpose associated with the pricing. */
    loanPurpose: LoanPurposeType;
    /** The loan term associated with the pricing. */
    loanTerm: Maybe<Scalars["Int"]>;
    /** The lock period associated with the pricing. */
    lockPeriod: Maybe<Scalars["Int"]>;
    /** The mortgage types associated with the pricing. */
    mortgageType: MortgageType;
    /** The property details associated with the pricing. */
    propertyDetails: Maybe<PropertyDetails>;
    /** The purchase details associated with the pricing. */
    purchaseDetails: Maybe<PurchaseDetails>;
    /** The rate associated with the pricing. */
    rate: Maybe<Rate>;
    /** The refinance details associated with the pricing. */
    refinanceDetails: Maybe<RefinanceDetails>;
    /** The resource ID of the pricing run. */
    resourceId: Maybe<Scalars["String"]>;
    /** The VA loan details associated with the pricing. */
    vaLoanDetails: Maybe<VaLoanDetails>;
};
/** Fee details associated with pricing. */
export type PricingFee = {
    __typename: "PricingFee";
    /** Dollar amount of this fee. */
    amount: Maybe<Scalars["Float"]>;
    /** Amount that the buyer will pay for this fee. */
    buyerAmount: Maybe<Scalars["Float"]>;
    /** Category of the fee that was applied. */
    category: Maybe<Scalars["String"]>;
    /** Disclosure section of the fee that was applied. */
    disclosureSection: Maybe<Scalars["String"]>;
    /** Whether the fee is an APR fee. */
    isApr: Maybe<Scalars["Boolean"]>;
    /** Whether the fee is shoppable. */
    isShoppable: Maybe<Scalars["String"]>;
    /** Line number of the fee that was applied. */
    lineNumber: Maybe<Scalars["String"]>;
    /** Name of the fee that was applied. */
    name: Maybe<Scalars["String"]>;
    /** Paid to. */
    paidTo: Maybe<Scalars["String"]>;
    /** Payer of the fee that was applied. */
    payer: Maybe<Scalars["String"]>;
    /** Amount that the seller will pay for this fee. */
    sellerAmount: Maybe<Scalars["Float"]>;
    /** Name of the vendor that provided the fee. */
    source: Maybe<FeeVendorSource>;
};
/** Military options for pricing. */
export enum PricingMilitary {
    /** National Guard/Reserves. */
    NationalGuard = "NationalGuard",
    /** Regular military. */
    RegularMilitary = "RegularMilitary"
}
export enum PricingMortgageInsurance {
    /** Buyer finances PMI into loan amount. */
    FinancedSinglePremiumBPMI = "FinancedSinglePremiumBPMI",
    /** Lender pays, which results in a higher note rate. */
    LPMI = "LPMI",
    /** Buyer pays entirely on own, monthly. */
    NonFinancedMonthlyBPMI = "NonFinancedMonthlyBPMI",
    /** Buyer pays entirely on own in one lump sum. */
    NonFinancedSinglePremiumBPMI = "NonFinancedSinglePremiumBPMI"
}
/** Property options for pricing. */
export enum PricingPropertyType {
    /** Commercial property. */
    Commercial = "Commercial",
    /** Condo property. */
    Condo = "Condo",
    /** Condominium property. */
    Condominium = "Condominium",
    /** Condotel property. */
    Condotel = "Condotel",
    /** Coop property. */
    Coop = "Coop",
    /** Duplex property. */
    Duplex = "Duplex",
    /** Fourplex property. */
    Fourplex = "Fourplex",
    /** Land property. */
    Land = "Land",
    /** Mobile or manufactured property. */
    MobileOrManufactured = "MobileOrManufactured",
    /** Multi-family property. */
    MultiFamily = "MultiFamily",
    /** Single-family property. */
    Single = "Single",
    /** Townhome property. */
    Townhome = "Townhome",
    /** Triplex property. */
    Triplex = "Triplex",
    /** Two to four unit property. */
    TwoToFourUnit = "TwoToFourUnit"
}
/** VA usage options for pricing. */
export enum PricingVaUsage {
    /** First time use. */
    FirstTimeUse = "FirstTimeUse",
    /** Subsequent use. */
    SubsequentUse = "SubsequentUse"
}
/** Property details for the property associated with pricing. */
export type PropertyDetails = {
    __typename: "PropertyDetails";
    /** The attachment type of the property associated with the scenario. */
    attachmentType: AttachmentType;
    /** Whether the property is a planned unit development. */
    isPlannedUnitDevelopment: Scalars["Boolean"];
    /** The number of units in the property associated with the scenario. */
    numberOfUnits: Maybe<Scalars["Int"]>;
    /** The occupancy type of the property associated with the scenario. */
    occupancyType: OccupancyType;
    /** The type of the property associated with the scenario. */
    propertyType: PricingPropertyType;
};
/** Purchase details associated with pricing. */
export type PurchaseDetails = {
    __typename: "PurchaseDetails";
    /** The down payment amounts associated with the pricing. */
    downPaymentAmounts: Maybe<Array<Scalars["Float"]>>;
    /** The down payment percentages associated with the pricing. */
    downPaymentPercentages: Maybe<Array<Scalars["Float"]>>;
    /** The purchase price of the property. */
    purchasePrice: Maybe<Scalars["Float"]>;
    /** The selected down payment amount associated with the pricing. */
    selectedDownPaymentAmount: Maybe<Scalars["Float"]>;
    /** The selected down payment percentage associated with the pricing. */
    selectedDownPaymentPercentage: Maybe<Scalars["Float"]>;
    /** The seller credit amount associated with the pricing. */
    sellerCreditAmount: Maybe<Scalars["Float"]>;
    /** The seller credit percentage associated with the pricing. */
    sellerCreditPercentage: Maybe<Scalars["Float"]>;
    /** Whether the maximum seller credit is used. */
    useMaximumSellerCredit: Maybe<Scalars["Boolean"]>;
    /** Whether the minimum down payment is used. */
    useMinimumDownPayment: Maybe<Scalars["Boolean"]>;
};
export type QuickAppFeatures = {
    __typename: "QuickAppFeatures";
    ctaDocumentRequestUrl: Maybe<Scalars["String"]>;
    ctaDocumentRequestUrlWithDomain: Maybe<Scalars["String"]>;
    ctaPreApprovalUrl: Maybe<Scalars["String"]>;
    ctaPreApprovalUrlWithDomain: Maybe<Scalars["String"]>;
    ctaQuickAppUrl: Maybe<Scalars["String"]>;
    ctaQuickAppUrlWithDomain: Maybe<Scalars["String"]>;
    hasOutstandingTasks: Scalars["Boolean"];
    isQuickApp: Maybe<Scalars["Boolean"]>;
    loanId: Scalars["ID"];
};
/** Rate details associated with pricing. */
export type Rate = {
    __typename: "Rate";
    /** The additional over par borrower rebate in dollars. */
    additionalOverParBorrowerRebateDollar: Maybe<Scalars["Float"]>;
    /** The additional over par borrower rebate in percent. */
    additionalOverParBorrowerRebatePercent: Maybe<Scalars["Float"]>;
    /** Rate sheet adjustments total adjustment to the price. */
    adjustmentPriceTotal: Maybe<Scalars["Float"]>;
    /** Rate sheet adjustments total adjustment to the rate. */
    adjustmentRateTotal: Maybe<Scalars["Float"]>;
    /** List of rate sheet adjustments applied. */
    adjustments: Maybe<Array<AdjustmentDetail>>;
    /** Whether the AMI LLPA waiver is applied. */
    amiLlpaWaiver: Maybe<Scalars["Boolean"]>;
    /** The amortization type associated with the pricing. */
    amortizationType: Maybe<AmortizationType>;
    /** The Annual Percentage Rate for this rate */
    apr: Maybe<Scalars["Float"]>;
    /** ARM - Adjustable Rate Mortgage term details and caps. */
    armDetails: Maybe<ArmDetails>;
    /** The base loan amount associated with the pricing. */
    baseLoanAmount: Maybe<Scalars["Float"]>;
    /** The base loan to value ratio associated with the pricing. */
    baseLtv: Maybe<Scalars["Float"]>;
    /**
     * The number of months until this rate reaches a break-even
     * point in cost relative to the rate closest to the target
     * discount points with the same lock term.
     */
    breakEvenMonths: Maybe<Scalars["Float"]>;
    /** The buydown amount from the borrower in dollars. */
    buydownAmountFromBorrowerDollar: Maybe<Scalars["Float"]>;
    /** The total amount of points the buyer is paying to buy down the rate in this rate. */
    buydownAmountFromBorrowerPercent: Maybe<Scalars["Float"]>;
    /** A collection of results for compliance checks. */
    compliance: Maybe<Array<ComplianceSection>>;
    /** Computed data for the rate. */
    computed: Maybe<ComputedRateData>;
    /** The total dollar amount of cost that was adjusted. */
    costAdjustmentTotalDollar: Maybe<Scalars["Float"]>;
    /** The total percentage of cost that was adjusted. */
    costAdjustmentTotalPercent: Maybe<Scalars["Float"]>;
    /** The total dollar amount associated with the cost of this loan. */
    costTotalDollar: Maybe<Scalars["Float"]>;
    /** The total percentage of cost this loan will generate. */
    costTotalPercent: Maybe<Scalars["Float"]>;
    /** The debt to income ratio associated with the pricing. */
    debtToIncomePercent: Maybe<Scalars["Float"]>;
    /** The ID of the fee provider. */
    feeProviderId: Maybe<Scalars["String"]>;
    /** The source of the fee provider. */
    feeProviderSource: Maybe<Scalars["String"]>;
    /** Total dollar amount of closing fees applied. */
    feeTotal: Maybe<Scalars["Float"]>;
    /** Collection of fees that make up the total fees. */
    fees: Maybe<Array<Maybe<PricingFee>>>;
    /** The price of the loan in this rate after all adjustments are made and all profit is accounted for. */
    finalPrice: Maybe<Scalars["Float"]>;
    /** The date and time the first payment is due in UTC. */
    firstPaymentDate: Maybe<Scalars["String"]>;
    /** The ID of the rate. */
    id: Maybe<Scalars["ID"]>;
    /** The interest rate associated with the pricing. */
    interestRate: Maybe<Scalars["Float"]>;
    /** True when loan program is Home Possible or Home Ready. */
    isHomeReadyHomePossible: Maybe<Scalars["Boolean"]>;
    /** Whether the rate is a Jumbo loan. */
    isJumbo: Maybe<Scalars["Boolean"]>;
    /** Whether the rate is par. */
    isPar: Maybe<Scalars["Boolean"]>;
    /**
     * The loan amount associated with the rate.
     * @deprecated This field is deprecated. Use baseLoanAmount and totalLoanAmount instead.
     */
    loanAmount: Maybe<Scalars["Int"]>;
    /** The loan program associated with the pricing. */
    loanProgram: Maybe<LoanProgram>;
    /**
     * The loan to value ratio for this rate.
     * @deprecated This field is deprecated. Use baseLtv and totalLtv instead.
     */
    ltv: Maybe<Scalars["Float"]>;
    /** The dollar amount due each month in mortgage insurance or government fees for the pricing */
    monthlyMortgageInsurance: Maybe<Scalars["Float"]>;
    /** The annual premium percent for this rate. */
    monthlyPremiumAnnualPercent: Maybe<Scalars["Float"]>;
    /** The dollar amount due each month in mortgage insurance or government fees for this rate. */
    monthlyPremiumMonthlyDollar: Maybe<Scalars["Float"]>;
    /** Monthly Premium Period */
    monthlyPremiumPeriod: Maybe<Scalars["Int"]>;
    /** The percent of the mortgage insurance or government fees that is due each month for this rate. */
    monthlyPremiumRenewalPercent: Maybe<Scalars["Float"]>;
    /** The period of time between the renewal of the mortgage insurance or government fees for this rate. */
    monthlyPremiumRenewalPeriod: Maybe<Scalars["Float"]>;
    /** The date and time the mortgage insurance or government fees for this rate will terminate. */
    monthlyPremiumTermination: Maybe<Scalars["String"]>;
    /** The principal and interest associated with the pricing. */
    monthlyPrincipalAndInterest: Maybe<Scalars["Float"]>;
    /** The monthly principal, interest, taxes, and insurance associated with the pricing. */
    monthlyPrincipalInterestTaxesAndInsurance: Maybe<Scalars["Float"]>;
    /** The name of the company that provides the mortgage insurance or government fees for this rate. */
    mortgageInsuranceCompanyName: Maybe<Scalars["String"]>;
    /** The ID of the mortgage insurance quote for this rate. */
    mortgageInsuranceQuoteID: Maybe<Scalars["String"]>;
    /** The dollar amount of profit added to this rate due to it being over par. */
    overParProfitDollar: Maybe<Scalars["Float"]>;
    /** The percentage amount of profit added to this rate due to it being over par. */
    overParProfitPercent: Maybe<Scalars["Float"]>;
    /** The par buydown amount from the borrower in dollars. */
    parBuydownAmountFromBorrowerDollar: Maybe<Scalars["Float"]>;
    /** The par buydown amount from the borrower in percent. */
    parBuydownAmountFromBorrowerPercent: Maybe<Scalars["Float"]>;
    /** The par interest rate for this rate. */
    parInterestRate: Maybe<Scalars["Float"]>;
    /** The par monthly principal, interest, taxes, and insurance for this rate. */
    parMonthlyPrincipalInterestTaxesAndInsurance: Maybe<Scalars["Float"]>;
    /** The dollar amount of cost associated with this loan that was pre-planned. */
    plannedCostDollar: Maybe<Scalars["Float"]>;
    /** The percentage amount of cost associated with this loan that was pre-planned. */
    plannedCostPercent: Maybe<Scalars["Float"]>;
    /** The dollar amount of profit associated with this loan that was pre-planned as opposed to over par profit. */
    plannedProfitDollar: Maybe<Scalars["Float"]>;
    /** The percentage amount of profit associated with this loan that was pre-planned as opposed to over par profit. */
    plannedProfitPercent: Maybe<Scalars["Float"]>;
    /** The display name for a rate which can be customized by the loan officer. */
    productDisplayName: Maybe<Scalars["String"]>;
    /** The associated pricing Mortech Product ID. */
    productId: Maybe<Scalars["Int"]>;
    /** The associated pricing product name. */
    productName: Maybe<Scalars["String"]>;
    /** The total dollar amount of profit that was adjusted. */
    profitAdjustmentTotalDollar: Maybe<Scalars["Float"]>;
    /** The total percentage of profit that was adjusted. */
    profitAdjustmentTotalPercent: Maybe<Scalars["Float"]>;
    /** The total dollar amount of profit this loan will generate. */
    profitTotalDollar: Maybe<Scalars["Float"]>;
    /** The total percentage of profit this loan will generate. */
    profitTotalPercent: Maybe<Scalars["Float"]>;
    /** The overall interest rate of the loan the borrower will get from this rate. */
    ratePercent: Maybe<Scalars["Float"]>;
    /** The base price that this rate will start from based on the investor, product, and number of lock days. */
    rateSheetPrice: Maybe<Scalars["Float"]>;
    /** Service Release Premium - an adjustment by the investor to the price of the loan that is not subject to other investor adjustment rules and restrictions. */
    serviceReleasePremium: Maybe<Scalars["Float"]>;
    /** Total Buyer Fees Amount */
    totalBuyerFeesAmount: Maybe<Scalars["Float"]>;
    /** Total amount of cash needed to close on a loan for this rate. */
    totalCashToClose: Maybe<Scalars["Float"]>;
    /** The net amount of funds required to close a transaction, if available. */
    totalClosingCosts: Maybe<Scalars["Float"]>;
    /** The total loan amount associated with the pricing. */
    totalLoanAmount: Maybe<Scalars["Float"]>;
    /** The total loan to value ratio associated with the pricing. */
    totalLtv: Maybe<Scalars["Float"]>;
    /** Total Seller Fees Amount */
    totalSellerFeesAmount: Maybe<Scalars["Float"]>;
    /** The date and time the rate was last updated in UTC. */
    updatedAt: Maybe<Scalars["String"]>;
    /** The upfront fee in dollars associated with the pricing. */
    upfrontFeeDollar: Maybe<Scalars["Float"]>;
    /** The percent of the loan amount applied in up front fees for this rate. */
    upfrontFeePercent: Maybe<Scalars["Float"]>;
    /** The ID of the fee in ZHL. */
    zhlFeeId: Maybe<Scalars["String"]>;
};
/** Refinance details associated with pricing. */
export type RefinanceDetails = {
    __typename: "RefinanceDetails";
    /** Whether appraisal is required. */
    appraisalRequired: Scalars["Boolean"];
    /** Cash Out Details */
    cashOut: Maybe<CashOutDetails>;
    /** Whether credit is required. */
    creditRequired: Scalars["Boolean"];
    /** The current balance on a loan account is the unpaid balance of the loan. */
    currentBalance: Maybe<Scalars["Float"]>;
    /** The estimated value of the property. */
    estimatedValue: Maybe<Scalars["Float"]>;
    /** The refinance program. */
    program: Maybe<RefinanceProgram>;
};
/** Refinance program options for pricing. */
export enum RefinanceProgram {
    FullDocumentation = "FullDocumentation",
    InterestRateReduction = "InterestRateReduction",
    Streamlined = "Streamlined",
    StreamlinedIRRRL = "StreamlinedIRRRL"
}
/** @deprecated: use ZHLTaskParticipantRole */
export enum TaskParticipantRole {
    CoBorrower = "CoBorrower",
    LoanOfficer = "LoanOfficer",
    LoanOfficerManager = "LoanOfficerManager",
    NonBorrowingOwner = "NonBorrowingOwner",
    PersonaUnspecified = "PersonaUnspecified",
    PrimaryBorrower = "PrimaryBorrower",
    Processor = "Processor",
    ProcessorManager = "ProcessorManager",
    TasksEngine = "TasksEngine",
    Underwriter = "Underwriter",
    UnderwriterManager = "UnderwriterManager",
    Unspecified = "Unspecified",
    ZHLEmployee = "ZHLEmployee"
}
/** Test section details associated with pricing. */
export type TestSection = {
    __typename: "TestSection";
    /** First line of text for the performed compliance test. */
    descriptionLine1: Maybe<Scalars["String"]>;
    /** Second line of text for the performed compliance test. */
    descriptionLine2: Maybe<Scalars["String"]>;
    /** Help text explaining details of how the test is performed. */
    helpText: Maybe<Scalars["String"]>;
    /** Name of the test performed */
    name: Maybe<Scalars["String"]>;
    /** The result of the test. */
    result: Maybe<Scalars["String"]>;
};
/** VA loan details associated with pricing. */
export type VaLoanDetails = {
    __typename: "VaLoanDetails";
    /** Whether the borrower is a military member. */
    isMilitary: Maybe<Scalars["Boolean"]>;
    /** Whether the VA Funding Fee is financed. */
    isVAFFFinance: Maybe<Scalars["Boolean"]>;
    /** Whether the VA Funding Fee is exempt. */
    isVaFundingFeeExempt: Maybe<Scalars["Boolean"]>;
    /** The type of military service. */
    militaryType: Maybe<PricingMilitary>;
    /** The type of VA usage. */
    usageType: Maybe<PricingVaUsage>;
};
export type VerifyZHLSelfServiceRecoveryToolAttempt = {
    __typename: "VerifyZHLSelfServiceRecoveryToolAttempt";
    actionTaken: VerifyZHLSelfServiceRecoveryToolAttemptAction;
    blendLoginUrl: Scalars["String"];
};
export enum VerifyZHLSelfServiceRecoveryToolAttemptAction {
    ACTIVATED_USER = "ACTIVATED_USER",
    LOAN_ALREADY_RECOVERED = "LOAN_ALREADY_RECOVERED"
}
export type VerifyZHLSelfServiceRecoveryToolAttemptByLoanAttributesInput = {
    beginZHLSelfServiceRecoveryToolAttemptID: Scalars["ID"];
    /** A valid phone number including area code such as 5555555555 or 555-555-5555 */
    phoneNumber: Scalars["String"];
    propertyAddress: ZHLSelfServiceRecoveryToolLoanPropertyAddress;
    /** The last four digits of social security number. */
    socialSecurityNumber: Scalars["String"];
    trackingId: Scalars["String"];
};
export enum VerifyZHLSelfServiceRecoveryToolAttemptError {
    FEATURE_DISABLED = "FEATURE_DISABLED",
    INVALID_INPUT_PHONE_NUMBER = "INVALID_INPUT_PHONE_NUMBER",
    INVALID_INPUT_SSN = "INVALID_INPUT_SSN",
    INVALID_INPUT_STATE = "INVALID_INPUT_STATE",
    INVALID_INPUT_ZIPCODE = "INVALID_INPUT_ZIPCODE",
    INVALID_RECOVERY_ATTEMPT = "INVALID_RECOVERY_ATTEMPT",
    RECOVERY_ATTEMPT_FAILED = "RECOVERY_ATTEMPT_FAILED",
    UNKNOWN_ERROR = "UNKNOWN_ERROR"
}
export type VerifyZHLSelfServiceRecoveryToolAttemptErrorDetail = {
    __typename: "VerifyZHLSelfServiceRecoveryToolAttemptErrorDetail";
    errorCode: VerifyZHLSelfServiceRecoveryToolAttemptError;
    errorMessage: Scalars["String"];
};
export type ZHLBorrower = {
    __typename: "ZHLBorrower";
    assets: Maybe<Array<Maybe<Scalars["ID"]>>>;
    attributes: Maybe<ZHLUserAttributes>;
    /** The borrower pair. */
    borrowerPair: Array<Maybe<Scalars["ID"]>>;
    /**
     * For primary borrower on a loan, returns the whole borrower group.
     * For a borrower in a pair, returns the pair.
     * For a single borrower, returns the single borrowers and the borrower itself.
     */
    coborrowers: Maybe<Array<Array<Maybe<Scalars["ID"]>>>>;
    creditConsent: Maybe<ZHLCreditConsent>;
    employmentRecords: Maybe<Array<Maybe<ZHLEmployment>>>;
    employments: Maybe<Array<Maybe<Scalars["ID"]>>>;
    id: Scalars["ID"];
    loanId: Scalars["ID"];
    otherIncomes: Maybe<Array<Maybe<Scalars["ID"]>>>;
    /**
     * Returns the email either associated with the borrower's ZUID in LFS if one has been attached
     * or the comms email in LFS if the borrower has not activated their account.
     * If neither of these can be found for any reason, this will return null.
     */
    recommendedLoginEmail: Maybe<Scalars["String"]>;
    /**
     * Whether the borrower has gone through the ZHL activation flow or if they still need to.
     * ZHL activation is required for a borrower to have and be able to access their dashboard.
     */
    zhlFirstPartyActivationStatus: ZhlFirstPartyActivationStatus;
    zuid: Maybe<Scalars["ID"]>;
};
/** Type to represent a conversation summary */
export type ZHLConversationSummary = {
    __typename: "ZHLConversationSummary";
    /** The direction of the call either INBOUND, OUTBOUND or UNKNOWN */
    callDirection: CallDirection;
    /** The duration of the call in seconds if available */
    callDuration: Maybe<Scalars["Int"]>;
    /** The summary content generated by the AI model */
    content: Scalars["String"];
    /** The ID from the Contact Center as a Service (Genesys) that uniquely identifies a conversation */
    genesysConversationId: Scalars["ID"];
    /** The name of the loan officer that owns the lead from this call */
    loanOfficerName: Maybe<Scalars["String"]>;
    /** The next steps extracted by the AI model if available */
    nextSteps: Maybe<Scalars["String"]>;
    /** The conversation timestamp */
    timestamp: Maybe<Scalars["String"]>;
    /** The title summary extracted by the AI model if available */
    title: Maybe<Scalars["String"]>;
};
export type ZHLCreditConsent = {
    __typename: "ZHLCreditConsent";
    method: Maybe<ZHLCreditConsentMethod>;
};
export enum ZHLCreditConsentMethod {
    Verbal = "Verbal",
    Website = "Website"
}
export type ZHLDashboardActivationToken = {
    __typename: "ZHLDashboardActivationToken";
    expirationUtc: Scalars["String"];
    token: Scalars["String"];
};
export enum ZHLDashboardActivationTokenGenerationStatus {
    GENERATED = "GENERATED",
    USER_PREVIOUSLY_ACTIVATED = "USER_PREVIOUSLY_ACTIVATED"
}
/**
 * Response shape for when errors are returned from a graph request.
 * This is legacy from before Pathfinders was using errors as data for most things,
 * but we still need it for backwards compatibility until we update/deprecate the queries that don't use EAD
 */
export type ZHLDashboardErrorExtension = {
    __typename: "ZHLDashboardErrorExtension";
    errorCode: Maybe<Scalars["Int"]>;
    errorMsg: Maybe<Scalars["String"]>;
    errorType: Maybe<Scalars["String"]>;
    statusText: Maybe<Scalars["String"]>;
    typename: Maybe<Scalars["String"]>;
};
export type ZHLDashboardGenerateActivationTokenResult = {
    __typename: "ZHLDashboardGenerateActivationTokenResult";
    activationToken: Maybe<ZHLDashboardActivationToken>;
    /** @deprecated Use url */
    activationUrl: Maybe<Scalars["String"]>;
    tokenGenerationStatus: ZHLDashboardActivationTokenGenerationStatus;
    url: Maybe<Scalars["String"]>;
};
export type ZHLDashboardUserActivationFailureMessage = {
    __typename: "ZHLDashboardUserActivationFailureMessage";
    failureDescriptionMarkdown: Scalars["String"];
    failureHeading: Scalars["String"];
};
/**  Returns Dashboard User 1p Activation result  */
export type ZHLDashboardUserActivationResult = {
    __typename: "ZHLDashboardUserActivationResult";
    /** @deprecated Use landingUrl */
    dashboardUrl: Maybe<Scalars["String"]>;
    /**
     * Front-end messaging to use when status is FAILED.
     * This should be displayed directly to the user on the failure page.
     * This should not be specified on a successful activation,
     * but even if it is, it should be ignored for successful activations.
     * If not provided on a failure, clients should use their own default messaging.
     */
    failureMessage: Maybe<ZHLDashboardUserActivationFailureMessage>;
    landingUrl: Maybe<Scalars["String"]>;
    status: ZHLDashboardUserActivationStatus;
};
export enum ZHLDashboardUserActivationStatus {
    ACTIVATED = "ACTIVATED",
    FAILED = "FAILED"
}
/** Document in a loan. Backed by zDocs to provide viewing & signing experience. */
export type ZHLDocument = {
    __typename: "ZHLDocument";
    _id: Scalars["ID"];
    createdBy: Maybe<Scalars["String"]>;
    createdDate: Maybe<Scalars["String"]>;
    documentId: Scalars["ID"];
    /** URL to download the document */
    downloadURL: Maybe<Scalars["String"]>;
    /** @deprecated(reason: "Use documentId instead") while "_id" is a unique identifier for caching purpose only, will change "id" to equal "_id" in the future */
    id: Scalars["ID"];
    name: Maybe<Scalars["String"]>;
    sortKey: Maybe<Scalars["ID"]>;
    /** status of the document, there will be only one document that is not inactive with the same id */
    status: Maybe<ZHLDocumentStatus>;
    type: Maybe<DocumentType>;
    uploadURL: Maybe<Scalars["String"]>;
    viewingURL: Maybe<Scalars["String"]>;
};
export type ZHLDocumentMetadata = {
    __typename: "ZHLDocumentMetadata";
    documentURL: Maybe<Scalars["String"]>;
    downloadURL: Maybe<Scalars["String"]>;
};
export type ZHLDocumentPreApprovalMetaData = {
    __typename: "ZHLDocumentPreApprovalMetaData";
    amortizationType: Maybe<Scalars["String"]>;
    apr: Maybe<Scalars["String"]>;
    baseLoanAmount: Maybe<Scalars["String"]>;
    cashToClose: Maybe<Scalars["String"]>;
    conditions: Maybe<Array<Maybe<PreApprovalCondition>>>;
    creditScore: Maybe<Scalars["Int"]>;
    downPayment: Maybe<Scalars["String"]>;
    expiryDate: Maybe<Scalars["Date"]>;
    findingId: Maybe<Scalars["String"]>;
    isUfmipVaffFinanced: Maybe<Scalars["Boolean"]>;
    issueDate: Scalars["Date"];
    loanAmount: Scalars["String"];
    loanProgram: Maybe<Scalars["String"]>;
    loanPurpose: Maybe<Scalars["String"]>;
    loanTerm: Maybe<Scalars["String"]>;
    loanType: Maybe<Scalars["String"]>;
    ltvRatio: Maybe<Scalars["String"]>;
    monthlyHOA: Maybe<Scalars["String"]>;
    monthlyHOI: Maybe<Scalars["String"]>;
    monthlyPMI: Maybe<Scalars["String"]>;
    monthlyPiti: Maybe<Scalars["String"]>;
    monthlyPrincipalInterest: Maybe<Scalars["String"]>;
    monthlyTaxes: Maybe<Scalars["String"]>;
    noteRate: Maybe<Scalars["String"]>;
    occupancyType: Maybe<Scalars["String"]>;
    otherMonthlyPayments: Maybe<Scalars["String"]>;
    /** The pricing configuration for a loan. */
    pricingConfiguration: Maybe<PricingConfiguration>;
    propertyType: Maybe<Scalars["String"]>;
    purchasePrice: Maybe<Scalars["String"]>;
    ratePoints: Maybe<Scalars["String"]>;
    ratePointsCostAmount: Maybe<Scalars["String"]>;
    sellerCredit: Maybe<Scalars["String"]>;
    sourceDocumentId: Maybe<Scalars["ID"]>;
    subjectPropertyLocation: Maybe<Scalars["String"]>;
    subjectPropertyLocationCity: Maybe<Scalars["String"]>;
    subjectPropertyLocationCounty: Maybe<Scalars["String"]>;
    subjectPropertyLocationState: Maybe<Scalars["String"]>;
    subjectPropertyLocationZip: Maybe<Scalars["String"]>;
    totalClosingCosts: Maybe<Scalars["String"]>;
    upfrontFees: Maybe<Scalars["String"]>;
};
export enum ZHLDocumentStatus {
    DOCUMENT_STATUS_DELETED = "DOCUMENT_STATUS_DELETED",
    DOCUMENT_STATUS_INACTIVE = "DOCUMENT_STATUS_INACTIVE",
    DOCUMENT_STATUS_READY = "DOCUMENT_STATUS_READY",
    DOCUMENT_STATUS_SIGNED = "DOCUMENT_STATUS_SIGNED",
    DOCUMENT_STATUS_UNSPECIFIED = "DOCUMENT_STATUS_UNSPECIFIED",
    DOCUMENT_STATUS_UPLOADED = "DOCUMENT_STATUS_UPLOADED",
    DOCUMENT_STATUS_VIEWED = "DOCUMENT_STATUS_VIEWED"
}
export type ZHLEmployment = {
    __typename: "ZHLEmployment";
    attributes: ZHLEmploymentAttributes;
    borrowerID: Maybe<Scalars["ID"]>;
    createdUTC: Scalars["Date"];
    id: Scalars["ID"];
    loanID: Maybe<Scalars["ID"]>;
};
export type ZHLEmploymentAddress = {
    __typename: "ZHLEmploymentAddress";
    city: Maybe<Scalars["String"]>;
    code: Maybe<Scalars["String"]>;
    country: Scalars["String"];
    street: Maybe<Scalars["String"]>;
    subdivision: Maybe<Scalars["String"]>;
};
export type ZHLEmploymentAttributes = {
    __typename: "ZHLEmploymentAttributes";
    address: ZHLEmploymentAddress;
    dataSource: Maybe<Scalars["String"]>;
    employmentRecordType: Maybe<Scalars["String"]>;
    foreign: Scalars["Boolean"];
    income: Maybe<ZHLEmploymentIncome>;
    monthsInLineOfWork: Maybe<Scalars["Int"]>;
    name: Scalars["String"];
    position: Maybe<Scalars["String"]>;
    seasonal: Scalars["Boolean"];
    selfEmployed: Scalars["Boolean"];
    specialBorrowerEmployerRelationship: Scalars["Boolean"];
    startDate: Maybe<Scalars["Date"]>;
    verificationStatus: Maybe<Scalars["String"]>;
};
export type ZHLEmploymentIncome = {
    __typename: "ZHLEmploymentIncome";
    base: Maybe<ZHLEmploymentIncomeBase>;
};
export type ZHLEmploymentIncomeBase = {
    __typename: "ZHLEmploymentIncomeBase";
    amount: Maybe<Scalars["Float"]>;
    frequency: Maybe<Scalars["String"]>;
};
export enum ZHLEntityType {
    ENTITY_TYPE_CLOSING_ORDER_ID = "ENTITY_TYPE_CLOSING_ORDER_ID",
    ENTITY_TYPE_LEAD_ID = "ENTITY_TYPE_LEAD_ID",
    ENTITY_TYPE_LFS_LOAN_ID = "ENTITY_TYPE_LFS_LOAN_ID",
    ENTITY_TYPE_UNSPECIFIED = "ENTITY_TYPE_UNSPECIFIED",
    ENTITY_TYPE_ZHLUID = "ENTITY_TYPE_ZHLUID"
}
/** A generic clickstream event for a ZHL Experience Event */
export type ZHLExperienceAnalyticClickstreamEvent = ClickstreamMetadata & NeutronAnalyticEvent & {
    __typename: "ZHLExperienceAnalyticClickstreamEvent";
    /** data governance taxonomic name for the event */
    analyticsTag: Scalars["String"];
    /** This block will show key identifying attributes for the event */
    clickstreamEnvelope: ZHLExperienceAnalyticEventClickstreamEnvelope;
    /** This block will show the context-adding attributes that describe where the event was fired */
    clickstreamTriggerBlock: ZHLExperienceAnalyticEventClickstreamTriggerBlock;
    /** The id of the block or module who's interaction is associated with this event */
    id: Scalars["String"];
    /** If a specific new lane block is needed, this will be the name of the block */
    productSpecificBlock: Maybe<Scalars["String"]>;
    /** If a specific new lane block is needed, the data will be provided here and the specific block name will be provided in the productSpecificBlock field */
    productSpecificBlockData: Maybe<Scalars["JSONObject"]>;
    /** This block will describe the event with intentional context along with key tags about the event that is provided by the producer */
    semanticBlock: ZHLExperienceAnalyticEventSemanticBlock;
    /** Stringified version of productSpecificBlockData */
    stringifiedProductSpecificBlockData: Maybe<Scalars["String"]>;
};
/** Represents the envelope block of a clickstream event */
export type ZHLExperienceAnalyticEventClickstreamEnvelope = {
    __typename: "ZHLExperienceAnalyticEventClickstreamEnvelope";
    /** id representing this specific template instrument */
    eventTemplateID: Maybe<Scalars["String"]>;
    /** version number for this template */
    eventTemplateVersionID: Maybe<Scalars["String"]>;
    /** event type this template characterizes */
    eventTypeID: Maybe<Scalars["String"]>;
    /** version number for this event type */
    eventTypeVersionID: Maybe<Scalars["String"]>;
};
/** Represents the trigger block of a clickstream event */
export type ZHLExperienceAnalyticEventClickstreamTriggerBlock = {
    __typename: "ZHLExperienceAnalyticEventClickstreamTriggerBlock";
    /** This is what the display of the website screen is called */
    triggerLocationName: Maybe<Scalars["String"]>;
    /** The object that was interacted with. screen view trigger types will note the render component object. */
    triggerObjectName: Maybe<Scalars["String"]>;
    /** The source of the interaction. screen view trigger types will have a render request trigger source */
    triggerSourceName: Maybe<Scalars["String"]>;
    /** Describes what the event being emitted (taxonomy of trigger action types e.g. submit button, content view) */
    triggerTypeName: ZHLExperienceAnalyticEventClickstreamTriggerType;
};
/** Supported Clickstream Trigger Types */
export enum ZHLExperienceAnalyticEventClickstreamTriggerType {
    /** IMPRESSION maps to the clickstream taxonomic trigger type 'impression' */
    IMPRESSION = "IMPRESSION",
    /** INTERACTION maps to the clickstream taxonomic trigger type 'interaction' */
    INTERACTION = "INTERACTION",
    /** VIEW maps to the clickstream taxonomic trigger type 'view' */
    VIEW = "VIEW"
}
/** Represents the semantic block of a clickstream event */
export type ZHLExperienceAnalyticEventSemanticBlock = {
    __typename: "ZHLExperienceAnalyticEventSemanticBlock";
    /** data governance taxonomic name for the event */
    semanticEventName: Scalars["String"];
    /** Array of topic tags associated with this semantic event | e.g. event may be "view_content" with topic tags "finance", "pre|qualify" characterizing the content */
    topicTagText: Maybe<Array<Scalars["String"]>>;
};
/**
 * Frame Alignments in Android for ZHL Experience Graph Blocks
 * These are determined by what Alignment options are supported by Android Compose
 */
export enum ZHLExperienceAndroidAlignment {
    /** Bottom Vertical Alignment for Content */
    BOTTOM = "BOTTOM",
    /** Bottom Center Alignment for Content (Bottom-Center) */
    BOTTOM_CENTER = "BOTTOM_CENTER",
    /** Bottom End Alignment for Content (Bottom-Right) */
    BOTTOM_END = "BOTTOM_END",
    /** Bottom Start Alignment for Content (Bottom-Left) */
    BOTTOM_START = "BOTTOM_START",
    /** Center Alignment for Content (Center-Center) */
    CENTER = "CENTER",
    /** Center End Alignment for Content (Center-Right) */
    CENTER_END = "CENTER_END",
    /** Center Horizontal Alignment for Content */
    CENTER_HORIZONTALLY = "CENTER_HORIZONTALLY",
    /** Center Start Alignment for Content (Center-Left) */
    CENTER_START = "CENTER_START",
    /** Center Vertical Alignment for Content */
    CENTER_VERTICALLY = "CENTER_VERTICALLY",
    /** End Horizontal Alignment for Content */
    END = "END",
    /** Start Horizontal Alignment for Content */
    START = "START",
    /** Top Vertical Alignment for Content */
    TOP = "TOP",
    /** Top Center Alignment for Content (Top-Center) */
    TOP_CENTER = "TOP_CENTER",
    /** Top End Alignment for Content (Top-Right) */
    TOP_END = "TOP_END",
    /** Top Start Alignment for Content (Top-Left) */
    TOP_START = "TOP_START"
}
/** Icons supported in Android Constellation 8 in ZHL Experience Graph */
export enum ZHLExperienceAndroidConstellation8Icon {
    /** BANK maps to an equivalently named supported Icon from the Constellation foundations */
    BANK = "BANK",
    /** BANK_OUTLINE maps to an equivalently named supported Icon from the Constellation foundations */
    BANK_OUTLINE = "BANK_OUTLINE",
    /** CALCULATOR maps to an equivalently named supported Icon from the Constellation foundations */
    CALCULATOR = "CALCULATOR",
    /** CALCULATOR_OUTLINE maps to an equivalently named supported Icon from the Constellation foundations */
    CALCULATOR_OUTLINE = "CALCULATOR_OUTLINE",
    /** CHECKLIST maps to an equivalently named supported Icon from the Constellation foundations */
    CHECKLIST = "CHECKLIST",
    /** CHECKLIST_OUTLINE maps to an equivalently named supported Icon from the Constellation foundations */
    CHECKLIST_OUTLINE = "CHECKLIST_OUTLINE",
    /** CHECKMARK maps to an equivalently named supported Icon from the Constellation foundations */
    CHECKMARK = "CHECKMARK",
    /** CHECKMARK_CIRCLE maps to an equivalently named supported Icon from the Constellation foundations */
    CHECKMARK_CIRCLE = "CHECKMARK_CIRCLE",
    /** CHECKMARK_CIRCLE_OUTLINE maps to an equivalently named supported Icon from the Constellation foundations */
    CHECKMARK_CIRCLE_OUTLINE = "CHECKMARK_CIRCLE_OUTLINE",
    /** CHEVRON_RIGHT maps to an equivalently named supported Icon from the Constellation foundations */
    CHEVRON_RIGHT = "CHEVRON_RIGHT",
    /** CREDIT_SCORE maps to an equivalently named supported Icon from the Constellation foundations */
    CREDIT_SCORE = "CREDIT_SCORE",
    /** CREDIT_SCORE_OUTLINE maps to an equivalently named supported Icon from the Constellation foundations */
    CREDIT_SCORE_OUTLINE = "CREDIT_SCORE_OUTLINE",
    /** DELETE maps to an equivalently named supported Icon from the Constellation foundations */
    DELETE = "DELETE",
    /** DOLLAR_SIGN_CIRCLE maps to an equivalently named Icon from the Constellation foundations */
    DOLLAR_SIGN_CIRCLE = "DOLLAR_SIGN_CIRCLE",
    /** DOLLAR_SIGN_CIRCLE_OUTLINE maps to an equivalently named Icon from the Constellation foundations */
    DOLLAR_SIGN_CIRCLE_OUTLINE = "DOLLAR_SIGN_CIRCLE_OUTLINE",
    /** FILE maps to an equivalently named supported Icon from the Constellation foundations */
    FILE = "FILE",
    /** FILE_OUTLINE maps to an equivalently named supported Icon from the Constellation foundations */
    FILE_OUTLINE = "FILE_OUTLINE",
    /** INFO maps to an equivalent icon available from the Constellation foundations */
    INFO = "INFO",
    /** INFO_OUTLINE maps to an equivalent icon available from the Constellation foundations */
    INFO_OUTLINE = "INFO_OUTLINE",
    /** LOCK maps to an equivalently named supported Icon from the Constellation foundations */
    LOCK = "LOCK",
    /** MAIL maps to an equivalently named supported Icon from the Constellation foundations */
    MAIL = "MAIL",
    /** MAIL_OUTLINE maps to an equivalently named supported Icon from the Constellation foundations */
    MAIL_OUTLINE = "MAIL_OUTLINE",
    /** MY_HOME maps to an equivalently named Component from the Constellation foundations */
    MY_HOME = "MY_HOME",
    /** MY_HOME_OUTLINE maps to an equivalently named Component from the Constellation foundations */
    MY_HOME_OUTLINE = "MY_HOME_OUTLINE",
    /** PIGGY maps to an equivalently named supported Icon from the Constellation foundations */
    PIGGY = "PIGGY",
    /** PIGGY_OUTLINE maps to an equivalently named supported Icon from the Constellation foundations */
    PIGGY_OUTLINE = "PIGGY_OUTLINE",
    /** PLUS_OUTLINE maps to an equivalently named supported Icon from the Constellation foundations */
    PLUS_OUTLINE = "PLUS_OUTLINE",
    /** SORT_ASCENDING maps to an equivalently named supported Icon from the Constellation foundations */
    SORT_ASCENDING = "SORT_ASCENDING",
    /** TARGET maps to an equivalently named supported Icon from the Constellation foundations */
    TARGET = "TARGET",
    /** TARGET_OUTLINE maps to an equivalently named supported Icon from the Constellation foundations */
    TARGET_OUTLINE = "TARGET_OUTLINE",
    /** TRENDING maps to an equivalently named supported Icon from the Constellation foundations */
    TRENDING = "TRENDING",
    /** TRENDING_OUTLINE maps to an equivalently named supported Icon from the Constellation foundations */
    TRENDING_OUTLINE = "TRENDING_OUTLINE",
    /** UPLOAD_OUTLINE maps to an equivalently named supported Icon from the Constellation foundations */
    UPLOAD_OUTLINE = "UPLOAD_OUTLINE",
    /** USER maps to an equivalently named Component from the Constellation foundations */
    USER = "USER",
    /** USER_OUTLINE maps to an equivalently named Component from the Constellation foundations */
    USER_OUTLINE = "USER_OUTLINE",
    /** WARNING maps to an equivalently named supported Icon from the Constellation foundations */
    WARNING = "WARNING"
}
/**
 * ZHL Experience Android Block
 * - Implementation of the ZHLExperienceIcon, for rendering an icon with Constellation Android
 */
export type ZHLExperienceAndroidIcon = NeutronBlock & {
    __typename: "ZHLExperienceAndroidIcon";
    /** The configuration for the icon */
    configuration: ZHLExperienceAndroidIconConfiguration;
    /** Necessary for wiring actions to this block, and for client-side identity-based UI diffing for partial updates */
    id: Scalars["String"];
};
/** Supported configurations for the Icon block in Android for ZHL Experience Graph */
export type ZHLExperienceAndroidIconConfiguration = ZHLExperienceAndroidIconConstellation8Configuration;
/** Configuration for an icon with Android Constellation 8 for ZHL Experience Graph */
export type ZHLExperienceAndroidIconConstellation8Configuration = {
    __typename: "ZHLExperienceAndroidIconConstellation8Configuration";
    /** What constellation version this configuration is for. Should be Android_8 */
    constellationVersion: ZHLExperienceConstellationVersion;
    /** What Icon to render */
    icon: ZHLExperienceAndroidConstellation8Icon;
    /** What platform this configuration is for. Should be Android */
    platform: ZHLExperiencePlatformType;
    /** The size of the icon */
    size: Maybe<NeutronAndroidConstellation8IconSize>;
    /** What tint color to apply to the icon. Maps to an enum that can be leveraged with a view modifier */
    tintColor: Maybe<NeutronAndroidConstellation8IconColor>;
};
/**
 * ZHL Experience Android Block
 * - Implements the underlined navigation / phone link component in Android
 */
export type ZHLExperienceAndroidLink = NeutronBlock & {
    __typename: "ZHLExperienceAndroidLink";
    /** The configuration for the link, in a specific Constellation version dictated by the requested constellation version */
    configuration: ZHLExperienceAndroidLinkConfiguration;
    /** The text content of the link */
    content: Scalars["String"];
    /** Necessary for wiring actions to this block, and for client-side identity-based UI diffing for partial updates */
    id: Scalars["String"];
    /** The resource to navigate to when the link is clicked */
    resource: Scalars["String"];
};
/** Supported Android configurations for links in ZHL Experience Graph */
export type ZHLExperienceAndroidLinkConfiguration = ZHLExperienceAndroidLinkConstellation8Configuration;
/**
 * ZHL Experience Android Block Configuration
 * - Provides the configuration for an Anchor component in Constellation 8 Android
 */
export type ZHLExperienceAndroidLinkConstellation8Configuration = {
    __typename: "ZHLExperienceAndroidLinkConstellation8Configuration";
    /** The constellation version this configuration is intended for. Should be WEB_8 */
    constellationVersion: ZHLExperienceConstellationVersion;
    /** The platform this configuration is intended for. Should be WEB */
    platform: ZHLExperiencePlatformType;
};
/**
 * ZHL Experience Android Block
 * - Implements the Heading and Text components in Constellation
 */
export type ZHLExperienceAndroidText = NeutronBlock & {
    __typename: "ZHLExperienceAndroidText";
    /**
     * The configuration for the text, in a specific Constellation version dictated by the requested constellation version
     *
     * If there are embedded blocks, this will still be provided but the configuration for each embedded block should take precedence over this configuration
     */
    configuration: ZHLExperienceAndroidTextConfiguration;
    /**
     * The raw text content to display. This will always be a markdown string, however where possible, the configuration options
     * will be used to set the whole text as bold, italics, or underlined. Therefore clients should parse the text as markdown and render it,
     * then additionally set the configuration options to ensure the string renders correctly
     */
    content: Scalars["String"];
    /**
     * If this text should have embedded blocks in it (such as navigation links, tooltips, etc.), this will contain the text laid out
     * as a left to right list of blocks, with either Text elements or the other embedded blocks, such that if rendered left to right, they form
     * the content with the embedded blocks placed in the correct locations within the text
     */
    contentWithEmbeddedBlocks: Maybe<Array<ZHLExperienceAndroidTextEmbeddableBlocks>>;
    /** Necessary for wiring actions to this block, and for client-side identity-based UI diffing for partial updates */
    id: Scalars["String"];
};
/** Supported Android configurations for text */
export type ZHLExperienceAndroidTextConfiguration = ZHLExperienceAndroidTextConstellation8Configuration;
/**
 * ZHL Experience Android Block Configuration
 * - Provides the configuration for a Text or Paragraph component in Constellation 8 Android
 */
export type ZHLExperienceAndroidTextConstellation8Configuration = {
    __typename: "ZHLExperienceAndroidTextConstellation8Configuration";
    /** Which alignment view modifier to apply to the text */
    alignment: ZHLExperienceAndroidAlignment;
    /** The constellation version this configuration is intended for. Should be ANDROID_8 */
    constellationVersion: ZHLExperienceConstellationVersion;
    /** Indicates whether the text should be given the semantic meaning of a heading. */
    isAccessibilityHeading: Scalars["Boolean"];
    /** The platform this configuration is intended for. Should be Android */
    platform: ZHLExperiencePlatformType;
    /** Which typography view modifier to apply to the text */
    typography: Maybe<NeutronAndroidConstellation8Typography>;
};
/** Android Blocks that can be intermixed within a rich text block that contains other embedded blocks */
export type ZHLExperienceAndroidTextEmbeddableBlocks = ZHLExperienceAndroidIcon | ZHLExperienceAndroidLink | ZHLExperienceAndroidText;
/**
 * This enum describes the constellation versions that ZHL Experience Graph supports, and will
 * tailor responses to fit. For queries that return a union of the platform responses, all platform unions _except_
 * for the one matching the requested constellation version will be null.
 */
export enum ZHLExperienceConstellationVersion {
    /**
     * Android Constellation 8 + Material UI
     *
     * Specific Minor/Patch Versions changes are supported on a needs basis as a non-breaking addition to the XPG contract
     */
    ANDROID_8 = "ANDROID_8",
    /**
     * IOS Constellation 8 + current Apple SDK API.
     *
     * Specific Minor/Patch Versions changes are supported on a needs basis as a non-breaking addition to the XPG contract
     */
    IOS_8 = "IOS_8",
    /**
     * Web Constellation 8 + Styled Components API + React
     *
     * Specific Minor/Patch Versions changes are supported on a needs basis as a non-breaking addition to the XPG contract
     */
    WEB_8 = "WEB_8",
    /**
     * Web Constellation 10 Alpha + Panda CSS API + React
     *
     * Specific Minor/Patch Versions changes are supported on a needs basis as a non-breaking addition to the XPG contract
     */
    WEB_10_ALPHA = "WEB_10_ALPHA"
}
/**
 * ZHL Experience Action
 *
 * Represents an action to perform a destructive operation that the user should be prompted to confirm.
 *
 * Only destructive operations that can be "thunked" (ergo, pre-planned and don't need a payload) are supported
 */
export type ZHLExperienceDestructiveOperationAction = NeutronAction & {
    __typename: "ZHLExperienceDestructiveOperationAction";
    /** Must match the id for the corresponding block */
    id: Scalars["String"];
    /** Which destructive operation to perform */
    operationToPerform: ZHLExperienceSupportedDestructiveOperation;
};
/** Represents the flow direction of a layout section in ZHL Experience Graph */
export enum ZHLExperienceFlowDirection {
    HORIZONTAL = "HORIZONTAL",
    VERTICAL = "VERTICAL"
}
/** An action describing that the user should be able to contact the contact card owner */
export type ZHLExperienceGetInTouchAction = NeutronAction & {
    __typename: "ZHLExperienceGetInTouchAction";
    /** The phone number or email address */
    contactResource: Scalars["String"];
    /** What type of contact method is supported by the resource */
    contactType: ZHLExperienceGetInTouchActionContactType;
    /** Must match the id for the corresponding block */
    id: Scalars["String"];
};
/** Supported contact methods in ZHL Experience Graph */
export enum ZHLExperienceGetInTouchActionContactType {
    /** The user can/should call the contact resource */
    CALL = "CALL",
    /** The user can/should call or text the contact resource */
    CALL_OR_TEXT = "CALL_OR_TEXT",
    /** The user can/should email the contact resource */
    EMAIL = "EMAIL"
}
/**
 * Represents the base contract for a layout in ZHL Experience Graph
 *
 * - Layouts leverage the box model and the grid layout model to declaratively describe the final state of the layout,
 * and allow the clients to handle how to translate that description to a final rendered layout.
 */
export type ZHLExperienceGraphLayout = {
    /** The number of columns in the layout */
    numberOfColumns: Scalars["Int"];
    /** Sections reserved for a module or block within the layout */
    sections: Array<ZHLExperienceGraphLayoutSection>;
};
/**
 * Represents the base contract for a layout section in ZHL Experience Graph
 * - LayoutSections are an individual grid square in the layout grid, which contains a Module or Block
 *   (depending on whether the Layout is for the Experience or Module respectively), and can be
 *   described by the row it resides on, and how many columns it consumes.
 */
export type ZHLExperienceGraphLayoutSection = {
    /** Represents how many columns this section spans. Must always be less than or equal to the total number of columns */
    columnSpan: Scalars["Int"];
    /** Optional margin around the block or module content, described using the Box model */
    margin: Maybe<ZHLExperienceSpacing>;
    /** Optional padding around the block or module content, described using the Box model */
    padding: Maybe<ZHLExperienceSpacing>;
};
/**
 * Frame Alignments in iOS for ZHL Experience Graph Blocks
 * These are determined by what ViewModfier options are supported by iOS
 */
export enum ZHLExperienceIOSAlignment {
    /** Bottom Alignment for Content */
    BOTTOM = "BOTTOM",
    /** Bottom Leading Alignment for Content */
    BOTTOM_LEADING = "BOTTOM_LEADING",
    /** Bottom Trailingg for Content */
    BOTTOM_TRAILING = "BOTTOM_TRAILING",
    /** Centered Alignment for Content */
    CENTER = "CENTER",
    /** Leading Alignment for Content */
    LEADING = "LEADING",
    /** Leading Last Text Alignment for Content */
    LEADING_LAST_TEXT_BASELINE = "LEADING_LAST_TEXT_BASELINE",
    /** Top Alignment for Content */
    TOP = "TOP",
    /** Top Leading Alignment for Content */
    TOP_LEADING = "TOP_LEADING",
    /** Top Trailing Alignment for Content */
    TOP_TRAILING = "TOP_TRAILING",
    /** Trailing Alignment for Content */
    TRAILING = "TRAILING",
    /** Trailing Last Text Alignment for Content */
    TRAILING_LAST_TEXT_BASELINE = "TRAILING_LAST_TEXT_BASELINE"
}
/** Icons supported in iOS Constellation 8 in ZHL Experience Graph */
export enum ZHLExperienceIOSConstellation8Icon {
    /** AIR_CONDITIONING maps to an equivalently named supported Icon from the Constellation foundations */
    AIR_CONDITIONING = "AIR_CONDITIONING",
    /** AIR_QUALITY maps to an equivalently named supported Icon from the Constellation foundations */
    AIR_QUALITY = "AIR_QUALITY",
    /** ANDROID_SHARE maps to an equivalently named supported Icon from the Constellation foundations */
    ANDROID_SHARE = "ANDROID_SHARE",
    /** ARCHIVE maps to an equivalently named supported Icon from the Constellation foundations */
    ARCHIVE = "ARCHIVE",
    /** ARROW_DOWN maps to an equivalently named supported Icon from the Constellation foundations */
    ARROW_DOWN = "ARROW_DOWN",
    /** ARROW_DOWN_CIRCLE maps to an equivalently named supported Icon from the Constellation foundations */
    ARROW_DOWN_CIRCLE = "ARROW_DOWN_CIRCLE",
    /** ARROW_LEFT maps to an equivalently named supported Icon from the Constellation foundations */
    ARROW_LEFT = "ARROW_LEFT",
    /** ARROW_LEFT_CIRCLE maps to an equivalently named supported Icon from the Constellation foundations */
    ARROW_LEFT_CIRCLE = "ARROW_LEFT_CIRCLE",
    /** ARROW_RIGHT maps to an equivalently named supported Icon from the Constellation foundations */
    ARROW_RIGHT = "ARROW_RIGHT",
    /** ARROW_RIGHT_CIRCLE maps to an equivalently named supported Icon from the Constellation foundations */
    ARROW_RIGHT_CIRCLE = "ARROW_RIGHT_CIRCLE",
    /** ARROW_UP maps to an equivalently named supported Icon from the Constellation foundations */
    ARROW_UP = "ARROW_UP",
    /** ARROW_UP_CIRCLE maps to an equivalently named supported Icon from the Constellation foundations */
    ARROW_UP_CIRCLE = "ARROW_UP_CIRCLE",
    /** ASK_QUESTION maps to an equivalently named supported Icon from the Constellation foundations */
    ASK_QUESTION = "ASK_QUESTION",
    /** AWARD_RIBBON maps to an equivalently named supported Icon from the Constellation foundations */
    AWARD_RIBBON = "AWARD_RIBBON",
    /** BANK maps to an equivalently named supported Icon from the Constellation foundations */
    BANK = "BANK",
    /** BANK_OUTLINE maps to an equivalently named supported Icon from the Constellation foundations */
    BANK_OUTLINE = "BANK_OUTLINE",
    /** BASKETBALL maps to an equivalently named supported Icon from the Constellation foundations */
    BASKETBALL = "BASKETBALL",
    /** BATH maps to an equivalently named supported Icon from the Constellation foundations */
    BATH = "BATH",
    /** BATTERY_FULL maps to an equivalently named supported Icon from the Constellation foundations */
    BATTERY_FULL = "BATTERY_FULL",
    /** BATTERY_HALF maps to an equivalently named supported Icon from the Constellation foundations */
    BATTERY_HALF = "BATTERY_HALF",
    /** BATTERY_LOW maps to an equivalently named supported Icon from the Constellation foundations */
    BATTERY_LOW = "BATTERY_LOW",
    /** BEAUTY_PRODUCTS maps to an equivalently named supported Icon from the Constellation foundations */
    BEAUTY_PRODUCTS = "BEAUTY_PRODUCTS",
    /** BED maps to an equivalently named supported Icon from the Constellation foundations */
    BED = "BED",
    /** BELL maps to an equivalently named supported Icon from the Constellation foundations */
    BELL = "BELL",
    /** BIKE maps to an equivalently named supported Icon from the Constellation foundations */
    BIKE = "BIKE",
    /** BLUEPRINT maps to an equivalently named supported Icon from the Constellation foundations */
    BLUEPRINT = "BLUEPRINT",
    /** BROKEN_LINK maps to an equivalently named supported Icon from the Constellation foundations */
    BROKEN_LINK = "BROKEN_LINK",
    /** BUILDING maps to an equivalently named supported Icon from the Constellation foundations */
    BUILDING = "BUILDING",
    /** BUILDINGS maps to an equivalently named supported Icon from the Constellation foundations */
    BUILDINGS = "BUILDINGS",
    /** BULB maps to an equivalently named supported Icon from the Constellation foundations */
    BULB = "BULB",
    /** BUS maps to an equivalently named supported Icon from the Constellation foundations */
    BUS = "BUS",
    /** BUS_SIDE maps to an equivalently named supported Icon from the Constellation foundations */
    BUS_SIDE = "BUS_SIDE",
    /** CALCULATOR maps to an equivalently named supported Icon from the Constellation foundations */
    CALCULATOR = "CALCULATOR",
    /** CALCULATOR_OUTLINE maps to an equivalently named supported Icon from the Constellation foundations */
    CALCULATOR_OUTLINE = "CALCULATOR_OUTLINE",
    /** CALENDAR maps to an equivalently named supported Icon from the Constellation foundations */
    CALENDAR = "CALENDAR",
    /** CALENDAR_TIME maps to an equivalently named supported Icon from the Constellation foundations */
    CALENDAR_TIME = "CALENDAR_TIME",
    /** CAMERA maps to an equivalently named supported Icon from the Constellation foundations */
    CAMERA = "CAMERA",
    /** CAMERA_EXPOSURE maps to an equivalently named supported Icon from the Constellation foundations */
    CAMERA_EXPOSURE = "CAMERA_EXPOSURE",
    /** CAMERA_GRID maps to an equivalently named supported Icon from the Constellation foundations */
    CAMERA_GRID = "CAMERA_GRID",
    /** CAMERA_SHUTTER maps to an equivalently named supported Icon from the Constellation foundations */
    CAMERA_SHUTTER = "CAMERA_SHUTTER",
    /** CAR maps to an equivalently named supported Icon from the Constellation foundations */
    CAR = "CAR",
    /** CART maps to an equivalently named supported Icon from the Constellation foundations */
    CART = "CART",
    /** CAR_SIDE maps to an equivalently named supported Icon from the Constellation foundations */
    CAR_SIDE = "CAR_SIDE",
    /** CHECKLIST maps to an equivalently named supported Icon from the Constellation foundations */
    CHECKLIST = "CHECKLIST",
    /** CHECKLIST_OUTLINE maps to an equivalently named supported Icon from the Constellation foundations */
    CHECKLIST_OUTLINE = "CHECKLIST_OUTLINE",
    /** CHECKMARK maps to an equivalently named supported Icon from the Constellation foundations */
    CHECKMARK = "CHECKMARK",
    /** CHECKMARK_CIRCLE maps to an equivalently named supported Icon from the Constellation foundations */
    CHECKMARK_CIRCLE = "CHECKMARK_CIRCLE",
    /** CHEVRON_DOWN maps to an equivalently named supported Icon from the Constellation foundations */
    CHEVRON_DOWN = "CHEVRON_DOWN",
    /** CHEVRON_DOWN_CIRCLE maps to an equivalently named supported Icon from the Constellation foundations */
    CHEVRON_DOWN_CIRCLE = "CHEVRON_DOWN_CIRCLE",
    /** CHEVRON_LEFT maps to an equivalently named supported Icon from the Constellation foundations */
    CHEVRON_LEFT = "CHEVRON_LEFT",
    /** CHEVRON_LEFT_CIRCLE maps to an equivalently named supported Icon from the Constellation foundations */
    CHEVRON_LEFT_CIRCLE = "CHEVRON_LEFT_CIRCLE",
    /** CHEVRON_RIGHT maps to an equivalently named supported Icon from the Constellation foundations */
    CHEVRON_RIGHT = "CHEVRON_RIGHT",
    /** CHEVRON_RIGHT_CIRCLE maps to an equivalently named supported Icon from the Constellation foundations */
    CHEVRON_RIGHT_CIRCLE = "CHEVRON_RIGHT_CIRCLE",
    /** CHEVRON_UP maps to an equivalently named supported Icon from the Constellation foundations */
    CHEVRON_UP = "CHEVRON_UP",
    /** CHEVRON_UP_CIRCLE maps to an equivalently named supported Icon from the Constellation foundations */
    CHEVRON_UP_CIRCLE = "CHEVRON_UP_CIRCLE",
    /** CHEVRON_UP_DOWN maps to an equivalently named supported Icon from the Constellation foundations */
    CHEVRON_UP_DOWN = "CHEVRON_UP_DOWN",
    /** CIRCLE maps to an equivalently named supported Icon from the Constellation foundations */
    CIRCLE = "CIRCLE",
    /** CLOCK maps to an equivalently named supported Icon from the Constellation foundations */
    CLOCK = "CLOCK",
    /** CLOSE maps to an equivalently named supported Icon from the Constellation foundations */
    CLOSE = "CLOSE",
    /** CLOSE_CIRCLE maps to an equivalently named supported Icon from the Constellation foundations */
    CLOSE_CIRCLE = "CLOSE_CIRCLE",
    /** COG maps to an equivalently named supported Icon from the Constellation foundations */
    COG = "COG",
    /** COMMUNITY maps to an equivalently named supported Icon from the Constellation foundations */
    COMMUNITY = "COMMUNITY",
    /** COMPARABLE_HOMES maps to an equivalently named supported Icon from the Constellation foundations */
    COMPARABLE_HOMES = "COMPARABLE_HOMES",
    /** COMPASS maps to an equivalently named supported Icon from the Constellation foundations */
    COMPASS = "COMPASS",
    /** COPY maps to an equivalently named supported Icon from the Constellation foundations */
    COPY = "COPY",
    /** CREDIT_SCORE maps to an equivalently named supported Icon from the Constellation foundations */
    CREDIT_SCORE = "CREDIT_SCORE",
    /** CREDIT_SCORE_OUTLINE maps to an equivalently named supported Icon from the Constellation foundations */
    CREDIT_SCORE_OUTLINE = "CREDIT_SCORE_OUTLINE",
    /** CROWN maps to an equivalently named supported Icon from the Constellation foundations */
    CROWN = "CROWN",
    /** DELETE maps to an equivalently named supported Icon from the Constellation foundations */
    DELETE = "DELETE",
    /** DINING_ROOM maps to an equivalently named supported Icon from the Constellation foundations */
    DINING_ROOM = "DINING_ROOM",
    /** DOLLAR_SIGN_CIRCLE maps to an equivalently named supported Icon from the Constellation foundations */
    DOLLAR_SIGN_CIRCLE = "DOLLAR_SIGN_CIRCLE",
    /** DOLLAR_SIGN_CIRCLE_OUTLINE maps to an equivalently named supported Icon from the Constellation foundations */
    DOLLAR_SIGN_CIRCLE_OUTLINE = "DOLLAR_SIGN_CIRCLE_OUTLINE",
    /** DOOR_OPEN maps to an equivalently named supported Icon from the Constellation foundations */
    DOOR_OPEN = "DOOR_OPEN",
    /** DOWNLOAD maps to an equivalently named supported Icon from the Constellation foundations */
    DOWNLOAD = "DOWNLOAD",
    /** DRAG maps to an equivalently named supported Icon from the Constellation foundations */
    DRAG = "DRAG",
    /** DRAW maps to an equivalently named supported Icon from the Constellation foundations */
    DRAW = "DRAW",
    /** DRIVING_DIRECTION maps to an equivalently named supported Icon from the Constellation foundations */
    DRIVING_DIRECTION = "DRIVING_DIRECTION",
    /** EDIT maps to an equivalently named supported Icon from the Constellation foundations */
    EDIT = "EDIT",
    /** EDIT_FORM maps to an equivalently named supported Icon from the Constellation foundations */
    EDIT_FORM = "EDIT_FORM",
    /** EHO maps to an equivalently named supported Icon from the Constellation foundations */
    EHO = "EHO",
    /** EXCLAMATION_CIRCLE maps to an equivalently named supported Icon from the Constellation foundations */
    EXCLAMATION_CIRCLE = "EXCLAMATION_CIRCLE",
    /** EXPAND maps to an equivalently named supported Icon from the Constellation foundations */
    EXPAND = "EXPAND",
    /** EYE_CLOSED maps to an equivalently named supported Icon from the Constellation foundations */
    EYE_CLOSED = "EYE_CLOSED",
    /** EYE_OPEN maps to an equivalently named supported Icon from the Constellation foundations */
    EYE_OPEN = "EYE_OPEN",
    /** FACE_HAPPY maps to an equivalently named supported Icon from the Constellation foundations */
    FACE_HAPPY = "FACE_HAPPY",
    /** FACE_OK maps to an equivalently named supported Icon from the Constellation foundations */
    FACE_OK = "FACE_OK",
    /** FACE_UNHAPPY maps to an equivalently named supported Icon from the Constellation foundations */
    FACE_UNHAPPY = "FACE_UNHAPPY",
    /** FACE_VERY_HAPPY maps to an equivalently named supported Icon from the Constellation foundations */
    FACE_VERY_HAPPY = "FACE_VERY_HAPPY",
    /** FACE_VERY_UNHAPPY maps to an equivalently named supported Icon from the Constellation foundations */
    FACE_VERY_UNHAPPY = "FACE_VERY_UNHAPPY",
    /** FACTS_FEATURES maps to an equivalently named supported Icon from the Constellation foundations */
    FACTS_FEATURES = "FACTS_FEATURES",
    /** FAVORITE_HOME maps to an equivalently named supported Icon from the Constellation foundations */
    FAVORITE_HOME = "FAVORITE_HOME",
    /** FILE maps to an equivalently named supported Icon from the Constellation foundations */
    FILE = "FILE",
    /** FILE_CSV maps to an equivalently named supported Icon from the Constellation foundations */
    FILE_CSV = "FILE_CSV",
    /** FILE_OUTLINE maps to an equivalently named supported Icon from the Constellation foundations */
    FILE_OUTLINE = "FILE_OUTLINE",
    /** FILE_PDF maps to an equivalently named supported Icon from the Constellation foundations */
    FILE_PDF = "FILE_PDF",
    /** FILE_SPREADSHEET maps to an equivalently named supported Icon from the Constellation foundations */
    FILE_SPREADSHEET = "FILE_SPREADSHEET",
    /** FILE_TEXT maps to an equivalently named supported Icon from the Constellation foundations */
    FILE_TEXT = "FILE_TEXT",
    /** FINGER_DRAW maps to an equivalently named supported Icon from the Constellation foundations */
    FINGER_DRAW = "FINGER_DRAW",
    /** FIRE maps to an equivalently named supported Icon from the Constellation foundations */
    FIRE = "FIRE",
    /** FIREPLACE maps to an equivalently named supported Icon from the Constellation foundations */
    FIREPLACE = "FIREPLACE",
    /** FLAG maps to an equivalently named supported Icon from the Constellation foundations */
    FLAG = "FLAG",
    /** FLAG_SWALLOWTAIL maps to an equivalently named supported Icon from the Constellation foundations */
    FLAG_SWALLOWTAIL = "FLAG_SWALLOWTAIL",
    /** FLOOD maps to an equivalently named supported Icon from the Constellation foundations */
    FLOOD = "FLOOD",
    /** FOLDER maps to an equivalently named supported Icon from the Constellation foundations */
    FOLDER = "FOLDER",
    /** FULL_SCREEN maps to an equivalently named supported Icon from the Constellation foundations */
    FULL_SCREEN = "FULL_SCREEN",
    /** GAS_STATION maps to an equivalently named supported Icon from the Constellation foundations */
    GAS_STATION = "GAS_STATION",
    /** GIFT maps to an equivalently named supported Icon from the Constellation foundations */
    GIFT = "GIFT",
    /** GLOBE maps to an equivalently named supported Icon from the Constellation foundations */
    GLOBE = "GLOBE",
    /** GRADUATION_CAP maps to an equivalently named supported Icon from the Constellation foundations */
    GRADUATION_CAP = "GRADUATION_CAP",
    /** GRID maps to an equivalently named supported Icon from the Constellation foundations */
    GRID = "GRID",
    /** HAMMER maps to an equivalently named supported Icon from the Constellation foundations */
    HAMMER = "HAMMER",
    /** HANGER maps to an equivalently named supported Icon from the Constellation foundations */
    HANGER = "HANGER",
    /** HDR maps to an equivalently named supported Icon from the Constellation foundations */
    HDR = "HDR",
    /** HEART maps to an equivalently named supported Icon from the Constellation foundations */
    HEART = "HEART",
    /** HEAT maps to an equivalently named supported Icon from the Constellation foundations */
    HEAT = "HEAT",
    /** HEATING maps to an equivalently named supported Icon from the Constellation foundations */
    HEATING = "HEATING",
    /** HELP maps to an equivalently named supported Icon from the Constellation foundations */
    HELP = "HELP",
    /** HIDE maps to an equivalently named supported Icon from the Constellation foundations */
    HIDE = "HIDE",
    /** HOA maps to an equivalently named supported Icon from the Constellation foundations */
    HOA = "HOA",
    /** HOME_SIMILAR maps to an equivalently named supported Icon from the Constellation foundations */
    HOME_SIMILAR = "HOME_SIMILAR",
    /** HOSPITAL maps to an equivalently named supported Icon from the Constellation foundations */
    HOSPITAL = "HOSPITAL",
    /** HOUSE maps to an equivalently named supported Icon from the Constellation foundations */
    HOUSE = "HOUSE",
    /** HOUSE_TIME maps to an equivalently named supported Icon from the Constellation foundations */
    HOUSE_TIME = "HOUSE_TIME",
    /** HOUSE_TYPE maps to an equivalently named supported Icon from the Constellation foundations */
    HOUSE_TYPE = "HOUSE_TYPE",
    /** INBOX maps to an equivalently named supported Icon from the Constellation foundations */
    INBOX = "INBOX",
    /** INFO maps to an equivalent icon available from the Constellation foundations */
    INFO = "INFO",
    /** INFO_OUTLINE maps to an equivalent icon available from the Constellation foundations */
    INFO_OUTLINE = "INFO_OUTLINE",
    /** ISO maps to an equivalently named supported Icon from the Constellation foundations */
    ISO = "ISO",
    /** KEY maps to an equivalently named supported Icon from the Constellation foundations */
    KEY = "KEY",
    /** KEYBOARD maps to an equivalently named supported Icon from the Constellation foundations */
    KEYBOARD = "KEYBOARD",
    /** LAPTOP maps to an equivalently named supported Icon from the Constellation foundations */
    LAPTOP = "LAPTOP",
    /** LAUNDRY maps to an equivalently named supported Icon from the Constellation foundations */
    LAUNDRY = "LAUNDRY",
    /** LAYERS maps to an equivalently named supported Icon from the Constellation foundations */
    LAYERS = "LAYERS",
    /** LEAF maps to an equivalently named supported Icon from the Constellation foundations */
    LEAF = "LEAF",
    /** LIGHTNING_BOLT maps to an equivalently named supported Icon from the Constellation foundations */
    LIGHTNING_BOLT = "LIGHTNING_BOLT",
    /** LINK maps to an equivalently named supported Icon from the Constellation foundations */
    LINK = "LINK",
    /** LIST maps to an equivalently named supported Icon from the Constellation foundations */
    LIST = "LIST",
    /** LISTING_PRICE maps to an equivalently named supported Icon from the Constellation foundations */
    LISTING_PRICE = "LISTING_PRICE",
    /** LIST_BULLETED maps to an equivalently named supported Icon from the Constellation foundations */
    LIST_BULLETED = "LIST_BULLETED",
    /** LIST_NUMBERED maps to an equivalently named supported Icon from the Constellation foundations */
    LIST_NUMBERED = "LIST_NUMBERED",
    /** LIVING_ROOM maps to an equivalently named supported Icon from the Constellation foundations */
    LIVING_ROOM = "LIVING_ROOM",
    /** LOCATION maps to an equivalently named supported Icon from the Constellation foundations */
    LOCATION = "LOCATION",
    /** LOCATION_ARROW maps to an equivalently named supported Icon from the Constellation foundations */
    LOCATION_ARROW = "LOCATION_ARROW",
    /** LOCK maps to an equivalently named supported Icon from the Constellation foundations */
    LOCK = "LOCK",
    /** LOT maps to an equivalently named supported Icon from the Constellation foundations */
    LOT = "LOT",
    /** MAIL maps to an equivalently named supported Icon from the Constellation foundations */
    MAIL = "MAIL",
    /** MAP maps to an equivalently named supported Icon from the Constellation foundations */
    MAP = "MAP",
    /** MAP_DRAW maps to an equivalently named supported Icon from the Constellation foundations */
    MAP_DRAW = "MAP_DRAW",
    /** MARTINI_GLASS maps to an equivalently named supported Icon from the Constellation foundations */
    MARTINI_GLASS = "MARTINI_GLASS",
    /** MENU maps to an equivalently named supported Icon from the Constellation foundations */
    MENU = "MENU",
    /** MESSAGE maps to an equivalently named supported Icon from the Constellation foundations */
    MESSAGE = "MESSAGE",
    /** MESSAGE_HEART maps to an equivalently named supported Icon from the Constellation foundations */
    MESSAGE_HEART = "MESSAGE_HEART",
    /** MIC maps to an equivalently named supported Icon from the Constellation foundations */
    MIC = "MIC",
    /** MINIMIZE maps to an equivalently named supported Icon from the Constellation foundations */
    MINIMIZE = "MINIMIZE",
    /** MINUS maps to an equivalently named supported Icon from the Constellation foundations */
    MINUS = "MINUS",
    /** MINUS_CIRCLE maps to an equivalently named supported Icon from the Constellation foundations */
    MINUS_CIRCLE = "MINUS_CIRCLE",
    /** MLS maps to an equivalently named supported Icon from the Constellation foundations */
    MLS = "MLS",
    /** MONITOR maps to an equivalently named supported Icon from the Constellation foundations */
    MONITOR = "MONITOR",
    /** MORE maps to an equivalently named supported Icon from the Constellation foundations */
    MORE = "MORE",
    /** MOUSE maps to an equivalently named supported Icon from the Constellation foundations */
    MOUSE = "MOUSE",
    /** MUG maps to an equivalently named supported Icon from the Constellation foundations */
    MUG = "MUG",
    /** MY_HOME maps to an equivalently named Component in Constellation 8 */
    MY_HOME = "MY_HOME",
    /** MY_HOME_OUTLINE maps to an equivalently named Component in Constellation 8 */
    MY_HOME_OUTLINE = "MY_HOME_OUTLINE",
    /** NEIGHBORHOOD maps to an equivalently named supported Icon from the Constellation foundations */
    NEIGHBORHOOD = "NEIGHBORHOOD",
    /** NEW_TEAM_MEMBER maps to an equivalently named supported Icon from the Constellation foundations */
    NEW_TEAM_MEMBER = "NEW_TEAM_MEMBER",
    /** NOTE maps to an equivalently named supported Icon from the Constellation foundations */
    NOTE = "NOTE",
    /** NOTE_PLUS maps to an equivalently named supported Icon from the Constellation foundations */
    NOTE_PLUS = "NOTE_PLUS",
    /** PANORAMA maps to an equivalently named supported Icon from the Constellation foundations */
    PANORAMA = "PANORAMA",
    /** PANORAMA360 maps to an equivalently named supported Icon from the Constellation foundations */
    PANORAMA360 = "PANORAMA360",
    /** PARKING maps to an equivalently named supported Icon from the Constellation foundations */
    PARKING = "PARKING",
    /** PASTE maps to an equivalently named supported Icon from the Constellation foundations */
    PASTE = "PASTE",
    /** PATIO maps to an equivalently named supported Icon from the Constellation foundations */
    PATIO = "PATIO",
    /** PAUSE maps to an equivalently named supported Icon from the Constellation foundations */
    PAUSE = "PAUSE",
    /** PAUSE_CIRCLE maps to an equivalently named supported Icon from the Constellation foundations */
    PAUSE_CIRCLE = "PAUSE_CIRCLE",
    /** PEDESTRIAN maps to an equivalently named supported Icon from the Constellation foundations */
    PEDESTRIAN = "PEDESTRIAN",
    /** PETS maps to an equivalently named supported Icon from the Constellation foundations */
    PETS = "PETS",
    /** PHONE maps to an equivalently named supported Icon from the Constellation foundations */
    PHONE = "PHONE",
    /** PHONE_CIRCLE maps to an equivalently named supported Icon from the Constellation foundations */
    PHONE_CIRCLE = "PHONE_CIRCLE",
    /** PHOTOS maps to an equivalently named supported Icon from the Constellation foundations */
    PHOTOS = "PHOTOS",
    /** PIGGY maps to an equivalently named supported Icon from the Constellation foundations */
    PIGGY = "PIGGY",
    /** PIGGY_OUTLINE maps to an equivalently named supported Icon from the Constellation foundations */
    PIGGY_OUTLINE = "PIGGY_OUTLINE",
    /** PLAY maps to an equivalently named supported Icon from the Constellation foundations */
    PLAY = "PLAY",
    /** PLAY_2 maps to an equivalently named supported Icon from the Constellation foundations */
    PLAY_2 = "PLAY_2",
    /** PLAY_CIRCLE maps to an equivalently named supported Icon from the Constellation foundations */
    PLAY_CIRCLE = "PLAY_CIRCLE",
    /** PLUS maps to an equivalently named supported Icon from the Constellation foundations */
    PLUS = "PLUS",
    /** PLUS_CIRCLE maps to an equivalently named supported Icon from the Constellation foundations */
    PLUS_CIRCLE = "PLUS_CIRCLE",
    /** PLUS_OUTLINE maps to an equivalently named supported Icon from the Constellation foundations */
    PLUS_OUTLINE = "PLUS_OUTLINE",
    /** POINTER_DOWN maps to an equivalently named supported Icon from the Constellation foundations */
    POINTER_DOWN = "POINTER_DOWN",
    /** POINTER_UP maps to an equivalently named supported Icon from the Constellation foundations */
    POINTER_UP = "POINTER_UP",
    /** PRESCRIPTION_PILL maps to an equivalently named supported Icon from the Constellation foundations */
    PRESCRIPTION_PILL = "PRESCRIPTION_PILL",
    /** PRICE_SQFT maps to an equivalently named supported Icon from the Constellation foundations */
    PRICE_SQFT = "PRICE_SQFT",
    /** PRINTER maps to an equivalently named supported Icon from the Constellation foundations */
    PRINTER = "PRINTER",
    /** PUBLIC_TRANSIT maps to an equivalently named supported Icon from the Constellation foundations */
    PUBLIC_TRANSIT = "PUBLIC_TRANSIT",
    /** REFRIGERATOR maps to an equivalently named supported Icon from the Constellation foundations */
    REFRIGERATOR = "REFRIGERATOR",
    /** RENAME maps to an equivalently named supported Icon from the Constellation foundations */
    RENAME = "RENAME",
    /** ROTATE_CLOCKWISE maps to an equivalently named supported Icon from the Constellation foundations */
    ROTATE_CLOCKWISE = "ROTATE_CLOCKWISE",
    /** ROTATE_COUNTER_CLOCKWISE maps to an equivalently named supported Icon from the Constellation foundations */
    ROTATE_COUNTER_CLOCKWISE = "ROTATE_COUNTER_CLOCKWISE",
    /** SAVED_SEARCH maps to an equivalently named supported Icon from the Constellation foundations */
    SAVED_SEARCH = "SAVED_SEARCH",
    /** SCHOOL maps to an equivalently named supported Icon from the Constellation foundations */
    SCHOOL = "SCHOOL",
    /** SEARCH maps to an equivalently named supported Icon from the Constellation foundations */
    SEARCH = "SEARCH",
    /** SEND maps to an equivalently named supported Icon from the Constellation foundations */
    SEND = "SEND",
    /** SHOPPING_BAGS maps to an equivalently named supported Icon from the Constellation foundations */
    SHOPPING_BAGS = "SHOPPING_BAGS",
    /** SHORTCUT_FIELDS maps to an equivalently named supported Icon from the Constellation foundations */
    SHORTCUT_FIELDS = "SHORTCUT_FIELDS",
    /** SMART_PHONE maps to an equivalently named supported Icon from the Constellation foundations */
    SMART_PHONE = "SMART_PHONE",
    /** SORT maps to an equivalently named supported Icon from the Constellation foundations */
    SORT = "SORT",
    /** SORT_ASCENDING maps to an equivalently named supported Icon from the Constellation foundations */
    SORT_ASCENDING = "SORT_ASCENDING",
    /** SPAM_FOLDER maps to an equivalently named supported Icon from the Constellation foundations */
    SPAM_FOLDER = "SPAM_FOLDER",
    /** SPARKLE maps to an equivalently named supported Icon from the Constellation foundations */
    SPARKLE = "SPARKLE",
    /** SPEAKER maps to an equivalently named supported Icon from the Constellation foundations */
    SPEAKER = "SPEAKER",
    /** SQUARE_FEET maps to an equivalently named supported Icon from the Constellation foundations */
    SQUARE_FEET = "SQUARE_FEET",
    /** STETHOSCOPE maps to an equivalently named supported Icon from the Constellation foundations */
    STETHOSCOPE = "STETHOSCOPE",
    /** STOP maps to an equivalently named supported Icon from the Constellation foundations */
    STOP = "STOP",
    /** STOP_2 maps to an equivalently named supported Icon from the Constellation foundations */
    STOP_2 = "STOP_2",
    /** STREET_VIEW maps to an equivalently named supported Icon from the Constellation foundations */
    STREET_VIEW = "STREET_VIEW",
    /** TABLET maps to an equivalently named supported Icon from the Constellation foundations */
    TABLET = "TABLET",
    /** TAG maps to an equivalently named supported Icon from the Constellation foundations */
    TAG = "TAG",
    /** TARGET maps to an equivalently named supported Icon from the Constellation foundations */
    TARGET = "TARGET",
    /** TARGET_OUTLINE maps to an equivalently named supported Icon from the Constellation foundations */
    TARGET_OUTLINE = "TARGET_OUTLINE",
    /** TAX maps to an equivalently named supported Icon from the Constellation foundations */
    TAX = "TAX",
    /** TEAM maps to an equivalently named supported Icon from the Constellation foundations */
    TEAM = "TEAM",
    /** TEXT_BOLD maps to an equivalently named supported Icon from the Constellation foundations */
    TEXT_BOLD = "TEXT_BOLD",
    /** TEXT_CENTER_ALIGNED maps to an equivalently named supported Icon from the Constellation foundations */
    TEXT_CENTER_ALIGNED = "TEXT_CENTER_ALIGNED",
    /** TEXT_COLOR maps to an equivalently named supported Icon from the Constellation foundations */
    TEXT_COLOR = "TEXT_COLOR",
    /** TEXT_ITALICS maps to an equivalently named supported Icon from the Constellation foundations */
    TEXT_ITALICS = "TEXT_ITALICS",
    /** TEXT_LEFT_ALIGNED maps to an equivalently named supported Icon from the Constellation foundations */
    TEXT_LEFT_ALIGNED = "TEXT_LEFT_ALIGNED",
    /** TEXT_RIGHT_ALIGNED maps to an equivalently named supported Icon from the Constellation foundations */
    TEXT_RIGHT_ALIGNED = "TEXT_RIGHT_ALIGNED",
    /** TEXT_UNDERLINED maps to an equivalently named supported Icon from the Constellation foundations */
    TEXT_UNDERLINED = "TEXT_UNDERLINED",
    /** THREE_DIMENSIONAL maps to an equivalently named supported Icon from the Constellation foundations */
    THREE_DIMENSIONAL = "THREE_DIMENSIONAL",
    /** THUMBS_DOWN maps to an equivalently named supported Icon from the Constellation foundations */
    THUMBS_DOWN = "THUMBS_DOWN",
    /** THUMBS_UP maps to an equivalently named supported Icon from the Constellation foundations */
    THUMBS_UP = "THUMBS_UP",
    /** TICKET maps to an equivalently named supported Icon from the Constellation foundations */
    TICKET = "TICKET",
    /** TOUR maps to an equivalently named supported Icon from the Constellation foundations */
    TOUR = "TOUR",
    /** TOUR_DOOR maps to an equivalently named supported Icon from the Constellation foundations */
    TOUR_DOOR = "TOUR_DOOR",
    /** TRASHCAN maps to an equivalently named supported Icon from the Constellation foundations */
    TRASHCAN = "TRASHCAN",
    /** TREES maps to an equivalently named supported Icon from the Constellation foundations */
    TREES = "TREES",
    /** TREES_EVERGREEN maps to an equivalently named supported Icon from the Constellation foundations */
    TREES_EVERGREEN = "TREES_EVERGREEN",
    /** TRENDING maps to an equivalently named supported Icon from the Constellation foundations */
    TRENDING = "TRENDING",
    /** TRENDING_OUTLINE maps to an equivalently named supported Icon from the Constellation foundations */
    TRENDING_OUTLINE = "TRENDING_OUTLINE",
    /** TROPHY maps to an equivalently named supported Icon from the Constellation foundations */
    TROPHY = "TROPHY",
    /** UNLOCK maps to an equivalently named supported Icon from the Constellation foundations */
    UNLOCK = "UNLOCK",
    /** UPLOAD maps to an equivalently named supported Icon from the Constellation foundations */
    UPLOAD = "UPLOAD",
    /** UPLOAD_OUTLINE maps to an equivalently named supported Icon from the Constellation foundations */
    UPLOAD_OUTLINE = "UPLOAD_OUTLINE",
    /** USER maps to an equivalently named Component from the Constellation foundations */
    USER = "USER",
    /** USER_OUTLINE maps to an equivalently named Component from the Constellation foundations */
    USER_OUTLINE = "USER_OUTLINE",
    /** UTENSILS maps to an equivalently named supported Icon from the Constellation foundations */
    UTENSILS = "UTENSILS",
    /** VACATION maps to an equivalently named supported Icon from the Constellation foundations */
    VACATION = "VACATION",
    /** VIDEO maps to an equivalently named supported Icon from the Constellation foundations */
    VIDEO = "VIDEO",
    /** VIDEO_PLAY maps to an equivalently named supported Icon from the Constellation foundations */
    VIDEO_PLAY = "VIDEO_PLAY",
    /** WAITING maps to an equivalently named supported Icon from the Constellation foundations */
    WAITING = "WAITING",
    /** WARNING maps to an equivalently named supported Icon from the Constellation foundations */
    WARNING = "WARNING",
    /** WEIGHT maps to an equivalently named supported Icon from the Constellation foundations */
    WEIGHT = "WEIGHT",
    /** WHITE_BALANCE maps to an equivalently named supported Icon from the Constellation foundations */
    WHITE_BALANCE = "WHITE_BALANCE",
    /** WIND maps to an equivalently named supported Icon from the Constellation foundations */
    WIND = "WIND",
    /** YARD_SIGN maps to an equivalently named supported Icon from the Constellation foundations */
    YARD_SIGN = "YARD_SIGN",
    /** ZOOM_IN maps to an equivalently named supported Icon from the Constellation foundations */
    ZOOM_IN = "ZOOM_IN",
    /** ZOOM_OUT maps to an equivalently named supported Icon from the Constellation foundations */
    ZOOM_OUT = "ZOOM_OUT"
}
/** Supported icon colors in IOS Constellation 8 for ZHL Experience Graph */
export enum ZHLExperienceIOSConstellation8IconColor {
    /** ACCENT_AQUA_HERO maps to an equivalent IOS Constellation 8 color token supported by the Icon component */
    ACCENT_AQUA_HERO = "ACCENT_AQUA_HERO",
    /** ACCENT_AQUA_STRONG maps to an equivalent IOS Constellation 8 color token supported by the Icon component */
    ACCENT_AQUA_STRONG = "ACCENT_AQUA_STRONG",
    /** ACCENT_BLUE_HERO maps to an equivalent IOS Constellation 8 color token supported by the Icon component */
    ACCENT_BLUE_HERO = "ACCENT_BLUE_HERO",
    /** ACCENT_BLUE_STRONG maps to an equivalent IOS Constellation 8 color token supported by the Icon component */
    ACCENT_BLUE_STRONG = "ACCENT_BLUE_STRONG",
    /** ACCENT_BRAND_HERO maps to an equivalent IOS Constellation 8 color token supported by the Icon component */
    ACCENT_BRAND_HERO = "ACCENT_BRAND_HERO",
    /** ACCENT_GRAY_HERO maps to an equivalent IOS Constellation 8 color token supported by the Icon component */
    ACCENT_GRAY_HERO = "ACCENT_GRAY_HERO",
    /** ACCENT_GRAY_STRONG maps to an equivalent IOS Constellation 8 color token supported by the Icon component */
    ACCENT_GRAY_STRONG = "ACCENT_GRAY_STRONG",
    /** ACCENT_GREEN_HERO maps to an equivalent IOS Constellation 8 color token supported by the Icon component */
    ACCENT_GREEN_HERO = "ACCENT_GREEN_HERO",
    /** ACCENT_GREEN_STRONG maps to an equivalent IOS Constellation 8 color token supported by the Icon component */
    ACCENT_GREEN_STRONG = "ACCENT_GREEN_STRONG",
    /** ACCENT_ORANGE_HERO maps to an equivalent IOS Constellation 8 color token supported by the Icon component */
    ACCENT_ORANGE_HERO = "ACCENT_ORANGE_HERO",
    /** ACCENT_ORANGE_STRONG maps to an equivalent IOS Constellation 8 color token supported by the Icon component */
    ACCENT_ORANGE_STRONG = "ACCENT_ORANGE_STRONG",
    /** ACCENT_PURPLE_HERO maps to an equivalent IOS Constellation 8 color token supported by the Icon component */
    ACCENT_PURPLE_HERO = "ACCENT_PURPLE_HERO",
    /** ACCENT_PURPLE_STRONG maps to an equivalent IOS Constellation 8 color token supported by the Icon component */
    ACCENT_PURPLE_STRONG = "ACCENT_PURPLE_STRONG",
    /** ACCENT_RED_HERO maps to an equivalent IOS Constellation 8 color token supported by the Icon component */
    ACCENT_RED_HERO = "ACCENT_RED_HERO",
    /** ACCENT_RED_STRONG maps to an equivalent IOS Constellation 8 color token supported by the Icon component */
    ACCENT_RED_STRONG = "ACCENT_RED_STRONG",
    /** ACCENT_TEAL_HERO maps to an equivalent IOS Constellation 8 color token supported by the Icon component */
    ACCENT_TEAL_HERO = "ACCENT_TEAL_HERO",
    /** ACCENT_TEAL_STRONG maps to an equivalent IOS Constellation 8 color token supported by the Icon component */
    ACCENT_TEAL_STRONG = "ACCENT_TEAL_STRONG",
    /** ACCENT_YELLOW_HERO maps to an equivalent IOS Constellation 8 color token supported by the Icon component */
    ACCENT_YELLOW_HERO = "ACCENT_YELLOW_HERO",
    /** ACCENT_YELLOW_STRONG maps to an equivalent IOS Constellation 8 color token supported by the Icon component */
    ACCENT_YELLOW_STRONG = "ACCENT_YELLOW_STRONG",
    /** ACTION_CRITICAL_HERO maps to an equivalent IOS Constellation 8 color token supported by the Icon component */
    ACTION_CRITICAL_HERO = "ACTION_CRITICAL_HERO",
    /** ACTION_CRITICAL_STRONG maps to an equivalent IOS Constellation 8 color token supported by the Icon component */
    ACTION_CRITICAL_STRONG = "ACTION_CRITICAL_STRONG",
    /** ACTION_HERO maps to an equivalent IOS Constellation 8 color token supported by the Icon component */
    ACTION_HERO = "ACTION_HERO",
    /** ACTION_NEUTRAL maps to an equivalent IOS Constellation 8 color token supported by the Icon component */
    ACTION_NEUTRAL = "ACTION_NEUTRAL",
    /** ACTION_STRONG maps to an equivalent IOS Constellation 8 color token supported by the Icon component */
    ACTION_STRONG = "ACTION_STRONG",
    /** INVISIBLE maps to an equivalent IOS Constellation 8 color token supported by the Icon component */
    INVISIBLE = "INVISIBLE",
    /** NEUTRAL maps to an equivalent IOS Constellation 8 color token supported by the Icon component */
    NEUTRAL = "NEUTRAL",
    /** SUBTLE maps to an equivalent IOS Constellation 8 color token supported by the Icon component */
    SUBTLE = "SUBTLE"
}
/**
 * Supported Icon sizes in iOS Constellation 8 in ZHL Experience Graph.
 *
 * These map to equivalent enums on Constellation IOS that can be used in view modifiers
 */
export enum ZHLExperienceIOSConstellation8IconSize {
    /** Large Icon Size */
    LARGE = "LARGE",
    /** Medium Icon Size */
    MEDIUM = "MEDIUM",
    /** Small Icon Size */
    SMALL = "SMALL"
}
/** Supported IOS configurations for text in ZHL Experience Graph */
export enum ZHLExperienceIOSConstellation8Typography {
    /** Regular Text */
    BODY = "BODY",
    /** Bolded Text */
    BODY_BOLD = "BODY_BOLD",
    /** Extra Small Text */
    BODY_EXTRA_SMALL = "BODY_EXTRA_SMALL",
    /** Bolded Extra Small Text */
    BODY_EXTRA_SMALL_BOLD = "BODY_EXTRA_SMALL_BOLD",
    /** Semi Bolded Text */
    BODY_SEMI_BOLD = "BODY_SEMI_BOLD",
    /** Small Text */
    BODY_SMALL = "BODY_SMALL",
    /** Bolded Small Text */
    BODY_SMALL_BOLD = "BODY_SMALL_BOLD",
    /** Fineprint */
    FINEPRINT = "FINEPRINT",
    /** Bolded Fineprint */
    FINEPRINT_BOLD = "FINEPRINT_BOLD",
    /** Small Fineprint */
    FINEPRINT_SMALL = "FINEPRINT_SMALL",
    /** Bolded Small Fineprint */
    FINEPRINT_SMALL_BOLD = "FINEPRINT_SMALL_BOLD",
    /** Alternate Extra Large Heading Text Style */
    HEADING_ALT_EXTRA_LARGE = "HEADING_ALT_EXTRA_LARGE",
    /** Alternate Extra Small Heading Text Style */
    HEADING_ALT_EXTRA_SMALL = "HEADING_ALT_EXTRA_SMALL",
    /** Alternate Large Heading Text Style */
    HEADING_ALT_LARGE = "HEADING_ALT_LARGE",
    /** Alternate Medium Heading Text Style */
    HEADING_ALT_MEDIUM = "HEADING_ALT_MEDIUM",
    /** Alternate Small Heading Text Style */
    HEADING_ALT_SMALL = "HEADING_ALT_SMALL",
    /** Extra Large Heading Text Style */
    HEADING_EXTRA_LARGE = "HEADING_EXTRA_LARGE",
    /** Extra Small Heading Text Style */
    HEADING_EXTRA_SMALL = "HEADING_EXTRA_SMALL",
    /** Large Heading Text Style */
    HEADING_LARGE = "HEADING_LARGE",
    /** Medium Heading Text Style */
    HEADING_MEDIUM = "HEADING_MEDIUM",
    /** Small Heading Text Style */
    HEADING_SMALL = "HEADING_SMALL"
}
/**
 * ZHL Experience iOS Block
 * - Implementation of the ZHLExperienceIcon, for rendering an icon with Constellation iOS
 */
export type ZHLExperienceIOSIcon = NeutronBlock & {
    __typename: "ZHLExperienceIOSIcon";
    /** The configuration for the icon */
    configuration: ZHLExperienceIOSIconConfiguration;
    /** Necessary for wiring actions to this block, and for client-side identity-based UI diffing for partial updates */
    id: Scalars["String"];
};
/** Supported configurations for the Icon block in iOS for ZHL Experience Graph */
export type ZHLExperienceIOSIconConfiguration = ZHLExperienceIOSIconConstellation8Configuration;
/** Configuration for an icon with IOS Constellation 8 for ZHL Experience Graph */
export type ZHLExperienceIOSIconConstellation8Configuration = {
    __typename: "ZHLExperienceIOSIconConstellation8Configuration";
    /** What constellation version this configuration is for. Should be IOS_8 */
    constellationVersion: ZHLExperienceConstellationVersion;
    /** Whether the icon should be rendered as filled or outlined */
    filled: Maybe<Scalars["Boolean"]>;
    /** What Icon to render */
    icon: ZHLExperienceIOSConstellation8Icon;
    /** What platform this configuration is for. Should be IOS */
    platform: ZHLExperiencePlatformType;
    /** The size of the icon */
    size: Maybe<ZHLExperienceIOSConstellation8IconSize>;
    /** What tint color to apply to the icon. Maps to an enum that can be leveraged witha  view modifier */
    tintColor: Maybe<ZHLExperienceIOSConstellation8IconColor>;
};
/**
 * ZHL Experience IOS Block
 * - Implements the underlined navigation / phone link component in iOS
 */
export type ZHLExperienceIOSLink = NeutronBlock & {
    __typename: "ZHLExperienceIOSLink";
    /** The configuration for the link, in a specific Constellation version dictated by the requested constellation version */
    configuration: ZHLExperienceIOSLinkConfiguration;
    /** The text content of the link */
    content: Scalars["String"];
    /** Necessary for wiring actions to this block, and for client-side identity-based UI diffing for partial updates */
    id: Scalars["String"];
    /** The resource to navigate to when the link is clicked */
    resource: Scalars["String"];
};
/** Supported IOS configurations for links in ZHL Experience Graph */
export type ZHLExperienceIOSLinkConfiguration = ZHLExperienceIOSLinkConstellation8Configuration;
/**
 * ZHL Experience IOS Block Configuration
 * - Provides the configuration for an Anchor component in Constellation 8 IOS
 */
export type ZHLExperienceIOSLinkConstellation8Configuration = {
    __typename: "ZHLExperienceIOSLinkConstellation8Configuration";
    /** The constellation version this configuration is intended for. Should be WEB_8 */
    constellationVersion: ZHLExperienceConstellationVersion;
    /** The platform this configuration is intended for. Should be WEB */
    platform: ZHLExperiencePlatformType;
};
/**
 * ZHL Experience IOS Block
 * - Implements the Heading and Text components in Constellation
 */
export type ZHLExperienceIOSText = NeutronBlock & {
    __typename: "ZHLExperienceIOSText";
    /**
     * The configuration for the text, in a specific Constellation version dictated by the requested constellation version
     *
     * If there are embedded blocks, this will still be provided but the configuration for each embedded block should take precedence over this configuration
     */
    configuration: ZHLExperienceIOSTextConfiguration;
    /**
     * The raw text content to display. This will always be a markdown string, however where possible, the configuration options
     * will be used to set the whole text as bold, italics, or underlined. Therefore clients should parse the text as markdown and render it,
     * then additionally set the configuration options to ensure the string renders correctly
     */
    content: Scalars["String"];
    /**
     * If this text should have embedded blocks in it (such as navigation links, tooltips, etc.), this will contain the text laid out
     * as a left to right list of blocks, with either Text elements or the other embedded blocks, such that if rendered left to right, they form
     * the content with the embedded blocks placed in the correct locations within the text
     */
    contentWithEmbeddedBlocks: Maybe<Array<ZHLExperienceIOSTextEmbeddableBlocks>>;
    /** Necessary for wiring actions to this block, and for client-side identity-based UI diffing for partial updates */
    id: Scalars["String"];
};
/** Supported IOS configurations for text */
export type ZHLExperienceIOSTextConfiguration = ZHLExperienceIOSTextConstellation8Configuration;
/**
 * ZHL Experience IOS Block Configuration
 * - Provides the configuration for a Text or Paragraph component in Constellation 8 IOS
 */
export type ZHLExperienceIOSTextConstellation8Configuration = {
    __typename: "ZHLExperienceIOSTextConstellation8Configuration";
    /** Which alignment view modifier to apply to the text */
    alignment: ZHLExperienceIOSAlignment;
    /** The constellation version this configuration is intended for. Should be IOS_8 */
    constellationVersion: ZHLExperienceConstellationVersion;
    /** The platform this configuration is intended for. Should be IOS */
    platform: ZHLExperiencePlatformType;
    /** Which typography view modifier to apply to the text */
    typography: ZHLExperienceIOSConstellation8Typography;
};
/** IOS Blocks that can be intermixed within a rich text block that contains other embedded blocks */
export type ZHLExperienceIOSTextEmbeddableBlocks = ZHLExperienceIOSIcon | ZHLExperienceIOSLink | ZHLExperienceIOSText;
/**
 * Represents a layout for a ZHLExperienceModule, described using the Grid model with columns consumed
 * by sections that are arrayed in rows and can span 1 or many columns.
 */
export type ZHLExperienceModuleLayout = ZHLExperienceGraphLayout & {
    __typename: "ZHLExperienceModuleLayout";
    /** The number of columns in this layout */
    numberOfColumns: Scalars["Int"];
    /** Sections in the layout for blocks within the module */
    sections: Array<ZHLExperienceModuleLayoutSection>;
};
/**
 * Represents a reserved space in a ZHLExperienceModule's layout for a block, defined by a certain number of columns in a row.
 *
 * The row the section will appear on is an emergent property of the overall layout definition and is not captured in this type
 */
export type ZHLExperienceModuleLayoutSection = ZHLExperienceGraphLayoutSection & {
    __typename: "ZHLExperienceModuleLayoutSection";
    /**
     * Represents the unique name for a given block
     *
     * Contract: This _must_ match a field name on the blocks lookup for the ZHLExperienceModule.blocksByName
     */
    block: Scalars["String"];
    /** Represents how many columns this section spans. Must always be less than or equal to the total number of columns */
    columnSpan: Scalars["Int"];
    /** Optional flow direction for the layout of the sections in this layout */
    flowDirection: Maybe<ZHLExperienceFlowDirection>;
    /** Optional gap between this section and the next section in the layout */
    gapBetweenBlocks: Maybe<ZHLExperienceSpacingSize>;
    /** Optional margin outside the block content, described using the Box model */
    margin: Maybe<ZHLExperienceSpacing>;
    /** Optional padding around the block content, described using the Box model */
    padding: Maybe<ZHLExperienceSpacing>;
};
/** This enum enables description of which platform given data is designed to support */
export enum ZHLExperiencePlatformType {
    /** All Android phones and tablets supported by ZG */
    ANDROID = "ANDROID",
    /** All Apple phones and tablets supported by ZG */
    IOS = "IOS",
    /** All web browsers supported by ZG */
    WEB = "WEB"
}
/** Box Model representation of spacing around a block or module in ZHL Experience Graph */
export type ZHLExperienceSpacing = {
    __typename: "ZHLExperienceSpacing";
    /** Hold-off space (padding or margin) below the content */
    bottom: ZHLExperienceSpacingSize;
    /** Hold-off space (padding or margin) to the left the content */
    left: ZHLExperienceSpacingSize;
    /** Hold-off space (padding or margin) to the right of the content */
    right: ZHLExperienceSpacingSize;
    /** Hold-off space (padding or margin) above the content */
    top: ZHLExperienceSpacingSize;
};
/** Represents pre-defined spacing enums in Constellation, along with 2 more special cases: NONE and AUTO */
export enum ZHLExperienceSpacingSize {
    /**
     * Represents greedily expanding size.
     *
     * - Auto left and right padding or margin would imply an element that is centered
     *
     * - Auto left padding or margin would imply an element that is right aligned
     *
     * - Auto right padding or margin would imply an element that is left aligned
     */
    AUTO = "AUTO",
    /**
     * Large spacing (specific values managed by Constellation)
     *
     * Maps to an equivalent token in Constellation
     */
    LG = "LG",
    /**
     * Medium spacing (specific values managed by Constellation)
     *
     * Maps to an equivalent token in Constellation
     */
    MD = "MD",
    /** Represents spacing should be used */
    NONE = "NONE",
    /**
     * Small spacing (specific values managed by Constellation)
     *
     * Maps to an equivalent token in Constellation
     */
    SM = "SM",
    /**
     * Extra large spacing (specific values managed by Constellation)
     *
     * Maps to an equivalent token in Constellation
     */
    XL = "XL",
    /**
     * Extra small spacing (specific values managed by Constellation)
     *
     * Maps to an equivalent token in Constellation
     */
    XS = "XS"
}
/** The list of pre-agreed upon destructive operations that the client can perform */
export enum ZHLExperienceSupportedDestructiveOperation {
    /** Perform the operation to cancel the scheduled Call Scheduler call the user has */
    CANCEL_CALL = "CANCEL_CALL"
}
/**
 * ZHL Experience Graph Block
 *
 * - Atoms responsible for rendering a block of text across the different Constellation SDKs for ZHL Experience Graph
 */
export type ZHLExperienceText = ZHLExperienceAndroidText | ZHLExperienceIOSText | ZHLExperienceWebText;
/**
 * ZHL Experience Graph Web Block
 *
 * - Implementation of the ZHLExperienceAvatar, for rendering an avatar with Constellation Web
 */
export type ZHLExperienceWebAvatar = {
    __typename: "ZHLExperienceWebAvatar";
    /** The constellation version aware configuration for the avatar */
    configuration: ZHLExperienceWebAvatarConfiguration;
    /** Necessary for wiring actions to this block, and for client-side identity-based UI diffing for partial updates */
    id: Scalars["String"];
};
/** Supported Web Avatar configurations in ZHL Experience Graph */
export type ZHLExperienceWebAvatarConfiguration = ZHLExperienceWebAvatarConstellation8Configuration | ZHLExperienceWebAvatarConstellation10AlphaConfiguration;
/** Web Constellation 8 configuration for the Avatar block in ZHL Experience Graph */
export type ZHLExperienceWebAvatarConstellation8Configuration = {
    __typename: "ZHLExperienceWebAvatarConstellation8Configuration";
    /** An accessible alternative description of the avatar */
    alt: Maybe<Scalars["String"]>;
    /** If the avatar is meant to be an icon avatar, icon will be defined */
    avatarIcon: Maybe<ZHLExperienceWebIcon>;
    /** All badge properties will be null or defined together */
    badgeIcon: Maybe<ZHLExperienceWebIcon>;
    /** What size to render the avatar if it is a badged avatar. Takes precedence over `size` */
    badgedSize: Maybe<ZHLExperienceWebConstellation8BadgedAvatarSize>;
    /** What color to render the avatar background if using initials or an icon */
    color: ZHLExperienceWebConstellation8AvatarColor;
    /** What constellation version this configuration is for. Should be WEB_8 */
    constellationVersion: ZHLExperienceConstellationVersion;
    /** If the avatar is meant to be an initials avatar, fullName will be defined */
    fullName: Maybe<Scalars["String"]>;
    /**
     * If the avatar should use an image, this can be used to constrain the avatar size beyond
     * what Constellation supports
     */
    maxAvatarImageHeight: Maybe<Scalars["String"]>;
    /** What platform this configuration is for. Should be WEB */
    platform: ZHLExperiencePlatformType;
    /** What size to render the avatar if it is not a badged avatar */
    size: Maybe<ZHLExperienceWebConstellation8AvatarSize>;
    /** If the avatar is meant to be an image avatar, both src and alt will be defined */
    src: Maybe<Scalars["String"]>;
    /** If true, the default Constellation Avatar Icon should be used rather than a custom icon */
    useDefaultAvatar: Maybe<Scalars["Boolean"]>;
};
/** Web Constellation 10 configuration for the Avatar block in ZHL Experience Graph */
export type ZHLExperienceWebAvatarConstellation10AlphaConfiguration = {
    __typename: "ZHLExperienceWebAvatarConstellation10AlphaConfiguration";
    /** An accessible alternative description of the avatar */
    alt: Maybe<Scalars["String"]>;
    /** If the avatar is meant to be an icon avatar, icon will be defined */
    avatarIcon: Maybe<ZHLExperienceWebIcon>;
    /** What icon to use for the badge if a custom icon should be used. */
    badgeIcon: Maybe<ZHLExperienceWebIcon>;
    /** What size to render the avatar if it is a badged avatar. Takes precedence over `size` */
    badgedSize: Maybe<ZHLExperienceWebConstellation10BadgedAvatarSize>;
    /** What constellation version this configuration is for. Should be WEB_10_ALPHA */
    constellationVersion: ZHLExperienceConstellationVersion;
    /** If the avatar is meant to be an initials avatar, fullName will be defined */
    fullName: Maybe<Scalars["String"]>;
    /**
     * If the avatar should use an image, this can be used to constrain the avatar size beyond
     * what Constellation supports
     */
    maxAvatarImageHeight: Maybe<Scalars["String"]>;
    /** What platform this configuration is for. Should be WEB */
    platform: ZHLExperiencePlatformType;
    /** What size to render the avatar if it is not a badged avatar */
    size: Maybe<ZHLExperienceWebConstellation10AvatarSize>;
    /** If the avatar is meant to be an image avatar, both src and alt will be defined */
    src: Maybe<Scalars["String"]>;
    /** What color to render the avatar background if using initials or an icon */
    tone: Maybe<ZHLExperienceWebConstellation10AvatarTone>;
    /** If true, the default Constellation Avatar Icon should be used rather than a custom icon */
    useDefaultAvatar: Maybe<Scalars["Boolean"]>;
};
/**
 * Neutron Web Block
 * - Implementation of the ZHLExperienceButton interface for Web
 */
export type ZHLExperienceWebButton = NeutronBlock & {
    __typename: "ZHLExperienceWebButton";
    /** The configuration for the button */
    configuration: ZHLExperienceWebButtonConfiguration;
    /** The raw text content for the button */
    content: Scalars["String"];
    /** Necessary for wiring actions to this block, and for client-side identity-based UI diffing for partial updates */
    id: Scalars["String"];
};
/** Supported Configurations for Web Constellation Buttons in Neutron */
export type ZHLExperienceWebButtonConfiguration = ZHLExperienceWebButtonConstellation8Configuration | ZHLExperienceWebButtonConstellation10AlphaConfiguration;
/**
 * Neutron Web Block Configuration
 *
 * - Provides integration with Constellation 8 to configure a button on web
 */
export type ZHLExperienceWebButtonConstellation8Configuration = {
    __typename: "ZHLExperienceWebButtonConstellation8Configuration";
    /** What button type to render the button with */
    buttonType: ZHLExperienceWebConstellation8ButtonType;
    /** What constellation version this configuration is for. Should be WEB_8 */
    constellationVersion: ZHLExperienceConstellationVersion;
    /**
     * If presentAsTextButtonOnDesktop is true, this will be the content of the text button, and
     * the content on the base button will be the content to show on mobile
     */
    desktopContent: Maybe<Scalars["String"]>;
    /** Whether the button should consume the full horizontal width of it's container */
    fluid: Scalars["Boolean"];
    /** If an icon should be rendered within the button, where to render it */
    iconPosition: Maybe<ZHLExperienceWebConstellation8ButtonIconPosition>;
    /** Whether to invert the colors of the button for dark mode */
    inverse: Scalars["Boolean"];
    /** What platform this configuration is for. Should be WEB */
    platform: ZHLExperiencePlatformType;
    /**
     * If true, the button should be rendered as a text button / link on desktop, and only appear as the described
     * button when in mobile breakpoints
     */
    presentAsTextButtonOnDesktop: Scalars["Boolean"];
    /** What size to render the button */
    size: ZHLExperienceWebConstellation8ButtonSize;
};
/**
 * Neutron Web Block Configuration
 *
 * - Provides integration with Constellation 10 to configure a button on web
 */
export type ZHLExperienceWebButtonConstellation10AlphaConfiguration = {
    __typename: "ZHLExperienceWebButtonConstellation10AlphaConfiguration";
    /** What border radius to render the button with */
    borderRadius: Maybe<NeutronWebConstellation10ButtonBorderRadius>;
    /** What constellation version this configuration is for. Should be WEB_10_ALPHA */
    constellationVersion: ZHLExperienceConstellationVersion;
    /**
     * If presentAsTextButtonOnDesktop is true, this will be the content of the text button, and
     * the content on the base button will be the content to show on mobile
     */
    desktopContent: Maybe<Scalars["String"]>;
    /** What emphasis to render the button with */
    emphasis: ZHLExperienceWebConstellation10ButtonEmphasis;
    /** Whether the button should consume the full horizontal width of it's container */
    fluid: Scalars["Boolean"];
    icon: Maybe<ZHLExperienceWebIcon>;
    /** If an icon should be rendered within the button, where to render it */
    iconPosition: Maybe<ZHLExperienceWebConstellation10ButtonIconPosition>;
    /**
     * Will match the id of the block that this configuration is for. Necessary so that neutron subgraphs can federate new properties onto this configuration.
     *
     * **Important note**: New properties are strongly encouraged to be nullable to avoid federation composition errors.
     */
    id: Scalars["String"];
    /** Whether to invert the colors of the button for dark mode */
    onImpact: Scalars["Boolean"];
    /** What platform this configuration is for. Should be WEB */
    platform: ZHLExperiencePlatformType;
    /**
     * Whether to render the button as a text button in ZHL QuickApp
     * @deprecated Use NeutronTextButton to represent text button types
     */
    presentAsTextButton: Maybe<Scalars["Boolean"]>;
    /**
     * If true, the button should be rendered as a text button / link on desktop, and only appear as the described
     * button when in mobile breakpoints
     */
    presentAsTextButtonOnDesktop: Scalars["Boolean"];
    /** What size to render the button */
    size: ZHLExperienceWebConstellation10ButtonSize;
    /** What tone to render the button with */
    tone: ZHLExperienceWebConstellation10ButtonTone;
};
/** Supported Avatar colors in Web Constellation 8 in ZHL Experience Graph */
export enum ZHLExperienceWebConstellation8AvatarColor {
    /** AQUA_500 matches to an equivalent Constellation 8 token */
    AQUA_500 = "AQUA_500",
    /** BLUE_500 matches to an equivalent Constellation 8 token */
    BLUE_500 = "BLUE_500",
    /** GRAY_200 matches to an equivalent Constellation 8 token */
    GRAY_200 = "GRAY_200",
    /** GREEN_500 matches to an equivalent Constellation 8 token */
    GREEN_500 = "GREEN_500",
    /** PURPLE_500 matches to an equivalent Constellation 8 token */
    PURPLE_500 = "PURPLE_500"
}
/** Supported Avatar sizes in Web Constellation 8 in ZHL Experience Graph */
export enum ZHLExperienceWebConstellation8AvatarSize {
    /** LG matches to an equivalent Constellation 8 token */
    LG = "LG",
    /** MD matches to an equivalent Constellation 8 token */
    MD = "MD",
    /** SM matches to an equivalent Constellation 8 token */
    SM = "SM",
    /** XL matches to an equivalent Constellation 8 token */
    XL = "XL",
    /** XS matches to an equivalent Constellation 8 token */
    XS = "XS",
    /** XXL matches to an equivalent Constellation 8 token */
    XXL = "XXL"
}
/** Supported Badged Avatar sizes in Web Constellation 8 */
export enum ZHLExperienceWebConstellation8BadgedAvatarSize {
    /** LG matches to an equivalent Constellation 8 token */
    LG = "LG",
    /** XL matches to an equivalent Constellation 8 token */
    XL = "XL",
    /** XXL matches to an equivalent Constellation 8 token */
    XXL = "XXL"
}
/**
 * Supported Button Icon Positions in Constellation 8 for Neutron
 *
 * These aren't defined by the SDK, but are instead based on the implementation of the block component responsible for rendering the button.
 */
export enum ZHLExperienceWebConstellation8ButtonIconPosition {
    /** END indicates the icon should be rendered after the text content of the button */
    END = "END",
    /** START indicates the icon should be rendered before the text content of the button */
    START = "START"
}
/** Supported Button types in Constellation 8 Web for Neutron */
export enum ZHLExperienceWebConstellation8ButtonSize {
    /** LG maps to an equivalent token in Constellation 8 */
    LG = "LG",
    /** MD maps to an equivalent token in Constellation 8 */
    MD = "MD",
    /** SM maps to an equivalent token in Constellation 8 */
    SM = "SM"
}
/** Supported Button types in Constellation 8 Web for Neutron */
export enum ZHLExperienceWebConstellation8ButtonType {
    /** CAUTION maps to an equivalent token for Constellation 8 */
    CAUTION = "CAUTION",
    /** PRIMARY maps to an equivalent token for Constellation 8 */
    PRIMARY = "PRIMARY",
    /** SECONDARY maps to an equivalent token for Constellation 8 */
    SECONDARY = "SECONDARY",
    /** TERTIARY maps to an equivalent token for Constellation 8 */
    TERTIARY = "TERTIARY"
}
/** Supported colors in Web Constellation 8 for ZHL Experience Graph */
export enum ZHLExperienceWebConstellation8Color {
    /** AQUA_100 maps to an equivalent Constellation Token */
    AQUA_100 = "AQUA_100",
    /** AQUA_200 maps to an equivalent Constellation Token */
    AQUA_200 = "AQUA_200",
    /** AQUA_300 maps to an equivalent Constellation Token */
    AQUA_300 = "AQUA_300",
    /** AQUA_400 maps to an equivalent Constellation Token */
    AQUA_400 = "AQUA_400",
    /** AQUA_500 maps to an equivalent Constellation Token */
    AQUA_500 = "AQUA_500",
    /** AQUA_600 maps to an equivalent Constellation Token */
    AQUA_600 = "AQUA_600",
    /** BACKGROUND_AQUA maps to an equivalent Constellation Token */
    BACKGROUND_AQUA = "BACKGROUND_AQUA",
    /** BACKGROUND_BLUE maps to an equivalent Constellation Token */
    BACKGROUND_BLUE = "BACKGROUND_BLUE",
    /** BACKGROUND_DARK maps to an equivalent Constellation Token */
    BACKGROUND_DARK = "BACKGROUND_DARK",
    /** BACKGROUND_DARK_BLUE maps to an equivalent Constellation Token */
    BACKGROUND_DARK_BLUE = "BACKGROUND_DARK_BLUE",
    /** BACKGROUND_GREEN maps to an equivalent Constellation Token */
    BACKGROUND_GREEN = "BACKGROUND_GREEN",
    /** BACKGROUND_ORANGE maps to an equivalent Constellation Token */
    BACKGROUND_ORANGE = "BACKGROUND_ORANGE",
    /** BACKGROUND_RED maps to an equivalent Constellation Token */
    BACKGROUND_RED = "BACKGROUND_RED",
    /** BACKGROUND_WHITE maps to an equivalent Constellation Token */
    BACKGROUND_WHITE = "BACKGROUND_WHITE",
    /** BACKGROUND_YELLOW maps to an equivalent Constellation Token */
    BACKGROUND_YELLOW = "BACKGROUND_YELLOW",
    /** BLACK maps to an equivalent Constellation Token */
    BLACK = "BLACK",
    /** BLUE_100 maps to an equivalent Constellation Token */
    BLUE_100 = "BLUE_100",
    /** BLUE_200 maps to an equivalent Constellation Token */
    BLUE_200 = "BLUE_200",
    /** BLUE_300 maps to an equivalent Constellation Token */
    BLUE_300 = "BLUE_300",
    /** BLUE_400 maps to an equivalent Constellation Token */
    BLUE_400 = "BLUE_400",
    /** BLUE_500 maps to an equivalent Constellation Token */
    BLUE_500 = "BLUE_500",
    /** BLUE_600 maps to an equivalent Constellation Token */
    BLUE_600 = "BLUE_600",
    /** BORDER_DARK maps to an equivalent Constellation Token */
    BORDER_DARK = "BORDER_DARK",
    /** BORDER_LIGHT maps to an equivalent Constellation Token */
    BORDER_LIGHT = "BORDER_LIGHT",
    /** BRAND maps to an equivalent Constellation Token */
    BRAND = "BRAND",
    /** COMING_SOON maps to an equivalent Constellation Token */
    COMING_SOON = "COMING_SOON",
    /** FACEBOOK maps to an equivalent Constellation Token */
    FACEBOOK = "FACEBOOK",
    /** FOR_RENT maps to an equivalent Constellation Token */
    FOR_RENT = "FOR_RENT",
    /** FOR_SALE maps to an equivalent Constellation Token */
    FOR_SALE = "FOR_SALE",
    /** GRAY_100 maps to an equivalent Constellation Token */
    GRAY_100 = "GRAY_100",
    /** GRAY_200 maps to an equivalent Constellation Token */
    GRAY_200 = "GRAY_200",
    /** GRAY_300 maps to an equivalent Constellation Token */
    GRAY_300 = "GRAY_300",
    /** GRAY_400 maps to an equivalent Constellation Token */
    GRAY_400 = "GRAY_400",
    /** GRAY_500 maps to an equivalent Constellation Token */
    GRAY_500 = "GRAY_500",
    /** GRAY_600 maps to an equivalent Constellation Token */
    GRAY_600 = "GRAY_600",
    /** GREEN_100 maps to an equivalent Constellation Token */
    GREEN_100 = "GREEN_100",
    /** GREEN_200 maps to an equivalent Constellation Token */
    GREEN_200 = "GREEN_200",
    /** GREEN_300 maps to an equivalent Constellation Token */
    GREEN_300 = "GREEN_300",
    /** GREEN_400 maps to an equivalent Constellation Token */
    GREEN_400 = "GREEN_400",
    /** GREEN_500 maps to an equivalent Constellation Token */
    GREEN_500 = "GREEN_500",
    /** GREEN_600 maps to an equivalent Constellation Token */
    GREEN_600 = "GREEN_600",
    /** OFF_MARKET maps to an equivalent Constellation Token */
    OFF_MARKET = "OFF_MARKET",
    /** ORANGE_100 maps to an equivalent Constellation Token */
    ORANGE_100 = "ORANGE_100",
    /** ORANGE_200 maps to an equivalent Constellation Token */
    ORANGE_200 = "ORANGE_200",
    /** ORANGE_300 maps to an equivalent Constellation Token */
    ORANGE_300 = "ORANGE_300",
    /** ORANGE_400 maps to an equivalent Constellation Token */
    ORANGE_400 = "ORANGE_400",
    /** ORANGE_500 maps to an equivalent Constellation Token */
    ORANGE_500 = "ORANGE_500",
    /** PURPLE_100 maps to an equivalent Constellation Token */
    PURPLE_100 = "PURPLE_100",
    /** PURPLE_200 maps to an equivalent Constellation Token */
    PURPLE_200 = "PURPLE_200",
    /** PURPLE_300 maps to an equivalent Constellation Token */
    PURPLE_300 = "PURPLE_300",
    /** PURPLE_400 maps to an equivalent Constellation Token */
    PURPLE_400 = "PURPLE_400",
    /** PURPLE_500 maps to an equivalent Constellation Token */
    PURPLE_500 = "PURPLE_500",
    /** PURPLE_600 maps to an equivalent Constellation Token */
    PURPLE_600 = "PURPLE_600",
    /** RECENTLY_SOLD maps to an equivalent Constellation Token */
    RECENTLY_SOLD = "RECENTLY_SOLD",
    /** RED_100 maps to an equivalent Constellation Token */
    RED_100 = "RED_100",
    /** RED_200 maps to an equivalent Constellation Token */
    RED_200 = "RED_200",
    /** RED_300 maps to an equivalent Constellation Token */
    RED_300 = "RED_300",
    /** RED_400 maps to an equivalent Constellation Token */
    RED_400 = "RED_400",
    /** RED_500 maps to an equivalent Constellation Token */
    RED_500 = "RED_500",
    /** RED_600 maps to an equivalent Constellation Token */
    RED_600 = "RED_600",
    /** TEXT_DARK maps to an equivalent Constellation Token */
    TEXT_DARK = "TEXT_DARK",
    /** TEXT_LIGHT maps to an equivalent Constellation Token */
    TEXT_LIGHT = "TEXT_LIGHT",
    /** TEXT_MEDIUM maps to an equivalent Constellation Token */
    TEXT_MEDIUM = "TEXT_MEDIUM",
    /** TEXT_WHITE maps to an equivalent Constellation Token */
    TEXT_WHITE = "TEXT_WHITE",
    /** TRUE_BLACK maps to an equivalent Constellation Token */
    TRUE_BLACK = "TRUE_BLACK",
    /** TWITTER maps to an equivalent Constellation Token */
    TWITTER = "TWITTER",
    /** WHITE maps to an equivalent Constellation Token */
    WHITE = "WHITE",
    /** YELLOW_100 maps to an equivalent Constellation Token */
    YELLOW_100 = "YELLOW_100",
    /** YELLOW_200 maps to an equivalent Constellation Token */
    YELLOW_200 = "YELLOW_200",
    /** YELLOW_300 maps to an equivalent Constellation Token */
    YELLOW_300 = "YELLOW_300",
    /** YELLOW_400 maps to an equivalent Constellation Token */
    YELLOW_400 = "YELLOW_400",
    /** YELLOW_500 maps to an equivalent Constellation Token */
    YELLOW_500 = "YELLOW_500"
}
/** Supported Web Constellation 8 Font Families in ZHL Experience Graph */
export enum ZHLExperienceWebConstellation8FontFamily {
    /** Sans Serif Font */
    SANS_SERIF = "SANS_SERIF",
    /** Serifed Font */
    SERIF = "SERIF"
}
/** Supported Web Constellation 8 Font Types in ZHL Experience Graph */
export enum ZHLExperienceWebConstellation8FontType {
    /** Regular Text */
    BODY = "BODY",
    /** Bolded Text */
    BODY_HEADING = "BODY_HEADING",
    /** Small Text */
    BODY_SM = "BODY_SM",
    /** Small Bolded Text */
    BODY_SM_HEADING = "BODY_SM_HEADING",
    /** Fineprint */
    FINEPRINT = "FINEPRINT",
    /** Bolded Fineprint */
    FINEPRINT_HEADING = "FINEPRINT_HEADING",
    /** Heading level 0 */
    H0 = "H0",
    /** Heading level 1 */
    H1 = "H1",
    /** Heading level 2 */
    H2 = "H2",
    /** Heading level 3 */
    H3 = "H3",
    /** Heading level 4 */
    H4 = "H4",
    /** Heading level 5 */
    H5 = "H5",
    /** Heading level 6 */
    H6 = "H6",
    /** Small Fineprint */
    LEGAL = "LEGAL"
}
/**
 * All supported icons on Web Constellation 8 for ZHL Experience Graph
 *
 * These values map closely to equivalent Icon components for the Constellation SDK on Styled Components
 */
export enum ZHLExperienceWebConstellation8Icon {
    /** AIR_CONDITIONING maps to an equivalently named Component in Constellation 8 */
    AIR_CONDITIONING = "AIR_CONDITIONING",
    /** AIR_CONDITIONING_OUTLINE maps to an equivalently named Component in Constellation 8 */
    AIR_CONDITIONING_OUTLINE = "AIR_CONDITIONING_OUTLINE",
    /** ANDROID_SHARE maps to an equivalently named Component in Constellation 8 */
    ANDROID_SHARE = "ANDROID_SHARE",
    /** ANDROID_SHARE_OUTLINE maps to an equivalently named Component in Constellation 8 */
    ANDROID_SHARE_OUTLINE = "ANDROID_SHARE_OUTLINE",
    /** ARCHIVE maps to an equivalently named Component in Constellation 8 */
    ARCHIVE = "ARCHIVE",
    /** ARCHIVE_OUTLINE maps to an equivalently named Component in Constellation 8 */
    ARCHIVE_OUTLINE = "ARCHIVE_OUTLINE",
    /** ARROW_DOWN maps to an equivalently named Component in Constellation 8 */
    ARROW_DOWN = "ARROW_DOWN",
    /** ARROW_DOWN_CIRCLE maps to an equivalently named Component in Constellation 8 */
    ARROW_DOWN_CIRCLE = "ARROW_DOWN_CIRCLE",
    /** ARROW_DOWN_CIRCLE_OUTLINE maps to an equivalently named Component in Constellation 8 */
    ARROW_DOWN_CIRCLE_OUTLINE = "ARROW_DOWN_CIRCLE_OUTLINE",
    /** ARROW_DOWN_OUTLINE maps to an equivalently named Component in Constellation 8 */
    ARROW_DOWN_OUTLINE = "ARROW_DOWN_OUTLINE",
    /** ARROW_LEFT maps to an equivalently named Component in Constellation 8 */
    ARROW_LEFT = "ARROW_LEFT",
    /** ARROW_LEFT_CIRCLE maps to an equivalently named Component in Constellation 8 */
    ARROW_LEFT_CIRCLE = "ARROW_LEFT_CIRCLE",
    /** ARROW_LEFT_CIRCLE_OUTLINE maps to an equivalently named Component in Constellation 8 */
    ARROW_LEFT_CIRCLE_OUTLINE = "ARROW_LEFT_CIRCLE_OUTLINE",
    /** ARROW_LEFT_OUTLINE maps to an equivalently named Component in Constellation 8 */
    ARROW_LEFT_OUTLINE = "ARROW_LEFT_OUTLINE",
    /** ARROW_RIGHT maps to an equivalently named Component in Constellation 8 */
    ARROW_RIGHT = "ARROW_RIGHT",
    /** ARROW_RIGHT_CIRCLE maps to an equivalently named Component in Constellation 8 */
    ARROW_RIGHT_CIRCLE = "ARROW_RIGHT_CIRCLE",
    /** ARROW_RIGHT_CIRCLE_OUTLINE maps to an equivalently named Component in Constellation 8 */
    ARROW_RIGHT_CIRCLE_OUTLINE = "ARROW_RIGHT_CIRCLE_OUTLINE",
    /** ARROW_RIGHT_OUTLINE maps to an equivalently named Component in Constellation 8 */
    ARROW_RIGHT_OUTLINE = "ARROW_RIGHT_OUTLINE",
    /** ARROW_UP maps to an equivalently named Component in Constellation 8 */
    ARROW_UP = "ARROW_UP",
    /** ARROW_UP_CIRCLE maps to an equivalently named Component in Constellation 8 */
    ARROW_UP_CIRCLE = "ARROW_UP_CIRCLE",
    /** ARROW_UP_CIRCLE_OUTLINE maps to an equivalently named Component in Constellation 8 */
    ARROW_UP_CIRCLE_OUTLINE = "ARROW_UP_CIRCLE_OUTLINE",
    /** ARROW_UP_OUTLINE maps to an equivalently named Component in Constellation 8 */
    ARROW_UP_OUTLINE = "ARROW_UP_OUTLINE",
    /** ASK_QUESTION maps to an equivalently named Component in Constellation 8 */
    ASK_QUESTION = "ASK_QUESTION",
    /** ASK_QUESTION_OUTLINE maps to an equivalently named Component in Constellation 8 */
    ASK_QUESTION_OUTLINE = "ASK_QUESTION_OUTLINE",
    /** ATTACHMENT maps to an equivalently named Component in Constellation 8 */
    ATTACHMENT = "ATTACHMENT",
    /** AWARD_RIBBON maps to an equivalently named Component in Constellation 8 */
    AWARD_RIBBON = "AWARD_RIBBON",
    /** AWARD_RIBBON_OUTLINE maps to an equivalently named Component in Constellation 8 */
    AWARD_RIBBON_OUTLINE = "AWARD_RIBBON_OUTLINE",
    /** BANK maps to an equivalently named Component in Constellation 8 */
    BANK = "BANK",
    /** BANK_OUTLINE maps to an equivalently named Component in Constellation 8 */
    BANK_OUTLINE = "BANK_OUTLINE",
    /** BASKETBALL maps to an equivalently named Component in Constellation 8 */
    BASKETBALL = "BASKETBALL",
    /** BASKETBALL_OUTLINE maps to an equivalently named Component in Constellation 8 */
    BASKETBALL_OUTLINE = "BASKETBALL_OUTLINE",
    /** BATH maps to an equivalently named Component in Constellation 8 */
    BATH = "BATH",
    /** BATH_OUTLINE maps to an equivalently named Component in Constellation 8 */
    BATH_OUTLINE = "BATH_OUTLINE",
    /** BATTERY_FULL maps to an equivalently named Component in Constellation 8 */
    BATTERY_FULL = "BATTERY_FULL",
    /** BATTERY_FULL_OUTLINE maps to an equivalently named Component in Constellation 8 */
    BATTERY_FULL_OUTLINE = "BATTERY_FULL_OUTLINE",
    /** BATTERY_HALF maps to an equivalently named Component in Constellation 8 */
    BATTERY_HALF = "BATTERY_HALF",
    /** BATTERY_HALF_OUTLINE maps to an equivalently named Component in Constellation 8 */
    BATTERY_HALF_OUTLINE = "BATTERY_HALF_OUTLINE",
    /** BATTERY_LOW maps to an equivalently named Component in Constellation 8 */
    BATTERY_LOW = "BATTERY_LOW",
    /** BATTERY_LOW_OUTLINE maps to an equivalently named Component in Constellation 8 */
    BATTERY_LOW_OUTLINE = "BATTERY_LOW_OUTLINE",
    /** BEAUTY_PRODUCTS maps to an equivalently named Component in Constellation 8 */
    BEAUTY_PRODUCTS = "BEAUTY_PRODUCTS",
    /** BEAUTY_PRODUCTS_OUTLINE maps to an equivalently named Component in Constellation 8 */
    BEAUTY_PRODUCTS_OUTLINE = "BEAUTY_PRODUCTS_OUTLINE",
    /** BED maps to an equivalently named Component in Constellation 8 */
    BED = "BED",
    /** BED_OUTLINE maps to an equivalently named Component in Constellation 8 */
    BED_OUTLINE = "BED_OUTLINE",
    /** BELL maps to an equivalently named Component in Constellation 8 */
    BELL = "BELL",
    /** BELL_OUTLINE maps to an equivalently named Component in Constellation 8 */
    BELL_OUTLINE = "BELL_OUTLINE",
    /** BEST_OF_ZILLOW maps to an equivalently named Component in Constellation 8 */
    BEST_OF_ZILLOW = "BEST_OF_ZILLOW",
    /** BIKE maps to an equivalently named Component in Constellation 8 */
    BIKE = "BIKE",
    /** BIKE_OUTLINE maps to an equivalently named Component in Constellation 8 */
    BIKE_OUTLINE = "BIKE_OUTLINE",
    /** BLUEPRINT maps to an equivalently named Component in Constellation 8 */
    BLUEPRINT = "BLUEPRINT",
    /** BLUEPRINT_OUTLINE maps to an equivalently named Component in Constellation 8 */
    BLUEPRINT_OUTLINE = "BLUEPRINT_OUTLINE",
    /** BROKEN_LINK maps to an equivalently named Component in Constellation 8 */
    BROKEN_LINK = "BROKEN_LINK",
    /** BROKEN_LINK_OUTLINE maps to an equivalently named Component in Constellation 8 */
    BROKEN_LINK_OUTLINE = "BROKEN_LINK_OUTLINE",
    /** BUILDING maps to an equivalently named Component in Constellation 8 */
    BUILDING = "BUILDING",
    /** BUILDINGS maps to an equivalently named Component in Constellation 8 */
    BUILDINGS = "BUILDINGS",
    /** BUILDINGS_OUTLINE maps to an equivalently named Component in Constellation 8 */
    BUILDINGS_OUTLINE = "BUILDINGS_OUTLINE",
    /** BUILDING_OUTLINE maps to an equivalently named Component in Constellation 8 */
    BUILDING_OUTLINE = "BUILDING_OUTLINE",
    /** BULB maps to an equivalently named Component in Constellation 8 */
    BULB = "BULB",
    /** BULB_OUTLINE maps to an equivalently named Component in Constellation 8 */
    BULB_OUTLINE = "BULB_OUTLINE",
    /** BUS maps to an equivalently named Component in Constellation 8 */
    BUS = "BUS",
    /** BUS_OUTLINE maps to an equivalently named Component in Constellation 8 */
    BUS_OUTLINE = "BUS_OUTLINE",
    /** BUS_SIDE maps to an equivalently named Component in Constellation 8 */
    BUS_SIDE = "BUS_SIDE",
    /** BUS_SIDE_OUTLINE maps to an equivalently named Component in Constellation 8 */
    BUS_SIDE_OUTLINE = "BUS_SIDE_OUTLINE",
    /** CALCULATOR maps to an equivalently named Component in Constellation 8 */
    CALCULATOR = "CALCULATOR",
    /** CALCULATOR_OUTLINE maps to an equivalently named Component in Constellation 8 */
    CALCULATOR_OUTLINE = "CALCULATOR_OUTLINE",
    /** CALENDAR maps to an equivalently named Component in Constellation 8 */
    CALENDAR = "CALENDAR",
    /** CALENDAR_OUTLINE maps to an equivalently named Component in Constellation 8 */
    CALENDAR_OUTLINE = "CALENDAR_OUTLINE",
    /** CALENDAR_TIME maps to an equivalently named Component in Constellation 8 */
    CALENDAR_TIME = "CALENDAR_TIME",
    /** CALENDAR_TIME_OUTLINE maps to an equivalently named Component in Constellation 8 */
    CALENDAR_TIME_OUTLINE = "CALENDAR_TIME_OUTLINE",
    /** CAMERA maps to an equivalently named Component in Constellation 8 */
    CAMERA = "CAMERA",
    /** CAMERA_GRID maps to an equivalently named Component in Constellation 8 */
    CAMERA_GRID = "CAMERA_GRID",
    /** CAMERA_GRID_OUTLINE maps to an equivalently named Component in Constellation 8 */
    CAMERA_GRID_OUTLINE = "CAMERA_GRID_OUTLINE",
    /** CAMERA_OUTLINE maps to an equivalently named Component in Constellation 8 */
    CAMERA_OUTLINE = "CAMERA_OUTLINE",
    /** CAMERA_SHUTTER maps to an equivalently named Component in Constellation 8 */
    CAMERA_SHUTTER = "CAMERA_SHUTTER",
    /** CAMERA_SHUTTER_OUTLINE maps to an equivalently named Component in Constellation 8 */
    CAMERA_SHUTTER_OUTLINE = "CAMERA_SHUTTER_OUTLINE",
    /** CAR maps to an equivalently named Component in Constellation 8 */
    CAR = "CAR",
    /** CART maps to an equivalently named Component in Constellation 8 */
    CART = "CART",
    /** CART_OUTLINE maps to an equivalently named Component in Constellation 8 */
    CART_OUTLINE = "CART_OUTLINE",
    /** CAR_OUTLINE maps to an equivalently named Component in Constellation 8 */
    CAR_OUTLINE = "CAR_OUTLINE",
    /** CAR_SIDE maps to an equivalently named Component in Constellation 8 */
    CAR_SIDE = "CAR_SIDE",
    /** CAR_SIDE_OUTLINE maps to an equivalently named Component in Constellation 8 */
    CAR_SIDE_OUTLINE = "CAR_SIDE_OUTLINE",
    /** CHECKBOX maps to an equivalently named Component in Constellation 8 */
    CHECKBOX = "CHECKBOX",
    /** CHECKLIST maps to an equivalently named Component in Constellation 8 */
    CHECKLIST = "CHECKLIST",
    /** CHECKLIST_OUTLINE maps to an equivalently named Component in Constellation 8 */
    CHECKLIST_OUTLINE = "CHECKLIST_OUTLINE",
    /** CHECKMARK maps to an equivalently named Component in Constellation 8 */
    CHECKMARK = "CHECKMARK",
    /** CHECKMARK_CIRCLE maps to an equivalently named Component in Constellation 8 */
    CHECKMARK_CIRCLE = "CHECKMARK_CIRCLE",
    /** CHECKMARK_CIRCLE_OUTLINE maps to an equivalently named Component in Constellation 8 */
    CHECKMARK_CIRCLE_OUTLINE = "CHECKMARK_CIRCLE_OUTLINE",
    /** CHECKMARK_OUTLINE maps to an equivalently named Component in Constellation 8 */
    CHECKMARK_OUTLINE = "CHECKMARK_OUTLINE",
    /** CHEVRON_DOWN maps to an equivalently named Component in Constellation 8 */
    CHEVRON_DOWN = "CHEVRON_DOWN",
    /** CHEVRON_DOWN_CIRCLE maps to an equivalently named Component in Constellation 8 */
    CHEVRON_DOWN_CIRCLE = "CHEVRON_DOWN_CIRCLE",
    /** CHEVRON_DOWN_CIRCLE_OUTLINE maps to an equivalently named Component in Constellation 8 */
    CHEVRON_DOWN_CIRCLE_OUTLINE = "CHEVRON_DOWN_CIRCLE_OUTLINE",
    /** CHEVRON_DOWN_OUTLINE maps to an equivalently named Component in Constellation 8 */
    CHEVRON_DOWN_OUTLINE = "CHEVRON_DOWN_OUTLINE",
    /** CHEVRON_LEFT maps to an equivalently named Component in Constellation 8 */
    CHEVRON_LEFT = "CHEVRON_LEFT",
    /** CHEVRON_LEFT_CIRCLE maps to an equivalently named Component in Constellation 8 */
    CHEVRON_LEFT_CIRCLE = "CHEVRON_LEFT_CIRCLE",
    /** CHEVRON_LEFT_CIRCLE_OUTLINE maps to an equivalently named Component in Constellation 8 */
    CHEVRON_LEFT_CIRCLE_OUTLINE = "CHEVRON_LEFT_CIRCLE_OUTLINE",
    /** CHEVRON_LEFT_OUTLINE maps to an equivalently named Component in Constellation 8 */
    CHEVRON_LEFT_OUTLINE = "CHEVRON_LEFT_OUTLINE",
    /** CHEVRON_RIGHT maps to an equivalently named Component in Constellation 8 */
    CHEVRON_RIGHT = "CHEVRON_RIGHT",
    /** CHEVRON_RIGHT_CIRCLE maps to an equivalently named Component in Constellation 8 */
    CHEVRON_RIGHT_CIRCLE = "CHEVRON_RIGHT_CIRCLE",
    /** CHEVRON_RIGHT_CIRCLE_OUTLINE maps to an equivalently named Component in Constellation 8 */
    CHEVRON_RIGHT_CIRCLE_OUTLINE = "CHEVRON_RIGHT_CIRCLE_OUTLINE",
    /** CHEVRON_RIGHT_OUTLINE maps to an equivalently named Component in Constellation 8 */
    CHEVRON_RIGHT_OUTLINE = "CHEVRON_RIGHT_OUTLINE",
    /** CHEVRON_UP maps to an equivalently named Component in Constellation 8 */
    CHEVRON_UP = "CHEVRON_UP",
    /** CHEVRON_UP_CIRCLE maps to an equivalently named Component in Constellation 8 */
    CHEVRON_UP_CIRCLE = "CHEVRON_UP_CIRCLE",
    /** CHEVRON_UP_CIRCLE_OUTLINE maps to an equivalently named Component in Constellation 8 */
    CHEVRON_UP_CIRCLE_OUTLINE = "CHEVRON_UP_CIRCLE_OUTLINE",
    /** CHEVRON_UP_OUTLINE maps to an equivalently named Component in Constellation 8 */
    CHEVRON_UP_OUTLINE = "CHEVRON_UP_OUTLINE",
    /** CIRCLE maps to an equivalently named Component in Constellation 8 */
    CIRCLE = "CIRCLE",
    /** CIRCLE_OUTLINE maps to an equivalently named Component in Constellation 8 */
    CIRCLE_OUTLINE = "CIRCLE_OUTLINE",
    /** CLOCK maps to an equivalently named Component in Constellation 8 */
    CLOCK = "CLOCK",
    /** CLOCK_OUTLINE maps to an equivalently named Component in Constellation 8 */
    CLOCK_OUTLINE = "CLOCK_OUTLINE",
    /** CLOSE maps to an equivalently named Component in Constellation 8 */
    CLOSE = "CLOSE",
    /** CLOSE_CIRCLE maps to an equivalently named Component in Constellation 8 */
    CLOSE_CIRCLE = "CLOSE_CIRCLE",
    /** CLOSE_CIRCLE_OUTLINE maps to an equivalently named Component in Constellation 8 */
    CLOSE_CIRCLE_OUTLINE = "CLOSE_CIRCLE_OUTLINE",
    /** CLOSE_OUTLINE maps to an equivalently named Component in Constellation 8 */
    CLOSE_OUTLINE = "CLOSE_OUTLINE",
    /** COG maps to an equivalently named Component in Constellation 8 */
    COG = "COG",
    /** COG_OUTLINE maps to an equivalently named Component in Constellation 8 */
    COG_OUTLINE = "COG_OUTLINE",
    /** COLLAPSE maps to an equivalently named Component in Constellation 8 */
    COLLAPSE = "COLLAPSE",
    /** COLLAPSE_OUTLINE maps to an equivalently named Component in Constellation 8 */
    COLLAPSE_OUTLINE = "COLLAPSE_OUTLINE",
    /** COMMUNITY maps to an equivalently named Component in Constellation 8 */
    COMMUNITY = "COMMUNITY",
    /** COMMUNITY_OUTLINE maps to an equivalently named Component in Constellation 8 */
    COMMUNITY_OUTLINE = "COMMUNITY_OUTLINE",
    /** COMPARABLE_HOMES maps to an equivalently named Component in Constellation 8 */
    COMPARABLE_HOMES = "COMPARABLE_HOMES",
    /** COMPARABLE_HOMES_OUTLINE maps to an equivalently named Component in Constellation 8 */
    COMPARABLE_HOMES_OUTLINE = "COMPARABLE_HOMES_OUTLINE",
    /** COMPASS maps to an equivalently named Component in Constellation 8 */
    COMPASS = "COMPASS",
    /** COMPASS_OUTLINE maps to an equivalently named Component in Constellation 8 */
    COMPASS_OUTLINE = "COMPASS_OUTLINE",
    /** COPY maps to an equivalently named Component in Constellation 8 */
    COPY = "COPY",
    /** COPY_OUTLINE maps to an equivalently named Component in Constellation 8 */
    COPY_OUTLINE = "COPY_OUTLINE",
    /** CREDIT_SCORE maps to an equivalently named Component in Constellation 8 */
    CREDIT_SCORE = "CREDIT_SCORE",
    /** CREDIT_SCORE_OUTLINE maps to an equivalently named Component in Constellation 8 */
    CREDIT_SCORE_OUTLINE = "CREDIT_SCORE_OUTLINE",
    /** CROWN maps to an equivalently named Component in Constellation 8 */
    CROWN = "CROWN",
    /** CROWN_OUTLINE maps to an equivalently named Component in Constellation 8 */
    CROWN_OUTLINE = "CROWN_OUTLINE",
    /** DOLLAR_SIGN_CIRCLE maps to an equivalently named Component in Constellation 8 */
    DOLLAR_SIGN_CIRCLE = "DOLLAR_SIGN_CIRCLE",
    /** DOLLAR_SIGN_CIRCLE_OUTLINE maps to an equivalently named Component in Constellation 8 */
    DOLLAR_SIGN_CIRCLE_OUTLINE = "DOLLAR_SIGN_CIRCLE_OUTLINE",
    /** DOOR_OPEN maps to an equivalently named Component in Constellation 8 */
    DOOR_OPEN = "DOOR_OPEN",
    /** DOOR_OPEN_OUTLINE maps to an equivalently named Component in Constellation 8 */
    DOOR_OPEN_OUTLINE = "DOOR_OPEN_OUTLINE",
    /** DOWNLOAD maps to an equivalently named Component in Constellation 8 */
    DOWNLOAD = "DOWNLOAD",
    /** DOWNLOAD_OUTLINE maps to an equivalently named Component in Constellation 8 */
    DOWNLOAD_OUTLINE = "DOWNLOAD_OUTLINE",
    /** DRAW maps to an equivalently named Component in Constellation 8 */
    DRAW = "DRAW",
    /** DRAW_OUTLINE maps to an equivalently named Component in Constellation 8 */
    DRAW_OUTLINE = "DRAW_OUTLINE",
    /** DRIVING_DIRECTIONS maps to an equivalently named Component in Constellation 8 */
    DRIVING_DIRECTIONS = "DRIVING_DIRECTIONS",
    /** DRIVING_DIRECTIONS_OUTLINE maps to an equivalently named Component in Constellation 8 */
    DRIVING_DIRECTIONS_OUTLINE = "DRIVING_DIRECTIONS_OUTLINE",
    /** EDIT maps to an equivalently named Component in Constellation 8 */
    EDIT = "EDIT",
    /** EDIT_FORM maps to an equivalently named Component in Constellation 8 */
    EDIT_FORM = "EDIT_FORM",
    /** EDIT_FORM_OUTLINE maps to an equivalently named Component in Constellation 8 */
    EDIT_FORM_OUTLINE = "EDIT_FORM_OUTLINE",
    /** EDIT_OUTLINE maps to an equivalently named Component in Constellation 8 */
    EDIT_OUTLINE = "EDIT_OUTLINE",
    /** EHO maps to an equivalently named Component in Constellation 8 */
    EHO = "EHO",
    /** EQUAL_HOUSING maps to an equivalently named Component in Constellation 8 */
    EQUAL_HOUSING = "EQUAL_HOUSING",
    /** EQUAL_HOUSING_OUTLINE maps to an equivalently named Component in Constellation 8 */
    EQUAL_HOUSING_OUTLINE = "EQUAL_HOUSING_OUTLINE",
    /** ERROR maps to an equivalently named Component in Constellation 8 */
    ERROR = "ERROR",
    /** EXCLAMATION_CIRCLE maps to an equivalently named Component in Constellation 8 */
    EXCLAMATION_CIRCLE = "EXCLAMATION_CIRCLE",
    /** EXCLAMATION_CIRCLE_OUTLINE maps to an equivalently named Component in Constellation 8 */
    EXCLAMATION_CIRCLE_OUTLINE = "EXCLAMATION_CIRCLE_OUTLINE",
    /** EXPAND maps to an equivalently named Component in Constellation 8 */
    EXPAND = "EXPAND",
    /** EXPAND_OUTLINE maps to an equivalently named Component in Constellation 8 */
    EXPAND_OUTLINE = "EXPAND_OUTLINE",
    /** EXTERNAL maps to an equivalently named Component in Constellation 8 */
    EXTERNAL = "EXTERNAL",
    /** EYE_CLOSED maps to an equivalently named Component in Constellation 8 */
    EYE_CLOSED = "EYE_CLOSED",
    /** EYE_CLOSED_OUTLINE maps to an equivalently named Component in Constellation 8 */
    EYE_CLOSED_OUTLINE = "EYE_CLOSED_OUTLINE",
    /** EYE_OPEN maps to an equivalently named Component in Constellation 8 */
    EYE_OPEN = "EYE_OPEN",
    /** EYE_OPEN_OUTLINE maps to an equivalently named Component in Constellation 8 */
    EYE_OPEN_OUTLINE = "EYE_OPEN_OUTLINE",
    /** FACEBOOK maps to an equivalently named Component in Constellation 8 */
    FACEBOOK = "FACEBOOK",
    /** FACE_HAPPY maps to an equivalently named Component in Constellation 8 */
    FACE_HAPPY = "FACE_HAPPY",
    /** FACE_HAPPY_OUTLINE maps to an equivalently named Component in Constellation 8 */
    FACE_HAPPY_OUTLINE = "FACE_HAPPY_OUTLINE",
    /** FACE_OK maps to an equivalently named Component in Constellation 8 */
    FACE_OK = "FACE_OK",
    /** FACE_OK_OUTLINE maps to an equivalently named Component in Constellation 8 */
    FACE_OK_OUTLINE = "FACE_OK_OUTLINE",
    /** FACE_UNHAPPY maps to an equivalently named Component in Constellation 8 */
    FACE_UNHAPPY = "FACE_UNHAPPY",
    /** FACE_UNHAPPY_OUTLINE maps to an equivalently named Component in Constellation 8 */
    FACE_UNHAPPY_OUTLINE = "FACE_UNHAPPY_OUTLINE",
    /** FACE_VERY_HAPPY maps to an equivalently named Component in Constellation 8 */
    FACE_VERY_HAPPY = "FACE_VERY_HAPPY",
    /** FACE_VERY_HAPPY_OUTLINE maps to an equivalently named Component in Constellation 8 */
    FACE_VERY_HAPPY_OUTLINE = "FACE_VERY_HAPPY_OUTLINE",
    /** FACE_VERY_UNHAPPY maps to an equivalently named Component in Constellation 8 */
    FACE_VERY_UNHAPPY = "FACE_VERY_UNHAPPY",
    /** FACE_VERY_UNHAPPY_OUTLINE maps to an equivalently named Component in Constellation 8 */
    FACE_VERY_UNHAPPY_OUTLINE = "FACE_VERY_UNHAPPY_OUTLINE",
    /** FACTS_FEATURES maps to an equivalently named Component in Constellation 8 */
    FACTS_FEATURES = "FACTS_FEATURES",
    /** FACTS_FEATURES_OUTLINE maps to an equivalently named Component in Constellation 8 */
    FACTS_FEATURES_OUTLINE = "FACTS_FEATURES_OUTLINE",
    /** FAVORITE_HOME maps to an equivalently named Component in Constellation 8 */
    FAVORITE_HOME = "FAVORITE_HOME",
    /** FAVORITE_HOME_OUTLINE maps to an equivalently named Component in Constellation 8 */
    FAVORITE_HOME_OUTLINE = "FAVORITE_HOME_OUTLINE",
    /** FILE maps to an equivalently named Component in Constellation 8 */
    FILE = "FILE",
    /** FILE_CSV maps to an equivalently named Component in Constellation 8 */
    FILE_CSV = "FILE_CSV",
    /** FILE_CSV_OUTLINE maps to an equivalently named Component in Constellation 8 */
    FILE_CSV_OUTLINE = "FILE_CSV_OUTLINE",
    /** FILE_OUTLINE maps to an equivalently named Component in Constellation 8 */
    FILE_OUTLINE = "FILE_OUTLINE",
    /** FILE_PDF maps to an equivalently named Component in Constellation 8 */
    FILE_PDF = "FILE_PDF",
    /** FILE_PDF_OUTLINE maps to an equivalently named Component in Constellation 8 */
    FILE_PDF_OUTLINE = "FILE_PDF_OUTLINE",
    /** FILE_SPREADSHEET maps to an equivalently named Component in Constellation 8 */
    FILE_SPREADSHEET = "FILE_SPREADSHEET",
    /** FILE_SPREADSHEET_OUTLINE maps to an equivalently named Component in Constellation 8 */
    FILE_SPREADSHEET_OUTLINE = "FILE_SPREADSHEET_OUTLINE",
    /** FILE_TEXT maps to an equivalently named Component in Constellation 8 */
    FILE_TEXT = "FILE_TEXT",
    /** FILE_TEXT_OUTLINE maps to an equivalently named Component in Constellation 8 */
    FILE_TEXT_OUTLINE = "FILE_TEXT_OUTLINE",
    /** FILTERS maps to an equivalently named Component in Constellation 8 */
    FILTERS = "FILTERS",
    /** FINGER_DRAW maps to an equivalently named Component in Constellation 8 */
    FINGER_DRAW = "FINGER_DRAW",
    /** FINGER_DRAW_OUTLINE maps to an equivalently named Component in Constellation 8 */
    FINGER_DRAW_OUTLINE = "FINGER_DRAW_OUTLINE",
    /** FLAG maps to an equivalently named Component in Constellation 8 */
    FLAG = "FLAG",
    /** FLAG_OUTLINE maps to an equivalently named Component in Constellation 8 */
    FLAG_OUTLINE = "FLAG_OUTLINE",
    /** FLAG_SWALLOWTAIL maps to an equivalently named Component in Constellation 8 */
    FLAG_SWALLOWTAIL = "FLAG_SWALLOWTAIL",
    /** FLAG_SWALLOWTAIL_OUTLINE maps to an equivalently named Component in Constellation 8 */
    FLAG_SWALLOWTAIL_OUTLINE = "FLAG_SWALLOWTAIL_OUTLINE",
    /** FLOOR_PLAN maps to an equivalently named Component in Constellation 8 */
    FLOOR_PLAN = "FLOOR_PLAN",
    /** FOLDER maps to an equivalently named Component in Constellation 8 */
    FOLDER = "FOLDER",
    /** FOLDER_OUTLINE maps to an equivalently named Component in Constellation 8 */
    FOLDER_OUTLINE = "FOLDER_OUTLINE",
    /** FULL_SCREEN maps to an equivalently named Component in Constellation 8 */
    FULL_SCREEN = "FULL_SCREEN",
    /** FULL_SCREEN_OUTLINE maps to an equivalently named Component in Constellation 8 */
    FULL_SCREEN_OUTLINE = "FULL_SCREEN_OUTLINE",
    /** GAS_STATION maps to an equivalently named Component in Constellation 8 */
    GAS_STATION = "GAS_STATION",
    /** GAS_STATION_OUTLINE maps to an equivalently named Component in Constellation 8 */
    GAS_STATION_OUTLINE = "GAS_STATION_OUTLINE",
    /** GIFT maps to an equivalently named Component in Constellation 8 */
    GIFT = "GIFT",
    /** GIFT_OUTLINE maps to an equivalently named Component in Constellation 8 */
    GIFT_OUTLINE = "GIFT_OUTLINE",
    /** GLOBE maps to an equivalently named Component in Constellation 8 */
    GLOBE = "GLOBE",
    /** GLOBE_OUTLINE maps to an equivalently named Component in Constellation 8 */
    GLOBE_OUTLINE = "GLOBE_OUTLINE",
    /** GOOGLE maps to an equivalently named Component in Constellation 8 */
    GOOGLE = "GOOGLE",
    /** GRADUATION_CAP maps to an equivalently named Component in Constellation 8 */
    GRADUATION_CAP = "GRADUATION_CAP",
    /** GRADUATION_CAP_OUTLINE maps to an equivalently named Component in Constellation 8 */
    GRADUATION_CAP_OUTLINE = "GRADUATION_CAP_OUTLINE",
    /** GRID maps to an equivalently named Component in Constellation 8 */
    GRID = "GRID",
    /** GRID_OUTLINE maps to an equivalently named Component in Constellation 8 */
    GRID_OUTLINE = "GRID_OUTLINE",
    /** HAMMER maps to an equivalently named Component in Constellation 8 */
    HAMMER = "HAMMER",
    /** HAMMER_OUTLINE maps to an equivalently named Component in Constellation 8 */
    HAMMER_OUTLINE = "HAMMER_OUTLINE",
    /** HANGER maps to an equivalently named Component in Constellation 8 */
    HANGER = "HANGER",
    /** HANGER_OUTLINE maps to an equivalently named Component in Constellation 8 */
    HANGER_OUTLINE = "HANGER_OUTLINE",
    /** HDR maps to an equivalently named Component in Constellation 8 */
    HDR = "HDR",
    /** HDR_OUTLINE maps to an equivalently named Component in Constellation 8 */
    HDR_OUTLINE = "HDR_OUTLINE",
    /** HEART maps to an equivalently named Component in Constellation 8 */
    HEART = "HEART",
    /** HEART_OUTLINE maps to an equivalently named Component in Constellation 8 */
    HEART_OUTLINE = "HEART_OUTLINE",
    /** HEATING maps to an equivalently named Component in Constellation 8 */
    HEATING = "HEATING",
    /** HEATING_OUTLINE maps to an equivalently named Component in Constellation 8 */
    HEATING_OUTLINE = "HEATING_OUTLINE",
    /** HELP maps to an equivalently named Component in Constellation 8 */
    HELP = "HELP",
    /** HELP_OUTLINE maps to an equivalently named Component in Constellation 8 */
    HELP_OUTLINE = "HELP_OUTLINE",
    /** HIDE maps to an equivalently named Component in Constellation 8 */
    HIDE = "HIDE",
    /** HIDE_OUTLINE maps to an equivalently named Component in Constellation 8 */
    HIDE_OUTLINE = "HIDE_OUTLINE",
    /** HOA maps to an equivalently named Component in Constellation 8 */
    HOA = "HOA",
    /** HOA_OUTLINE maps to an equivalently named Component in Constellation 8 */
    HOA_OUTLINE = "HOA_OUTLINE",
    /** HOME_SIMILAR maps to an equivalently named Component in Constellation 8 */
    HOME_SIMILAR = "HOME_SIMILAR",
    /** HOME_SIMILAR_OUTLINE maps to an equivalently named Component in Constellation 8 */
    HOME_SIMILAR_OUTLINE = "HOME_SIMILAR_OUTLINE",
    /** HOSPITAL maps to an equivalently named Component in Constellation 8 */
    HOSPITAL = "HOSPITAL",
    /** HOSPITAL_OUTLINE maps to an equivalently named Component in Constellation 8 */
    HOSPITAL_OUTLINE = "HOSPITAL_OUTLINE",
    /** HOUSE maps to an equivalently named Component in Constellation 8 */
    HOUSE = "HOUSE",
    /** HOUSE_OUTLINE maps to an equivalently named Component in Constellation 8 */
    HOUSE_OUTLINE = "HOUSE_OUTLINE",
    /** HOUSE_TIME maps to an equivalently named Component in Constellation 8 */
    HOUSE_TIME = "HOUSE_TIME",
    /** HOUSE_TIME_OUTLINE maps to an equivalently named Component in Constellation 8 */
    HOUSE_TIME_OUTLINE = "HOUSE_TIME_OUTLINE",
    /** HOUSE_TYPE maps to an equivalently named Component in Constellation 8 */
    HOUSE_TYPE = "HOUSE_TYPE",
    /** HOUSE_TYPE_OUTLINE maps to an equivalently named Component in Constellation 8 */
    HOUSE_TYPE_OUTLINE = "HOUSE_TYPE_OUTLINE",
    /** INBOX maps to an equivalently named Component in Constellation 8 */
    INBOX = "INBOX",
    /** INBOX_OUTLINE maps to an equivalently named Component in Constellation 8 */
    INBOX_OUTLINE = "INBOX_OUTLINE",
    /** INFO maps to an equivalently named Component in Constellation 8 */
    INFO = "INFO",
    /** INFO_OUTLINE maps to an equivalently named Component in Constellation 8 */
    INFO_OUTLINE = "INFO_OUTLINE",
    /** INITIALS maps to an equivalently named Component in Constellation 8 */
    INITIALS = "INITIALS",
    /** INSTAGRAM maps to an equivalently named Component in Constellation 8 */
    INSTAGRAM = "INSTAGRAM",
    /** KEY maps to an equivalently named Component in Constellation 8 */
    KEY = "KEY",
    /** KEYBOARD maps to an equivalently named Component in Constellation 8 */
    KEYBOARD = "KEYBOARD",
    /** KEYBOARD_OUTLINE maps to an equivalently named Component in Constellation 8 */
    KEYBOARD_OUTLINE = "KEYBOARD_OUTLINE",
    /** KEY_OUTLINE maps to an equivalently named Component in Constellation 8 */
    KEY_OUTLINE = "KEY_OUTLINE",
    /** LAPTOP maps to an equivalently named Component in Constellation 8 */
    LAPTOP = "LAPTOP",
    /** LAPTOP_OUTLINE maps to an equivalently named Component in Constellation 8 */
    LAPTOP_OUTLINE = "LAPTOP_OUTLINE",
    /** LAUNDRY maps to an equivalently named Component in Constellation 8 */
    LAUNDRY = "LAUNDRY",
    /** LAUNDRY_OUTLINE maps to an equivalently named Component in Constellation 8 */
    LAUNDRY_OUTLINE = "LAUNDRY_OUTLINE",
    /** LAYERS maps to an equivalently named Component in Constellation 8 */
    LAYERS = "LAYERS",
    /** LAYERS_OUTLINE maps to an equivalently named Component in Constellation 8 */
    LAYERS_OUTLINE = "LAYERS_OUTLINE",
    /** LEAF maps to an equivalently named Component in Constellation 8 */
    LEAF = "LEAF",
    /** LEAF_OUTLINE maps to an equivalently named Component in Constellation 8 */
    LEAF_OUTLINE = "LEAF_OUTLINE",
    /** LIGHTNING maps to an equivalently named Component in Constellation 8 */
    LIGHTNING = "LIGHTNING",
    /** LIGHTNING_OUTLINE maps to an equivalently named Component in Constellation 8 */
    LIGHTNING_OUTLINE = "LIGHTNING_OUTLINE",
    /** LINK maps to an equivalently named Component in Constellation 8 */
    LINK = "LINK",
    /** LINKED_IN maps to an equivalently named Component in Constellation 8 */
    LINKED_IN = "LINKED_IN",
    /** LINK_OUTLINE maps to an equivalently named Component in Constellation 8 */
    LINK_OUTLINE = "LINK_OUTLINE",
    /** LIST maps to an equivalently named Component in Constellation 8 */
    LIST = "LIST",
    /** LIST_BULLETED maps to an equivalently named Component in Constellation 8 */
    LIST_BULLETED = "LIST_BULLETED",
    /** LIST_BULLETED_OUTLINE maps to an equivalently named Component in Constellation 8 */
    LIST_BULLETED_OUTLINE = "LIST_BULLETED_OUTLINE",
    /** LIST_NUMBERED maps to an equivalently named Component in Constellation 8 */
    LIST_NUMBERED = "LIST_NUMBERED",
    /** LIST_NUMBERED_OUTLINE maps to an equivalently named Component in Constellation 8 */
    LIST_NUMBERED_OUTLINE = "LIST_NUMBERED_OUTLINE",
    /** LIST_OUTLINE maps to an equivalently named Component in Constellation 8 */
    LIST_OUTLINE = "LIST_OUTLINE",
    /** LIVE_NOW maps to an equivalently named Component in Constellation 8 */
    LIVE_NOW = "LIVE_NOW",
    /** LOCATION maps to an equivalently named Component in Constellation 8 */
    LOCATION = "LOCATION",
    /** LOCATION_ARROW maps to an equivalently named Component in Constellation 8 */
    LOCATION_ARROW = "LOCATION_ARROW",
    /** LOCATION_ARROW_OUTLINE maps to an equivalently named Component in Constellation 8 */
    LOCATION_ARROW_OUTLINE = "LOCATION_ARROW_OUTLINE",
    /** LOCATION_OUTLINE maps to an equivalently named Component in Constellation 8 */
    LOCATION_OUTLINE = "LOCATION_OUTLINE",
    /** LOCK maps to an equivalently named Component in Constellation 8 */
    LOCK = "LOCK",
    /** LOCK_OUTLINE maps to an equivalently named Component in Constellation 8 */
    LOCK_OUTLINE = "LOCK_OUTLINE",
    /** LOT maps to an equivalently named Component in Constellation 8 */
    LOT = "LOT",
    /** LOT_OUTLINE maps to an equivalently named Component in Constellation 8 */
    LOT_OUTLINE = "LOT_OUTLINE",
    /** MAIL maps to an equivalently named Component in Constellation 8 */
    MAIL = "MAIL",
    /** MAIL_OUTLINE maps to an equivalently named Component in Constellation 8 */
    MAIL_OUTLINE = "MAIL_OUTLINE",
    /** MAP maps to an equivalently named Component in Constellation 8 */
    MAP = "MAP",
    /** MAP_DRAW maps to an equivalently named Component in Constellation 8 */
    MAP_DRAW = "MAP_DRAW",
    /** MAP_DRAW_OUTLINE maps to an equivalently named Component in Constellation 8 */
    MAP_DRAW_OUTLINE = "MAP_DRAW_OUTLINE",
    /** MAP_OUTLINE maps to an equivalently named Component in Constellation 8 */
    MAP_OUTLINE = "MAP_OUTLINE",
    /** MARTINI_GLASS maps to an equivalently named Component in Constellation 8 */
    MARTINI_GLASS = "MARTINI_GLASS",
    /** MARTINI_GLASS_OUTLINE maps to an equivalently named Component in Constellation 8 */
    MARTINI_GLASS_OUTLINE = "MARTINI_GLASS_OUTLINE",
    /** MENU maps to an equivalently named Component in Constellation 8 */
    MENU = "MENU",
    /** MENU_OUTLINE maps to an equivalently named Component in Constellation 8 */
    MENU_OUTLINE = "MENU_OUTLINE",
    /** MESSAGE maps to an equivalently named Component in Constellation 8 */
    MESSAGE = "MESSAGE",
    /** MESSAGE_ADD maps to an equivalently named Component in Constellation 8 */
    MESSAGE_ADD = "MESSAGE_ADD",
    /** MESSAGE_ADD_OUTLINE maps to an equivalently named Component in Constellation 8 */
    MESSAGE_ADD_OUTLINE = "MESSAGE_ADD_OUTLINE",
    /** MESSAGE_HEART maps to an equivalently named Component in Constellation 8 */
    MESSAGE_HEART = "MESSAGE_HEART",
    /** MESSAGE_HEART_OUTLINE maps to an equivalently named Component in Constellation 8 */
    MESSAGE_HEART_OUTLINE = "MESSAGE_HEART_OUTLINE",
    /** MESSAGE_OUTLINE maps to an equivalently named Component in Constellation 8 */
    MESSAGE_OUTLINE = "MESSAGE_OUTLINE",
    /** MICROPHONE maps to an equivalently named Component in Constellation 8 */
    MICROPHONE = "MICROPHONE",
    /** MICROPHONE_OUTLINE maps to an equivalently named Component in Constellation 8 */
    MICROPHONE_OUTLINE = "MICROPHONE_OUTLINE",
    /** MINUS maps to an equivalently named Component in Constellation 8 */
    MINUS = "MINUS",
    /** MINUS_CIRCLE maps to an equivalently named Component in Constellation 8 */
    MINUS_CIRCLE = "MINUS_CIRCLE",
    /** MINUS_CIRCLE_OUTLINE maps to an equivalently named Component in Constellation 8 */
    MINUS_CIRCLE_OUTLINE = "MINUS_CIRCLE_OUTLINE",
    /** MINUS_OUTLINE maps to an equivalently named Component in Constellation 8 */
    MINUS_OUTLINE = "MINUS_OUTLINE",
    /** MLS maps to an equivalently named Component in Constellation 8 */
    MLS = "MLS",
    /** MLS_OUTLINE maps to an equivalently named Component in Constellation 8 */
    MLS_OUTLINE = "MLS_OUTLINE",
    /** MONITOR maps to an equivalently named Component in Constellation 8 */
    MONITOR = "MONITOR",
    /** MONITOR_OUTLINE maps to an equivalently named Component in Constellation 8 */
    MONITOR_OUTLINE = "MONITOR_OUTLINE",
    /** MORE maps to an equivalently named Component in Constellation 8 */
    MORE = "MORE",
    /** MORE_OUTLINE maps to an equivalently named Component in Constellation 8 */
    MORE_OUTLINE = "MORE_OUTLINE",
    /** MORE_VERTICAL maps to an equivalently named Component in Constellation 8 */
    MORE_VERTICAL = "MORE_VERTICAL",
    /** MORE_VERTICAL_OUTLINE maps to an equivalently named Component in Constellation 8 */
    MORE_VERTICAL_OUTLINE = "MORE_VERTICAL_OUTLINE",
    /** MOUSE maps to an equivalently named Component in Constellation 8 */
    MOUSE = "MOUSE",
    /** MOUSE_OUTLINE maps to an equivalently named Component in Constellation 8 */
    MOUSE_OUTLINE = "MOUSE_OUTLINE",
    /** MUG maps to an equivalently named Component in Constellation 8 */
    MUG = "MUG",
    /** MUG_OUTLINE maps to an equivalently named Component in Constellation 8 */
    MUG_OUTLINE = "MUG_OUTLINE",
    /** MY_HOME maps to an equivalently named Component in Constellation 8 */
    MY_HOME = "MY_HOME",
    /** MY_HOME_OUTLINE maps to an equivalently named Component in Constellation 8 */
    MY_HOME_OUTLINE = "MY_HOME_OUTLINE",
    /** NEIGHBORHOOD maps to an equivalently named Component in Constellation 8 */
    NEIGHBORHOOD = "NEIGHBORHOOD",
    /** NEIGHBORHOOD_OUTLINE maps to an equivalently named Component in Constellation 8 */
    NEIGHBORHOOD_OUTLINE = "NEIGHBORHOOD_OUTLINE",
    /** NEW_TEAM_MEMBER maps to an equivalently named Component in Constellation 8 */
    NEW_TEAM_MEMBER = "NEW_TEAM_MEMBER",
    /** NEW_TEAM_MEMBER_OUTLINE maps to an equivalently named Component in Constellation 8 */
    NEW_TEAM_MEMBER_OUTLINE = "NEW_TEAM_MEMBER_OUTLINE",
    /** NOTE maps to an equivalently named Component in Constellation 8 */
    NOTE = "NOTE",
    /** NOTE_ADD maps to an equivalently named Component in Constellation 8 */
    NOTE_ADD = "NOTE_ADD",
    /** NOTE_ADD_OUTLINE maps to an equivalently named Component in Constellation 8 */
    NOTE_ADD_OUTLINE = "NOTE_ADD_OUTLINE",
    /** NOTE_OUTLINE maps to an equivalently named Component in Constellation 8 */
    NOTE_OUTLINE = "NOTE_OUTLINE",
    /** PANORAMA maps to an equivalently named Component in Constellation 8 */
    PANORAMA = "PANORAMA",
    /** PANORAMA_360 maps to an equivalently named Component in Constellation 8 */
    PANORAMA_360 = "PANORAMA_360",
    /** PANORAMA_360_OUTLINE maps to an equivalently named Component in Constellation 8 */
    PANORAMA_360_OUTLINE = "PANORAMA_360_OUTLINE",
    /** PANORAMA_OUTLINE maps to an equivalently named Component in Constellation 8 */
    PANORAMA_OUTLINE = "PANORAMA_OUTLINE",
    /** PARKING maps to an equivalently named Component in Constellation 8 */
    PARKING = "PARKING",
    /** PARKING_OUTLINE maps to an equivalently named Component in Constellation 8 */
    PARKING_OUTLINE = "PARKING_OUTLINE",
    /** PASTE maps to an equivalently named Component in Constellation 8 */
    PASTE = "PASTE",
    /** PASTE_OUTLINE maps to an equivalently named Component in Constellation 8 */
    PASTE_OUTLINE = "PASTE_OUTLINE",
    /** PATIO maps to an equivalently named Component in Constellation 8 */
    PATIO = "PATIO",
    /** PATIO_OUTLINE maps to an equivalently named Component in Constellation 8 */
    PATIO_OUTLINE = "PATIO_OUTLINE",
    /** PAUSE maps to an equivalently named Component in Constellation 8 */
    PAUSE = "PAUSE",
    /** PAUSE_CIRCLE maps to an equivalently named Component in Constellation 8 */
    PAUSE_CIRCLE = "PAUSE_CIRCLE",
    /** PAUSE_CIRCLE_OUTLINE maps to an equivalently named Component in Constellation 8 */
    PAUSE_CIRCLE_OUTLINE = "PAUSE_CIRCLE_OUTLINE",
    /** PAUSE_OUTLINE maps to an equivalently named Component in Constellation 8 */
    PAUSE_OUTLINE = "PAUSE_OUTLINE",
    /** PEDESTRIAN maps to an equivalently named Component in Constellation 8 */
    PEDESTRIAN = "PEDESTRIAN",
    /** PEDESTRIAN_OUTLINE maps to an equivalently named Component in Constellation 8 */
    PEDESTRIAN_OUTLINE = "PEDESTRIAN_OUTLINE",
    /** PETS maps to an equivalently named Component in Constellation 8 */
    PETS = "PETS",
    /** PETS_OUTLINE maps to an equivalently named Component in Constellation 8 */
    PETS_OUTLINE = "PETS_OUTLINE",
    /** PHONE maps to an equivalently named Component in Constellation 8 */
    PHONE = "PHONE",
    /** PHONE_CIRCLE maps to an equivalently named Component in Constellation 8 */
    PHONE_CIRCLE = "PHONE_CIRCLE",
    /** PHONE_CIRCLE_OUTLINE maps to an equivalently named Component in Constellation 8 */
    PHONE_CIRCLE_OUTLINE = "PHONE_CIRCLE_OUTLINE",
    /** PHONE_OUTLINE maps to an equivalently named Component in Constellation 8 */
    PHONE_OUTLINE = "PHONE_OUTLINE",
    /** PHOTOS maps to an equivalently named Component in Constellation 8 */
    PHOTOS = "PHOTOS",
    /** PHOTOS_OUTLINE maps to an equivalently named Component in Constellation 8 */
    PHOTOS_OUTLINE = "PHOTOS_OUTLINE",
    /** PIG maps to an equivalently named Component in Constellation 8 */
    PIG = "PIG",
    /** PIG_OUTLINE maps to an equivalently named Component in Constellation 8 */
    PIG_OUTLINE = "PIG_OUTLINE",
    /** PINTEREST maps to an equivalently named Component in Constellation 8 */
    PINTEREST = "PINTEREST",
    /** PLAY maps to an equivalently named Component in Constellation 8 */
    PLAY = "PLAY",
    /** PLAY_CIRCLE maps to an equivalently named Component in Constellation 8 */
    PLAY_CIRCLE = "PLAY_CIRCLE",
    /** PLAY_CIRCLE_OUTLINE maps to an equivalently named Component in Constellation 8 */
    PLAY_CIRCLE_OUTLINE = "PLAY_CIRCLE_OUTLINE",
    /** PLAY_OUTLINE maps to an equivalently named Component in Constellation 8 */
    PLAY_OUTLINE = "PLAY_OUTLINE",
    /** PLUS maps to an equivalently named Component in Constellation 8 */
    PLUS = "PLUS",
    /** PLUS_CIRCLE maps to an equivalently named Component in Constellation 8 */
    PLUS_CIRCLE = "PLUS_CIRCLE",
    /** PLUS_CIRCLE_OUTLINE maps to an equivalently named Component in Constellation 8 */
    PLUS_CIRCLE_OUTLINE = "PLUS_CIRCLE_OUTLINE",
    /** PLUS_OUTLINE maps to an equivalently named Component in Constellation 8 */
    PLUS_OUTLINE = "PLUS_OUTLINE",
    /** POINTER_DOWN maps to an equivalently named Component in Constellation 8 */
    POINTER_DOWN = "POINTER_DOWN",
    /** POINTER_DOWN_OUTLINE maps to an equivalently named Component in Constellation 8 */
    POINTER_DOWN_OUTLINE = "POINTER_DOWN_OUTLINE",
    /** POINTER_UP maps to an equivalently named Component in Constellation 8 */
    POINTER_UP = "POINTER_UP",
    /** POINTER_UP_OUTLINE maps to an equivalently named Component in Constellation 8 */
    POINTER_UP_OUTLINE = "POINTER_UP_OUTLINE",
    /** PRESCRIPTION_PILL maps to an equivalently named Component in Constellation 8 */
    PRESCRIPTION_PILL = "PRESCRIPTION_PILL",
    /** PRESCRIPTION_PILL_OUTLINE maps to an equivalently named Component in Constellation 8 */
    PRESCRIPTION_PILL_OUTLINE = "PRESCRIPTION_PILL_OUTLINE",
    /** PRESS maps to an equivalently named Component in Constellation 8 */
    PRESS = "PRESS",
    /** PRESS_OUTLINE maps to an equivalently named Component in Constellation 8 */
    PRESS_OUTLINE = "PRESS_OUTLINE",
    /** PRICE_SQFT maps to an equivalently named Component in Constellation 8 */
    PRICE_SQFT = "PRICE_SQFT",
    /** PRICE_SQFT_OUTLINE maps to an equivalently named Component in Constellation 8 */
    PRICE_SQFT_OUTLINE = "PRICE_SQFT_OUTLINE",
    /** PRICE_TAG maps to an equivalently named Component in Constellation 8 */
    PRICE_TAG = "PRICE_TAG",
    /** PRICE_TAG_OUTLINE maps to an equivalently named Component in Constellation 8 */
    PRICE_TAG_OUTLINE = "PRICE_TAG_OUTLINE",
    /** PRINTER maps to an equivalently named Component in Constellation 8 */
    PRINTER = "PRINTER",
    /** PRINTER_OUTLINE maps to an equivalently named Component in Constellation 8 */
    PRINTER_OUTLINE = "PRINTER_OUTLINE",
    /** PROFILE maps to an equivalently named Component in Constellation 8 */
    PROFILE = "PROFILE",
    /** PROFILE_OUTLINE maps to an equivalently named Component in Constellation 8 */
    PROFILE_OUTLINE = "PROFILE_OUTLINE",
    /** PUBLIC_TRANSIT maps to an equivalently named Component in Constellation 8 */
    PUBLIC_TRANSIT = "PUBLIC_TRANSIT",
    /** PUBLIC_TRANSIT_OUTLINE maps to an equivalently named Component in Constellation 8 */
    PUBLIC_TRANSIT_OUTLINE = "PUBLIC_TRANSIT_OUTLINE",
    /** REDO maps to an equivalently named Component in Constellation 8 */
    REDO = "REDO",
    /** REFRIGERATOR maps to an equivalently named Component in Constellation 8 */
    REFRIGERATOR = "REFRIGERATOR",
    /** REFRIGERATOR_OUTLINE maps to an equivalently named Component in Constellation 8 */
    REFRIGERATOR_OUTLINE = "REFRIGERATOR_OUTLINE",
    /** RELOAD maps to an equivalently named Component in Constellation 8 */
    RELOAD = "RELOAD",
    /** RENAME maps to an equivalently named Component in Constellation 8 */
    RENAME = "RENAME",
    /** RENAME_OUTLINE maps to an equivalently named Component in Constellation 8 */
    RENAME_OUTLINE = "RENAME_OUTLINE",
    /** REORDER maps to an equivalently named Component in Constellation 8 */
    REORDER = "REORDER",
    /** REPLY maps to an equivalently named Component in Constellation 8 */
    REPLY = "REPLY",
    /** RESTORE_OUTLINE maps to an equivalently named Component in Constellation 8 */
    RESTORE_OUTLINE = "RESTORE_OUTLINE",
    /** ROTATE_CLOCKWISE maps to an equivalently named Component in Constellation 8 */
    ROTATE_CLOCKWISE = "ROTATE_CLOCKWISE",
    /** ROTATE_CLOCKWISE_OUTLINE maps to an equivalently named Component in Constellation 8 */
    ROTATE_CLOCKWISE_OUTLINE = "ROTATE_CLOCKWISE_OUTLINE",
    /** ROTATE_COUNTER_CLOCKWISE maps to an equivalently named Component in Constellation 8 */
    ROTATE_COUNTER_CLOCKWISE = "ROTATE_COUNTER_CLOCKWISE",
    /** ROTATE_COUNTER_CLOCKWISE_OUTLINE maps to an equivalently named Component in Constellation 8 */
    ROTATE_COUNTER_CLOCKWISE_OUTLINE = "ROTATE_COUNTER_CLOCKWISE_OUTLINE",
    /** SAVED_SEARCH maps to an equivalently named Component in Constellation 8 */
    SAVED_SEARCH = "SAVED_SEARCH",
    /** SAVED_SEARCH_OUTLINE maps to an equivalently named Component in Constellation 8 */
    SAVED_SEARCH_OUTLINE = "SAVED_SEARCH_OUTLINE",
    /** SCHOOL maps to an equivalently named Component in Constellation 8 */
    SCHOOL = "SCHOOL",
    /** SCHOOL_OUTLINE maps to an equivalently named Component in Constellation 8 */
    SCHOOL_OUTLINE = "SCHOOL_OUTLINE",
    /** SEARCH maps to an equivalently named Component in Constellation 8 */
    SEARCH = "SEARCH",
    /** SEARCH_OUTLINE maps to an equivalently named Component in Constellation 8 */
    SEARCH_OUTLINE = "SEARCH_OUTLINE",
    /** SEND maps to an equivalently named Component in Constellation 8 */
    SEND = "SEND",
    /** SEND_OUTLINE maps to an equivalently named Component in Constellation 8 */
    SEND_OUTLINE = "SEND_OUTLINE",
    /** SHARE maps to an equivalently named Component in Constellation 8 */
    SHARE = "SHARE",
    /** SHOPPING_BAGS maps to an equivalently named Component in Constellation 8 */
    SHOPPING_BAGS = "SHOPPING_BAGS",
    /** SHOPPING_BAGS_OUTLINE maps to an equivalently named Component in Constellation 8 */
    SHOPPING_BAGS_OUTLINE = "SHOPPING_BAGS_OUTLINE",
    /** SIGNATURE maps to an equivalently named Component in Constellation 8 */
    SIGNATURE = "SIGNATURE",
    /** SMARTPHONE maps to an equivalently named Component in Constellation 8 */
    SMARTPHONE = "SMARTPHONE",
    /** SMARTPHONE_OUTLINE maps to an equivalently named Component in Constellation 8 */
    SMARTPHONE_OUTLINE = "SMARTPHONE_OUTLINE",
    /** SNOWFLAKE maps to an equivalently named Component in Constellation 8 */
    SNOWFLAKE = "SNOWFLAKE",
    /** SORT maps to an equivalently named Component in Constellation 8 */
    SORT = "SORT",
    /** SORT_ASCENDING maps to an equivalently named Component in Constellation 8 */
    SORT_ASCENDING = "SORT_ASCENDING",
    /** SORT_DESCENDING maps to an equivalently named Component in Constellation 8 */
    SORT_DESCENDING = "SORT_DESCENDING",
    /** SORT_OUTLINE maps to an equivalently named Component in Constellation 8 */
    SORT_OUTLINE = "SORT_OUTLINE",
    /** SPAM_FOLDER maps to an equivalently named Component in Constellation 8 */
    SPAM_FOLDER = "SPAM_FOLDER",
    /** SPAM_FOLDER_OUTLINE maps to an equivalently named Component in Constellation 8 */
    SPAM_FOLDER_OUTLINE = "SPAM_FOLDER_OUTLINE",
    /** SPARKLE maps to an equivalently named Component in Constellation 8 */
    SPARKLE = "SPARKLE",
    /** SPARKLE_OUTLINE maps to an equivalently named Component in Constellation 8 */
    SPARKLE_OUTLINE = "SPARKLE_OUTLINE",
    /** SPEAKER_VOLUME_UP maps to an equivalently named Component in Constellation 8 */
    SPEAKER_VOLUME_UP = "SPEAKER_VOLUME_UP",
    /** SPEAKER_VOLUME_UP_OUTLINE maps to an equivalently named Component in Constellation 8 */
    SPEAKER_VOLUME_UP_OUTLINE = "SPEAKER_VOLUME_UP_OUTLINE",
    /** SQUARE_FEET maps to an equivalently named Component in Constellation 8 */
    SQUARE_FEET = "SQUARE_FEET",
    /** SQUARE_FEET_OUTLINE maps to an equivalently named Component in Constellation 8 */
    SQUARE_FEET_OUTLINE = "SQUARE_FEET_OUTLINE",
    /** STAR maps to an equivalently named Component in Constellation 8 */
    STAR = "STAR",
    /** STAR_25 maps to an equivalently named Component in Constellation 8 */
    STAR_25_PERCENT = "STAR_25_PERCENT",
    /** STAR_50 maps to an equivalently named Component in Constellation 8 */
    STAR_50_PERCENT = "STAR_50_PERCENT",
    /** STAR_75 maps to an equivalently named Component in Constellation 8 */
    STAR_75_PERCENT = "STAR_75_PERCENT",
    /** STAR_OUTLINE maps to an equivalently named Component in Constellation 8 */
    STAR_OUTLINE = "STAR_OUTLINE",
    /** STETHOSCOPE maps to an equivalently named Component in Constellation 8 */
    STETHOSCOPE = "STETHOSCOPE",
    /** STETHOSCOPE_OUTLINE maps to an equivalently named Component in Constellation 8 */
    STETHOSCOPE_OUTLINE = "STETHOSCOPE_OUTLINE",
    /** STOP maps to an equivalently named Component in Constellation 8 */
    STOP = "STOP",
    /** STOP_OUTLINE maps to an equivalently named Component in Constellation 8 */
    STOP_OUTLINE = "STOP_OUTLINE",
    /** STREET_VIEW maps to an equivalently named Component in Constellation 8 */
    STREET_VIEW = "STREET_VIEW",
    /** STREET_VIEW_OUTLINE maps to an equivalently named Component in Constellation 8 */
    STREET_VIEW_OUTLINE = "STREET_VIEW_OUTLINE",
    /** SUCCESS maps to an equivalently named Component in Constellation 8 */
    SUCCESS = "SUCCESS",
    /** SWIPE maps to an equivalently named Component in Constellation 8 */
    SWIPE = "SWIPE",
    /** SWIPE_OUTLINE maps to an equivalently named Component in Constellation 8 */
    SWIPE_OUTLINE = "SWIPE_OUTLINE",
    /** SYNC maps to an equivalently named Component in Constellation 8 */
    SYNC = "SYNC",
    /** TABLET maps to an equivalently named Component in Constellation 8 */
    TABLET = "TABLET",
    /** TABLET_OUTLINE maps to an equivalently named Component in Constellation 8 */
    TABLET_OUTLINE = "TABLET_OUTLINE",
    /** TAG maps to an equivalently named Component in Constellation 8 */
    TAG = "TAG",
    /** TAG_OUTLINE maps to an equivalently named Component in Constellation 8 */
    TAG_OUTLINE = "TAG_OUTLINE",
    /** TAX maps to an equivalently named Component in Constellation 8 */
    TAX = "TAX",
    /** TAX_OUTLINE maps to an equivalently named Component in Constellation 8 */
    TAX_OUTLINE = "TAX_OUTLINE",
    /** TEAM maps to an equivalently named Component in Constellation 8 */
    TEAM = "TEAM",
    /** TEAM_OUTLINE maps to an equivalently named Component in Constellation 8 */
    TEAM_OUTLINE = "TEAM_OUTLINE",
    /** TEXT_BOLD maps to an equivalently named Component in Constellation 8 */
    TEXT_BOLD = "TEXT_BOLD",
    /** TEXT_BOLD_OUTLINE maps to an equivalently named Component in Constellation 8 */
    TEXT_BOLD_OUTLINE = "TEXT_BOLD_OUTLINE",
    /** TEXT_CENTER_ALIGNED maps to an equivalently named Component in Constellation 8 */
    TEXT_CENTER_ALIGNED = "TEXT_CENTER_ALIGNED",
    /** TEXT_CENTER_ALIGNED_OUTLINE maps to an equivalently named Component in Constellation 8 */
    TEXT_CENTER_ALIGNED_OUTLINE = "TEXT_CENTER_ALIGNED_OUTLINE",
    /** TEXT_COLOR maps to an equivalently named Component in Constellation 8 */
    TEXT_COLOR = "TEXT_COLOR",
    /** TEXT_COLOR_OUTLINE maps to an equivalently named Component in Constellation 8 */
    TEXT_COLOR_OUTLINE = "TEXT_COLOR_OUTLINE",
    /** TEXT_ITALIC maps to an equivalently named Component in Constellation 8 */
    TEXT_ITALIC = "TEXT_ITALIC",
    /** TEXT_ITALIC_OUTLINE maps to an equivalently named Component in Constellation 8 */
    TEXT_ITALIC_OUTLINE = "TEXT_ITALIC_OUTLINE",
    /** TEXT_LEFT_ALIGNED maps to an equivalently named Component in Constellation 8 */
    TEXT_LEFT_ALIGNED = "TEXT_LEFT_ALIGNED",
    /** TEXT_LEFT_ALIGNED_OUTLINE maps to an equivalently named Component in Constellation 8 */
    TEXT_LEFT_ALIGNED_OUTLINE = "TEXT_LEFT_ALIGNED_OUTLINE",
    /** TEXT_RIGHT_ALIGNED maps to an equivalently named Component in Constellation 8 */
    TEXT_RIGHT_ALIGNED = "TEXT_RIGHT_ALIGNED",
    /** TEXT_RIGHT_ALIGNED_OUTLINE maps to an equivalently named Component in Constellation 8 */
    TEXT_RIGHT_ALIGNED_OUTLINE = "TEXT_RIGHT_ALIGNED_OUTLINE",
    /** TEXT_UNDERLINED maps to an equivalently named Component in Constellation 8 */
    TEXT_UNDERLINED = "TEXT_UNDERLINED",
    /** TEXT_UNDERLINED_OUTLINE maps to an equivalently named Component in Constellation 8 */
    TEXT_UNDERLINED_OUTLINE = "TEXT_UNDERLINED_OUTLINE",
    /** THREE_DIMENSIONAL maps to an equivalently named Component in Constellation 8 */
    THREE_DIMENSIONAL = "THREE_DIMENSIONAL",
    /** THREE_DIMENSIONAL_OUTLINE maps to an equivalently named Component in Constellation 8 */
    THREE_DIMENSIONAL_OUTLINE = "THREE_DIMENSIONAL_OUTLINE",
    /** THUMBS_DOWN maps to an equivalently named Component in Constellation 8 */
    THUMBS_DOWN = "THUMBS_DOWN",
    /** THUMBS_DOWN_OUTLINE maps to an equivalently named Component in Constellation 8 */
    THUMBS_DOWN_OUTLINE = "THUMBS_DOWN_OUTLINE",
    /** THUMBS_UP maps to an equivalently named Component in Constellation 8 */
    THUMBS_UP = "THUMBS_UP",
    /** THUMBS_UP_OUTLINE maps to an equivalently named Component in Constellation 8 */
    THUMBS_UP_OUTLINE = "THUMBS_UP_OUTLINE",
    /** TICKET maps to an equivalently named Component in Constellation 8 */
    TICKET = "TICKET",
    /** TICKET_OUTLINE maps to an equivalently named Component in Constellation 8 */
    TICKET_OUTLINE = "TICKET_OUTLINE",
    /** TIK_TOK maps to an equivalently named Component in Constellation 8 */
    TIK_TOK = "TIK_TOK",
    /** TOP_AGENT maps to an equivalently named Component in Constellation 8 */
    TOP_AGENT = "TOP_AGENT",
    /** TOUR_DOOR maps to an equivalently named Component in Constellation 8 */
    TOUR_DOOR = "TOUR_DOOR",
    /** TOUR_DOOR_OUTLINE maps to an equivalently named Component in Constellation 8 */
    TOUR_DOOR_OUTLINE = "TOUR_DOOR_OUTLINE",
    /** TRASHCAN maps to an equivalently named Component in Constellation 8 */
    TRASHCAN = "TRASHCAN",
    /** TRASHCAN_OUTLINE maps to an equivalently named Component in Constellation 8 */
    TRASHCAN_OUTLINE = "TRASHCAN_OUTLINE",
    /** TREES maps to an equivalently named Component in Constellation 8 */
    TREES = "TREES",
    /** TREES_EVERGREEN maps to an equivalently named Component in Constellation 8 */
    TREES_EVERGREEN = "TREES_EVERGREEN",
    /** TREES_EVERGREEN_OUTLINE maps to an equivalently named Component in Constellation 8 */
    TREES_EVERGREEN_OUTLINE = "TREES_EVERGREEN_OUTLINE",
    /** TREES_OUTLINE maps to an equivalently named Component in Constellation 8 */
    TREES_OUTLINE = "TREES_OUTLINE",
    /** TRENDING maps to an equivalently named Component in Constellation 8 */
    TRENDING = "TRENDING",
    /** TRENDING_OUTLINE maps to an equivalently named Component in Constellation 8 */
    TRENDING_OUTLINE = "TRENDING_OUTLINE",
    /** TROPHY maps to an equivalently named Component in Constellation 8 */
    TROPHY = "TROPHY",
    /** TROPHY_OUTLINE maps to an equivalently named Component in Constellation 8 */
    TROPHY_OUTLINE = "TROPHY_OUTLINE",
    /** TWITTER maps to an equivalently named Component in Constellation 8 */
    TWITTER = "TWITTER",
    /** UNDO maps to an equivalently named Component in Constellation 8 */
    UNDO = "UNDO",
    /** UNLOCK maps to an equivalently named Component in Constellation 8 */
    UNLOCK = "UNLOCK",
    /** UNLOCK_OUTLINE maps to an equivalently named Component in Constellation 8 */
    UNLOCK_OUTLINE = "UNLOCK_OUTLINE",
    /** UPLOAD maps to an equivalently named Component in Constellation 8 */
    UPLOAD = "UPLOAD",
    /** UPLOAD_OUTLINE maps to an equivalently named Component in Constellation 8 */
    UPLOAD_OUTLINE = "UPLOAD_OUTLINE",
    /** USER maps to an equivalently named Component in Constellation 8 */
    USER = "USER",
    /** USER_OUTLINE maps to an equivalently named Component in Constellation 8 */
    USER_OUTLINE = "USER_OUTLINE",
    /** USER_SETTINGS maps to an equivalently named Component in Constellation 8 */
    USER_SETTINGS = "USER_SETTINGS",
    /** USER_SETTINGS_OUTLINE maps to an equivalently named Component in Constellation 8 */
    USER_SETTINGS_OUTLINE = "USER_SETTINGS_OUTLINE",
    /** UTENSILS maps to an equivalently named Component in Constellation 8 */
    UTENSILS = "UTENSILS",
    /** UTENSILS_OUTLINE maps to an equivalently named Component in Constellation 8 */
    UTENSILS_OUTLINE = "UTENSILS_OUTLINE",
    /** VACATION maps to an equivalently named Component in Constellation 8 */
    VACATION = "VACATION",
    /** VACATION_OUTLINE maps to an equivalently named Component in Constellation 8 */
    VACATION_OUTLINE = "VACATION_OUTLINE",
    /** VIDEO maps to an equivalently named Component in Constellation 8 */
    VIDEO = "VIDEO",
    /** VIDEO_OUTLINE maps to an equivalently named Component in Constellation 8 */
    VIDEO_OUTLINE = "VIDEO_OUTLINE",
    /** VIDEO_PLAY maps to an equivalently named Component in Constellation 8 */
    VIDEO_PLAY = "VIDEO_PLAY",
    /** VIDEO_PLAY_OUTLINE maps to an equivalently named Component in Constellation 8 */
    VIDEO_PLAY_OUTLINE = "VIDEO_PLAY_OUTLINE",
    /** WAITING maps to an equivalently named Component in Constellation 8 */
    WAITING = "WAITING",
    /** WAITING_OUTLINE maps to an equivalently named Component in Constellation 8 */
    WAITING_OUTLINE = "WAITING_OUTLINE",
    /** WARNING maps to an equivalently named Component in Constellation 8 */
    WARNING = "WARNING",
    /** WARNING_OUTLINE maps to an equivalently named Component in Constellation 8 */
    WARNING_OUTLINE = "WARNING_OUTLINE",
    /** WEIGHT maps to an equivalently named Component in Constellation 8 */
    WEIGHT = "WEIGHT",
    /** WEIGHT_OUTLINE maps to an equivalently named Component in Constellation 8 */
    WEIGHT_OUTLINE = "WEIGHT_OUTLINE",
    /** WHATS_APP maps to an equivalently named Component in Constellation 8 */
    WHATS_APP = "WHATS_APP",
    /** WHITE_BALANCE maps to an equivalently named Component in Constellation 8 */
    WHITE_BALANCE = "WHITE_BALANCE",
    /** WHITE_BALANCE_OUTLINE maps to an equivalently named Component in Constellation 8 */
    WHITE_BALANCE_OUTLINE = "WHITE_BALANCE_OUTLINE",
    /** X maps to an equivalently named Component in Constellation 8 */
    X = "X",
    /** YARD_SIGN maps to an equivalently named Component in Constellation 8 */
    YARD_SIGN = "YARD_SIGN",
    /** YARD_SIGN_OUTLINE maps to an equivalently named Component in Constellation 8 */
    YARD_SIGN_OUTLINE = "YARD_SIGN_OUTLINE",
    /** YOU_TUBE maps to an equivalently named Component in Constellation 8 */
    YOU_TUBE = "YOU_TUBE",
    /** ZILLOW_LOGO maps to an equivalently named Component in Constellation 8 */
    ZILLOW_LOGO = "ZILLOW_LOGO",
    /** ZOOM_IN maps to an equivalently named Component in Constellation 8 */
    ZOOM_IN = "ZOOM_IN",
    /** ZOOM_IN_OUTLINE maps to an equivalently named Component in Constellation 8 */
    ZOOM_IN_OUTLINE = "ZOOM_IN_OUTLINE",
    /** ZOOM_OUT maps to an equivalently named Component in Constellation 8 */
    ZOOM_OUT = "ZOOM_OUT",
    /** ZOOM_OUT_OUTLINE maps to an equivalently named Component in Constellation 8 */
    ZOOM_OUT_OUTLINE = "ZOOM_OUT_OUTLINE"
}
/**
 * Supported Appearances for a Constellation 8 Icon Button.
 *
 * Aligns with Constellation 8 Tokens
 */
export enum ZHLExperienceWebConstellation8IconButtonAppearance {
    /** Circular appearance. */
    CIRCLE = "CIRCLE",
    /** Square appearance. */
    SQUARE = "SQUARE"
}
/**
 * Supported Button Types for a Constellation 8 Icon Button.
 *
 * Aligns with Constellation 8 Tokens
 */
export enum ZHLExperienceWebConstellation8IconButtonType {
    /** Critical button type. */
    CRITICAL = "CRITICAL",
    /** Primary button type. */
    PRIMARY = "PRIMARY",
    /** Secondary button type. */
    SECONDARY = "SECONDARY",
    /** Tertiary button type. */
    TERTIARY = "TERTIARY"
}
/**
 * Supported sizing for Icons in Constellation 8 Web in ZHL Experience Graph
 *
 * These values map closely to equivalent tokens for the Constellation SDK on Styled Components
 */
export enum ZHLExperienceWebConstellation8IconSize {
    /** Large Icon Size */
    LG = "LG",
    /** Medium Icon Size */
    MD = "MD",
    /** Small icon size */
    SM = "SM",
    /** Extra small icon size */
    XS = "XS"
}
/** Supported List appearances in Web Constellation 8 in ZHL Experience Graph */
export enum ZHLExperienceWebConstellation8ListAppearance {
    /** Display the list as a bullet point list */
    BULLET = "BULLET",
    /** Display the list as a horizontal table sans columns */
    HORIZONTAL_TABLE = "HORIZONTAL_TABLE",
    /** Special case where an icon is used as a bullet */
    ICONIFIED = "ICONIFIED",
    /** Display the list as a set of vertically stacked text */
    NONE = "NONE",
    /** Display the list as a numbered list */
    NUMBER = "NUMBER"
}
/** Supported Web Constellation 8 Text Alignments in ZHL Experience Graph */
export enum ZHLExperienceWebConstellation8TextAlignment {
    /** Center aligned text */
    CENTER = "CENTER",
    /** End aligned text */
    END = "END",
    /** Justified text */
    JUSTIFY = "JUSTIFY",
    /** Left aligned text */
    LEFT = "LEFT",
    /** Right aligned text */
    RIGHT = "RIGHT",
    /** Start aligned text */
    START = "START"
}
/** Supported Avatar sizes in Web Constellation 10 in ZHL Experience Graph */
export enum ZHLExperienceWebConstellation10AvatarSize {
    /** LG matches to an equivalent Constellation 10 token */
    LG = "LG",
    /** MD matches to an equivalent Constellation 10 token */
    MD = "MD",
    /** SM matches to an equivalent Constellation 10 token */
    SM = "SM",
    /** XL matches to an equivalent Constellation 10 token */
    XL = "XL",
    /** XS matches to an equivalent Constellation 10 token */
    XS = "XS",
    /** XXL matches to an equivalent Constellation 10 token */
    XXL = "XXL"
}
/** Supported Avatar badge tones in Web Constellation 10 in ZHL Experience Graph */
export enum ZHLExperienceWebConstellation10AvatarTone {
    /** ACCENT_1 matches to an equivalent Constellation 10 token */
    ACCENT_1 = "ACCENT_1",
    /** ACCENT_2 matches to an equivalent Constellation 10 token */
    ACCENT_2 = "ACCENT_2",
    /** ACCENT_3 matches to an equivalent Constellation 10 token */
    ACCENT_3 = "ACCENT_3",
    /** ACCENT_4 matches to an equivalent Constellation 10 token */
    ACCENT_4 = "ACCENT_4",
    /** DEFAULT matches to an equivalent Constellation 10 token */
    DEFAULT = "DEFAULT"
}
/** Supported Badged Avaar sizes in Web Constellation 10 */
export enum ZHLExperienceWebConstellation10BadgedAvatarSize {
    /** LG matches to an equivalent Constellation 10 token */
    LG = "LG",
    /** XL matches to an equivalent Constellation 10 token */
    XL = "XL",
    /** XXL matches to an equivalent Constellation 10 token */
    XXL = "XXL"
}
/** Supported Button emphasis values in Constellation 10 Web for Neutron */
export enum ZHLExperienceWebConstellation10ButtonEmphasis {
    BARE = "BARE",
    /** FILLED maps to an equivalent Constellation 10 / PandaCSS Token */
    FILLED = "FILLED",
    /** OUTLINED maps to an equivalent Constellation 10 / PandaCSS Token */
    OUTLINED = "OUTLINED"
}
/**
 * Supported Button Icon Positions in Constellation 10 for Neutron.
 *
 * These aren't defined by the SDK, but are instead based on the implementation of the block component responsible for rendering the button.
 */
export enum ZHLExperienceWebConstellation10ButtonIconPosition {
    /** END indicates the icon should be rendered after the text content of the button */
    END = "END",
    /** START indicates the icon should be rendered before the text content of the button */
    START = "START"
}
/** Supported Button types in Constellation 10 Web for Neutron */
export enum ZHLExperienceWebConstellation10ButtonSize {
    /** LG maps to an equivalent token in Constelaltion 10 */
    LG = "LG",
    /** MD maps to an equivalent token in Constelaltion 10 */
    MD = "MD",
    /** SM maps to an equivalent token in Constelaltion 10 */
    SM = "SM"
}
/** Supported Button tones in Constellation 10 Web for Neutron */
export enum ZHLExperienceWebConstellation10ButtonTone {
    /** BRAND maps to an equivalent Constellation 10 / PandaCSS Token */
    BRAND = "BRAND",
    /** CRITICAL maps to an equivalent Constellation 10 / PandaCSS Token */
    CRITICAL = "CRITICAL",
    /** NEUTRAL maps to an equivalent Constellation 10 / PandaCSS Token */
    NEUTRAL = "NEUTRAL"
}
/** Supported font colors in Web Constellation 10 for ZHL Experience Graph */
export enum ZHLExperienceWebConstellation10FontColor {
    /** BRAND maps to an equivalent Constellation 10 / PandaCSS Token */
    BRAND = "BRAND",
    /**
     * DARK maps to an equivalent Constellation 10 / PandaCSS Token
     * @deprecated Constellation 10 has deprecated this color
     */
    DARK = "DARK",
    /** INVISIBLE maps to an equivalent Constellation 10 / PandaCSS Token */
    INVISIBLE = "INVISIBLE",
    LIGHT = "LIGHT",
    /** NEUTRAL maps to an equivalent Constellation 10 / PandaCSS Token */
    NEUTRAL = "NEUTRAL",
    /** NEUTRAL_FIXED maps to an equivalent Constellation 10 / PandaCSS Token */
    NEUTRAL_FIXED = "NEUTRAL_FIXED",
    /** SUBTLE maps to an equivalent Constellation 10 / PandaCSS Token */
    SUBTLE = "SUBTLE",
    /** TRANSPARENT maps to an equivalent Constellation 10 / PandaCSS Token */
    TRANSPARENT = "TRANSPARENT",
    WHITE = "WHITE"
}
/** Supported Web Constellation 10 Font Families in ZHL Experience Graph */
export enum ZHLExperienceWebConstellation10FontFamily {
    /** Default Heading styling */
    HEADING = "HEADING",
    /** Alternative Heading styling */
    HEADING_ALT = "HEADING_ALT",
    /**
     * Sans Serif Font
     * @deprecated use HEADING instead. SANS_SERIF has been deprecated in Constellation 10.
     */
    SANS_SERIF = "SANS_SERIF",
    /**
     * Serifed Font
     * @deprecated use HEADING_ALT instead. SERIF has been deprecated in Constellation 10.
     */
    SERIF = "SERIF"
}
/** Supported Web Constellation 10 Heading Text Styles in ZHL Experience Graph */
export enum ZHLExperienceWebConstellation10HeadingTextStyle {
    /** Bolded Large Text Style */
    BODY_LG_BOLD = "BODY_LG_BOLD",
    /** Large Heading Text Style */
    HEADING_LG = "HEADING_LG",
    /** Medium Heading Text Style */
    HEADING_MD = "HEADING_MD",
    /** Small Heading Text Style */
    HEADING_SM = "HEADING_SM",
    /** Extra Large Heading Text Style */
    HEADING_XL = "HEADING_XL",
    /** Extra Small Heading Text Style */
    HEADING_XS = "HEADING_XS",
    /** Responsive Large Heading Text Style */
    RESPONSIVE_HEADING_LG = "RESPONSIVE_HEADING_LG",
    /** Responsive Medium Heading Text Style */
    RESPONSIVE_HEADING_MD = "RESPONSIVE_HEADING_MD",
    /** Responsive Small Heading Text Style */
    RESPONSIVE_HEADING_SM = "RESPONSIVE_HEADING_SM",
    /** Responsive Extra Large Heading Text Style */
    RESPONSIVE_HEADING_XL = "RESPONSIVE_HEADING_XL",
    /** Responsive Extra Small Heading Text Style */
    RESPONSIVE_HEADING_XS = "RESPONSIVE_HEADING_XS"
}
/** All supported icons on Web Constellation 10 */
export enum ZHLExperienceWebConstellation10Icon {
    /** AIR_CONDITIONING maps to an equivalent icon available from constellation-icons */
    AIR_CONDITIONING = "AIR_CONDITIONING",
    /** AIR_CONDITIONING_OUTLINE maps to an equivalent icon available from constellation-icons */
    AIR_CONDITIONING_OUTLINE = "AIR_CONDITIONING_OUTLINE",
    /** ARCHIVE maps to an equivalent icon available from constellation-icons */
    ARCHIVE = "ARCHIVE",
    /** ARCHIVE_OUTLINE maps to an equivalent icon available from constellation-icons */
    ARCHIVE_OUTLINE = "ARCHIVE_OUTLINE",
    /** ARROW_DOWN maps to an equivalent icon available from constellation-icons */
    ARROW_DOWN = "ARROW_DOWN",
    /** ARROW_DOWN_CIRCLE maps to an equivalent icon available from constellation-icons */
    ARROW_DOWN_CIRCLE = "ARROW_DOWN_CIRCLE",
    /** ARROW_DOWN_CIRCLE_OUTLINE maps to an equivalent icon available from constellation-icons */
    ARROW_DOWN_CIRCLE_OUTLINE = "ARROW_DOWN_CIRCLE_OUTLINE",
    /** ARROW_DOWN_OUTLINE maps to an equivalent icon available from constellation-icons */
    ARROW_DOWN_OUTLINE = "ARROW_DOWN_OUTLINE",
    /** ARROW_LEFT maps to an equivalent icon available from constellation-icons */
    ARROW_LEFT = "ARROW_LEFT",
    /** ARROW_LEFT_CIRCLE maps to an equivalent icon available from constellation-icons */
    ARROW_LEFT_CIRCLE = "ARROW_LEFT_CIRCLE",
    /** ARROW_LEFT_CIRCLE_OUTLINE maps to an equivalent icon available from constellation-icons */
    ARROW_LEFT_CIRCLE_OUTLINE = "ARROW_LEFT_CIRCLE_OUTLINE",
    /** ARROW_LEFT_OUTLINE maps to an equivalent icon available from constellation-icons */
    ARROW_LEFT_OUTLINE = "ARROW_LEFT_OUTLINE",
    /** ARROW_RIGHT maps to an equivalent icon available from constellation-icons */
    ARROW_RIGHT = "ARROW_RIGHT",
    /** ARROW_RIGHT_CIRCLE maps to an equivalent icon available from constellation-icons */
    ARROW_RIGHT_CIRCLE = "ARROW_RIGHT_CIRCLE",
    /** ARROW_RIGHT_CIRCLE_OUTLINE maps to an equivalent icon available from constellation-icons */
    ARROW_RIGHT_CIRCLE_OUTLINE = "ARROW_RIGHT_CIRCLE_OUTLINE",
    /** ARROW_RIGHT_OUTLINE maps to an equivalent icon available from constellation-icons */
    ARROW_RIGHT_OUTLINE = "ARROW_RIGHT_OUTLINE",
    /** ARROW_UP maps to an equivalent icon available from constellation-icons */
    ARROW_UP = "ARROW_UP",
    /** ARROW_UP_CIRCLE maps to an equivalent icon available from constellation-icons */
    ARROW_UP_CIRCLE = "ARROW_UP_CIRCLE",
    /** ARROW_UP_CIRCLE_OUTLINE maps to an equivalent icon available from constellation-icons */
    ARROW_UP_CIRCLE_OUTLINE = "ARROW_UP_CIRCLE_OUTLINE",
    /** ARROW_UP_OUTLINE maps to an equivalent icon available from constellation-icons */
    ARROW_UP_OUTLINE = "ARROW_UP_OUTLINE",
    /** ATTACHMENT maps to an equivalent icon available from constellation-icons */
    ATTACHMENT = "ATTACHMENT",
    /** AWARD_RIBBON maps to an equivalent icon available from constellation-icons */
    AWARD_RIBBON = "AWARD_RIBBON",
    /** AWARD_RIBBON_OUTLINE maps to an equivalent icon available from constellation-icons */
    AWARD_RIBBON_OUTLINE = "AWARD_RIBBON_OUTLINE",
    /** BANK maps to an equivalent icon available from constellation-icons */
    BANK = "BANK",
    /** BANK_OUTLINE maps to an equivalent icon available from constellation-icons */
    BANK_OUTLINE = "BANK_OUTLINE",
    /** BATH maps to an equivalent icon available from constellation-icons */
    BATH = "BATH",
    /** BATH_OUTLINE maps to an equivalent icon available from constellation-icons */
    BATH_OUTLINE = "BATH_OUTLINE",
    /** BATTERY_FULL maps to an equivalent icon available from constellation-icons */
    BATTERY_FULL = "BATTERY_FULL",
    /** BATTERY_FULL_OUTLINE maps to an equivalent icon available from constellation-icons */
    BATTERY_FULL_OUTLINE = "BATTERY_FULL_OUTLINE",
    /** BATTERY_HALF maps to an equivalent icon available from constellation-icons */
    BATTERY_HALF = "BATTERY_HALF",
    /** BATTERY_HALF_OUTLINE maps to an equivalent icon available from constellation-icons */
    BATTERY_HALF_OUTLINE = "BATTERY_HALF_OUTLINE",
    /** BATTERY_LOW maps to an equivalent icon available from constellation-icons */
    BATTERY_LOW = "BATTERY_LOW",
    /** BATTERY_LOW_OUTLINE maps to an equivalent icon available from constellation-icons */
    BATTERY_LOW_OUTLINE = "BATTERY_LOW_OUTLINE",
    /** BEAUTY_PRODUCTS maps to an equivalent icon available from constellation-icons */
    BEAUTY_PRODUCTS = "BEAUTY_PRODUCTS",
    /** BEAUTY_PRODUCTS_OUTLINE maps to an equivalent icon available from constellation-icons */
    BEAUTY_PRODUCTS_OUTLINE = "BEAUTY_PRODUCTS_OUTLINE",
    /** BED maps to an equivalent icon available from constellation-icons */
    BED = "BED",
    /** BED_OUTLINE maps to an equivalent icon available from constellation-icons */
    BED_OUTLINE = "BED_OUTLINE",
    /** BIKE maps to an equivalent icon available from constellation-icons */
    BIKE = "BIKE",
    /** BIKE_OUTLINE maps to an equivalent icon available from constellation-icons */
    BIKE_OUTLINE = "BIKE_OUTLINE",
    /** BLUEPRINT maps to an equivalent icon available from constellation-icons */
    BLUEPRINT = "BLUEPRINT",
    /** BLUEPRINT_OUTLINE maps to an equivalent icon available from constellation-icons */
    BLUEPRINT_OUTLINE = "BLUEPRINT_OUTLINE",
    /** BUILDING maps to an equivalent icon available from constellation-icons */
    BUILDING = "BUILDING",
    /** BUILDINGS maps to an equivalent icon available from constellation-icons */
    BUILDINGS = "BUILDINGS",
    /** BUILDINGS_OUTLINE maps to an equivalent icon available from constellation-icons */
    BUILDINGS_OUTLINE = "BUILDINGS_OUTLINE",
    /** BUILDING_OUTLINE maps to an equivalent icon available from constellation-icons */
    BUILDING_OUTLINE = "BUILDING_OUTLINE",
    /** BUS maps to an equivalent icon available from constellation-icons */
    BUS = "BUS",
    /** BUS_OUTLINE maps to an equivalent icon available from constellation-icons */
    BUS_OUTLINE = "BUS_OUTLINE",
    /** BUS_SIDE maps to an equivalent icon available from constellation-icons */
    BUS_SIDE = "BUS_SIDE",
    /** BUS_SIDE_OUTLINE maps to an equivalent icon available from constellation-icons */
    BUS_SIDE_OUTLINE = "BUS_SIDE_OUTLINE",
    /** CALCULATOR maps to an equivalent icon available from constellation-icons */
    CALCULATOR = "CALCULATOR",
    /** CALCULATOR_OUTLINE maps to an equivalent icon available from constellation-icons */
    CALCULATOR_OUTLINE = "CALCULATOR_OUTLINE",
    /** CALENDAR maps to an equivalent icon available from constellation-icons */
    CALENDAR = "CALENDAR",
    /** CALENDAR_CLOCK maps to an equivalent icon available from constellation-icons */
    CALENDAR_CLOCK = "CALENDAR_CLOCK",
    /** CALENDAR_CLOCK_OUTLINE maps to an equivalent icon available from constellation-icons */
    CALENDAR_CLOCK_OUTLINE = "CALENDAR_CLOCK_OUTLINE",
    /** CALENDAR_OUTLINE maps to an equivalent icon available from constellation-icons */
    CALENDAR_OUTLINE = "CALENDAR_OUTLINE",
    /** CAMERA maps to an equivalent icon available from constellation-icons */
    CAMERA = "CAMERA",
    /** CAMERA_GRID maps to an equivalent icon available from constellation-icons */
    CAMERA_GRID = "CAMERA_GRID",
    /** CAMERA_GRID_OUTLINE maps to an equivalent icon available from constellation-icons */
    CAMERA_GRID_OUTLINE = "CAMERA_GRID_OUTLINE",
    /** CAMERA_OUTLINE maps to an equivalent icon available from constellation-icons */
    CAMERA_OUTLINE = "CAMERA_OUTLINE",
    /** CAMERA_SHUTTER maps to an equivalent icon available from constellation-icons */
    CAMERA_SHUTTER = "CAMERA_SHUTTER",
    /** CAMERA_SHUTTER_OUTLINE maps to an equivalent icon available from constellation-icons */
    CAMERA_SHUTTER_OUTLINE = "CAMERA_SHUTTER_OUTLINE",
    /** CAR maps to an equivalent icon available from constellation-icons */
    CAR = "CAR",
    /** CAR_OUTLINE maps to an equivalent icon available from constellation-icons */
    CAR_OUTLINE = "CAR_OUTLINE",
    /** CAR_SIDE maps to an equivalent icon available from constellation-icons */
    CAR_SIDE = "CAR_SIDE",
    /** CAR_SIDE_OUTLINE maps to an equivalent icon available from constellation-icons */
    CAR_SIDE_OUTLINE = "CAR_SIDE_OUTLINE",
    /** CHECKBOX maps to an equivalent icon available from constellation-icons */
    CHECKBOX = "CHECKBOX",
    /** CHECKLIST maps to an equivalent icon available from constellation-icons */
    CHECKLIST = "CHECKLIST",
    /** CHECKLIST_OUTLINE maps to an equivalent icon available from constellation-icons */
    CHECKLIST_OUTLINE = "CHECKLIST_OUTLINE",
    /** CHECKMARK maps to an equivalent icon available from constellation-icons */
    CHECKMARK = "CHECKMARK",
    /** CHECKMARK_CIRCLE maps to an equivalent icon available from constellation-icons */
    CHECKMARK_CIRCLE = "CHECKMARK_CIRCLE",
    /** CHECKMARK_CIRCLE_OUTLINE maps to an equivalent icon available from constellation-icons */
    CHECKMARK_CIRCLE_OUTLINE = "CHECKMARK_CIRCLE_OUTLINE",
    /** CHECKMARK_OUTLINE maps to an equivalent icon available from constellation-icons */
    CHECKMARK_OUTLINE = "CHECKMARK_OUTLINE",
    /** CHEVRON_DOWN maps to an equivalent icon available from constellation-icons */
    CHEVRON_DOWN = "CHEVRON_DOWN",
    /** CHEVRON_DOWN_CIRCLE maps to an equivalent icon available from constellation-icons */
    CHEVRON_DOWN_CIRCLE = "CHEVRON_DOWN_CIRCLE",
    /** CHEVRON_DOWN_CIRCLE_OUTLINE maps to an equivalent icon available from constellation-icons */
    CHEVRON_DOWN_CIRCLE_OUTLINE = "CHEVRON_DOWN_CIRCLE_OUTLINE",
    /** CHEVRON_DOWN_OUTLINE maps to an equivalent icon available from constellation-icons */
    CHEVRON_DOWN_OUTLINE = "CHEVRON_DOWN_OUTLINE",
    /** CHEVRON_LEFT maps to an equivalent icon available from constellation-icons */
    CHEVRON_LEFT = "CHEVRON_LEFT",
    /** CHEVRON_LEFT_CIRCLE maps to an equivalent icon available from constellation-icons */
    CHEVRON_LEFT_CIRCLE = "CHEVRON_LEFT_CIRCLE",
    /** CHEVRON_LEFT_CIRCLE_OUTLINE maps to an equivalent icon available from constellation-icons */
    CHEVRON_LEFT_CIRCLE_OUTLINE = "CHEVRON_LEFT_CIRCLE_OUTLINE",
    /** CHEVRON_LEFT_OUTLINE maps to an equivalent icon available from constellation-icons */
    CHEVRON_LEFT_OUTLINE = "CHEVRON_LEFT_OUTLINE",
    /** CHEVRON_RIGHT maps to an equivalent icon available from constellation-icons */
    CHEVRON_RIGHT = "CHEVRON_RIGHT",
    /** CHEVRON_RIGHT_CIRCLE maps to an equivalent icon available from constellation-icons */
    CHEVRON_RIGHT_CIRCLE = "CHEVRON_RIGHT_CIRCLE",
    /** CHEVRON_RIGHT_CIRCLE_OUTLINE maps to an equivalent icon available from constellation-icons */
    CHEVRON_RIGHT_CIRCLE_OUTLINE = "CHEVRON_RIGHT_CIRCLE_OUTLINE",
    /** CHEVRON_RIGHT_OUTLINE maps to an equivalent icon available from constellation-icons */
    CHEVRON_RIGHT_OUTLINE = "CHEVRON_RIGHT_OUTLINE",
    /** CHEVRON_UP maps to an equivalent icon available from constellation-icons */
    CHEVRON_UP = "CHEVRON_UP",
    /** CHEVRON_UP_CIRCLE maps to an equivalent icon available from constellation-icons */
    CHEVRON_UP_CIRCLE = "CHEVRON_UP_CIRCLE",
    /** CHEVRON_UP_CIRCLE_OUTLINE maps to an equivalent icon available from constellation-icons */
    CHEVRON_UP_CIRCLE_OUTLINE = "CHEVRON_UP_CIRCLE_OUTLINE",
    /** CHEVRON_UP_OUTLINE maps to an equivalent icon available from constellation-icons */
    CHEVRON_UP_OUTLINE = "CHEVRON_UP_OUTLINE",
    /** CIRCLE maps to an equivalent icon available from constellation-icons */
    CIRCLE = "CIRCLE",
    /** CIRCLE_OUTLINE maps to an equivalent icon available from constellation-icons */
    CIRCLE_OUTLINE = "CIRCLE_OUTLINE",
    /** CLOCK maps to an equivalent icon available from constellation-icons */
    CLOCK = "CLOCK",
    /** CLOCK_OUTLINE maps to an equivalent icon available from constellation-icons */
    CLOCK_OUTLINE = "CLOCK_OUTLINE",
    /** CLOSE maps to an equivalent icon available from constellation-icons */
    CLOSE = "CLOSE",
    /** CLOSE_CIRCLE maps to an equivalent icon available from constellation-icons */
    CLOSE_CIRCLE = "CLOSE_CIRCLE",
    /** CLOSE_CIRCLE_OUTLINE maps to an equivalent icon available from constellation-icons */
    CLOSE_CIRCLE_OUTLINE = "CLOSE_CIRCLE_OUTLINE",
    /** CLOSE_OUTLINE maps to an equivalent icon available from constellation-icons */
    CLOSE_OUTLINE = "CLOSE_OUTLINE",
    /** COLLAPSE maps to an equivalent icon available from constellation-icons */
    COLLAPSE = "COLLAPSE",
    /** COLLAPSE_OUTLINE maps to an equivalent icon available from constellation-icons */
    COLLAPSE_OUTLINE = "COLLAPSE_OUTLINE",
    /** COMPASS maps to an equivalent icon available from constellation-icons */
    COMPASS = "COMPASS",
    /** COMPASS_OUTLINE maps to an equivalent icon available from constellation-icons */
    COMPASS_OUTLINE = "COMPASS_OUTLINE",
    /** COPY maps to an equivalent icon available from constellation-icons */
    COPY = "COPY",
    /** COPY_OUTLINE maps to an equivalent icon available from constellation-icons */
    COPY_OUTLINE = "COPY_OUTLINE",
    /** CREDIT_SCORE maps to an equivalent icon available from constellation-icons */
    CREDIT_SCORE = "CREDIT_SCORE",
    /** CREDIT_SCORE_OUTLINE maps to an equivalent icon available from constellation-icons */
    CREDIT_SCORE_OUTLINE = "CREDIT_SCORE_OUTLINE",
    /** CROWN maps to an equivalent icon available from constellation-icons */
    CROWN = "CROWN",
    /** CROWN_OUTLINE maps to an equivalent icon available from constellation-icons */
    CROWN_OUTLINE = "CROWN_OUTLINE",
    DELETE = "DELETE",
    /** DOLLAR_SIGN_CIRCLE maps to an equivalent icon available from constellation-icons */
    DOLLAR_SIGN_CIRCLE = "DOLLAR_SIGN_CIRCLE",
    /** DOLLAR_SIGN_CIRCLE_OUTLINE maps to an equivalent icon available from constellation-icons */
    DOLLAR_SIGN_CIRCLE_OUTLINE = "DOLLAR_SIGN_CIRCLE_OUTLINE",
    /** DOOR_OPEN maps to an equivalent icon available from constellation-icons */
    DOOR_OPEN = "DOOR_OPEN",
    /** DOOR_OPEN_OUTLINE maps to an equivalent icon available from constellation-icons */
    DOOR_OPEN_OUTLINE = "DOOR_OPEN_OUTLINE",
    /** DOWNLOAD maps to an equivalent icon available from constellation-icons */
    DOWNLOAD = "DOWNLOAD",
    /** DOWNLOAD_OUTLINE maps to an equivalent icon available from constellation-icons */
    DOWNLOAD_OUTLINE = "DOWNLOAD_OUTLINE",
    /** DRAW maps to an equivalent icon available from constellation-icons */
    DRAW = "DRAW",
    /** DRAW_OUTLINE maps to an equivalent icon available from constellation-icons */
    DRAW_OUTLINE = "DRAW_OUTLINE",
    /** EDIT maps to an equivalent icon available from constellation-icons */
    EDIT = "EDIT",
    /** EDIT_FORM maps to an equivalent icon available from constellation-icons */
    EDIT_FORM = "EDIT_FORM",
    /** EDIT_FORM_OUTLINE maps to an equivalent icon available from constellation-icons */
    EDIT_FORM_OUTLINE = "EDIT_FORM_OUTLINE",
    /** EDIT_OUTLINE maps to an equivalent icon available from constellation-icons */
    EDIT_OUTLINE = "EDIT_OUTLINE",
    /** EHO maps to an equivalent icon available from constellation-icons */
    EHO = "EHO",
    /** EQUAL_HOUSING maps to an equivalent icon available from constellation-icons */
    EQUAL_HOUSING = "EQUAL_HOUSING",
    /** EQUAL_HOUSING_OUTLINE maps to an equivalent icon available from constellation-icons */
    EQUAL_HOUSING_OUTLINE = "EQUAL_HOUSING_OUTLINE",
    /** ERROR maps to an equivalent icon available from constellation-icons */
    ERROR = "ERROR",
    /** EXCLAMATION_CIRCLE maps to an equivalent icon available from constellation-icons */
    EXCLAMATION_CIRCLE = "EXCLAMATION_CIRCLE",
    /** EXCLAMATION_CIRCLE_OUTLINE maps to an equivalent icon available from constellation-icons */
    EXCLAMATION_CIRCLE_OUTLINE = "EXCLAMATION_CIRCLE_OUTLINE",
    /** EXPAND maps to an equivalent icon available from constellation-icons */
    EXPAND = "EXPAND",
    /** EXPAND_OUTLINE maps to an equivalent icon available from constellation-icons */
    EXPAND_OUTLINE = "EXPAND_OUTLINE",
    /** EXTERNAL maps to an equivalent icon available from constellation-icons */
    EXTERNAL = "EXTERNAL",
    /** FACTS_FEATURES maps to an equivalent icon available from constellation-icons */
    FACTS_FEATURES = "FACTS_FEATURES",
    /** FACTS_FEATURES_OUTLINE maps to an equivalent icon available from constellation-icons */
    FACTS_FEATURES_OUTLINE = "FACTS_FEATURES_OUTLINE",
    /** FILE maps to an equivalent icon available from constellation-icons */
    FILE = "FILE",
    /** FILE_CSV maps to an equivalent icon available from constellation-icons */
    FILE_CSV = "FILE_CSV",
    /** FILE_CSV_OUTLINE maps to an equivalent icon available from constellation-icons */
    FILE_CSV_OUTLINE = "FILE_CSV_OUTLINE",
    /** FILE_OUTLINE maps to an equivalent icon available from constellation-icons */
    FILE_OUTLINE = "FILE_OUTLINE",
    /** FILE_PDF maps to an equivalent icon available from constellation-icons */
    FILE_PDF = "FILE_PDF",
    /** FILE_PDF_OUTLINE maps to an equivalent icon available from constellation-icons */
    FILE_PDF_OUTLINE = "FILE_PDF_OUTLINE",
    /** FILE_SPREADSHEET maps to an equivalent icon available from constellation-icons */
    FILE_SPREADSHEET = "FILE_SPREADSHEET",
    /** FILE_SPREADSHEET_OUTLINE maps to an equivalent icon available from constellation-icons */
    FILE_SPREADSHEET_OUTLINE = "FILE_SPREADSHEET_OUTLINE",
    /** FILE_TEXT maps to an equivalent icon available from constellation-icons */
    FILE_TEXT = "FILE_TEXT",
    /** FILE_TEXT_OUTLINE maps to an equivalent icon available from constellation-icons */
    FILE_TEXT_OUTLINE = "FILE_TEXT_OUTLINE",
    /** FINGER_DRAW maps to an equivalent icon available from constellation-icons */
    FINGER_DRAW = "FINGER_DRAW",
    /** FINGER_DRAW_OUTLINE maps to an equivalent icon available from constellation-icons */
    FINGER_DRAW_OUTLINE = "FINGER_DRAW_OUTLINE",
    /** FLAG maps to an equivalent icon available from constellation-icons */
    FLAG = "FLAG",
    /** FLAG_OUTLINE maps to an equivalent icon available from constellation-icons */
    FLAG_OUTLINE = "FLAG_OUTLINE",
    /** FLOOR_PLAN maps to an equivalent icon available from constellation-icons */
    FLOOR_PLAN = "FLOOR_PLAN",
    /** FOLDER maps to an equivalent icon available from constellation-icons */
    FOLDER = "FOLDER",
    /** FOLDER_OUTLINE maps to an equivalent icon available from constellation-icons */
    FOLDER_OUTLINE = "FOLDER_OUTLINE",
    /** FULL_SCREEN maps to an equivalent icon available from constellation-icons */
    FULL_SCREEN = "FULL_SCREEN",
    /** FULL_SCREEN_OUTLINE maps to an equivalent icon available from constellation-icons */
    FULL_SCREEN_OUTLINE = "FULL_SCREEN_OUTLINE",
    /** GAS_STATION maps to an equivalent icon available from constellation-icons */
    GAS_STATION = "GAS_STATION",
    /** GAS_STATION_OUTLINE maps to an equivalent icon available from constellation-icons */
    GAS_STATION_OUTLINE = "GAS_STATION_OUTLINE",
    /** GIFT maps to an equivalent icon available from constellation-icons */
    GIFT = "GIFT",
    /** GIFT_OUTLINE maps to an equivalent icon available from constellation-icons */
    GIFT_OUTLINE = "GIFT_OUTLINE",
    /** GLOBE maps to an equivalent icon available from constellation-icons */
    GLOBE = "GLOBE",
    /** GLOBE_OUTLINE maps to an equivalent icon available from constellation-icons */
    GLOBE_OUTLINE = "GLOBE_OUTLINE",
    /** GRID maps to an equivalent icon available from constellation-icons */
    GRID = "GRID",
    /** GRID_OUTLINE maps to an equivalent icon available from constellation-icons */
    GRID_OUTLINE = "GRID_OUTLINE",
    /** HAMMER maps to an equivalent icon available from constellation-icons */
    HAMMER = "HAMMER",
    /** HAMMER_OUTLINE maps to an equivalent icon available from constellation-icons */
    HAMMER_OUTLINE = "HAMMER_OUTLINE",
    /** HDR maps to an equivalent icon available from constellation-icons */
    HDR = "HDR",
    /** HDR_OUTLINE maps to an equivalent icon available from constellation-icons */
    HDR_OUTLINE = "HDR_OUTLINE",
    /** HEART maps to an equivalent icon available from constellation-icons */
    HEART = "HEART",
    /** HEART_OUTLINE maps to an equivalent icon available from constellation-icons */
    HEART_OUTLINE = "HEART_OUTLINE",
    /** HEATING maps to an equivalent icon available from constellation-icons */
    HEATING = "HEATING",
    /** HEATING_OUTLINE maps to an equivalent icon available from constellation-icons */
    HEATING_OUTLINE = "HEATING_OUTLINE",
    /** HIDE maps to an equivalent icon available from constellation-icons */
    HIDE = "HIDE",
    /** HIDE_OUTLINE maps to an equivalent icon available from constellation-icons */
    HIDE_OUTLINE = "HIDE_OUTLINE",
    /** HOA maps to an equivalent icon available from constellation-icons */
    HOA = "HOA",
    /** HOA_OUTLINE maps to an equivalent icon available from constellation-icons */
    HOA_OUTLINE = "HOA_OUTLINE",
    /** HOME_SIMILAR maps to an equivalent icon available from constellation-icons */
    HOME_SIMILAR = "HOME_SIMILAR",
    /** HOME_SIMILAR_OUTLINE maps to an equivalent icon available from constellation-icons */
    HOME_SIMILAR_OUTLINE = "HOME_SIMILAR_OUTLINE",
    /** HOSPITAL maps to an equivalent icon available from constellation-icons */
    HOSPITAL = "HOSPITAL",
    /** HOSPITAL_OUTLINE maps to an equivalent icon available from constellation-icons */
    HOSPITAL_OUTLINE = "HOSPITAL_OUTLINE",
    /** HOUSE maps to an equivalent icon available from constellation-icons */
    HOUSE = "HOUSE",
    /** HOUSE_CLOCK maps to an equivalent icon available from constellation-icons */
    HOUSE_CLOCK = "HOUSE_CLOCK",
    /** HOUSE_CLOCK_OUTLINE maps to an equivalent icon available from constellation-icons */
    HOUSE_CLOCK_OUTLINE = "HOUSE_CLOCK_OUTLINE",
    /** HOUSE_OUTLINE maps to an equivalent icon available from constellation-icons */
    HOUSE_OUTLINE = "HOUSE_OUTLINE",
    /** HOUSE_TYPE maps to an equivalent icon available from constellation-icons */
    HOUSE_TYPE = "HOUSE_TYPE",
    /** HOUSE_TYPE_OUTLINE maps to an equivalent icon available from constellation-icons */
    HOUSE_TYPE_OUTLINE = "HOUSE_TYPE_OUTLINE",
    /** INBOX maps to an equivalent icon available from constellation-icons */
    INBOX = "INBOX",
    /** INBOX_OUTLINE maps to an equivalent icon available from constellation-icons */
    INBOX_OUTLINE = "INBOX_OUTLINE",
    /** INFO maps to an equivalent icon available from constellation-icons */
    INFO = "INFO",
    /** INFO_OUTLINE maps to an equivalent icon available from constellation-icons */
    INFO_OUTLINE = "INFO_OUTLINE",
    /** INITIALS maps to an equivalent icon available from constellation-icons */
    INITIALS = "INITIALS",
    /** INSTAGRAM maps to an equivalent icon available from constellation-icons */
    INSTAGRAM = "INSTAGRAM",
    /** KEY maps to an equivalent icon available from constellation-icons */
    KEY = "KEY",
    /** KEYBOARD maps to an equivalent icon available from constellation-icons */
    KEYBOARD = "KEYBOARD",
    /** KEYBOARD_OUTLINE maps to an equivalent icon available from constellation-icons */
    KEYBOARD_OUTLINE = "KEYBOARD_OUTLINE",
    /** KEY_OUTLINE maps to an equivalent icon available from constellation-icons */
    KEY_OUTLINE = "KEY_OUTLINE",
    /** LAPTOP maps to an equivalent icon available from constellation-icons */
    LAPTOP = "LAPTOP",
    /** LAPTOP_OUTLINE maps to an equivalent icon available from constellation-icons */
    LAPTOP_OUTLINE = "LAPTOP_OUTLINE",
    /** LAUNDRY maps to an equivalent icon available from constellation-icons */
    LAUNDRY = "LAUNDRY",
    /** LAUNDRY_OUTLINE maps to an equivalent icon available from constellation-icons */
    LAUNDRY_OUTLINE = "LAUNDRY_OUTLINE",
    /** LAYERS maps to an equivalent icon available from constellation-icons */
    LAYERS = "LAYERS",
    /** LAYERS_OUTLINE maps to an equivalent icon available from constellation-icons */
    LAYERS_OUTLINE = "LAYERS_OUTLINE",
    /** LEAF maps to an equivalent icon available from constellation-icons */
    LEAF = "LEAF",
    /** LEAF_OUTLINE maps to an equivalent icon available from constellation-icons */
    LEAF_OUTLINE = "LEAF_OUTLINE",
    /** LIGHTBULB maps to an equivalent icon available from constellation-icons */
    LIGHTBULB = "LIGHTBULB",
    /** LIGHTBULB_OUTLINE maps to an equivalent icon available from constellation-icons */
    LIGHTBULB_OUTLINE = "LIGHTBULB_OUTLINE",
    /** LIGHTNING maps to an equivalent icon available from constellation-icons */
    LIGHTNING = "LIGHTNING",
    /** LIGHTNING_OUTLINE maps to an equivalent icon available from constellation-icons */
    LIGHTNING_OUTLINE = "LIGHTNING_OUTLINE",
    /** LINK maps to an equivalent icon available from constellation-icons */
    LINK = "LINK",
    /** LINKED_IN maps to an equivalent icon available from constellation-icons */
    LINKED_IN = "LINKED_IN",
    /** LINK_BROKEN maps to an equivalent icon available from constellation-icons */
    LINK_BROKEN = "LINK_BROKEN",
    /** LINK_BROKEN_OUTLINE maps to an equivalent icon available from constellation-icons */
    LINK_BROKEN_OUTLINE = "LINK_BROKEN_OUTLINE",
    /** LINK_OUTLINE maps to an equivalent icon available from constellation-icons */
    LINK_OUTLINE = "LINK_OUTLINE",
    /** LIST_BULLETED maps to an equivalent icon available from constellation-icons */
    LIST_BULLETED = "LIST_BULLETED",
    /** LIST_BULLETED_OUTLINE maps to an equivalent icon available from constellation-icons */
    LIST_BULLETED_OUTLINE = "LIST_BULLETED_OUTLINE",
    /** LIST_NUMBERED maps to an equivalent icon available from constellation-icons */
    LIST_NUMBERED = "LIST_NUMBERED",
    /** LIST_NUMBERED_OUTLINE maps to an equivalent icon available from constellation-icons */
    LIST_NUMBERED_OUTLINE = "LIST_NUMBERED_OUTLINE",
    /** LIVE_BROADCAST maps to an equivalent icon available from constellation-icons */
    LIVE_BROADCAST = "LIVE_BROADCAST",
    /** LOCATION maps to an equivalent icon available from constellation-icons */
    LOCATION = "LOCATION",
    /** LOCATION_ARROW maps to an equivalent icon available from constellation-icons */
    LOCATION_ARROW = "LOCATION_ARROW",
    /** LOCATION_ARROW_OUTLINE maps to an equivalent icon available from constellation-icons */
    LOCATION_ARROW_OUTLINE = "LOCATION_ARROW_OUTLINE",
    /** LOCATION_OUTLINE maps to an equivalent icon available from constellation-icons */
    LOCATION_OUTLINE = "LOCATION_OUTLINE",
    /** LOCK_CLOSED_FILLED maps to an equivalent icon available from constellation-icons */
    LOCK_CLOSED_FILLED = "LOCK_CLOSED_FILLED",
    /** MAIL maps to an equivalent icon available from constellation-icons */
    MAIL = "MAIL",
    /** MAIL_OUTLINE maps to an equivalent icon available from constellation-icons */
    MAIL_OUTLINE = "MAIL_OUTLINE",
    /** MAP maps to an equivalent icon available from constellation-icons */
    MAP = "MAP",
    /** MAP_DRAW maps to an equivalent icon available from constellation-icons */
    MAP_DRAW = "MAP_DRAW",
    /** MAP_DRAW_OUTLINE maps to an equivalent icon available from constellation-icons */
    MAP_DRAW_OUTLINE = "MAP_DRAW_OUTLINE",
    /** MAP_OUTLINE maps to an equivalent icon available from constellation-icons */
    MAP_OUTLINE = "MAP_OUTLINE",
    /** MENU maps to an equivalent icon available from constellation-icons */
    MENU = "MENU",
    /** MENU_OUTLINE maps to an equivalent icon available from constellation-icons */
    MENU_OUTLINE = "MENU_OUTLINE",
    /** MESSAGE maps to an equivalent icon available from constellation-icons */
    MESSAGE = "MESSAGE",
    /** MESSAGE_HEART maps to an equivalent icon available from constellation-icons */
    MESSAGE_HEART = "MESSAGE_HEART",
    /** MESSAGE_HEART_OUTLINE maps to an equivalent icon available from constellation-icons */
    MESSAGE_HEART_OUTLINE = "MESSAGE_HEART_OUTLINE",
    /** MESSAGE_OUTLINE maps to an equivalent icon available from constellation-icons */
    MESSAGE_OUTLINE = "MESSAGE_OUTLINE",
    /** MESSAGE_QUESTION maps to an equivalent icon available from constellation-icons */
    MESSAGE_QUESTION = "MESSAGE_QUESTION",
    /** MESSAGE_QUESTION_OUTLINE maps to an equivalent icon available from constellation-icons */
    MESSAGE_QUESTION_OUTLINE = "MESSAGE_QUESTION_OUTLINE",
    /** MICROPHONE maps to an equivalent icon available from constellation-icons */
    MICROPHONE = "MICROPHONE",
    /** MICROPHONE_OUTLINE maps to an equivalent icon available from constellation-icons */
    MICROPHONE_OUTLINE = "MICROPHONE_OUTLINE",
    /** MINUS maps to an equivalent icon available from constellation-icons */
    MINUS = "MINUS",
    /** MINUS_CIRCLE maps to an equivalent icon available from constellation-icons */
    MINUS_CIRCLE = "MINUS_CIRCLE",
    /** MINUS_CIRCLE_OUTLINE maps to an equivalent icon available from constellation-icons */
    MINUS_CIRCLE_OUTLINE = "MINUS_CIRCLE_OUTLINE",
    /** MINUS_OUTLINE maps to an equivalent icon available from constellation-icons */
    MINUS_OUTLINE = "MINUS_OUTLINE",
    /** MLS maps to an equivalent icon available from constellation-icons */
    MLS = "MLS",
    /** MLS_OUTLINE maps to an equivalent icon available from constellation-icons */
    MLS_OUTLINE = "MLS_OUTLINE",
    /** MONITOR maps to an equivalent icon available from constellation-icons */
    MONITOR = "MONITOR",
    /** MONITOR_OUTLINE maps to an equivalent icon available from constellation-icons */
    MONITOR_OUTLINE = "MONITOR_OUTLINE",
    /** MORE maps to an equivalent icon available from constellation-icons */
    MORE = "MORE",
    /** MORE_OUTLINE maps to an equivalent icon available from constellation-icons */
    MORE_OUTLINE = "MORE_OUTLINE",
    /** MORE_VERTICAL maps to an equivalent icon available from constellation-icons */
    MORE_VERTICAL = "MORE_VERTICAL",
    /** MORE_VERTICAL_OUTLINE maps to an equivalent icon available from constellation-icons */
    MORE_VERTICAL_OUTLINE = "MORE_VERTICAL_OUTLINE",
    /** MY_HOME maps to an equivalently named Component from constellation-icons */
    MY_HOME = "MY_HOME",
    /** MY_HOME_OUTLINE maps to an equivalently named Component from constellation-icons */
    MY_HOME_OUTLINE = "MY_HOME_OUTLINE",
    /** NOTE maps to an equivalent icon available from constellation-icons */
    NOTE = "NOTE",
    /** NOTE_OUTLINE maps to an equivalent icon available from constellation-icons */
    NOTE_OUTLINE = "NOTE_OUTLINE",
    /** NOTIFICATION maps to an equivalent icon available from constellation-icons */
    NOTIFICATION = "NOTIFICATION",
    /** NOTIFICATION_OUTLINE maps to an equivalent icon available from constellation-icons */
    NOTIFICATION_OUTLINE = "NOTIFICATION_OUTLINE",
    /** PANORAMA maps to an equivalent icon available from constellation-icons */
    PANORAMA = "PANORAMA",
    /** PANORAMA_360 maps to an equivalent icon available from constellation-icons */
    PANORAMA_360 = "PANORAMA_360",
    /** PANORAMA_360_OUTLINE maps to an equivalent icon available from constellation-icons */
    PANORAMA_360_OUTLINE = "PANORAMA_360_OUTLINE",
    /** PANORAMA_OUTLINE maps to an equivalent icon available from constellation-icons */
    PANORAMA_OUTLINE = "PANORAMA_OUTLINE",
    /** PARKING maps to an equivalent icon available from constellation-icons */
    PARKING = "PARKING",
    /** PARKING_OUTLINE maps to an equivalent icon available from constellation-icons */
    PARKING_OUTLINE = "PARKING_OUTLINE",
    /** PASTE maps to an equivalent icon available from constellation-icons */
    PASTE = "PASTE",
    /** PASTE_OUTLINE maps to an equivalent icon available from constellation-icons */
    PASTE_OUTLINE = "PASTE_OUTLINE",
    /** PATIO maps to an equivalent icon available from constellation-icons */
    PATIO = "PATIO",
    /** PATIO_OUTLINE maps to an equivalent icon available from constellation-icons */
    PATIO_OUTLINE = "PATIO_OUTLINE",
    /** PAUSE maps to an equivalent icon available from constellation-icons */
    PAUSE = "PAUSE",
    /** PAUSE_CIRCLE maps to an equivalent icon available from constellation-icons */
    PAUSE_CIRCLE = "PAUSE_CIRCLE",
    /** PAUSE_CIRCLE_OUTLINE maps to an equivalent icon available from constellation-icons */
    PAUSE_CIRCLE_OUTLINE = "PAUSE_CIRCLE_OUTLINE",
    /** PAUSE_OUTLINE maps to an equivalent icon available from constellation-icons */
    PAUSE_OUTLINE = "PAUSE_OUTLINE",
    /** PEDESTRIAN maps to an equivalent icon available from constellation-icons */
    PEDESTRIAN = "PEDESTRIAN",
    /** PEDESTRIAN_OUTLINE maps to an equivalent icon available from constellation-icons */
    PEDESTRIAN_OUTLINE = "PEDESTRIAN_OUTLINE",
    /** PETS maps to an equivalent icon available from constellation-icons */
    PETS = "PETS",
    /** PETS_OUTLINE maps to an equivalent icon available from constellation-icons */
    PETS_OUTLINE = "PETS_OUTLINE",
    /** PHONE maps to an equivalent icon available from constellation-icons */
    PHONE = "PHONE",
    /** PHONE_CIRCLE maps to an equivalent icon available from constellation-icons */
    PHONE_CIRCLE = "PHONE_CIRCLE",
    /** PHONE_CIRCLE_OUTLINE maps to an equivalent icon available from constellation-icons */
    PHONE_CIRCLE_OUTLINE = "PHONE_CIRCLE_OUTLINE",
    /** PHONE_OUTLINE maps to an equivalent icon available from constellation-icons */
    PHONE_OUTLINE = "PHONE_OUTLINE",
    /** PHOTOS maps to an equivalent icon available from constellation-icons */
    PHOTOS = "PHOTOS",
    /** PHOTOS_OUTLINE maps to an equivalent icon available from constellation-icons */
    PHOTOS_OUTLINE = "PHOTOS_OUTLINE",
    /** PIGGY maps to an equivalent icon available from constellation-icons */
    PIGGY = "PIGGY",
    /** PIGGY_OUTLINE maps to an equivalent icon available from constellation-icons */
    PIGGY_OUTLINE = "PIGGY_OUTLINE",
    /** PLAY maps to an equivalent icon available from constellation-icons */
    PLAY = "PLAY",
    /** PLAY_CIRCLE maps to an equivalent icon available from constellation-icons */
    PLAY_CIRCLE = "PLAY_CIRCLE",
    /** PLAY_CIRCLE_OUTLINE maps to an equivalent icon available from constellation-icons */
    PLAY_CIRCLE_OUTLINE = "PLAY_CIRCLE_OUTLINE",
    /** PLAY_OUTLINE maps to an equivalent icon available from constellation-icons */
    PLAY_OUTLINE = "PLAY_OUTLINE",
    /** PLUS maps to an equivalent icon available from constellation-icons */
    PLUS = "PLUS",
    /** PLUS_CIRCLE maps to an equivalent icon available from constellation-icons */
    PLUS_CIRCLE = "PLUS_CIRCLE",
    /** PLUS_CIRCLE_OUTLINE maps to an equivalent icon available from constellation-icons */
    PLUS_CIRCLE_OUTLINE = "PLUS_CIRCLE_OUTLINE",
    /** PLUS_OUTLINE maps to an equivalent icon available from constellation-icons */
    PLUS_OUTLINE = "PLUS_OUTLINE",
    /** POINTER_DOWN maps to an equivalent icon available from constellation-icons */
    POINTER_DOWN = "POINTER_DOWN",
    /** POINTER_DOWN_OUTLINE maps to an equivalent icon available from constellation-icons */
    POINTER_DOWN_OUTLINE = "POINTER_DOWN_OUTLINE",
    /** POINTER_UP maps to an equivalent icon available from constellation-icons */
    POINTER_UP = "POINTER_UP",
    /** POINTER_UP_OUTLINE maps to an equivalent icon available from constellation-icons */
    POINTER_UP_OUTLINE = "POINTER_UP_OUTLINE",
    /** PRICE_SQFT maps to an equivalent icon available from constellation-icons */
    PRICE_SQFT = "PRICE_SQFT",
    /** PRICE_SQFT_OUTLINE maps to an equivalent icon available from constellation-icons */
    PRICE_SQFT_OUTLINE = "PRICE_SQFT_OUTLINE",
    /** PROFILE maps to an equivalent icon available from constellation-icons */
    PROFILE = "PROFILE",
    /** PROFILE_OUTLINE maps to an equivalent icon available from constellation-icons */
    PROFILE_OUTLINE = "PROFILE_OUTLINE",
    /** PUBLIC_TRANSIT maps to an equivalent icon available from constellation-icons */
    PUBLIC_TRANSIT = "PUBLIC_TRANSIT",
    /** PUBLIC_TRANSIT_OUTLINE maps to an equivalent icon available from constellation-icons */
    PUBLIC_TRANSIT_OUTLINE = "PUBLIC_TRANSIT_OUTLINE",
    /** REDO maps to an equivalent icon available from constellation-icons */
    REDO = "REDO",
    /** RELOAD maps to an equivalent icon available from constellation-icons */
    RELOAD = "RELOAD",
    /** RENAME maps to an equivalent icon available from constellation-icons */
    RENAME = "RENAME",
    /** RENAME_OUTLINE maps to an equivalent icon available from constellation-icons */
    RENAME_OUTLINE = "RENAME_OUTLINE",
    /** REORDER maps to an equivalent icon available from constellation-icons */
    REORDER = "REORDER",
    /** REPLY maps to an equivalent icon available from constellation-icons */
    REPLY = "REPLY",
    /** ROTATE_CLOCKWISE maps to an equivalent icon available from constellation-icons */
    ROTATE_CLOCKWISE = "ROTATE_CLOCKWISE",
    /** ROTATE_CLOCKWISE_OUTLINE maps to an equivalent icon available from constellation-icons */
    ROTATE_CLOCKWISE_OUTLINE = "ROTATE_CLOCKWISE_OUTLINE",
    /** ROTATE_COUNTER_CLOCKWISE maps to an equivalent icon available from constellation-icons */
    ROTATE_COUNTER_CLOCKWISE = "ROTATE_COUNTER_CLOCKWISE",
    /** ROTATE_COUNTER_CLOCKWISE_OUTLINE maps to an equivalent icon available from constellation-icons */
    ROTATE_COUNTER_CLOCKWISE_OUTLINE = "ROTATE_COUNTER_CLOCKWISE_OUTLINE",
    /** SCHOOL maps to an equivalent icon available from constellation-icons */
    SCHOOL = "SCHOOL",
    /** SCHOOL_OUTLINE maps to an equivalent icon available from constellation-icons */
    SCHOOL_OUTLINE = "SCHOOL_OUTLINE",
    /** SEARCH maps to an equivalent icon available from constellation-icons */
    SEARCH = "SEARCH",
    /** SEARCH_OUTLINE maps to an equivalent icon available from constellation-icons */
    SEARCH_OUTLINE = "SEARCH_OUTLINE",
    /** SEND maps to an equivalent icon available from constellation-icons */
    SEND = "SEND",
    /** SEND_OUTLINE maps to an equivalent icon available from constellation-icons */
    SEND_OUTLINE = "SEND_OUTLINE",
    /** SETTINGS maps to an equivalent icon available from constellation-icons */
    SETTINGS = "SETTINGS",
    /** SETTINGS_OUTLINE maps to an equivalent icon available from constellation-icons */
    SETTINGS_OUTLINE = "SETTINGS_OUTLINE",
    /** SIGNATURE maps to an equivalent icon available from constellation-icons */
    SIGNATURE = "SIGNATURE",
    /** SMARTPHONE maps to an equivalent icon available from constellation-icons */
    SMARTPHONE = "SMARTPHONE",
    /** SMARTPHONE_OUTLINE maps to an equivalent icon available from constellation-icons */
    SMARTPHONE_OUTLINE = "SMARTPHONE_OUTLINE",
    /** SORT maps to an equivalent icon available from constellation-icons */
    SORT = "SORT",
    /** SORT_ASCENDING maps to an equivalent icon available from constellation-icons */
    SORT_ASCENDING = "SORT_ASCENDING",
    /** SORT_DESCENDING maps to an equivalent icon available from constellation-icons */
    SORT_DESCENDING = "SORT_DESCENDING",
    /** SORT_OUTLINE maps to an equivalent icon available from constellation-icons */
    SORT_OUTLINE = "SORT_OUTLINE",
    /** SPAM_FOLDER maps to an equivalent icon available from constellation-icons */
    SPAM_FOLDER = "SPAM_FOLDER",
    /** SPAM_FOLDER_OUTLINE maps to an equivalent icon available from constellation-icons */
    SPAM_FOLDER_OUTLINE = "SPAM_FOLDER_OUTLINE",
    /** SPARKLE maps to an equivalent icon available from constellation-icons */
    SPARKLE = "SPARKLE",
    /** SPARKLE_OUTLINE maps to an equivalent icon available from constellation-icons */
    SPARKLE_OUTLINE = "SPARKLE_OUTLINE",
    /** SQUARE_FEET maps to an equivalent icon available from constellation-icons */
    SQUARE_FEET = "SQUARE_FEET",
    /** SQUARE_FEET_OUTLINE maps to an equivalent icon available from constellation-icons */
    SQUARE_FEET_OUTLINE = "SQUARE_FEET_OUTLINE",
    /** STOP maps to an equivalent icon available from constellation-icons */
    STOP = "STOP",
    /** STOP_OUTLINE maps to an equivalent icon available from constellation-icons */
    STOP_OUTLINE = "STOP_OUTLINE",
    /** STREET_VIEW maps to an equivalent icon available from constellation-icons */
    STREET_VIEW = "STREET_VIEW",
    /** STREET_VIEW_OUTLINE maps to an equivalent icon available from constellation-icons */
    STREET_VIEW_OUTLINE = "STREET_VIEW_OUTLINE",
    /** SWIPE maps to an equivalent icon available from constellation-icons */
    SWIPE = "SWIPE",
    /** SWIPE_OUTLINE maps to an equivalent icon available from constellation-icons */
    SWIPE_OUTLINE = "SWIPE_OUTLINE",
    /** SYNC maps to an equivalent icon available from constellation-icons */
    SYNC = "SYNC",
    /** TABLET maps to an equivalent icon available from constellation-icons */
    TABLET = "TABLET",
    /** TABLET_OUTLINE maps to an equivalent icon available from constellation-icons */
    TABLET_OUTLINE = "TABLET_OUTLINE",
    /** TAG maps to an equivalent icon available from constellation-icons */
    TAG = "TAG",
    /** TAG_OUTLINE maps to an equivalent icon available from constellation-icons */
    TAG_OUTLINE = "TAG_OUTLINE",
    TARGET = "TARGET",
    TARGET_OUTLINE = "TARGET_OUTLINE",
    /** TAX maps to an equivalent icon available from constellation-icons */
    TAX = "TAX",
    /** TAX_OUTLINE maps to an equivalent icon available from constellation-icons */
    TAX_OUTLINE = "TAX_OUTLINE",
    /** TEXT_BOLD maps to an equivalent icon available from constellation-icons */
    TEXT_BOLD = "TEXT_BOLD",
    /** TEXT_BOLD_OUTLINE maps to an equivalent icon available from constellation-icons */
    TEXT_BOLD_OUTLINE = "TEXT_BOLD_OUTLINE",
    /** TEXT_COLOR maps to an equivalent icon available from constellation-icons */
    TEXT_COLOR = "TEXT_COLOR",
    /** TEXT_COLOR_OUTLINE maps to an equivalent icon available from constellation-icons */
    TEXT_COLOR_OUTLINE = "TEXT_COLOR_OUTLINE",
    /** TEXT_UNDERLINED maps to an equivalent icon available from constellation-icons */
    TEXT_UNDERLINED = "TEXT_UNDERLINED",
    /** TEXT_UNDERLINED_OUTLINE maps to an equivalent icon available from constellation-icons */
    TEXT_UNDERLINED_OUTLINE = "TEXT_UNDERLINED_OUTLINE",
    /** THREE_DIMENSIONAL maps to an equivalent icon available from constellation-icons */
    THREE_DIMENSIONAL = "THREE_DIMENSIONAL",
    /** THREE_DIMENSIONAL_OUTLINE maps to an equivalent icon available from constellation-icons */
    THREE_DIMENSIONAL_OUTLINE = "THREE_DIMENSIONAL_OUTLINE",
    /** THUMBS_DOWN maps to an equivalent icon available from constellation-icons */
    THUMBS_DOWN = "THUMBS_DOWN",
    /** THUMBS_DOWN_OUTLINE maps to an equivalent icon available from constellation-icons */
    THUMBS_DOWN_OUTLINE = "THUMBS_DOWN_OUTLINE",
    /** THUMBS_UP maps to an equivalent icon available from constellation-icons */
    THUMBS_UP = "THUMBS_UP",
    /** THUMBS_UP_OUTLINE maps to an equivalent icon available from constellation-icons */
    THUMBS_UP_OUTLINE = "THUMBS_UP_OUTLINE",
    /** TREES maps to an equivalent icon available from constellation-icons */
    TREES = "TREES",
    /** TREES_EVERGREEN maps to an equivalent icon available from constellation-icons */
    TREES_EVERGREEN = "TREES_EVERGREEN",
    /** TREES_EVERGREEN_OUTLINE maps to an equivalent icon available from constellation-icons */
    TREES_EVERGREEN_OUTLINE = "TREES_EVERGREEN_OUTLINE",
    /** TREES_OUTLINE maps to an equivalent icon available from constellation-icons */
    TREES_OUTLINE = "TREES_OUTLINE",
    /** TRENDING maps to an equivalent icon available from constellation-icons */
    TRENDING = "TRENDING",
    /** TRENDING_OUTLINE maps to an equivalent icon available from constellation-icons */
    TRENDING_OUTLINE = "TRENDING_OUTLINE",
    /** TROPHY maps to an equivalent icon available from constellation-icons */
    TROPHY = "TROPHY",
    /** TROPHY_OUTLINE maps to an equivalent icon available from constellation-icons */
    TROPHY_OUTLINE = "TROPHY_OUTLINE",
    /** UNDO maps to an equivalent icon available from constellation-icons */
    UNDO = "UNDO",
    /** UPLOAD maps to an equivalent icon available from constellation-icons */
    UPLOAD = "UPLOAD",
    /** UPLOAD_OUTLINE maps to an equivalent icon available from constellation-icons */
    UPLOAD_OUTLINE = "UPLOAD_OUTLINE",
    /** USER maps to an equivalent icon available from constellation-icons */
    USER = "USER",
    /** USER_OUTLINE maps to an equivalent icon available from constellation-icons */
    USER_OUTLINE = "USER_OUTLINE",
    /** USER_SETTINGS maps to an equivalent icon available from constellation-icons */
    USER_SETTINGS = "USER_SETTINGS",
    /** USER_SETTINGS_OUTLINE maps to an equivalent icon available from constellation-icons */
    USER_SETTINGS_OUTLINE = "USER_SETTINGS_OUTLINE",
    /** VIDEO_PLAY maps to an equivalent icon available from constellation-icons */
    VIDEO_PLAY = "VIDEO_PLAY",
    /** VIDEO_PLAY_OUTLINE maps to an equivalent icon available from constellation-icons */
    VIDEO_PLAY_OUTLINE = "VIDEO_PLAY_OUTLINE",
    /** WARNING maps to an equivalent icon available from constellation-icons */
    WARNING = "WARNING",
    /** WARNING_OUTLINE maps to an equivalent icon available from constellation-icons */
    WARNING_OUTLINE = "WARNING_OUTLINE",
    /** WHITE_BALANCE maps to an equivalent icon available from constellation-icons */
    WHITE_BALANCE = "WHITE_BALANCE",
    /** WHITE_BALANCE_OUTLINE maps to an equivalent icon available from constellation-icons */
    WHITE_BALANCE_OUTLINE = "WHITE_BALANCE_OUTLINE",
    /** YARD_SIGN maps to an equivalent icon available from constellation-icons */
    YARD_SIGN = "YARD_SIGN",
    /** YARD_SIGN_OUTLINE maps to an equivalent icon available from constellation-icons */
    YARD_SIGN_OUTLINE = "YARD_SIGN_OUTLINE",
    /** ZILLOW_LOGO maps to an equivalent icon available from constellation-icons */
    ZILLOW_LOGO = "ZILLOW_LOGO",
    /** ZOOM_IN maps to an equivalent icon available from constellation-icons */
    ZOOM_IN = "ZOOM_IN",
    /** ZOOM_IN_OUTLINE maps to an equivalent icon available from constellation-icons */
    ZOOM_IN_OUTLINE = "ZOOM_IN_OUTLINE",
    /** ZOOM_OUT maps to an equivalent icon available from constellation-icons */
    ZOOM_OUT = "ZOOM_OUT",
    /** ZOOM_OUT_OUTLINE maps to an equivalent icon available from constellation-icons */
    ZOOM_OUT_OUTLINE = "ZOOM_OUT_OUTLINE"
}
/**
 * Supported Emphasis styles for a Constellation 10 Icon Button.
 *
 * Aligns with Constellation 10 Tokens
 */
export enum ZHLExperienceWebConstellation10IconButtonEmphasis {
    /** No emphasis, minimal styling. */
    BARE = "BARE",
    /** Filled background for strong emphasis. */
    FILLED = "FILLED",
    /** Outlined border for medium emphasis. */
    OUTLINED = "OUTLINED"
}
/**
 * Supported Shapes for a Constellation 10 Icon Button.
 *
 * Aligns with Constellation 10 Tokens
 */
export enum ZHLExperienceWebConstellation10IconButtonShape {
    /** Circular button shape. */
    CIRCLE = "CIRCLE",
    /** Square button shape. */
    SQUARE = "SQUARE"
}
/**
 * Supported Button tones for a Constellation 10 Icon Button.
 *
 * Aligns with Constellation 10 Tokens
 */
export enum ZHLExperienceWebConstellation10IconButtonTone {
    /** Primary button tone. */
    BRAND = "BRAND",
    /** Critical button tone. */
    CRITICAL = "CRITICAL",
    /** Neutral button tone. */
    NEUTRAL = "NEUTRAL"
}
/** Supported icon colors in Web Constellation 10 for ZHL Experience Graph */
export enum ZHLExperienceWebConstellation10IconColor {
    /** BLUE_100 maps to an equivalent Constellation 10 / Panda CSS Token that is supported by the Icon component */
    BLUE_100 = "BLUE_100",
    /** BLUE_200 maps to an equivalent Constellation 10 / Panda CSS Token that is supported by the Icon component */
    BLUE_200 = "BLUE_200",
    /** BLUE_300 maps to an equivalent Constellation 10 / Panda CSS Token that is supported by the Icon component */
    BLUE_300 = "BLUE_300",
    /** BLUE_400 maps to an equivalent Constellation 10 / Panda CSS Token that is supported by the Icon component */
    BLUE_400 = "BLUE_400",
    /** BLUE_500 maps to an equivalent Constellation 10 / Panda CSS Token that is supported by the Icon component */
    BLUE_500 = "BLUE_500",
    BLUE_600 = "BLUE_600",
    /** BRAND maps to an equivalent Constellation 10 / Panda CSS Token that is supported by the Icon component */
    BRAND = "BRAND",
    /** BRAND_SECONDARY maps to an equivalent Constellation 10 / Panda CSS Token that is supported by the Icon component */
    BRAND_SECONDARY = "BRAND_SECONDARY",
    /** DARK maps to an equivalent Constellation 10 / Panda CSS Token that is supported by the Icon component */
    DARK = "DARK",
    /** GREEN_100 maps to an equivalent Constellation 10 / Panda CSS Token that is supported by the Icon component */
    GREEN_100 = "GREEN_100",
    /** GREEN_200 maps to an equivalent Constellation 10 / Panda CSS Token that is supported by the Icon component */
    GREEN_200 = "GREEN_200",
    /** GREEN_300 maps to an equivalent Constellation 10 / Panda CSS Token that is supported by the Icon component */
    GREEN_300 = "GREEN_300",
    /** GREEN_400 maps to an equivalent Constellation 10 / Panda CSS Token that is supported by the Icon component */
    GREEN_400 = "GREEN_400",
    /** GREEN_500 maps to an equivalent Constellation 10 / Panda CSS Token that is supported by the Icon component */
    GREEN_500 = "GREEN_500",
    LIGHT = "LIGHT",
    /** MUTED maps to an equivalent Constellation 10 / Panda CSS Token that is supported by the Icon component */
    MUTED = "MUTED",
    /** NEUTRAL maps to an equivalent Constellation 10 / Panda CSS Token that is supported by the Icon component */
    NEUTRAL = "NEUTRAL",
    /** ORANGE_100 maps to an equivalent Constellation 10 / Panda CSS Token that is supported by the Icon component */
    ORANGE_100 = "ORANGE_100",
    /** ORANGE_200 maps to an equivalent Constellation 10 / Panda CSS Token that is supported by the Icon component */
    ORANGE_200 = "ORANGE_200",
    /** ORANGE_300 maps to an equivalent Constellation 10 / Panda CSS Token that is supported by the Icon component */
    ORANGE_300 = "ORANGE_300",
    /** ORANGE_400 maps to an equivalent Constellation 10 / Panda CSS Token that is supported by the Icon component */
    ORANGE_400 = "ORANGE_400",
    /** ORANGE_500 maps to an equivalent Constellation 10 / Panda CSS Token that is supported by the Icon component */
    ORANGE_500 = "ORANGE_500",
    /** RED_100 maps to an equivalent Constellation 10 / Panda CSS Token that is supported by the Icon component */
    RED_100 = "RED_100",
    /** RED_200 maps to an equivalent Constellation 10 / Panda CSS Token that is supported by the Icon component */
    RED_200 = "RED_200",
    /** RED_300 maps to an equivalent Constellation 10 / Panda CSS Token that is supported by the Icon component */
    RED_300 = "RED_300",
    /** RED_400 maps to an equivalent Constellation 10 / Panda CSS Token that is supported by the Icon component */
    RED_400 = "RED_400",
    /** RED_500 maps to an equivalent Constellation 10 / Panda CSS Token that is supported by the Icon component */
    RED_500 = "RED_500",
    /** WHITE maps to an equivalent Constellation 10 / Panda CSS Token that is supported by the Icon component */
    WHITE = "WHITE",
    /** YELLOW_100 maps to an equivalent Constellation 10 / Panda CSS Token that is supported by the Icon component */
    YELLOW_100 = "YELLOW_100",
    /** YELLOW_200 maps to an equivalent Constellation 10 / Panda CSS Token that is supported by the Icon component */
    YELLOW_200 = "YELLOW_200",
    /** YELLOW_300 maps to an equivalent Constellation 10 / Panda CSS Token that is supported by the Icon component */
    YELLOW_300 = "YELLOW_300",
    /** YELLOW_400 maps to an equivalent Constellation 10 / Panda CSS Token that is supported by the Icon component */
    YELLOW_400 = "YELLOW_400",
    /** YELLOW_500 maps to an equivalent Constellation 10 / Panda CSS Token that is supported by the Icon component */
    YELLOW_500 = "YELLOW_500"
}
/**
 * Supported sizing for Icons in Constellation 10 Web in ZHL Experience Graph
 *
 * These values map closely to equivalent tokens for the Constellation SDK on Panda CSS
 */
export enum ZHLExperienceWebConstellation10IconSize {
    /** Large Icon Size */
    LG = "LG",
    /** Medium Icon Size */
    MD = "MD",
    /** Small icon size */
    SM = "SM",
    /** Extra Large Icon Size */
    XL = "XL"
}
/** Supported List appearances in Web Constellation 10 in ZHL Experience Graph */
export enum ZHLExperienceWebConstellation10ListAppearance {
    /** Display the list as a bullet point list */
    BULLET = "BULLET",
    /** Special case where an icon is used as a bullet */
    ICONIFIED = "ICONIFIED",
    /** Display the list as a set of vertically stacked text */
    NONE = "NONE",
    /** Display the list as a numbered list */
    NUMBER = "NUMBER"
}
/**
 * Supported Web Constellation 10 Text Styles in ZHL Experience Graph
 *
 * This enum caputres only the non-heading styles.
 */
export enum ZHLExperienceWebConstellation10TextStyle {
    /** Regular Text */
    BODY = "BODY",
    /** Bolded Regular Text */
    BODY_BOLD = "BODY_BOLD",
    /** Large Text */
    BODY_LG = "BODY_LG",
    /** Bolded Large Text */
    BODY_LG_BOLD = "BODY_LG_BOLD",
    /** Small Text */
    BODY_SM = "BODY_SM",
    /** Bolded Small Text */
    BODY_SM_BOLD = "BODY_SM_BOLD",
    /** Extra Small Text */
    BODY_XS = "BODY_XS",
    /** Bolded Extra Small Text */
    BODY_XS_BOLD = "BODY_XS_BOLD",
    /** Fineprint */
    FINEPRINT = "FINEPRINT",
    /** Bolded Fineprint */
    FINEPRINT_BOLD = "FINEPRINT_BOLD",
    /** Small Fineprint */
    FINEPRINT_SM = "FINEPRINT_SM",
    /** Bolded Small Fineprint */
    FINEPRINT_SM_BOLD = "FINEPRINT_SM_BOLD",
    HEADING_LG = "HEADING_LG",
    HEADING_MD = "HEADING_MD",
    HEADING_SM = "HEADING_SM",
    HEADING_XL = "HEADING_XL",
    HEADING_XS = "HEADING_XS"
}
/**
 * ZHL Experience Graph Block / Molecule
 *
 * - Higher order molecule for rendering a contact card in the UI using Constellation Web SDKs
 */
export type ZHLExperienceWebContactInformationSection = NeutronBlock & {
    __typename: "ZHLExperienceWebContactInformationSection";
    /** Either avatar or imageAsAvatar will be provided */
    avatar: Maybe<ZHLExperienceWebAvatar>;
    /** What constellation version this contact information section molecule is for */
    constellationVersion: ZHLExperienceConstellationVersion;
    contactMethods: Maybe<Array<ZHLExperienceWebButton>>;
    /** Content to be rendered below the headline, such as their job title */
    content: Maybe<Array<ZHLExperienceWebText>>;
    /**
     * A headline that describes the individual, such as their name
     *
     * Heading or Text will be provided but not both
     */
    headlineHeading: Maybe<ZHLExperienceWebHeading>;
    /**
     * A headline that describes the individual, such as their name
     *
     * Heading or Text will be provided but not both
     */
    headlineText: Maybe<ZHLExperienceWebText>;
    /** Necessary for wiring actions to this block, and for client-side identity-based UI diffing for partial updates */
    id: Scalars["String"];
    imageAsAvatar: Maybe<ZHLExperienceWebImage>;
    /** What platform this contact information section molecule is for. Should be WEB */
    platform: ZHLExperiencePlatformType;
    /** Content to be rendered beneath the avatar and title but above the contact methods */
    underNameTagContent: Maybe<Array<ZHLExperienceText>>;
};
/**
 * ZHL Experience Graph Web Block
 * - Implementation of the ZHLExperienceIcon, for rendering an icon with Constellation Web
 */
export type ZHLExperienceWebHeading = NeutronBlock & {
    __typename: "ZHLExperienceWebHeading";
    configuration: ZHLExperienceWebHeadingConfiguration;
    content: Scalars["String"];
    /** Necessary for wiring actions to this block, and for client-side identity-based UI diffing for partial updates */
    id: Scalars["String"];
};
/** Supported Web Heading configurations in ZHL Experience Graph */
export type ZHLExperienceWebHeadingConfiguration = ZHLExperienceWebHeadingConstellation8Configuration | ZHLExperienceWebHeadingConstellation10AlphaConfiguration;
/**
 * ZHL Experience Graph Web Block Configuration
 * - Configuration for Heading component in Web Constellation 8
 */
export type ZHLExperienceWebHeadingConstellation8Configuration = {
    __typename: "ZHLExperienceWebHeadingConstellation8Configuration";
    /** What Constellation Version this configuration is for. Should be WEB_8 */
    constellationVersion: ZHLExperienceConstellationVersion;
    /**
     * What text color to use when rendering the heading
     *
     * Maps to an equivalent token in Constellation 8
     */
    fontColor: ZHLExperienceWebConstellation8Color;
    /**
     * What font family to use when rendering the heading
     *
     * Maps to an equivalent token in Constellation 8
     */
    fontFamily: ZHLExperienceWebConstellation8FontFamily;
    /**
     * What font type to use when rendering the heading
     *
     * Maps to an equivalent token in Constellation 8
     */
    fontType: ZHLExperienceWebConstellation8FontType;
    /** What Heading level to render */
    level: Scalars["Int"];
    /** What platform this configuration is for. Should be WEB */
    platform: ZHLExperiencePlatformType;
    /**
     * What text alignment to use when rendering the heading
     *
     * Maps to an equivalent token in Constellation 8
     */
    textAlign: ZHLExperienceWebConstellation8TextAlignment;
};
/**
 * ZHL Experience Graph Web Block Configuration
 * - Configuration for Heading component in Web Constellation 10
 */
export type ZHLExperienceWebHeadingConstellation10AlphaConfiguration = {
    __typename: "ZHLExperienceWebHeadingConstellation10AlphaConfiguration";
    /**
     * What text color to use when rendering the heading
     *
     * Maps to an equivalent token in Constellation 10 / PandaCSS
     */
    color: ZHLExperienceWebConstellation10FontColor;
    /** What Constellation Version this configuration is for. Should be WEB_10_ALPHA */
    constellationVersion: ZHLExperienceConstellationVersion;
    /**
     * What font family to use when rendering the heading
     *
     * Maps to an equivalent token in Constellation 10 / PandaCSS
     */
    fontFamily: ZHLExperienceWebConstellation10FontFamily;
    /** What Heading level to render */
    level: Scalars["Int"];
    /** What platform this configuration is for. Should be WEB */
    platform: ZHLExperiencePlatformType;
    /**
     * What text style to use when rendering the heading
     *
     * Maps to an equivalent token in Constellation 10 / PandaCSS
     */
    textStyle: ZHLExperienceWebConstellation10HeadingTextStyle;
};
/**
 * ZHL Experience Graph Web Block
 *
 * - Implementation of the ZHLExperienceIcon, for rendering an icon with Constellation Web
 */
export type ZHLExperienceWebIcon = NeutronBlock & {
    __typename: "ZHLExperienceWebIcon";
    /** The constellation version aware configuration of the icon. Which is returned depends on the requested constellation version */
    configuration: ZHLExperienceWebIconConfiguration;
    /** Necessary for wiring actions to this block, and for client-side identity-based UI diffing for partial updates */
    id: Scalars["String"];
};
/**
 * ZHL Experience Graph Web Block
 *
 * - Represents an icon button block in the ZHL Experience web interface.
 */
export type ZHLExperienceWebIconButton = NeutronBlock & {
    __typename: "ZHLExperienceWebIconButton";
    /** Configuration options for the icon button. */
    configuration: Maybe<ZHLExperienceWebIconButtonConfiguration>;
    /** The icon displayed within the button. */
    icon: Maybe<ZHLExperienceWebIcon>;
    /** Unique identifier for the icon button. */
    id: Scalars["String"];
    /** Accessible title for the icon button. */
    title: Scalars["String"];
};
/** Configuration union for ZHLExperienceWebIconButton. */
export type ZHLExperienceWebIconButtonConfiguration = ZHLExperienceWebIconButtonConstellation8Configuration | ZHLExperienceWebIconButtonConstellation10Configuration;
/** Configuration for a Constellation 8 Icon Button. */
export type ZHLExperienceWebIconButtonConstellation8Configuration = {
    __typename: "ZHLExperienceWebIconButtonConstellation8Configuration";
    /** Appearance of the icon button. */
    appearance: ZHLExperienceWebConstellation8IconButtonAppearance;
    /** Whether the icon button should be rendered without borders */
    bare: Scalars["Boolean"];
    /** Visual emphasis style of the icon button. */
    buttonType: ZHLExperienceWebConstellation8IconButtonType;
    /** What constellation version this configuration is for. Should be WEB_8_ALPHA */
    constellationVersion: ZHLExperienceConstellationVersion;
    /** Whether the icon button should be rendered in dark mode. */
    inverse: Scalars["Boolean"];
    /** The size of the icon button. */
    size: ZHLExperienceWebConstellation8ButtonSize;
};
/** Configuration for a Constellation 10 Icon Button. */
export type ZHLExperienceWebIconButtonConstellation10Configuration = {
    __typename: "ZHLExperienceWebIconButtonConstellation10Configuration";
    /** What constellation version this configuration is for. Should be WEB_10_ALPHA */
    constellationVersion: ZHLExperienceConstellationVersion;
    /** Visual emphasis style of the icon button. */
    emphasis: Maybe<ZHLExperienceWebConstellation10IconButtonEmphasis>;
    /** Whether the icon button should be rendered in dark mode. */
    onImpact: Scalars["Boolean"];
    /** Shape of the icon button. */
    shape: Maybe<ZHLExperienceWebConstellation10IconButtonShape>;
    /** The tone of the icon button. */
    tone: ZHLExperienceWebConstellation10IconButtonTone;
};
/** Supported Web Icon configurations in ZHL Experience Graph */
export type ZHLExperienceWebIconConfiguration = ZHLExperienceWebIconConstellation8Configuration | ZHLExperienceWebIconConstellation10AlphaConfiguration;
/**
 * ZHL Experience Graph Web Block Configuration
 *
 * - Provides integration with Constellation 8 to configure an icon on web
 */
export type ZHLExperienceWebIconConstellation8Configuration = {
    __typename: "ZHLExperienceWebIconConstellation8Configuration";
    /** The constellation version this configuration is for. Should be WEB_8 */
    constellationVersion: ZHLExperienceConstellationVersion;
    /** What color to render the icon with */
    fontColor: Maybe<ZHLExperienceWebConstellation8Color>;
    /** What icon to render */
    icon: ZHLExperienceWebConstellation8Icon;
    /** The platform this configuration is for. Should be WEB */
    platform: ZHLExperiencePlatformType;
    /** What size to render the icon */
    size: ZHLExperienceWebConstellation8IconSize;
    /** An accessible description of the icon */
    title: Maybe<Scalars["String"]>;
};
/**
 * ZHL Experience Graph Web Block Configuration
 *
 * - Provides integration with Constellation 10 to configure an icon on web
 */
export type ZHLExperienceWebIconConstellation10AlphaConfiguration = {
    __typename: "ZHLExperienceWebIconConstellation10AlphaConfiguration";
    /** What color to render the icon with */
    color: Maybe<ZHLExperienceWebConstellation10IconColor>;
    /** The constellation version this configuration is for. Should be WEB_10_ALPHA */
    constellationVersion: ZHLExperienceConstellationVersion;
    /** What icon to render */
    icon: ZHLExperienceWebConstellation10Icon;
    /** The platform this configuration is for. Should be WEB */
    platform: ZHLExperiencePlatformType;
    /** What size to render the icon */
    size: ZHLExperienceWebConstellation10IconSize;
    /** An accessible description of the icon */
    title: Maybe<Scalars["String"]>;
};
/**
 * ZHL Experience Graph Web Block
 * - Implementation of the ZHLExperienceIcon, for rendering an icon with Constellation Web
 */
export type ZHLExperienceWebImage = NeutronBlock & {
    __typename: "ZHLExperienceWebImage";
    /** An alternate text used for describing the image for a11y purposes */
    altText: Scalars["String"];
    /** What Constellation version this image is for. Should be a WEB constellation version */
    constellationVersion: ZHLExperienceConstellationVersion;
    /** The height of the image */
    height: Scalars["String"];
    /** Necessary for wiring actions to this block, and for client-side identity-based UI diffing for partial updates */
    id: Scalars["String"];
    /** Whether the image should take up the full width of it's container */
    isFullWidth: Scalars["Boolean"];
    /** The source for the image */
    src: Scalars["String"];
    /** When full width is true, this will be null */
    width: Maybe<Scalars["String"]>;
};
/**
 * ZHL Experience Web Block
 * - Implements the Anchor Constellation component in Web
 */
export type ZHLExperienceWebLink = NeutronBlock & {
    __typename: "ZHLExperienceWebLink";
    configuration: ZHLExperienceWebLinkConfiguration;
    /** The text content of the link */
    content: Scalars["String"];
    /** Necessary for wiring actions to this block, and for client-side identity-based UI diffing for partial updates */
    id: Scalars["String"];
    /** The resource to navigate to when the link is clicked */
    resource: Scalars["String"];
};
/** Supported web configurations for links in ZHL Experience Graph */
export type ZHLExperienceWebLinkConfiguration = ZHLExperienceWebLinkConstellation8Configuration | ZHLExperienceWebLinkConstellation10AlphaConfiguration;
/**
 * ZHL Experience Web Block Configuration
 * - Provides the configuration for an Anchor component in Constellation 8 Web
 */
export type ZHLExperienceWebLinkConstellation8Configuration = {
    __typename: "ZHLExperienceWebLinkConstellation8Configuration";
    /** The constellation version this configuration is intended for. Should be WEB_8 */
    constellationVersion: ZHLExperienceConstellationVersion;
    /** Whether to inverse the link coloring for dark backrounds */
    inverse: Scalars["Boolean"];
    /** The platform this configuration is intended for. Should be WEB */
    platform: ZHLExperiencePlatformType;
};
/**
 * ZHL Experience Web Block Configuration
 * - Provides the configuration for an Anchor component in Constellation 10 Web
 */
export type ZHLExperienceWebLinkConstellation10AlphaConfiguration = {
    __typename: "ZHLExperienceWebLinkConstellation10AlphaConfiguration";
    /** The constellation version this configuration is intended for. Should be WEB_10_ALPHA */
    constellationVersion: ZHLExperienceConstellationVersion;
    /** Whether to inverse the link coloring for dark backrounds */
    onImpact: Scalars["Boolean"];
    /** The platform this configuration is intended for. Should be WEB */
    platform: ZHLExperiencePlatformType;
};
/**
 * ZHL Experience Graph Block
 *
 * - Atom for representing a list of text in a Web UI
 */
export type ZHLExperienceWebList = NeutronBlock & {
    __typename: "ZHLExperienceWebList";
    /** The configuration for the list in a specific Web Constellation version */
    configuration: ZHLExperienceWebListConfiguration;
    /** The raw string items for the list */
    content: Array<Scalars["String"]>;
    /** Necessary for wiring actions to this block, and for client-side identity-based UI diffing for partial updates */
    id: Scalars["String"];
};
/** All supported Web List configurations in ZHL Experience Graph */
export type ZHLExperienceWebListConfiguration = ZHLExperienceWebListConstellation8Configuration | ZHLExperienceWebListConstellation10AlphaConfiguration;
/** Supported List Configuration in Web Constellation 8 in ZHL Experience Graph */
export type ZHLExperienceWebListConstellation8Configuration = {
    __typename: "ZHLExperienceWebListConstellation8Configuration";
    /** What list appearance to use when displaying the list */
    appearance: ZHLExperienceWebConstellation8ListAppearance;
    /** What platform this configuration is for. Should be WEB_8 */
    constellationVersion: ZHLExperienceConstellationVersion;
    /** Only defined when appearance is ICONIFIED. WIll be an Icon block that can be used in place of the list bullets */
    icon: Maybe<ZHLExperienceWebIcon>;
    /** What platform this configuration is for. Should be WEB */
    platform: ZHLExperiencePlatformType;
};
/** Supported List configuration in Web Constellation 10 in ZHL Experience Graph */
export type ZHLExperienceWebListConstellation10AlphaConfiguration = {
    __typename: "ZHLExperienceWebListConstellation10AlphaConfiguration";
    /** What list appearance to use when displaying the list */
    appearance: ZHLExperienceWebConstellation10ListAppearance;
    /** What platform this configuration is for. Should be WEB_10_ALPHA */
    constellationVersion: ZHLExperienceConstellationVersion;
    /** Only defined when appearance is ICONIFIED. WIll be an Icon block that can be used in place of the list bullets */
    icon: Maybe<ZHLExperienceWebIcon>;
    /** What platform this configuration is for. Should be WEB */
    platform: ZHLExperiencePlatformType;
};
/** Describes an action to navigate to a web page for ZHL Experience Graph */
export type ZHLExperienceWebNavigationAction = NeutronAction & {
    __typename: "ZHLExperienceWebNavigationAction";
    /** The desired destination to send the user to */
    destination: Scalars["String"];
    /** Must match the id for the corresponding block */
    id: Scalars["String"];
};
/**
 * ZHL Experience Graph Web Block
 *
 * - Represents a popover block in the ZHL Experience web interface. When trigger is null, the default info circle / question mark circle should be used
 */
export type ZHLExperienceWebPopover = NeutronBlock & {
    __typename: "ZHLExperienceWebPopover";
    /** Additional call-to-action buttons to display in the popover. */
    additionalCTAs: Maybe<Array<ZHLExperienceWebButton>>;
    /** The main body content of the popover, typically text blocks. */
    body: Maybe<Array<ZHLExperienceWebText>>;
    /** Whether the popover should be displayed as a modal dialog. */
    displayAsModal: Scalars["Boolean"];
    /** Whether the popover should be displayed as a sheet on small screens */
    displayAsSheet: Maybe<Scalars["Boolean"]>;
    /** Optional header for the popover, typically a heading block. */
    header: Maybe<ZHLExperienceWebHeading>;
    /** Unique identifier for the popover. */
    id: Scalars["String"];
    /** The trigger element that opens the popover. */
    trigger: Maybe<ZHLExperienceWebPopoverTrigger>;
};
/**
 * Supported trigger types for a ZHLExperienceWebPopover.
 *
 * - Determines which UI element can open the popover.
 */
export type ZHLExperienceWebPopoverTrigger = ZHLExperienceWebButton | ZHLExperienceWebIcon | ZHLExperienceWebIconButton | ZHLExperienceWebLink;
/**
 * ZHL Experience Graph Web Block
 *
 * - Implements the Heading and Text components in Constellation
 */
export type ZHLExperienceWebText = NeutronBlock & {
    __typename: "ZHLExperienceWebText";
    /**
     * The configuration for the text. If there are embedded blocks, this will still be provided
     * but configuration for each embedded block should take precedence over this configuration.
     */
    configuration: ZHLExperienceWebTextConfiguration;
    /**
     * The raw text content to display. This will always be a markdown string, however where possible, the configuration options
     * will be used to set the whole text as bold, italics, or underlined. Therefore clients should parse the text as markdown and render it,
     * then additionally set the configuration options to ensure the string renders correctly
     */
    content: Scalars["String"];
    /**
     * If this text should have embedded blocks in it (such as navigation links, tooltips, etc.), this will contain the text laid out
     * as a left to right list of blocks, with either Text elements or the other embedded blocks, such that if rendered left to right, they form
     * the content with the embedded blocks placed in the correct locations within the text
     */
    contentWithEmbeddedBlocks: Maybe<Array<ZHLExperienceWebTextEmbeddableBlocks>>;
    /** Necessary for wiring actions to this block, and for client-side identity-based UI diffing for partial updates */
    id: Scalars["String"];
};
/** Supported web configurations for text in ZHL Experience Graph */
export type ZHLExperienceWebTextConfiguration = ZHLExperienceWebTextConstellation8Configuration | ZHLExperienceWebTextConstellation10AlphaConfiguration;
/**
 * ZHL Experience Graph Web Block Configuration
 *
 * - Provides the configuration for a Text or Paragraph component in Constellation 8 Web
 */
export type ZHLExperienceWebTextConstellation8Configuration = {
    __typename: "ZHLExperienceWebTextConstellation8Configuration";
    /** Does not match to an SDK value but Text and Paragraph are implemented identically so this saves us having to make a separate identical type */
    asParagraph: Scalars["Boolean"];
    /** What constellation version this configuration is intended for. Should be WEB_8 */
    constellationVersion: ZHLExperienceConstellationVersion;
    /**
     * What font color to display the text with
     *
     * Maps to an equivalent token in Constellation 8
     */
    fontColor: ZHLExperienceWebConstellation8Color;
    /**
     * What font type to display the text with
     *
     * Maps to an equivalent token in Constellation 8
     */
    fontType: ZHLExperienceWebConstellation8FontType;
    /** What platform this configuration is intended for. Should be WEB */
    platform: ZHLExperiencePlatformType;
    /**
     * What text alignment to display the text with
     *
     * Maps to an equivalent token in Constellation 8
     */
    textAlign: ZHLExperienceWebConstellation8TextAlignment;
};
/**
 * ZHL Experience Graph Web Block Configuration
 *
 * - Provides the configuration for a Text or Paragraph component in Constellation 10 Web
 */
export type ZHLExperienceWebTextConstellation10AlphaConfiguration = {
    __typename: "ZHLExperienceWebTextConstellation10AlphaConfiguration";
    /** Does not match to an SDK value but Text and Paragraph are implemented identically so this saves us having to make a separate identical type */
    asParagraph: Scalars["Boolean"];
    /**
     * What text color to display the text with
     *
     * Maps to an equivalent token in Constellation 10
     */
    color: ZHLExperienceWebConstellation10FontColor;
    /** What constellation version this configuration is intended for. Should be WEB_10_ALPHA */
    constellationVersion: ZHLExperienceConstellationVersion;
    /** What platform this configuration is intended for. Should be WEB */
    platform: ZHLExperiencePlatformType;
    /**
     * What text style to display the text with
     *
     * Maps to an equivalent token in Constellation 10
     */
    textStyle: ZHLExperienceWebConstellation10TextStyle;
};
/** Web Blocks that can be intermixed within a rich text block that contains other embedded blocks */
export type ZHLExperienceWebTextEmbeddableBlocks = ZHLExperienceWebIcon | ZHLExperienceWebLink | ZHLExperienceWebPopover | ZHLExperienceWebText;
export type ZHLLFSMetaData = {
    __typename: "ZHLLFSMetaData";
    id: Maybe<Scalars["ID"]>;
    lfsRecordSource: Maybe<ZHLLfsRecordSource>;
    lfsRecordSubSource: Maybe<ZHLLfsRecordSubSource>;
};
export type ZHLLeadAttributes = {
    __typename: "ZHLLeadAttributes";
    incentiveCreditAmount: Maybe<Scalars["Float"]>;
    leadSource: Maybe<Scalars["String"]>;
    leadType: Maybe<Scalars["String"]>;
    marksmanPricingType: Maybe<Scalars["String"]>;
    name: Maybe<Scalars["String"]>;
    program: Maybe<Scalars["String"]>;
    recordId: Maybe<Scalars["String"]>;
};
export type ZHLLeadSummary = {
    __typename: "ZHLLeadSummary";
    id: Scalars["ID"];
    leadState: Maybe<Scalars["String"]>;
    propertyValue: Maybe<Scalars["Float"]>;
};
export enum ZHLLfsRecordSource {
    LFS_RECORD_SOURCE_ASSET = "LFS_RECORD_SOURCE_ASSET",
    LFS_RECORD_SOURCE_BORROWER = "LFS_RECORD_SOURCE_BORROWER",
    LFS_RECORD_SOURCE_EMPLOYMENT = "LFS_RECORD_SOURCE_EMPLOYMENT",
    LFS_RECORD_SOURCE_GIFT = "LFS_RECORD_SOURCE_GIFT",
    LFS_RECORD_SOURCE_OTHER_INCOME = "LFS_RECORD_SOURCE_OTHER_INCOME",
    LFS_RECORD_SOURCE_REAL_ESTATE = "LFS_RECORD_SOURCE_REAL_ESTATE",
    LFS_RECORD_SOURCE_UNSPECIFIED = "LFS_RECORD_SOURCE_UNSPECIFIED"
}
export enum ZHLLfsRecordSubSource {
    LFS_RECORD_SUB_SOURCE_CITIZENSHIP = "LFS_RECORD_SUB_SOURCE_CITIZENSHIP",
    LFS_RECORD_SUB_SOURCE_UNSPECIFIED = "LFS_RECORD_SUB_SOURCE_UNSPECIFIED"
}
export type ZHLLoan = {
    __typename: "ZHLLoan";
    attributes: Maybe<ZHLLoanAttributes>;
    /** This returns mock data.  Will be implemented soon. */
    blendApplicationStatus: Maybe<BlendApplicationStatus>;
    borrowers: Maybe<Array<ZHLBorrower>>;
    ctaURL: Maybe<Scalars["String"]>;
    currentlyLoggedInBorrower: Maybe<ZHLBorrower>;
    digitalExperience: Maybe<ZHLPreApprovalDigitalExperience>;
    /** All disclosure packages for this loan */
    disclosureDocuments: Maybe<Array<ZhlDisclosureDocument>>;
    /** Documents associated with the loan. Supports filtering by type or ID */
    documents: Maybe<Array<Maybe<ZHLDocument>>>;
    /**
     * Full App features and CTAs with optional borrower context.
     * Pass borrowerId to generate URLs with login_hint for specific borrower.
     */
    fullAppFeatures: Maybe<FullAppFeatures>;
    id: Scalars["ID"];
    lead: Maybe<ZHLLeadSummary>;
    leadAttributes: Maybe<ZHLLeadAttributes>;
    loanNumber: Maybe<Scalars["String"]>;
    loanOfficer: Maybe<ZHLLoanOfficer>;
    loanProcessor: Maybe<ZHLLoanProcessor>;
    /** Non-borrowing owners associated with this loan. */
    nonBorrowingOwners: Maybe<Array<ZHLNonBorrowingOwner>>;
    /** This returns mock data.  Will be implemented soon. */
    offerAccepted: Maybe<Scalars["Boolean"]>;
    participants: Maybe<Array<Maybe<ZHLParticipant>>>;
    /** This returns current pre-approval letter. */
    preApprovalLetterURL: Maybe<ZHLDocumentMetadata>;
    /** This returns the pre approval document download and viewing URL. It will also return all of the data associated with that document if available */
    preApprovalLetters: Maybe<Array<Maybe<ZHLPreapprovalLetter>>>;
    /** Features associated with BOLT experience */
    quickAppFeatures: Maybe<QuickAppFeatures>;
    rateQuote: Maybe<ZHLRateQuote>;
    salesforceLoanStage: Maybe<Scalars["String"]>;
    /** This is the loan status as defined from LFS. */
    status: Maybe<Scalars["String"]>;
    /** This returns tasks from Tasks service. Supports filtering by taskTrigger, taskTriggerList and taskCategory. */
    tasks: Maybe<Array<Maybe<ZHLTask>>>;
    /** Version 2 of tasks API with enhanced metadata and form support. Supports filtering by classification, category, and subcategory. */
    tasksV2: Maybe<Array<Maybe<ZHLTaskV2>>>;
    tridTriggeredUTC: Maybe<Scalars["String"]>;
};
export type ZHLLoanAttributes = {
    __typename: "ZHLLoanAttributes";
    downPayment: Maybe<Scalars["Float"]>;
    leadId: Maybe<Scalars["ID"]>;
    loanPurpose: Maybe<ZHLLoanPurpose>;
    propertyType: Maybe<ZHLPropertyType>;
    propertyUse: Maybe<ZHLPropertyUse>;
    purchaseLocation: Maybe<ZHLLocation>;
    targetLoanAmount: Maybe<Scalars["Float"]>;
    valuation: Maybe<Scalars["Float"]>;
};
export type ZHLLoanOfficer = BridgeLoanOfficerParticipantDetails & {
    __typename: "ZHLLoanOfficer";
    branchNMLSID: Maybe<Scalars["Int"]>;
    dedicatedRelationship: Maybe<Array<Maybe<DedicatedRelationship>>>;
    email: Maybe<Scalars["String"]>;
    /** Workday Employee ID */
    employeeID: Maybe<Scalars["ID"]>;
    fullName: Maybe<Scalars["String"]>;
    isFavorite: Maybe<Scalars["Boolean"]>;
    licensedStates: Maybe<Array<Maybe<Scalars["String"]>>>;
    managerEmail: Maybe<Scalars["String"]>;
    managerFirstName: Maybe<Scalars["String"]>;
    managerId: Maybe<Scalars["String"]>;
    managerLastName: Maybe<Scalars["String"]>;
    managerLevel2Id: Maybe<Scalars["String"]>;
    name: Maybe<ZHLName>;
    nmlsID: Maybe<Scalars["Int"]>;
    officeAddressLine1: Maybe<Scalars["String"]>;
    officeAddressLine2: Maybe<Scalars["String"]>;
    officeCity: Maybe<Scalars["String"]>;
    officePhone: Maybe<Scalars["String"]>;
    officePostalCode: Maybe<Scalars["String"]>;
    officeStateCode: Maybe<Scalars["String"]>;
    profilePictureURL: Maybe<Scalars["String"]>;
    skipManagerEmail: Maybe<Scalars["String"]>;
    skipManagerFirstName: Maybe<Scalars["String"]>;
    skipManagerLastName: Maybe<Scalars["String"]>;
    title: Maybe<Scalars["String"]>;
    zgEmail: Maybe<Scalars["String"]>;
    zhlEmail: Maybe<Scalars["String"]>;
    zuid: Maybe<Scalars["ID"]>;
};
export type ZHLLoanProcessor = {
    __typename: "ZHLLoanProcessor";
    email: Maybe<Scalars["String"]>;
    name: Maybe<ZHLName>;
    officePhone: Maybe<Scalars["String"]>;
    title: Maybe<Scalars["String"]>;
    zuid: Maybe<Scalars["ID"]>;
};
export enum ZHLLoanPurpose {
    Purchase = "Purchase",
    Refinance = "Refinance"
}
export type ZHLLocation = {
    __typename: "ZHLLocation";
    city: Maybe<Scalars["String"]>;
    countyFIPS: Maybe<Scalars["String"]>;
    state: Maybe<Scalars["String"]>;
    street: Maybe<Scalars["String"]>;
    zipcode: Maybe<Scalars["String"]>;
};
export enum ZHLMaritalStatus {
    Married = "Married",
    Separated = "Separated",
    Unmarried = "Unmarried"
}
export enum ZHLMortgageType {
    Conventional = "Conventional",
    FHA = "FHA",
    HomeReadyAndHomePossible = "HomeReadyAndHomePossible",
    VA = "VA"
}
export type ZHLName = {
    __typename: "ZHLName";
    first: Maybe<Scalars["String"]>;
    last: Maybe<Scalars["String"]>;
    middle: Maybe<Scalars["String"]>;
    suffix: Maybe<Scalars["String"]>;
};
/** A non-borrowing owner on a loan. NBOs are titleholders of the financed property who are not borrowers on the mortgage. */
export type ZHLNonBorrowingOwner = {
    __typename: "ZHLNonBorrowingOwner";
    /** Attributes of the non-borrowing owner. */
    attributes: ZHLNonBorrowingOwnerAttributes;
    /** The unique identifier of the non-borrowing owner in LFS. */
    id: Scalars["ID"];
    /** The ID of the loan this non-borrowing owner is associated with. */
    loanId: Scalars["ID"];
    /**
     * Returns the email either associated with the nbo's ZUID in LFS if one has been attached
     * or the comms email in LFS if the nbo has not activated their account.
     * If neither of these can be found for any reason, this will return null.
     */
    recommendedLoginEmail: Maybe<Scalars["String"]>;
    /**
     * Whether the nbo has gone through the ZHL activation flow or if they still need to.
     * ZHL activation is required for an nbo to access App2Close.
     */
    zhlFirstPartyActivationStatus: ZhlFirstPartyActivationStatus;
    /** The ZHL user ID associated with this non-borrowing owner, if activated. */
    zhluid: Maybe<Scalars["ID"]>;
    /** The Zillow user ID associated with this non-borrowing owner, if activated. */
    zuid: Maybe<Scalars["ID"]>;
};
/** Attributes of a non-borrowing owner. */
export type ZHLNonBorrowingOwnerAttributes = {
    __typename: "ZHLNonBorrowingOwnerAttributes";
    /** Email address. */
    email: Maybe<Scalars["String"]>;
    /** First name. */
    firstName: Maybe<Scalars["String"]>;
    /** Last name. */
    lastName: Maybe<Scalars["String"]>;
    /** Middle name. */
    middleName: Maybe<Scalars["String"]>;
    /** Name suffix (e.g. Jr., III). */
    nameSuffix: Maybe<Scalars["String"]>;
};
export type ZHLParticipant = {
    __typename: "ZHLParticipant";
    id: Maybe<Scalars["ID"]>;
    participantType: Maybe<Scalars["String"]>;
};
export type ZHLPersonalizedNextStep = {
    __typename: "ZHLPersonalizedNextStep";
    status: ZHLPersonalizedNextStepStatus;
    title: Scalars["String"];
};
export enum ZHLPersonalizedNextStepExperience {
    FIRST_PARTY = "FIRST_PARTY",
    THIRD_PARTY = "THIRD_PARTY"
}
export enum ZHLPersonalizedNextStepState {
    /** @deprecated Digital pre-approval states are deprecated */
    DIGITAL_PREAPPROVAL_NEW_APPLICATION = "DIGITAL_PREAPPROVAL_NEW_APPLICATION",
    /** @deprecated Digital pre-approval states are deprecated */
    DIGITAL_PREAPPROVAL_VERIFIED_OUTSTANDING_TASKS = "DIGITAL_PREAPPROVAL_VERIFIED_OUTSTANDING_TASKS",
    /** @deprecated Digital pre-approval states are deprecated */
    DIGITAL_PREAPPROVAL_VERIFIED_PREAPPROVAL = "DIGITAL_PREAPPROVAL_VERIFIED_PREAPPROVAL",
    NEW_APPLICATION = "NEW_APPLICATION",
    OUTSTANDING_TASKS = "OUTSTANDING_TASKS",
    VERIFIED_PREAPPROVAL = "VERIFIED_PREAPPROVAL",
    VERIFIED_PREAPPROVAL_NO_TRID_OUTSTANDING_TASKS = "VERIFIED_PREAPPROVAL_NO_TRID_OUTSTANDING_TASKS",
    WAITING_TO_CLOSE = "WAITING_TO_CLOSE"
}
export enum ZHLPersonalizedNextStepStatus {
    COMPLETED = "COMPLETED",
    CURRENT = "CURRENT",
    NOT_STARTED = "NOT_STARTED"
}
export type ZHLPersonalizedNextSteps = {
    __typename: "ZHLPersonalizedNextSteps";
    currentExperience: ZHLPersonalizedNextStepExperience;
    currentState: ZHLPersonalizedNextStepState;
    /**  Used by HLT/mobile to direct to dashboard  */
    dashboardUrl: Maybe<Scalars["String"]>;
    /** The loanApplicationExperienceURL will return the correct URL for the 1st or 3rd party loan experience */
    loanApplicationExperienceURL: Maybe<Scalars["String"]>;
    loanId: Scalars["ID"];
    steps: Array<ZHLPersonalizedNextStep>;
    version: ZHLPersonalizedNextStepsVersion;
};
export enum ZHLPersonalizedNextStepsVersion {
    V1 = "V1",
    V2 = "V2"
}
export type ZHLPreApprovalDigitalExperience = {
    __typename: "ZHLPreApprovalDigitalExperience";
    ctaURL: Maybe<Scalars["String"]>;
    ctaURLWithHost: Maybe<Scalars["String"]>;
    experienceType: Maybe<ZHLPreApprovalExperienceType>;
    isEnabled: Scalars["Boolean"];
    isREOEnabled: Maybe<Scalars["Boolean"]>;
    uiAssetFlowType: Maybe<ZHLPreApprovalUIAssetFlowType>;
};
export enum ZHLPreApprovalExperienceType {
    DIGITAL_PRE_APPROVAL = "DIGITAL_PRE_APPROVAL",
    PA_TRANSFER = "PA_TRANSFER"
}
export enum ZHLPreApprovalUIAssetFlowType {
    GIFT = "GIFT",
    NONE = "NONE",
    PLAID = "PLAID",
    PLAID_GIFT = "PLAID_GIFT"
}
export type ZHLPreapprovalLetter = {
    __typename: "ZHLPreapprovalLetter";
    _id: Scalars["ID"];
    createdBy: Scalars["String"];
    createdDate: Scalars["Date"];
    documentId: Scalars["ID"];
    documentName: Maybe<Scalars["String"]>;
    documentType: Maybe<DocumentType>;
    downloadURL: Scalars["String"];
    /** document meta data, e.g. preApprovalMetaData. All meta data will be appended to this object */
    metaData: Maybe<ZHLDocumentPreApprovalMetaData>;
    viewingURL: Scalars["String"];
};
/** Property type for pre-approval. */
export enum ZHLPropertyType {
    CoOp = "CoOp",
    Commercial = "Commercial",
    Condo = "Condo",
    Condotel = "Condotel",
    /** @deprecated Use TwoToFourUnit instead */
    Duplex = "Duplex",
    /** @deprecated Use TwoToFourUnit instead */
    Fourplex = "Fourplex",
    Land = "Land",
    MobileOrManufactured = "MobileOrManufactured",
    MultiFamily = "MultiFamily",
    Single = "Single",
    Townhome = "Townhome",
    /** @deprecated Use TwoToFourUnit instead */
    Triplex = "Triplex",
    /** Replaces Duplex, Triplex, Fourplex */
    TwoToFourUnit = "TwoToFourUnit"
}
export enum ZHLPropertyUse {
    InvestmentProperty = "InvestmentProperty",
    PrimaryResidence = "PrimaryResidence",
    SecondHome = "SecondHome"
}
export type ZHLRateQuote = {
    __typename: "ZHLRateQuote";
    id: Scalars["ID"];
    scenario: Maybe<ZHLScenario>;
};
export type ZHLScenario = {
    __typename: "ZHLScenario";
    attributes: Maybe<ZHLScenarioAttributes>;
    id: Scalars["ID"];
};
export type ZHLScenarioAttributes = {
    __typename: "ZHLScenarioAttributes";
    mortgageType: Maybe<ZHLMortgageType>;
};
export type ZHLSelfServiceRecoveryToolEligibility = {
    __typename: "ZHLSelfServiceRecoveryToolEligibility";
    isEligible: Scalars["Boolean"];
};
export type ZHLSelfServiceRecoveryToolEligibilityErrorDetails = {
    __typename: "ZHLSelfServiceRecoveryToolEligibilityErrorDetails";
    errorCode: ZHLSelfServiceRecoveryToolIneligibilityError;
    errorMessage: Scalars["String"];
};
/** The payload for the zhlSelfServiceRecoveryToolCurrentUserEligibility query */
export type ZHLSelfServiceRecoveryToolEligibilityInput = {
    /** The cause of the blend access failure as reported by Blend */
    blendAccessFailureCause: BlendAccessFailureCause;
    /** The tracking ID for the user */
    trackingId: Scalars["String"];
};
/** The reason for the borrower being ineligible for the self service recovery tool */
export enum ZHLSelfServiceRecoveryToolIneligibilityError {
    /** The borrower's account has exhausted the number of allowed attempts in the current time period */
    ACCOUNT_RATE_LIMITED = "ACCOUNT_RATE_LIMITED",
    /** The attempted application to be recovered is rate limited */
    APPLICATION_RATE_LIMITED = "APPLICATION_RATE_LIMITED",
    /** The self-service recovery tool is not enabled */
    FEATURE_DISABLED = "FEATURE_DISABLED",
    /** An unexpected error occurred while processing the request */
    UNKNOWN_ERROR = "UNKNOWN_ERROR",
    /** The access failure cause is not supported by the self service recovery tool */
    UNSUPPORTED_ACCESS_FAILURE_CAUSE = "UNSUPPORTED_ACCESS_FAILURE_CAUSE"
}
export type ZHLSelfServiceRecoveryToolLoanPropertyAddress = {
    city: Scalars["String"];
    /** Two letter state abbreviation https://www.faa.gov/air_traffic/publications/atpubs/cnt_html/appendix_a.html */
    state: Scalars["String"];
    street: Scalars["String"];
    unit?: InputMaybe<Scalars["String"]>;
    zip: Scalars["String"];
};
export type ZHLTask = {
    __typename: "ZHLTask";
    documentServiceDocId: Maybe<Scalars["ID"]>;
    externalDescription: Maybe<Scalars["String"]>;
    id: Scalars["ID"];
    internalDescription: Maybe<Scalars["String"]>;
    lfsMetaData: Maybe<Array<Maybe<ZHLLFSMetaData>>>;
    source: Maybe<ZHLTaskSourceSystem>;
    /** @deprecated No current use case or returned data */
    stepMessage: Maybe<Scalars["String"]>;
    taskAssignedTo: Maybe<ZHLTaskParticipantRole>;
    taskCategory: Maybe<ZHLTaskCategory>;
    taskComments: Maybe<Array<Maybe<ZHLTaskComment>>>;
    taskCompletedDate: Maybe<Scalars["String"]>;
    taskCreatedDate: Maybe<Scalars["String"]>;
    /** @deprecated: use taskDocuments. This field will be removed in the future unless new usage is found. */
    taskDocument: Maybe<ZHLDocument>;
    taskDocuments: Maybe<Array<Maybe<ZHLDocument>>>;
    taskDueDate: Maybe<Scalars["String"]>;
    taskMergedDocumentsDownloadUrl: Maybe<Scalars["String"]>;
    taskName: Maybe<Scalars["String"]>;
    taskParticipants: Maybe<Array<Maybe<ZHLTaskParticipant>>>;
    taskReRequestedDate: Maybe<Scalars["String"]>;
    taskStatus: Maybe<ZHLTaskStatus>;
    taskTrigger: Maybe<ZHLTaskTrigger>;
    taskType: Maybe<ZHLTaskType>;
    taskUpdatedDate: Maybe<Scalars["String"]>;
    taskUpdatedDateByZHLEmployee: Maybe<Scalars["String"]>;
    title: Maybe<Scalars["String"]>;
};
export type ZHLTaskActionLog = {
    __typename: "ZHLTaskActionLog";
    id: Maybe<Scalars["ID"]>;
    note: Maybe<Scalars["String"]>;
    what: Maybe<Scalars["String"]>;
    when: Maybe<Scalars["String"]>;
    where: Maybe<Scalars["String"]>;
    who: Maybe<Scalars["String"]>;
    zuid: Maybe<Scalars["String"]>;
};
/** V2 ActionLog with enum types for type safety and better API contract enforcement. */
export type ZHLTaskActionLogV2 = {
    __typename: "ZHLTaskActionLogV2";
    id: Maybe<Scalars["ID"]>;
    note: Maybe<Scalars["String"]>;
    what: ZHLTaskActionType;
    when: Scalars["String"];
    where: ZHLTaskActionMode;
    who: Persona;
    zuid: Maybe<Scalars["String"]>;
};
export enum ZHLTaskActionMode {
    TASK_ACTION_MODE_AUTOMATED = "TASK_ACTION_MODE_AUTOMATED",
    TASK_ACTION_MODE_CLICK_ON_MOBILE = "TASK_ACTION_MODE_CLICK_ON_MOBILE",
    TASK_ACTION_MODE_CLICK_ON_WEB = "TASK_ACTION_MODE_CLICK_ON_WEB",
    TASK_ACTION_MODE_UNSPECIFIED = "TASK_ACTION_MODE_UNSPECIFIED",
    TASK_ACTION_MODE_WORK_DISCOVERY = "TASK_ACTION_MODE_WORK_DISCOVERY"
}
export enum ZHLTaskActionType {
    TASK_ACTION_TYPE_CALL = "TASK_ACTION_TYPE_CALL",
    TASK_ACTION_TYPE_DISMISS = "TASK_ACTION_TYPE_DISMISS",
    TASK_ACTION_TYPE_DISPOSITION = "TASK_ACTION_TYPE_DISPOSITION",
    TASK_ACTION_TYPE_EMAIL = "TASK_ACTION_TYPE_EMAIL",
    TASK_ACTION_TYPE_IGNORED = "TASK_ACTION_TYPE_IGNORED",
    TASK_ACTION_TYPE_NOTE_ADDED = "TASK_ACTION_TYPE_NOTE_ADDED",
    TASK_ACTION_TYPE_REASSIGNED = "TASK_ACTION_TYPE_REASSIGNED",
    TASK_ACTION_TYPE_TEXT = "TASK_ACTION_TYPE_TEXT",
    TASK_ACTION_TYPE_UNSPECIFIED = "TASK_ACTION_TYPE_UNSPECIFIED"
}
export enum ZHLTaskCategory {
    TASK_CATEGORY_ASSETS = "TASK_CATEGORY_ASSETS",
    TASK_CATEGORY_CREDIT = "TASK_CATEGORY_CREDIT",
    TASK_CATEGORY_INCOME = "TASK_CATEGORY_INCOME",
    TASK_CATEGORY_MISC = "TASK_CATEGORY_MISC",
    TASK_CATEGORY_PROPERTY = "TASK_CATEGORY_PROPERTY",
    TASK_CATEGORY_UNSPECIFIED = "TASK_CATEGORY_UNSPECIFIED"
}
export enum ZHLTaskClassification {
    CadenceTask = "CadenceTask",
    ClassificationUnspecified = "ClassificationUnspecified",
    DataNotificationTask = "DataNotificationTask",
    EngagementTask = "EngagementTask",
    FormTask = "FormTask",
    GenericTask = "GenericTask",
    ProductionTask = "ProductionTask"
}
export type ZHLTaskComment = {
    __typename: "ZHLTaskComment";
    audienceRole: Maybe<ZHLTaskParticipantRole>;
    content: Maybe<Scalars["String"]>;
    createdBy: Maybe<Scalars["String"]>;
    createdDate: Maybe<Scalars["String"]>;
    id: Maybe<Scalars["ID"]>;
};
export type ZHLTaskCommentV2 = {
    __typename: "ZHLTaskCommentV2";
    audienceRole: Maybe<Persona>;
    content: Maybe<Scalars["String"]>;
    createdBy: Maybe<Scalars["String"]>;
    createdDate: Maybe<Scalars["String"]>;
    id: Maybe<Scalars["String"]>;
};
export type ZHLTaskContent = {
    __typename: "ZHLTaskContent";
    comments: Maybe<Array<Maybe<ZHLTaskCommentV2>>>;
    executionARNs: Maybe<Array<Maybe<ZHLTaskExecutionARNs>>>;
    formState: Maybe<Scalars["JSON"]>;
    idMetaData: Maybe<Array<Maybe<ZHLTaskIdMetaData>>>;
    taskAssignedTo: Maybe<TaskParticipantRole>;
};
export type ZHLTaskDates = {
    __typename: "ZHLTaskDates";
    completed: Maybe<Scalars["String"]>;
    created: Maybe<Scalars["String"]>;
    due: Maybe<Scalars["String"]>;
    expiration: Maybe<Scalars["String"]>;
    updated: Maybe<Scalars["String"]>;
};
export type ZHLTaskExecutionARNs = {
    __typename: "ZHLTaskExecutionARNs";
    activityToken: Maybe<Scalars["String"]>;
    type: Maybe<ExecutionType>;
    value: Maybe<Scalars["String"]>;
};
export type ZHLTaskIdMetaData = {
    __typename: "ZHLTaskIdMetaData";
    type: Maybe<ZHLTaskIdType>;
    value: Maybe<Scalars["String"]>;
};
export enum ZHLTaskIdType {
    DocumentService = "DocumentService",
    Encompass = "Encompass",
    IdTypeUnspecified = "IdTypeUnspecified"
}
/** An extended ZHLTaskMetaDataV2 with contributed conversation summary */
export type ZHLTaskMetaDataV2 = {
    __typename: "ZHLTaskMetaDataV2";
    callerPhoneNumber: Maybe<Scalars["String"]>;
    /** The summary object associated to that conversation */
    conversationSummary: Maybe<ZHLConversationSummary>;
    formFields: Maybe<Scalars["JSON"]>;
    formGroup: Maybe<Scalars["JSON"]>;
    genesysConversationId: Maybe<Scalars["String"]>;
    loanOfficerPhoneNumber: Maybe<Scalars["String"]>;
    salesforceLeadId: Maybe<Scalars["String"]>;
    supportLORouted: Maybe<Scalars["Boolean"]>;
};
export type ZHLTaskParticipant = {
    __typename: "ZHLTaskParticipant";
    borrower: Maybe<ZHLBorrower>;
    /** Borrower's UUID in Loan File Service */
    borrowerId: Maybe<Scalars["ID"]>;
    participantRole: Maybe<ZHLTaskParticipantRole>;
    /** @deprecated: use participantRole */
    role: Maybe<TaskParticipantRole>;
    zuid: Maybe<Scalars["ID"]>;
};
export enum ZHLTaskParticipantRole {
    TASK_PARTICIPANT_ROLE_CONDITIONS_BORROWER = "TASK_PARTICIPANT_ROLE_CONDITIONS_BORROWER",
    TASK_PARTICIPANT_ROLE_CO_BORROWER = "TASK_PARTICIPANT_ROLE_CO_BORROWER",
    TASK_PARTICIPANT_ROLE_LOAN_OFFICER = "TASK_PARTICIPANT_ROLE_LOAN_OFFICER",
    TASK_PARTICIPANT_ROLE_LOAN_OFFICER_MANAGER = "TASK_PARTICIPANT_ROLE_LOAN_OFFICER_MANAGER",
    TASK_PARTICIPANT_ROLE_NON_BORROWING_OWNER = "TASK_PARTICIPANT_ROLE_NON_BORROWING_OWNER",
    TASK_PARTICIPANT_ROLE_PERSONA_UNSPECIFIED = "TASK_PARTICIPANT_ROLE_PERSONA_UNSPECIFIED",
    TASK_PARTICIPANT_ROLE_PRIMARY_BORROWER = "TASK_PARTICIPANT_ROLE_PRIMARY_BORROWER",
    TASK_PARTICIPANT_ROLE_PROCESSOR = "TASK_PARTICIPANT_ROLE_PROCESSOR",
    TASK_PARTICIPANT_ROLE_PROCESSOR_MANAGER = "TASK_PARTICIPANT_ROLE_PROCESSOR_MANAGER",
    TASK_PARTICIPANT_ROLE_TASKS_ENGINE = "TASK_PARTICIPANT_ROLE_TASKS_ENGINE",
    TASK_PARTICIPANT_ROLE_UNDERWRITER = "TASK_PARTICIPANT_ROLE_UNDERWRITER",
    TASK_PARTICIPANT_ROLE_UNDERWRITER_MANAGER = "TASK_PARTICIPANT_ROLE_UNDERWRITER_MANAGER",
    TASK_PARTICIPANT_ROLE_UNSPECIFIED = "TASK_PARTICIPANT_ROLE_UNSPECIFIED",
    TASK_PARTICIPANT_ROLE_ZHL_EMPLOYEE = "TASK_PARTICIPANT_ROLE_ZHL_EMPLOYEE"
}
export type ZHLTaskParticipantV2 = {
    __typename: "ZHLTaskParticipantV2";
    borrower: Maybe<ZHLBorrower>;
    participantRole: Maybe<ZHLTaskParticipantRole>;
    /** @deprecated: use participantRole */
    role: Maybe<TaskParticipantRole>;
    /** Borrower's UUID in Loan File Service */
    uuid: Maybe<Scalars["ID"]>;
    /** Borrower's ZHLUID */
    zhluid: Maybe<Scalars["ID"]>;
    zuid: Maybe<Scalars["ID"]>;
};
export enum ZHLTaskSourceSystem {
    CONDITIONS = "CONDITIONS",
    TASK_SERVICE = "TASK_SERVICE"
}
export enum ZHLTaskStatus {
    TASK_STATUS_BLOCKED = "TASK_STATUS_BLOCKED",
    TASK_STATUS_COMPLETED = "TASK_STATUS_COMPLETED",
    TASK_STATUS_DELETED = "TASK_STATUS_DELETED",
    TASK_STATUS_FAILED_TO_TRIGGER = "TASK_STATUS_FAILED_TO_TRIGGER",
    TASK_STATUS_IN_PROGRESS = "TASK_STATUS_IN_PROGRESS",
    TASK_STATUS_IN_REVIEW = "TASK_STATUS_IN_REVIEW",
    TASK_STATUS_PRE_TRIGGERED = "TASK_STATUS_PRE_TRIGGERED",
    TASK_STATUS_REJECTED = "TASK_STATUS_REJECTED",
    TASK_STATUS_TRIGGERED = "TASK_STATUS_TRIGGERED",
    TASK_STATUS_UNSPECIFIED = "TASK_STATUS_UNSPECIFIED"
}
export enum ZHLTaskTrigger {
    TASK_TRIGGER_API = "TASK_TRIGGER_API",
    TASK_TRIGGER_AUTOMATED = "TASK_TRIGGER_AUTOMATED",
    TASK_TRIGGER_BLEND_AUTOMATED = "TASK_TRIGGER_BLEND_AUTOMATED",
    TASK_TRIGGER_CONDITION_SET = "TASK_TRIGGER_CONDITION_SET",
    TASK_TRIGGER_GENESYS_MISSED_INBOUND_COMMS = "TASK_TRIGGER_GENESYS_MISSED_INBOUND_COMMS",
    TASK_TRIGGER_LOP = "TASK_TRIGGER_LOP",
    TASK_TRIGGER_LOP_AUTOMATED = "TASK_TRIGGER_LOP_AUTOMATED",
    TASK_TRIGGER_LOP_MANUAL = "TASK_TRIGGER_LOP_MANUAL",
    TASK_TRIGGER_LOP_PREAPPROVAL_AUTOMATED = "TASK_TRIGGER_LOP_PREAPPROVAL_AUTOMATED",
    TASK_TRIGGER_LOP_PREAPPROVAL_MANUAL = "TASK_TRIGGER_LOP_PREAPPROVAL_MANUAL",
    TASK_TRIGGER_MANUAL = "TASK_TRIGGER_MANUAL",
    /** @deprecated No current use case for this trigger, use one of the other PreApproval triggers instead. */
    TASK_TRIGGER_PREAPPROVAL = "TASK_TRIGGER_PREAPPROVAL",
    TASK_TRIGGER_PREAPPROVAL_AUTOMATED = "TASK_TRIGGER_PREAPPROVAL_AUTOMATED",
    TASK_TRIGGER_UNSPECIFIED = "TASK_TRIGGER_UNSPECIFIED"
}
export enum ZHLTaskType {
    TASK_TYPE_DOCUMENT_ESIGN = "TASK_TYPE_DOCUMENT_ESIGN",
    TASK_TYPE_DOCUMENT_REVIEW = "TASK_TYPE_DOCUMENT_REVIEW",
    TASK_TYPE_DOCUMENT_UPLOAD = "TASK_TYPE_DOCUMENT_UPLOAD",
    TASK_TYPE_UNSPECIFIED = "TASK_TYPE_UNSPECIFIED"
}
export type ZHLTaskV2 = {
    __typename: "ZHLTaskV2";
    /** @deprecated Use actionLogsV2 for type-safe enum values */
    actionLogs: Maybe<Array<Maybe<ZHLTaskActionLog>>>;
    actionLogsV2: Maybe<Array<Maybe<ZHLTaskActionLogV2>>>;
    classification: Maybe<ZHLTaskClassification>;
    dates: Maybe<ZHLTaskDates>;
    entityType: Maybe<ZHLEntityType>;
    entityValue: Maybe<Scalars["String"]>;
    externalDescription: Maybe<Scalars["String"]>;
    id: Scalars["ID"];
    internalDescription: Maybe<Scalars["String"]>;
    loanOfficerZuid: Maybe<Scalars["String"]>;
    taskAttributes: Maybe<Scalars["JSON"]>;
    taskCategory: Maybe<Scalars["String"]>;
    /** @deprecated Use dates.completed instead */
    taskCompletedDate: Maybe<Scalars["String"]>;
    taskContent: Maybe<ZHLTaskContent>;
    /** @deprecated Use dates.created instead */
    taskCreatedDate: Maybe<Scalars["String"]>;
    taskDocuments: Maybe<Array<Maybe<ZHLDocument>>>;
    /** @deprecated Use dates.due instead */
    taskDueDate: Maybe<Scalars["String"]>;
    taskMergedDocumentsDownloadUrl: Maybe<Scalars["String"]>;
    taskMetaData: Maybe<ZHLTaskMetaDataV2>;
    taskName: Maybe<Scalars["String"]>;
    taskParticipants: Maybe<Array<Maybe<ZHLTaskParticipantV2>>>;
    taskPriority: Maybe<Scalars["Int"]>;
    taskReRequestedDate: Maybe<Scalars["String"]>;
    taskStatus: Maybe<ZHLTaskStatus>;
    taskSubcategory: Maybe<Scalars["String"]>;
    taskTitle: Maybe<Scalars["String"]>;
    taskTrigger: Maybe<ZHLTaskTrigger>;
    /** @deprecated Use dates.updated instead */
    taskUpdatedDate: Maybe<Scalars["String"]>;
};
export type ZHLUserAttributes = {
    __typename: "ZHLUserAttributes";
    birthDate: Maybe<Scalars["String"]>;
    cellPhone: Maybe<Scalars["String"]>;
    email: Maybe<Scalars["String"]>;
    maritalStatus: Maybe<ZHLMaritalStatus>;
    names: Maybe<Array<ZHLName>>;
    taxpayerID: Maybe<Scalars["String"]>;
};
/** Method of document distribution */
export enum ZhlDisclosureDistributionMethod {
    ECLOSE = "ECLOSE",
    EDISCLOSE = "EDISCLOSE",
    ESIGN = "ESIGN",
    PAPER = "PAPER",
    UNKNOWN = "UNKNOWN"
}
/**
 * A disclosure document package sent to borrowers for signing/review.
 * Tracks the full lifecycle from distribution through completion.
 */
export type ZhlDisclosureDocument = {
    __typename: "ZhlDisclosureDocument";
    createdAt: Scalars["String"];
    /** Distribution method (eSign, eDisclose, eClose) */
    distributionMethod: ZhlDisclosureDistributionMethod;
    /** Composite ID in format loanId:orderId */
    documentId: Scalars["ID"];
    /** Package type (e.g., Initial Disclosure, Closing) */
    documentPackageType: ZhlDisclosurePackageType;
    /** Individual documents within this package */
    documents: Array<ZhlDisclosureDocumentItem>;
    expiresAt: Maybe<Scalars["String"]>;
    loanId: Scalars["ID"];
    metadata: ZhlDisclosureMetadata;
    /** Docutech order ID (unique identifier for this distribution) */
    orderId: Scalars["ID"];
    /** Parties involved in this disclosure (borrowers, co-borrowers) */
    parties: Array<ZhlDisclosureParty>;
    signedAt: Maybe<Scalars["String"]>;
    /** Public status (mapped from internal 9-status model) */
    status: ZhlDisclosureStatus;
    updatedAt: Scalars["String"];
};
/** An individual document within a disclosure package */
export type ZhlDisclosureDocumentItem = {
    __typename: "ZhlDisclosureDocumentItem";
    /** ConformX document ID */
    cxId: Scalars["ID"];
    /** Document name */
    cxName: Scalars["String"];
    /** Document service ID (when registered) */
    docServiceId: Maybe<Scalars["ID"]>;
    /** Document type code */
    documentType: Maybe<Scalars["String"]>;
    /** Generated filename for storage */
    fileName: Scalars["String"];
    /** Whether this document requires signature */
    isSignable: ZhlDisclosureSignableType;
    /** Processing status */
    lifecycleStatus: Scalars["String"];
    /** zDocs document ID (when uploaded) */
    zDocsId: Maybe<Scalars["ID"]>;
};
/** Metadata about the disclosure package */
export type ZhlDisclosureMetadata = {
    __typename: "ZhlDisclosureMetadata";
    /** When this distribution expires */
    estimatedDistributionExpireDate: Maybe<Scalars["String"]>;
    /** Loan officer ID */
    loanOfficerId: Maybe<Scalars["ID"]>;
    /** Docutech order ID */
    orderId: Scalars["String"];
    /** Package display name */
    packageName: Maybe<Scalars["String"]>;
    /** Solex distribution ID */
    solexDistributionId: Maybe<Scalars["String"]>;
};
/** Type of disclosure package */
export enum ZhlDisclosurePackageType {
    ADVERSE_ACTION = "ADVERSE_ACTION",
    APPRAISAL = "APPRAISAL",
    CLOSING = "CLOSING",
    COMMITMENT = "COMMITMENT",
    HYBRID_CLOSING = "HYBRID_CLOSING",
    INITIAL_DISCLOSURE = "INITIAL_DISCLOSURE",
    PRE_CLOSING = "PRE_CLOSING",
    PROCESSING = "PROCESSING",
    REDISCLOSURE = "REDISCLOSURE",
    RON_CLOSING = "RON_CLOSING",
    UNKNOWN = "UNKNOWN"
}
/** A party involved in the disclosure (borrower, co-borrower, etc.) */
export type ZhlDisclosureParty = {
    __typename: "ZhlDisclosureParty";
    /** Linked borrower ID in loan system */
    borrowerId: Maybe<Scalars["ID"]>;
    /** When this party consented to electronic delivery */
    consentedAt: Maybe<Scalars["String"]>;
    /** Display name */
    name: Scalars["String"];
    partyId: Scalars["ID"];
    /** Party type (e.g., Borrower, CoBorrower) */
    partyType: Scalars["String"];
    /** When this party completed document review */
    reviewedAt: Maybe<Scalars["String"]>;
    /** When this party signed */
    signedAt: Maybe<Scalars["String"]>;
};
/** Whether a document requires signature */
export enum ZhlDisclosureSignableType {
    ESIGN = "ESIGN",
    INK_SIGN = "INK_SIGN",
    NO = "NO"
}
/**
 * Public disclosure status (simplified from internal 9-status model).
 * Internal statuses map as follows:
 * - PENDING, CONSENT_PENDING, CONSENTED, REVIEWED -> PENDING
 * - SIGNED, SUBMITTED, COMPLETED -> SIGNED
 * - EXPIRED -> EXPIRED
 * - CANCELLED -> CANCELLED
 */
export enum ZhlDisclosureStatus {
    CANCELLED = "CANCELLED",
    EXPIRED = "EXPIRED",
    PENDING = "PENDING",
    SIGNED = "SIGNED"
}
/** Input for the query that gets the email associated with a 1P activation token, if it exists. */
export type ZhlFirstPartyActivationEmailLoginHintInput = {
    /** Beth's activation token */
    activationToken: Scalars["String"];
};
/** Response for the query that gets the email associated with a 1P activation token, if it exists. */
export type ZhlFirstPartyActivationEmailLoginHintResponse = {
    __typename: "ZhlFirstPartyActivationEmailLoginHintResponse";
    /** Email associated with activation token */
    email: Maybe<Scalars["String"]>;
};
export enum ZhlFirstPartyActivationStatus {
    ACTIVATED = "ACTIVATED",
    NOT_ACTIVATED = "NOT_ACTIVATED"
}
export type ClickstreamEventFragmentFragment = {
    __typename: "ZHLExperienceAnalyticClickstreamEvent";
    id: string;
    analyticsTag: string;
    productSpecificBlockData: any | null;
    productSpecificBlock: string | null;
    stringifiedProductSpecificBlockData: string | null;
    clickstreamEnvelope: {
        __typename: "ZHLExperienceAnalyticEventClickstreamEnvelope";
        eventTemplateID: string | null;
        eventTemplateVersionID: string | null;
        eventTypeID: string | null;
        eventTypeVersionID: string | null;
    };
    clickstreamTriggerBlock: {
        __typename: "ZHLExperienceAnalyticEventClickstreamTriggerBlock";
        triggerTypeName: ZHLExperienceAnalyticEventClickstreamTriggerType;
        triggerLocationName: string | null;
        triggerSourceName: string | null;
        triggerObjectName: string | null;
    };
    semanticBlock: {
        __typename: "ZHLExperienceAnalyticEventSemanticBlock";
        semanticEventName: string;
        topicTagText: Array<string> | null;
    };
};
export type NeutronConstellation8AvatarFragment = {
    __typename: "ZHLExperienceWebAvatar";
    id: string;
    configuration: {
        __typename: "ZHLExperienceWebAvatarConstellation8Configuration";
        alt: string | null;
        badgedSize: ZHLExperienceWebConstellation8BadgedAvatarSize | null;
        color: ZHLExperienceWebConstellation8AvatarColor;
        constellationVersion: ZHLExperienceConstellationVersion;
        fullName: string | null;
        maxAvatarImageHeight: string | null;
        platform: ZHLExperiencePlatformType;
        size: ZHLExperienceWebConstellation8AvatarSize | null;
        src: string | null;
        useDefaultAvatar: boolean | null;
        avatarIcon: {
            __typename: "ZHLExperienceWebIcon";
            id: string;
            configuration: {
                __typename: "ZHLExperienceWebIconConstellation8Configuration";
                constellationVersion: ZHLExperienceConstellationVersion;
                fontColor: ZHLExperienceWebConstellation8Color | null;
                icon: ZHLExperienceWebConstellation8Icon;
                platform: ZHLExperiencePlatformType;
                size: ZHLExperienceWebConstellation8IconSize;
                title: string | null;
            } | {
                __typename: "ZHLExperienceWebIconConstellation10AlphaConfiguration";
            };
        } | null;
        badgeIcon: {
            __typename: "ZHLExperienceWebIcon";
            id: string;
            configuration: {
                __typename: "ZHLExperienceWebIconConstellation8Configuration";
                constellationVersion: ZHLExperienceConstellationVersion;
                fontColor: ZHLExperienceWebConstellation8Color | null;
                icon: ZHLExperienceWebConstellation8Icon;
                platform: ZHLExperiencePlatformType;
                size: ZHLExperienceWebConstellation8IconSize;
                title: string | null;
            } | {
                __typename: "ZHLExperienceWebIconConstellation10AlphaConfiguration";
            };
        } | null;
    } | {
        __typename: "ZHLExperienceWebAvatarConstellation10AlphaConfiguration";
    };
};
export type NeutronConstellation10AvatarFragment = {
    __typename: "ZHLExperienceWebAvatar";
    id: string;
    configuration: {
        __typename: "ZHLExperienceWebAvatarConstellation8Configuration";
    } | {
        __typename: "ZHLExperienceWebAvatarConstellation10AlphaConfiguration";
        platform: ZHLExperiencePlatformType;
        constellationVersion: ZHLExperienceConstellationVersion;
        size: ZHLExperienceWebConstellation10AvatarSize | null;
        maxAvatarImageHeight: string | null;
        fullName: string | null;
        src: string | null;
        alt: string | null;
        tone: ZHLExperienceWebConstellation10AvatarTone | null;
        badgedSize: ZHLExperienceWebConstellation10BadgedAvatarSize | null;
        useDefaultAvatar: boolean | null;
        avatarIcon: {
            __typename: "ZHLExperienceWebIcon";
            id: string;
            configuration: {
                __typename: "ZHLExperienceWebIconConstellation8Configuration";
            } | {
                __typename: "ZHLExperienceWebIconConstellation10AlphaConfiguration";
                platform: ZHLExperiencePlatformType;
                constellationVersion: ZHLExperienceConstellationVersion;
                color: ZHLExperienceWebConstellation10IconColor | null;
                size: ZHLExperienceWebConstellation10IconSize;
                title: string | null;
                icon: ZHLExperienceWebConstellation10Icon;
            };
        } | null;
        badgeIcon: {
            __typename: "ZHLExperienceWebIcon";
            id: string;
            configuration: {
                __typename: "ZHLExperienceWebIconConstellation8Configuration";
            } | {
                __typename: "ZHLExperienceWebIconConstellation10AlphaConfiguration";
                platform: ZHLExperiencePlatformType;
                constellationVersion: ZHLExperienceConstellationVersion;
                color: ZHLExperienceWebConstellation10IconColor | null;
                size: ZHLExperienceWebConstellation10IconSize;
                title: string | null;
                icon: ZHLExperienceWebConstellation10Icon;
            };
        } | null;
    };
};
export type NeutronConstellation8ButtonFragment = {
    __typename: "ZHLExperienceWebButton";
    content: string;
    id: string;
    configuration: {
        __typename: "ZHLExperienceWebButtonConstellation8Configuration";
        buttonType: ZHLExperienceWebConstellation8ButtonType;
        constellationVersion: ZHLExperienceConstellationVersion;
        desktopContent: string | null;
        fluid: boolean;
        iconPosition: ZHLExperienceWebConstellation8ButtonIconPosition | null;
        inverse: boolean;
        platform: ZHLExperiencePlatformType;
        presentAsTextButtonOnDesktop: boolean;
        size: ZHLExperienceWebConstellation8ButtonSize;
    } | {
        __typename: "ZHLExperienceWebButtonConstellation10AlphaConfiguration";
    };
};
export type NeutronConstellation10ButtonFragment = {
    __typename: "ZHLExperienceWebButton";
    content: string;
    id: string;
    configuration: {
        __typename: "ZHLExperienceWebButtonConstellation8Configuration";
    } | {
        __typename: "ZHLExperienceWebButtonConstellation10AlphaConfiguration";
        platform: ZHLExperiencePlatformType;
        constellationVersion: ZHLExperienceConstellationVersion;
        tone: ZHLExperienceWebConstellation10ButtonTone;
        emphasis: ZHLExperienceWebConstellation10ButtonEmphasis;
        fluid: boolean;
        onImpact: boolean;
        size: ZHLExperienceWebConstellation10ButtonSize;
        iconPosition: ZHLExperienceWebConstellation10ButtonIconPosition | null;
        presentAsTextButtonOnDesktop: boolean;
        desktopContent: string | null;
    };
};
export type NeutronConstellation8ContactCardFragment = {
    __typename: "ZHLExperienceWebContactInformationSection";
    constellationVersion: ZHLExperienceConstellationVersion;
    id: string;
    platform: ZHLExperiencePlatformType;
    avatar: {
        __typename: "ZHLExperienceWebAvatar";
        id: string;
        configuration: {
            __typename: "ZHLExperienceWebAvatarConstellation8Configuration";
            alt: string | null;
            badgedSize: ZHLExperienceWebConstellation8BadgedAvatarSize | null;
            color: ZHLExperienceWebConstellation8AvatarColor;
            constellationVersion: ZHLExperienceConstellationVersion;
            fullName: string | null;
            maxAvatarImageHeight: string | null;
            platform: ZHLExperiencePlatformType;
            size: ZHLExperienceWebConstellation8AvatarSize | null;
            src: string | null;
            useDefaultAvatar: boolean | null;
            avatarIcon: {
                __typename: "ZHLExperienceWebIcon";
                id: string;
                configuration: {
                    __typename: "ZHLExperienceWebIconConstellation8Configuration";
                    constellationVersion: ZHLExperienceConstellationVersion;
                    fontColor: ZHLExperienceWebConstellation8Color | null;
                    icon: ZHLExperienceWebConstellation8Icon;
                    platform: ZHLExperiencePlatformType;
                    size: ZHLExperienceWebConstellation8IconSize;
                    title: string | null;
                } | {
                    __typename: "ZHLExperienceWebIconConstellation10AlphaConfiguration";
                };
            } | null;
            badgeIcon: {
                __typename: "ZHLExperienceWebIcon";
                id: string;
                configuration: {
                    __typename: "ZHLExperienceWebIconConstellation8Configuration";
                    constellationVersion: ZHLExperienceConstellationVersion;
                    fontColor: ZHLExperienceWebConstellation8Color | null;
                    icon: ZHLExperienceWebConstellation8Icon;
                    platform: ZHLExperiencePlatformType;
                    size: ZHLExperienceWebConstellation8IconSize;
                    title: string | null;
                } | {
                    __typename: "ZHLExperienceWebIconConstellation10AlphaConfiguration";
                };
            } | null;
        } | {
            __typename: "ZHLExperienceWebAvatarConstellation10AlphaConfiguration";
        };
    } | null;
    contactMethods: Array<{
        __typename: "ZHLExperienceWebButton";
        content: string;
        id: string;
        configuration: {
            __typename: "ZHLExperienceWebButtonConstellation8Configuration";
            buttonType: ZHLExperienceWebConstellation8ButtonType;
            constellationVersion: ZHLExperienceConstellationVersion;
            desktopContent: string | null;
            fluid: boolean;
            iconPosition: ZHLExperienceWebConstellation8ButtonIconPosition | null;
            inverse: boolean;
            platform: ZHLExperiencePlatformType;
            presentAsTextButtonOnDesktop: boolean;
            size: ZHLExperienceWebConstellation8ButtonSize;
        } | {
            __typename: "ZHLExperienceWebButtonConstellation10AlphaConfiguration";
        };
    }> | null;
    content: Array<{
        __typename: "ZHLExperienceWebText";
        content: string;
        id: string;
        configuration: {
            __typename: "ZHLExperienceWebTextConstellation8Configuration";
            asParagraph: boolean;
            constellationVersion: ZHLExperienceConstellationVersion;
            fontColor: ZHLExperienceWebConstellation8Color;
            fontType: ZHLExperienceWebConstellation8FontType;
            platform: ZHLExperiencePlatformType;
            textAlign: ZHLExperienceWebConstellation8TextAlignment;
        } | {
            __typename: "ZHLExperienceWebTextConstellation10AlphaConfiguration";
        };
    }> | null;
    headlineHeading: {
        __typename: "ZHLExperienceWebHeading";
        content: string;
        id: string;
        configuration: {
            __typename: "ZHLExperienceWebHeadingConstellation8Configuration";
            constellationVersion: ZHLExperienceConstellationVersion;
            fontColor: ZHLExperienceWebConstellation8Color;
            fontFamily: ZHLExperienceWebConstellation8FontFamily;
            fontType: ZHLExperienceWebConstellation8FontType;
            level: number;
            platform: ZHLExperiencePlatformType;
            textAlign: ZHLExperienceWebConstellation8TextAlignment;
        } | {
            __typename: "ZHLExperienceWebHeadingConstellation10AlphaConfiguration";
        };
    } | null;
    headlineText: {
        __typename: "ZHLExperienceWebText";
        content: string;
        id: string;
        configuration: {
            __typename: "ZHLExperienceWebTextConstellation8Configuration";
            asParagraph: boolean;
            constellationVersion: ZHLExperienceConstellationVersion;
            fontColor: ZHLExperienceWebConstellation8Color;
            fontType: ZHLExperienceWebConstellation8FontType;
            platform: ZHLExperiencePlatformType;
            textAlign: ZHLExperienceWebConstellation8TextAlignment;
        } | {
            __typename: "ZHLExperienceWebTextConstellation10AlphaConfiguration";
        };
    } | null;
    imageAsAvatar: {
        __typename: "ZHLExperienceWebImage";
        altText: string;
        constellationVersion: ZHLExperienceConstellationVersion;
        height: string;
        id: string;
        isFullWidth: boolean;
        src: string;
        width: string | null;
    } | null;
};
export type NeutronConstellation10ContactCardFragment = {
    __typename: "ZHLExperienceWebContactInformationSection";
    constellationVersion: ZHLExperienceConstellationVersion;
    id: string;
    platform: ZHLExperiencePlatformType;
    avatar: {
        __typename: "ZHLExperienceWebAvatar";
        id: string;
        configuration: {
            __typename: "ZHLExperienceWebAvatarConstellation8Configuration";
        } | {
            __typename: "ZHLExperienceWebAvatarConstellation10AlphaConfiguration";
            platform: ZHLExperiencePlatformType;
            constellationVersion: ZHLExperienceConstellationVersion;
            size: ZHLExperienceWebConstellation10AvatarSize | null;
            maxAvatarImageHeight: string | null;
            fullName: string | null;
            src: string | null;
            alt: string | null;
            tone: ZHLExperienceWebConstellation10AvatarTone | null;
            badgedSize: ZHLExperienceWebConstellation10BadgedAvatarSize | null;
            useDefaultAvatar: boolean | null;
            avatarIcon: {
                __typename: "ZHLExperienceWebIcon";
                id: string;
                configuration: {
                    __typename: "ZHLExperienceWebIconConstellation8Configuration";
                } | {
                    __typename: "ZHLExperienceWebIconConstellation10AlphaConfiguration";
                    platform: ZHLExperiencePlatformType;
                    constellationVersion: ZHLExperienceConstellationVersion;
                    color: ZHLExperienceWebConstellation10IconColor | null;
                    size: ZHLExperienceWebConstellation10IconSize;
                    title: string | null;
                    icon: ZHLExperienceWebConstellation10Icon;
                };
            } | null;
            badgeIcon: {
                __typename: "ZHLExperienceWebIcon";
                id: string;
                configuration: {
                    __typename: "ZHLExperienceWebIconConstellation8Configuration";
                } | {
                    __typename: "ZHLExperienceWebIconConstellation10AlphaConfiguration";
                    platform: ZHLExperiencePlatformType;
                    constellationVersion: ZHLExperienceConstellationVersion;
                    color: ZHLExperienceWebConstellation10IconColor | null;
                    size: ZHLExperienceWebConstellation10IconSize;
                    title: string | null;
                    icon: ZHLExperienceWebConstellation10Icon;
                };
            } | null;
        };
    } | null;
    contactMethods: Array<{
        __typename: "ZHLExperienceWebButton";
        content: string;
        id: string;
        configuration: {
            __typename: "ZHLExperienceWebButtonConstellation8Configuration";
        } | {
            __typename: "ZHLExperienceWebButtonConstellation10AlphaConfiguration";
            platform: ZHLExperiencePlatformType;
            constellationVersion: ZHLExperienceConstellationVersion;
            tone: ZHLExperienceWebConstellation10ButtonTone;
            emphasis: ZHLExperienceWebConstellation10ButtonEmphasis;
            fluid: boolean;
            onImpact: boolean;
            size: ZHLExperienceWebConstellation10ButtonSize;
            iconPosition: ZHLExperienceWebConstellation10ButtonIconPosition | null;
            presentAsTextButtonOnDesktop: boolean;
            desktopContent: string | null;
        };
    }> | null;
    content: Array<{
        __typename: "ZHLExperienceWebText";
        content: string;
        id: string;
        configuration: {
            __typename: "ZHLExperienceWebTextConstellation8Configuration";
        } | {
            __typename: "ZHLExperienceWebTextConstellation10AlphaConfiguration";
            platform: ZHLExperiencePlatformType;
            constellationVersion: ZHLExperienceConstellationVersion;
            asParagraph: boolean;
            color: ZHLExperienceWebConstellation10FontColor;
            textStyle: ZHLExperienceWebConstellation10TextStyle;
        };
    }> | null;
    headlineHeading: {
        __typename: "ZHLExperienceWebHeading";
        content: string;
        id: string;
        configuration: {
            __typename: "ZHLExperienceWebHeadingConstellation8Configuration";
        } | {
            __typename: "ZHLExperienceWebHeadingConstellation10AlphaConfiguration";
            platform: ZHLExperiencePlatformType;
            constellationVersion: ZHLExperienceConstellationVersion;
            level: number;
            textStyle: ZHLExperienceWebConstellation10HeadingTextStyle;
            fontFamily: ZHLExperienceWebConstellation10FontFamily;
            color: ZHLExperienceWebConstellation10FontColor;
        };
    } | null;
    headlineText: {
        __typename: "ZHLExperienceWebText";
        content: string;
        id: string;
        configuration: {
            __typename: "ZHLExperienceWebTextConstellation8Configuration";
        } | {
            __typename: "ZHLExperienceWebTextConstellation10AlphaConfiguration";
            platform: ZHLExperiencePlatformType;
            constellationVersion: ZHLExperienceConstellationVersion;
            asParagraph: boolean;
            color: ZHLExperienceWebConstellation10FontColor;
            textStyle: ZHLExperienceWebConstellation10TextStyle;
        };
    } | null;
    imageAsAvatar: {
        __typename: "ZHLExperienceWebImage";
        altText: string;
        constellationVersion: ZHLExperienceConstellationVersion;
        height: string;
        id: string;
        isFullWidth: boolean;
        src: string;
        width: string | null;
    } | null;
};
export type NeutronDestructiveOperationActionFragment = {
    __typename: "ZHLExperienceDestructiveOperationAction";
    id: string;
    operationToPerform: ZHLExperienceSupportedDestructiveOperation;
};
export type NeutronGetInTouchActionFragment = {
    __typename: "ZHLExperienceGetInTouchAction";
    contactResource: string;
    contactType: ZHLExperienceGetInTouchActionContactType;
    id: string;
};
export type NeutronConstellation8HeadingFragment = {
    __typename: "ZHLExperienceWebHeading";
    content: string;
    id: string;
    configuration: {
        __typename: "ZHLExperienceWebHeadingConstellation8Configuration";
        constellationVersion: ZHLExperienceConstellationVersion;
        fontColor: ZHLExperienceWebConstellation8Color;
        fontFamily: ZHLExperienceWebConstellation8FontFamily;
        fontType: ZHLExperienceWebConstellation8FontType;
        level: number;
        platform: ZHLExperiencePlatformType;
        textAlign: ZHLExperienceWebConstellation8TextAlignment;
    } | {
        __typename: "ZHLExperienceWebHeadingConstellation10AlphaConfiguration";
    };
};
export type NeutronConstellation10HeadingFragment = {
    __typename: "ZHLExperienceWebHeading";
    content: string;
    id: string;
    configuration: {
        __typename: "ZHLExperienceWebHeadingConstellation8Configuration";
    } | {
        __typename: "ZHLExperienceWebHeadingConstellation10AlphaConfiguration";
        platform: ZHLExperiencePlatformType;
        constellationVersion: ZHLExperienceConstellationVersion;
        level: number;
        textStyle: ZHLExperienceWebConstellation10HeadingTextStyle;
        fontFamily: ZHLExperienceWebConstellation10FontFamily;
        color: ZHLExperienceWebConstellation10FontColor;
    };
};
export type NeutronConstellation8IconFragment = {
    __typename: "ZHLExperienceWebIcon";
    id: string;
    configuration: {
        __typename: "ZHLExperienceWebIconConstellation8Configuration";
        constellationVersion: ZHLExperienceConstellationVersion;
        fontColor: ZHLExperienceWebConstellation8Color | null;
        icon: ZHLExperienceWebConstellation8Icon;
        platform: ZHLExperiencePlatformType;
        size: ZHLExperienceWebConstellation8IconSize;
        title: string | null;
    } | {
        __typename: "ZHLExperienceWebIconConstellation10AlphaConfiguration";
    };
};
export type NeutronConstellation10IconFragment = {
    __typename: "ZHLExperienceWebIcon";
    id: string;
    configuration: {
        __typename: "ZHLExperienceWebIconConstellation8Configuration";
    } | {
        __typename: "ZHLExperienceWebIconConstellation10AlphaConfiguration";
        platform: ZHLExperiencePlatformType;
        constellationVersion: ZHLExperienceConstellationVersion;
        color: ZHLExperienceWebConstellation10IconColor | null;
        size: ZHLExperienceWebConstellation10IconSize;
        title: string | null;
        icon: ZHLExperienceWebConstellation10Icon;
    };
};
export type NeutronImageFragment = {
    __typename: "ZHLExperienceWebImage";
    altText: string;
    constellationVersion: ZHLExperienceConstellationVersion;
    height: string;
    id: string;
    isFullWidth: boolean;
    src: string;
    width: string | null;
};
export type NeutronConstellation8ListFragment = {
    __typename: "ZHLExperienceWebList";
    content: Array<string>;
    id: string;
    configuration: {
        __typename: "ZHLExperienceWebListConstellation8Configuration";
        appearance: ZHLExperienceWebConstellation8ListAppearance;
        constellationVersion: ZHLExperienceConstellationVersion;
        platform: ZHLExperiencePlatformType;
        icon: {
            __typename: "ZHLExperienceWebIcon";
            id: string;
            configuration: {
                __typename: "ZHLExperienceWebIconConstellation8Configuration";
                constellationVersion: ZHLExperienceConstellationVersion;
                fontColor: ZHLExperienceWebConstellation8Color | null;
                icon: ZHLExperienceWebConstellation8Icon;
                platform: ZHLExperiencePlatformType;
                size: ZHLExperienceWebConstellation8IconSize;
                title: string | null;
            } | {
                __typename: "ZHLExperienceWebIconConstellation10AlphaConfiguration";
            };
        } | null;
    } | {
        __typename: "ZHLExperienceWebListConstellation10AlphaConfiguration";
    };
};
export type NeutronConstellation10ListFragment = {
    __typename: "ZHLExperienceWebList";
    content: Array<string>;
    id: string;
    configuration: {
        __typename: "ZHLExperienceWebListConstellation8Configuration";
    } | {
        __typename: "ZHLExperienceWebListConstellation10AlphaConfiguration";
        platform: ZHLExperiencePlatformType;
        constellationVersion: ZHLExperienceConstellationVersion;
        appearance: ZHLExperienceWebConstellation10ListAppearance;
        icon: {
            __typename: "ZHLExperienceWebIcon";
            id: string;
            configuration: {
                __typename: "ZHLExperienceWebIconConstellation8Configuration";
            } | {
                __typename: "ZHLExperienceWebIconConstellation10AlphaConfiguration";
                platform: ZHLExperiencePlatformType;
                constellationVersion: ZHLExperienceConstellationVersion;
                color: ZHLExperienceWebConstellation10IconColor | null;
                size: ZHLExperienceWebConstellation10IconSize;
                title: string | null;
                icon: ZHLExperienceWebConstellation10Icon;
            };
        } | null;
    };
};
export type NeutronModuleLayoutFragment = {
    __typename: "ZHLExperienceModuleLayout";
    numberOfColumns: number;
    sections: Array<{
        __typename: "ZHLExperienceModuleLayoutSection";
        gapBetweenBlocks: ZHLExperienceSpacingSize | null;
        flowDirection: ZHLExperienceFlowDirection | null;
        columnSpan: number;
        block: string;
        padding: {
            __typename: "ZHLExperienceSpacing";
            top: ZHLExperienceSpacingSize;
            right: ZHLExperienceSpacingSize;
            bottom: ZHLExperienceSpacingSize;
            left: ZHLExperienceSpacingSize;
        } | null;
        margin: {
            __typename: "ZHLExperienceSpacing";
            top: ZHLExperienceSpacingSize;
            right: ZHLExperienceSpacingSize;
            bottom: ZHLExperienceSpacingSize;
            left: ZHLExperienceSpacingSize;
        } | null;
    }>;
};
export type NeutronConstellation8TextFragment = {
    __typename: "ZHLExperienceWebText";
    content: string;
    id: string;
    configuration: {
        __typename: "ZHLExperienceWebTextConstellation8Configuration";
        asParagraph: boolean;
        constellationVersion: ZHLExperienceConstellationVersion;
        fontColor: ZHLExperienceWebConstellation8Color;
        fontType: ZHLExperienceWebConstellation8FontType;
        platform: ZHLExperiencePlatformType;
        textAlign: ZHLExperienceWebConstellation8TextAlignment;
    } | {
        __typename: "ZHLExperienceWebTextConstellation10AlphaConfiguration";
    };
};
export type NeutronConstellation10TextFragment = {
    __typename: "ZHLExperienceWebText";
    content: string;
    id: string;
    configuration: {
        __typename: "ZHLExperienceWebTextConstellation8Configuration";
    } | {
        __typename: "ZHLExperienceWebTextConstellation10AlphaConfiguration";
        platform: ZHLExperiencePlatformType;
        constellationVersion: ZHLExperienceConstellationVersion;
        asParagraph: boolean;
        color: ZHLExperienceWebConstellation10FontColor;
        textStyle: ZHLExperienceWebConstellation10TextStyle;
    };
};
export type NeutronWebNavigationActionFragment = {
    __typename: "ZHLExperienceWebNavigationAction";
    destination: string;
    id: string;
};
export type ZHLDashboardErrorExtensionFragment = {
    __typename: "ZHLDashboardErrorExtension";
    errorCode: number | null;
    errorType: string | null;
    statusText: string | null;
    errorMsg: string | null;
};
export type ActivateBlendLoanMutationVariables = Exact<{
    loanId: Scalars["ID"];
}>;
export type ActivateBlendLoanMutation = {
    __typename: "Mutation";
    activateBlendLoan: {
        __typename: "ActivateBlendLoanOutput";
        success: boolean | null;
        blend_activation_url: string | null;
    } | null;
};
export type ActivateZHLDashboardUserMutationVariables = Exact<{
    zuid: Scalars["String"];
    activationToken: Scalars["String"];
}>;
export type ActivateZHLDashboardUserMutation = {
    __typename: "Mutation";
    activateZHLDashboardUser: {
        __typename: "ZHLDashboardUserActivationResult";
        landingUrl: string | null;
        status: ZHLDashboardUserActivationStatus;
        failureMessage: {
            __typename: "ZHLDashboardUserActivationFailureMessage";
            failureHeading: string;
            failureDescriptionMarkdown: string;
        } | null;
    };
};
export type BeginZHLSelfServiceRecoveryToolAttemptMutationVariables = Exact<{
    input: BeginZHLSelfServiceRecoveryToolAttemptInput;
}>;
export type BeginZHLSelfServiceRecoveryToolAttemptMutation = {
    __typename: "Mutation";
    beginZHLSelfServiceRecoveryToolAttempt: {
        __typename: "BeginZHLSelfServiceRecoveryToolAttempt";
        id: string;
    } | {
        __typename: "BeginZHLSelfServiceRecoveryToolAttemptErrorDetail";
        errorCode: BeginZHLSelfServiceRecoveryToolAttemptError;
        errorMessage: string;
    };
};
export type GenerateZHLDashboardUserActivationTokenForLeadMutationVariables = Exact<{
    salesforceLeadId: Scalars["String"];
    participantEmail: Scalars["String"];
    participantType: LfsParticipantType;
}>;
export type GenerateZHLDashboardUserActivationTokenForLeadMutation = {
    __typename: "Mutation";
    generateZHLDashboardUserActivationTokenForLead: {
        __typename: "ZHLDashboardGenerateActivationTokenResult";
        tokenGenerationStatus: ZHLDashboardActivationTokenGenerationStatus;
        activationUrl: string | null;
        activationToken: {
            __typename: "ZHLDashboardActivationToken";
            token: string;
        } | null;
    };
};
export type RequestCallbackSchedulerAppointmentMutationVariables = Exact<{
    startDateTimeISO: Scalars["String"];
    timeZoneId: Scalars["String"];
}>;
export type RequestCallbackSchedulerAppointmentMutation = {
    __typename: "Mutation";
    requestCallbackSchedulerAppointment: {
        __typename: "CallbackAppointmentScheduled";
        leadPhoneNumber: string;
        scheduledSlot: string;
    } | {
        __typename: "HomeLoansDashboardBaseErrorDetails";
        errorCode: HomeLoansDashboardError;
        message: string;
    };
};
export type CallbackAppointmentScheduledFragment = {
    __typename: "CallbackAppointmentScheduled";
    leadPhoneNumber: string;
    scheduledSlot: string;
};
export type HomeLoansDashboardBaseErrorDetailsFragment = {
    __typename: "HomeLoansDashboardBaseErrorDetails";
    errorCode: HomeLoansDashboardError;
    message: string;
};
export type VerifyZHLSelfServiceRecoveryToolAttemptByLoanAttributesMutationVariables = Exact<{
    input: VerifyZHLSelfServiceRecoveryToolAttemptByLoanAttributesInput;
}>;
export type VerifyZHLSelfServiceRecoveryToolAttemptByLoanAttributesMutation = {
    __typename: "Mutation";
    verifyZHLSelfServiceRecoveryToolAttemptByLoanAttributes: {
        __typename: "VerifyZHLSelfServiceRecoveryToolAttempt";
        actionTaken: VerifyZHLSelfServiceRecoveryToolAttemptAction;
        blendLoginUrl: string;
    } | {
        __typename: "VerifyZHLSelfServiceRecoveryToolAttemptErrorDetail";
        errorCode: VerifyZHLSelfServiceRecoveryToolAttemptError;
        errorMessage: string;
    };
};
export type LoanOfficerFragment = {
    __typename: "ZHLLoanOfficer";
    email: string | null;
    officePhone: string | null;
    title: string | null;
    nmlsID: number | null;
    branchNMLSID: number | null;
    name: {
        __typename: "ZHLName";
        first: string | null;
        last: string | null;
    } | null;
};
export type LoanProcessorFragment = {
    __typename: "ZHLLoanProcessor";
    email: string | null;
    officePhone: string | null;
    title: string | null;
    name: {
        __typename: "ZHLName";
        first: string | null;
        last: string | null;
    } | null;
};
export type GetActivationFailurePageDataQueryVariables = Exact<{
    [key: string]: never;
}>;
export type GetActivationFailurePageDataQuery = {
    __typename: "Query";
    homeLoansDashboard: {
        __typename: "HomeLoansDashboard";
        currentlySelectedLoan: {
            __typename: "ZHLLoan";
            id: string;
            lead: {
                __typename: "ZHLLeadSummary";
                id: string;
            } | null;
            loanOfficer: {
                __typename: "ZHLLoanOfficer";
                email: string | null;
                officePhone: string | null;
                title: string | null;
                nmlsID: number | null;
                branchNMLSID: number | null;
                name: {
                    __typename: "ZHLName";
                    first: string | null;
                    last: string | null;
                } | null;
            } | null;
            loanProcessor: {
                __typename: "ZHLLoanProcessor";
                email: string | null;
                officePhone: string | null;
                title: string | null;
                name: {
                    __typename: "ZHLName";
                    first: string | null;
                    last: string | null;
                } | null;
            } | null;
        } | null;
    };
};
export type AssignedTeamMemberLoanOfficerFragment = {
    __typename: "ZHLLoanOfficer";
    email: string | null;
    officePhone: string | null;
    title: string | null;
    nmlsID: number | null;
    branchNMLSID: number | null;
    name: {
        __typename: "ZHLName";
        first: string | null;
        last: string | null;
    } | null;
};
export type AssignedTeamMemberLoanProcessorFragment = {
    __typename: "ZHLLoanProcessor";
    email: string | null;
    officePhone: string | null;
    title: string | null;
    name: {
        __typename: "ZHLName";
        first: string | null;
        last: string | null;
    } | null;
};
export type GetAssignedTeamMembersDataQueryVariables = Exact<{
    id: Scalars["ID"];
}>;
export type GetAssignedTeamMembersDataQuery = {
    __typename: "Query";
    homeLoansDashboardByLoanId: {
        __typename: "HomeLoansDashboard";
        personalizedNextSteps: {
            __typename: "ZHLPersonalizedNextSteps";
            currentState: ZHLPersonalizedNextStepState;
        };
    };
    zhlLoan: {
        __typename: "ZHLLoan";
        id: string;
        lead: {
            __typename: "ZHLLeadSummary";
            id: string;
        } | null;
        loanOfficer: {
            __typename: "ZHLLoanOfficer";
            email: string | null;
            officePhone: string | null;
            title: string | null;
            nmlsID: number | null;
            branchNMLSID: number | null;
            name: {
                __typename: "ZHLName";
                first: string | null;
                last: string | null;
            } | null;
        } | null;
        loanProcessor: {
            __typename: "ZHLLoanProcessor";
            email: string | null;
            officePhone: string | null;
            title: string | null;
            name: {
                __typename: "ZHLName";
                first: string | null;
                last: string | null;
            } | null;
        } | null;
    };
};
export type GetBlendAuthTrackingMetadataQueryVariables = Exact<{
    [key: string]: never;
}>;
export type GetBlendAuthTrackingMetadataQuery = {
    __typename: "Query";
    zhlLoans: Array<{
        __typename: "ZHLLoan";
        id: string;
    } | null> | null;
    homeLoansDashboard: {
        __typename: "HomeLoansDashboard";
        currentlySelectedLoan: {
            __typename: "ZHLLoan";
            id: string;
            leadAttributes: {
                __typename: "ZHLLeadAttributes";
                leadSource: string | null;
                leadType: string | null;
                program: string | null;
            } | null;
            quickAppFeatures: {
                __typename: "QuickAppFeatures";
                isQuickApp: boolean | null;
            } | null;
        } | null;
        personalizedNextSteps: {
            __typename: "ZHLPersonalizedNextSteps";
            currentState: ZHLPersonalizedNextStepState;
            currentExperience: ZHLPersonalizedNextStepExperience;
        };
    };
};
export type GetCallbackSchedulerLoanDetailsQueryVariables = Exact<{
    [key: string]: never;
}>;
export type GetCallbackSchedulerLoanDetailsQuery = {
    __typename: "Query";
    homeLoansDashboard: {
        __typename: "HomeLoansDashboard";
        currentlySelectedLoan: {
            __typename: "ZHLLoan";
            id: string;
            lead: {
                __typename: "ZHLLeadSummary";
                id: string;
            } | null;
            currentlyLoggedInBorrower: {
                __typename: "ZHLBorrower";
                attributes: {
                    __typename: "ZHLUserAttributes";
                    cellPhone: string | null;
                } | null;
            } | null;
        } | null;
        personalizedNextSteps: {
            __typename: "ZHLPersonalizedNextSteps";
            currentState: ZHLPersonalizedNextStepState;
            currentExperience: ZHLPersonalizedNextStepExperience;
        };
    };
};
export type GetCallbackSchedulerSlotsForNDaysQueryVariables = Exact<{
    startTimeUTCISO: Scalars["String"];
    numberOfAvailableDays: Scalars["Int"];
    includeTimeSlotsOnlyForFirstDay: Scalars["Boolean"];
}>;
export type GetCallbackSchedulerSlotsForNDaysQuery = {
    __typename: "Query";
    homeLoansDashboardCallbackScheduler: {
        __typename: "HomeLoansDashboardCallbackScheduler";
        leadStatusForCallbackScheduler: LeadStatusForHomeLoansDashboardCallbackScheduler;
        callbackSchedulerAvailability: {
            __typename: "HomeLoansDashboardCallbackSchedulerAvailability";
            callbackSchedulerDays: Array<{
                __typename: "CallbackSchedulerDay";
                date: string;
                timezone: string;
                timeSlots: Array<{
                    __typename: "CallbackSchedulerTimeSlot";
                    startTimeUTCISO: string;
                    durationInMinutes: number;
                }> | null;
            }> | null;
        } | {
            __typename: "HomeLoansDashboardCallbackSchedulerAvailabilityErrorDetails";
            errorCode: HomeLoansDashboardCallbackSchedulerAvailabilityError;
            errorMessage: string;
        };
    } | {
        __typename: "HomeLoansDashboardCallbackSchedulerErrorDetails";
        errorCode: HomeLoansDashboardCallbackSchedulerError;
        errorMessage: string;
    };
};
export type HomeLoansDashboardCallbackSchedulerFragment = {
    __typename: "HomeLoansDashboardCallbackScheduler";
    leadStatusForCallbackScheduler: LeadStatusForHomeLoansDashboardCallbackScheduler;
    callbackSchedulerAvailability: {
        __typename: "HomeLoansDashboardCallbackSchedulerAvailability";
        callbackSchedulerDays: Array<{
            __typename: "CallbackSchedulerDay";
            date: string;
            timezone: string;
            timeSlots: Array<{
                __typename: "CallbackSchedulerTimeSlot";
                startTimeUTCISO: string;
                durationInMinutes: number;
            }> | null;
        }> | null;
    } | {
        __typename: "HomeLoansDashboardCallbackSchedulerAvailabilityErrorDetails";
        errorCode: HomeLoansDashboardCallbackSchedulerAvailabilityError;
        errorMessage: string;
    };
};
export type HomeLoansDashboardCallbackSchedulerAvailabilityFragment = {
    __typename: "HomeLoansDashboardCallbackSchedulerAvailability";
    callbackSchedulerDays: Array<{
        __typename: "CallbackSchedulerDay";
        date: string;
        timezone: string;
        timeSlots: Array<{
            __typename: "CallbackSchedulerTimeSlot";
            startTimeUTCISO: string;
            durationInMinutes: number;
        }> | null;
    }> | null;
};
export type HomeLoansDashboardCallbackSchedulerAvailabilityErrorDetailsFragment = {
    __typename: "HomeLoansDashboardCallbackSchedulerAvailabilityErrorDetails";
    errorCode: HomeLoansDashboardCallbackSchedulerAvailabilityError;
    errorMessage: string;
};
export type HomeLoansDashboardCallbackSchedulerErrorDetailsFragment = {
    __typename: "HomeLoansDashboardCallbackSchedulerErrorDetails";
    errorCode: HomeLoansDashboardCallbackSchedulerError;
    errorMessage: string;
};
export type GetEntryBounceModuleDataQueryVariables = Exact<{
    [key: string]: never;
}>;
export type GetEntryBounceModuleDataQuery = {
    __typename: "Query";
    homeLoansDashboard: {
        __typename: "HomeLoansDashboard";
        currentlySelectedLoan: {
            __typename: "ZHLLoan";
            id: string;
            lead: {
                __typename: "ZHLLeadSummary";
                id: string;
            } | null;
        } | null;
        personalizedNextSteps: {
            __typename: "ZHLPersonalizedNextSteps";
            dashboardUrl: string | null;
            currentState: ZHLPersonalizedNextStepState;
            loanApplicationExperienceURL: string | null;
        };
    };
};
export type GetHeroGraphicModuleDataQueryVariables = Exact<{
    id: Scalars["ID"];
}>;
export type GetHeroGraphicModuleDataQuery = {
    __typename: "Query";
    homeLoansDashboardByLoanId: {
        __typename: "HomeLoansDashboard";
        id: string;
        personalizedNextSteps: {
            __typename: "ZHLPersonalizedNextSteps";
            currentState: ZHLPersonalizedNextStepState;
        };
    };
};
export type GetHomeLoansDashboardPageDataQueryVariables = Exact<{
    id: Scalars["ID"];
}>;
export type GetHomeLoansDashboardPageDataQuery = {
    __typename: "Query";
    homeLoansDashboardByLoanId: {
        __typename: "HomeLoansDashboard";
        id: string;
        currentlySelectedLoan: {
            __typename: "ZHLLoan";
            id: string;
            lead: {
                __typename: "ZHLLeadSummary";
                id: string;
            } | null;
        } | null;
        personalizedNextSteps: {
            __typename: "ZHLPersonalizedNextSteps";
            currentState: ZHLPersonalizedNextStepState;
        };
    };
};
export type GetResourceCardModuleDataQueryVariables = Exact<{
    id: Scalars["ID"];
}>;
export type GetResourceCardModuleDataQuery = {
    __typename: "Query";
    homeLoansDashboardByLoanId: {
        __typename: "HomeLoansDashboard";
        id: string;
        personalizedNextSteps: {
            __typename: "ZHLPersonalizedNextSteps";
            currentState: ZHLPersonalizedNextStepState;
            currentExperience: ZHLPersonalizedNextStepExperience;
            loanApplicationExperienceURL: string | null;
            loanId: string;
            steps: Array<{
                __typename: "ZHLPersonalizedNextStep";
                title: string;
                status: ZHLPersonalizedNextStepStatus;
            }>;
        };
        currentlySelectedLoan: {
            __typename: "ZHLLoan";
            id: string;
            quickAppFeatures: {
                __typename: "QuickAppFeatures";
                ctaPreApprovalUrlWithDomain: string | null;
            } | null;
            lead: {
                __typename: "ZHLLeadSummary";
                id: string;
            } | null;
            preApprovalLetterURL: {
                __typename: "ZHLDocumentMetadata";
                downloadURL: string | null;
                documentURL: string | null;
            } | null;
            currentlyLoggedInBorrower: {
                __typename: "ZHLBorrower";
                id: string;
            } | null;
        } | null;
    };
};
export type GetSelfServiceRecoveryToolEligibilityQueryVariables = Exact<{
    input: ZHLSelfServiceRecoveryToolEligibilityInput;
}>;
export type GetSelfServiceRecoveryToolEligibilityQuery = {
    __typename: "Query";
    zhlSelfServiceRecoveryToolEligibility: {
        __typename: "ZHLSelfServiceRecoveryToolEligibility";
        isEligible: boolean;
    } | {
        __typename: "ZHLSelfServiceRecoveryToolEligibilityErrorDetails";
        errorCode: ZHLSelfServiceRecoveryToolIneligibilityError;
    };
};
export type GetUpsellModuleDataQueryVariables = Exact<{
    id: Scalars["ID"];
}>;
export type GetUpsellModuleDataQuery = {
    __typename: "Query";
    homeLoansDashboardByLoanId: {
        __typename: "HomeLoansDashboard";
        id: string;
        personalizedNextSteps: {
            __typename: "ZHLPersonalizedNextSteps";
            currentState: ZHLPersonalizedNextStepState;
            currentExperience: ZHLPersonalizedNextStepExperience;
            loanApplicationExperienceURL: string | null;
            loanId: string;
            steps: Array<{
                __typename: "ZHLPersonalizedNextStep";
                title: string;
                status: ZHLPersonalizedNextStepStatus;
            }>;
        };
        currentlySelectedLoan: {
            __typename: "ZHLLoan";
            id: string;
            quickAppFeatures: {
                __typename: "QuickAppFeatures";
                ctaPreApprovalUrlWithDomain: string | null;
            } | null;
            lead: {
                __typename: "ZHLLeadSummary";
                id: string;
            } | null;
            attributes: {
                __typename: "ZHLLoanAttributes";
                valuation: number | null;
                purchaseLocation: {
                    __typename: "ZHLLocation";
                    street: string | null;
                } | null;
            } | null;
            preApprovalLetterURL: {
                __typename: "ZHLDocumentMetadata";
                downloadURL: string | null;
                documentURL: string | null;
            } | null;
            currentlyLoggedInBorrower: {
                __typename: "ZHLBorrower";
                id: string;
            } | null;
            preApprovalLetters: Array<{
                __typename: "ZHLPreapprovalLetter";
                metaData: {
                    __typename: "ZHLDocumentPreApprovalMetaData";
                    purchasePrice: string | null;
                    issueDate: string;
                } | null;
            } | null> | null;
        } | null;
    };
};
export type GetViewSavedInformationModuleDataQueryVariables = Exact<{
    id: Scalars["ID"];
}>;
export type GetViewSavedInformationModuleDataQuery = {
    __typename: "Query";
    homeLoansDashboardByLoanId: {
        __typename: "HomeLoansDashboard";
        id: string;
        personalizedNextSteps: {
            __typename: "ZHLPersonalizedNextSteps";
            currentState: ZHLPersonalizedNextStepState;
            currentExperience: ZHLPersonalizedNextStepExperience;
            loanId: string;
            loanApplicationExperienceURL: string | null;
        };
        currentlySelectedLoan: {
            __typename: "ZHLLoan";
            id: string;
            lead: {
                __typename: "ZHLLeadSummary";
                id: string;
            } | null;
            currentlyLoggedInBorrower: {
                __typename: "ZHLBorrower";
                id: string;
            } | null;
        } | null;
    };
};
export type GetWelcomeBannerModuleDataQueryVariables = Exact<{
    loanID: Scalars["ID"];
}>;
export type GetWelcomeBannerModuleDataQuery = {
    __typename: "Query";
    homeLoansDashboardByLoanId: {
        __typename: "HomeLoansDashboard";
        id: string;
        currentlySelectedLoan: {
            __typename: "ZHLLoan";
            currentlyLoggedInBorrower: {
                __typename: "ZHLBorrower";
                id: string;
                attributes: {
                    __typename: "ZHLUserAttributes";
                    email: string | null;
                    names: Array<{
                        __typename: "ZHLName";
                        first: string | null;
                        last: string | null;
                    }> | null;
                } | null;
            } | null;
        } | null;
    };
};
export type GetZhlFirstPartyActivationEmailLoginHintQueryVariables = Exact<{
    input: ZhlFirstPartyActivationEmailLoginHintInput;
}>;
export type GetZhlFirstPartyActivationEmailLoginHintQuery = {
    __typename: "Query";
    zhlFirstPartyActivationEmailLoginHint: {
        __typename: "ZhlFirstPartyActivationEmailLoginHintResponse";
        email: string | null;
    };
};
export const ClickstreamEventFragmentFragmentDoc = gql `
    fragment ClickstreamEventFragment on ZHLExperienceAnalyticClickstreamEvent {
        id
        __typename
        analyticsTag
        clickstreamEnvelope {
            eventTemplateID
            eventTemplateVersionID
            eventTypeID
            eventTypeVersionID
        }
        clickstreamTriggerBlock {
            triggerTypeName
            triggerLocationName
            triggerSourceName
            triggerObjectName
        }
        semanticBlock {
            semanticEventName
            topicTagText
        }
        productSpecificBlockData
        productSpecificBlock
        stringifiedProductSpecificBlockData
    }
`;
export const NeutronConstellation8IconFragmentDoc = gql `
    fragment NeutronConstellation8Icon on ZHLExperienceWebIcon {
        configuration {
            ... on ZHLExperienceWebIconConstellation8Configuration {
                constellationVersion
                fontColor
                icon
                platform
                size
                title
            }
        }
        id
    }
`;
export const NeutronConstellation8AvatarFragmentDoc = gql `
    fragment NeutronConstellation8Avatar on ZHLExperienceWebAvatar {
        configuration {
            ... on ZHLExperienceWebAvatarConstellation8Configuration {
                alt
                avatarIcon {
                    ...NeutronConstellation8Icon
                }
                badgeIcon {
                    ...NeutronConstellation8Icon
                }
                badgedSize
                color
                constellationVersion
                fullName
                maxAvatarImageHeight
                platform
                size
                src
                useDefaultAvatar
            }
        }
        id
    }
    ${NeutronConstellation8IconFragmentDoc}
`;
export const NeutronConstellation8ButtonFragmentDoc = gql `
    fragment NeutronConstellation8Button on ZHLExperienceWebButton {
        configuration {
            ... on ZHLExperienceWebButtonConstellation8Configuration {
                buttonType
                constellationVersion
                desktopContent
                fluid
                iconPosition
                inverse
                platform
                presentAsTextButtonOnDesktop
                size
            }
        }
        content
        id
    }
`;
export const NeutronConstellation8TextFragmentDoc = gql `
    fragment NeutronConstellation8Text on ZHLExperienceWebText {
        configuration {
            ... on ZHLExperienceWebTextConstellation8Configuration {
                asParagraph
                constellationVersion
                fontColor
                fontType
                platform
                textAlign
            }
        }
        content
        id
    }
`;
export const NeutronConstellation8HeadingFragmentDoc = gql `
    fragment NeutronConstellation8Heading on ZHLExperienceWebHeading {
        configuration {
            ... on ZHLExperienceWebHeadingConstellation8Configuration {
                constellationVersion
                fontColor
                fontFamily
                fontType
                level
                platform
                textAlign
            }
        }
        content
        id
    }
`;
export const NeutronImageFragmentDoc = gql `
    fragment NeutronImage on ZHLExperienceWebImage {
        altText
        constellationVersion
        height
        id
        isFullWidth
        src
        width
    }
`;
export const NeutronConstellation8ContactCardFragmentDoc = gql `
    fragment NeutronConstellation8ContactCard on ZHLExperienceWebContactInformationSection {
        avatar {
            ...NeutronConstellation8Avatar
        }
        constellationVersion
        contactMethods {
            ...NeutronConstellation8Button
        }
        content {
            ...NeutronConstellation8Text
        }
        headlineHeading {
            ...NeutronConstellation8Heading
        }
        headlineText {
            ...NeutronConstellation8Text
        }
        id
        imageAsAvatar {
            ...NeutronImage
        }
        platform
    }
    ${NeutronConstellation8AvatarFragmentDoc}
    ${NeutronConstellation8ButtonFragmentDoc}
    ${NeutronConstellation8TextFragmentDoc}
    ${NeutronConstellation8HeadingFragmentDoc}
    ${NeutronImageFragmentDoc}
`;
export const NeutronConstellation10IconFragmentDoc = gql `
    fragment NeutronConstellation10Icon on ZHLExperienceWebIcon {
        configuration {
            ... on ZHLExperienceWebIconConstellation10AlphaConfiguration {
                platform
                constellationVersion
                color
                size
                title
                icon
            }
        }
        id
    }
`;
export const NeutronConstellation10AvatarFragmentDoc = gql `
    fragment NeutronConstellation10Avatar on ZHLExperienceWebAvatar {
        configuration {
            ... on ZHLExperienceWebAvatarConstellation10AlphaConfiguration {
                avatarIcon {
                    ...NeutronConstellation10Icon
                }
                badgeIcon {
                    ...NeutronConstellation10Icon
                }
                platform
                constellationVersion
                size
                maxAvatarImageHeight
                fullName
                src
                alt
                tone
                badgedSize
                useDefaultAvatar
            }
        }
        id
    }
    ${NeutronConstellation10IconFragmentDoc}
`;
export const NeutronConstellation10ButtonFragmentDoc = gql `
    fragment NeutronConstellation10Button on ZHLExperienceWebButton {
        configuration {
            ... on ZHLExperienceWebButtonConstellation10AlphaConfiguration {
                platform
                constellationVersion
                tone
                emphasis
                fluid
                onImpact
                size
                iconPosition
                presentAsTextButtonOnDesktop
                desktopContent
            }
        }
        content
        id
    }
`;
export const NeutronConstellation10TextFragmentDoc = gql `
    fragment NeutronConstellation10Text on ZHLExperienceWebText {
        configuration {
            ... on ZHLExperienceWebTextConstellation10AlphaConfiguration {
                platform
                constellationVersion
                asParagraph
                color
                textStyle
            }
        }
        content
        id
    }
`;
export const NeutronConstellation10HeadingFragmentDoc = gql `
    fragment NeutronConstellation10Heading on ZHLExperienceWebHeading {
        configuration {
            ... on ZHLExperienceWebHeadingConstellation10AlphaConfiguration {
                platform
                constellationVersion
                level
                textStyle
                fontFamily
                color
            }
        }
        content
        id
    }
`;
export const NeutronConstellation10ContactCardFragmentDoc = gql `
    fragment NeutronConstellation10ContactCard on ZHLExperienceWebContactInformationSection {
        avatar {
            ...NeutronConstellation10Avatar
        }
        constellationVersion
        contactMethods {
            ...NeutronConstellation10Button
        }
        content {
            ...NeutronConstellation10Text
        }
        headlineHeading {
            ...NeutronConstellation10Heading
        }
        headlineText {
            ...NeutronConstellation10Text
        }
        id
        imageAsAvatar {
            ...NeutronImage
        }
        platform
    }
    ${NeutronConstellation10AvatarFragmentDoc}
    ${NeutronConstellation10ButtonFragmentDoc}
    ${NeutronConstellation10TextFragmentDoc}
    ${NeutronConstellation10HeadingFragmentDoc}
    ${NeutronImageFragmentDoc}
`;
export const NeutronDestructiveOperationActionFragmentDoc = gql `
    fragment NeutronDestructiveOperationAction on ZHLExperienceDestructiveOperationAction {
        id
        operationToPerform
    }
`;
export const NeutronGetInTouchActionFragmentDoc = gql `
    fragment NeutronGetInTouchAction on ZHLExperienceGetInTouchAction {
        contactResource
        contactType
        id
    }
`;
export const NeutronConstellation8ListFragmentDoc = gql `
    fragment NeutronConstellation8List on ZHLExperienceWebList {
        configuration {
            ... on ZHLExperienceWebListConstellation8Configuration {
                icon {
                    ...NeutronConstellation8Icon
                }
                appearance
                constellationVersion
                platform
            }
        }
        content
        id
    }
    ${NeutronConstellation8IconFragmentDoc}
`;
export const NeutronConstellation10ListFragmentDoc = gql `
    fragment NeutronConstellation10List on ZHLExperienceWebList {
        configuration {
            ... on ZHLExperienceWebListConstellation10AlphaConfiguration {
                icon {
                    ...NeutronConstellation10Icon
                }
                platform
                constellationVersion
                appearance
            }
        }
        content
        id
    }
    ${NeutronConstellation10IconFragmentDoc}
`;
export const NeutronModuleLayoutFragmentDoc = gql `
    fragment NeutronModuleLayout on ZHLExperienceModuleLayout {
        __typename
        numberOfColumns
        sections {
            __typename
            gapBetweenBlocks
            flowDirection
            columnSpan
            padding {
                top
                right
                bottom
                left
            }
            margin {
                top
                right
                bottom
                left
            }
            block
        }
    }
`;
export const NeutronWebNavigationActionFragmentDoc = gql `
    fragment NeutronWebNavigationAction on ZHLExperienceWebNavigationAction {
        destination
        id
    }
`;
export const ZHLDashboardErrorExtensionFragmentDoc = gql `
    fragment ZHLDashboardErrorExtension on ZHLDashboardErrorExtension {
        errorCode
        errorType
        statusText
        errorMsg
    }
`;
export const CallbackAppointmentScheduledFragmentDoc = gql `
    fragment CallbackAppointmentScheduled on CallbackAppointmentScheduled {
        leadPhoneNumber
        scheduledSlot
    }
`;
export const HomeLoansDashboardBaseErrorDetailsFragmentDoc = gql `
    fragment HomeLoansDashboardBaseErrorDetails on HomeLoansDashboardBaseErrorDetails {
        errorCode
        message
    }
`;
export const LoanOfficerFragmentDoc = gql `
    fragment LoanOfficer on ZHLLoanOfficer {
        name {
            first
            last
        }
        email
        officePhone
        title
        nmlsID
        branchNMLSID
    }
`;
export const LoanProcessorFragmentDoc = gql `
    fragment LoanProcessor on ZHLLoanProcessor {
        name {
            first
            last
        }
        email
        officePhone
        title
    }
`;
export const AssignedTeamMemberLoanOfficerFragmentDoc = gql `
    fragment AssignedTeamMemberLoanOfficer on ZHLLoanOfficer {
        name {
            first
            last
        }
        email
        officePhone
        title
        nmlsID
        branchNMLSID
    }
`;
export const AssignedTeamMemberLoanProcessorFragmentDoc = gql `
    fragment AssignedTeamMemberLoanProcessor on ZHLLoanProcessor {
        name {
            first
            last
        }
        email
        officePhone
        title
    }
`;
export const HomeLoansDashboardCallbackSchedulerAvailabilityFragmentDoc = gql `
    fragment HomeLoansDashboardCallbackSchedulerAvailability on HomeLoansDashboardCallbackSchedulerAvailability {
        callbackSchedulerDays {
            date
            timeSlots {
                startTimeUTCISO
                durationInMinutes
            }
            timezone
        }
    }
`;
export const HomeLoansDashboardCallbackSchedulerAvailabilityErrorDetailsFragmentDoc = gql `
    fragment HomeLoansDashboardCallbackSchedulerAvailabilityErrorDetails on HomeLoansDashboardCallbackSchedulerAvailabilityErrorDetails {
        errorCode
        errorMessage
    }
`;
export const HomeLoansDashboardCallbackSchedulerFragmentDoc = gql `
    fragment HomeLoansDashboardCallbackScheduler on HomeLoansDashboardCallbackScheduler {
        leadStatusForCallbackScheduler
        callbackSchedulerAvailability(
            startTimeUTCISO: $startTimeUTCISO
            numberOfAvailableDays: $numberOfAvailableDays
            includeTimeSlotsOnlyForFirstDay: $includeTimeSlotsOnlyForFirstDay
        ) {
            ...HomeLoansDashboardCallbackSchedulerAvailability
            ...HomeLoansDashboardCallbackSchedulerAvailabilityErrorDetails
        }
    }
    ${HomeLoansDashboardCallbackSchedulerAvailabilityFragmentDoc}
    ${HomeLoansDashboardCallbackSchedulerAvailabilityErrorDetailsFragmentDoc}
`;
export const HomeLoansDashboardCallbackSchedulerErrorDetailsFragmentDoc = gql `
    fragment HomeLoansDashboardCallbackSchedulerErrorDetails on HomeLoansDashboardCallbackSchedulerErrorDetails {
        errorCode
        errorMessage
    }
`;
export const ActivateBlendLoanDocument = gql `
    mutation ActivateBlendLoan($loanId: ID!) {
        activateBlendLoan(loanId: $loanId) {
            success
            blend_activation_url
        }
    }
`;
export type ActivateBlendLoanMutationFn = Apollo.MutationFunction<ActivateBlendLoanMutation, ActivateBlendLoanMutationVariables>;
/**
 * __useActivateBlendLoanMutation__
 *
 * To run a mutation, you first call `useActivateBlendLoanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateBlendLoanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateBlendLoanMutation, { data, loading, error }] = useActivateBlendLoanMutation({
 *   variables: {
 *      loanId: // value for 'loanId'
 *   },
 * });
 */
export function useActivateBlendLoanMutation(baseOptions?: Apollo.MutationHookOptions<ActivateBlendLoanMutation, ActivateBlendLoanMutationVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<ActivateBlendLoanMutation, ActivateBlendLoanMutationVariables>(ActivateBlendLoanDocument, options);
}
export type ActivateBlendLoanMutationHookResult = ReturnType<typeof useActivateBlendLoanMutation>;
export type ActivateBlendLoanMutationOptions = Apollo.BaseMutationOptions<ActivateBlendLoanMutation, ActivateBlendLoanMutationVariables>;
export const ActivateZHLDashboardUserDocument = gql `
    mutation ActivateZHLDashboardUser($zuid: String!, $activationToken: String!) {
        activateZHLDashboardUser(zuid: $zuid, activationToken: $activationToken) {
            landingUrl
            status
            failureMessage {
                failureHeading
                failureDescriptionMarkdown
            }
        }
    }
`;
export type ActivateZHLDashboardUserMutationFn = Apollo.MutationFunction<ActivateZHLDashboardUserMutation, ActivateZHLDashboardUserMutationVariables>;
/**
 * __useActivateZHLDashboardUserMutation__
 *
 * To run a mutation, you first call `useActivateZHLDashboardUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateZHLDashboardUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateZhlDashboardUserMutation, { data, loading, error }] = useActivateZHLDashboardUserMutation({
 *   variables: {
 *      zuid: // value for 'zuid'
 *      activationToken: // value for 'activationToken'
 *   },
 * });
 */
export function useActivateZHLDashboardUserMutation(baseOptions?: Apollo.MutationHookOptions<ActivateZHLDashboardUserMutation, ActivateZHLDashboardUserMutationVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<ActivateZHLDashboardUserMutation, ActivateZHLDashboardUserMutationVariables>(ActivateZHLDashboardUserDocument, options);
}
export type ActivateZHLDashboardUserMutationHookResult = ReturnType<typeof useActivateZHLDashboardUserMutation>;
export type ActivateZHLDashboardUserMutationOptions = Apollo.BaseMutationOptions<ActivateZHLDashboardUserMutation, ActivateZHLDashboardUserMutationVariables>;
export const BeginZHLSelfServiceRecoveryToolAttemptDocument = gql `
    mutation BeginZHLSelfServiceRecoveryToolAttempt($input: BeginZHLSelfServiceRecoveryToolAttemptInput!) {
        beginZHLSelfServiceRecoveryToolAttempt(input: $input) {
            ... on BeginZHLSelfServiceRecoveryToolAttemptErrorDetail {
                errorCode
                errorMessage
            }
            ... on BeginZHLSelfServiceRecoveryToolAttempt {
                id
            }
        }
    }
`;
export type BeginZHLSelfServiceRecoveryToolAttemptMutationFn = Apollo.MutationFunction<BeginZHLSelfServiceRecoveryToolAttemptMutation, BeginZHLSelfServiceRecoveryToolAttemptMutationVariables>;
/**
 * __useBeginZHLSelfServiceRecoveryToolAttemptMutation__
 *
 * To run a mutation, you first call `useBeginZHLSelfServiceRecoveryToolAttemptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBeginZHLSelfServiceRecoveryToolAttemptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [beginZhlSelfServiceRecoveryToolAttemptMutation, { data, loading, error }] = useBeginZHLSelfServiceRecoveryToolAttemptMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBeginZHLSelfServiceRecoveryToolAttemptMutation(baseOptions?: Apollo.MutationHookOptions<BeginZHLSelfServiceRecoveryToolAttemptMutation, BeginZHLSelfServiceRecoveryToolAttemptMutationVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<BeginZHLSelfServiceRecoveryToolAttemptMutation, BeginZHLSelfServiceRecoveryToolAttemptMutationVariables>(BeginZHLSelfServiceRecoveryToolAttemptDocument, options);
}
export type BeginZHLSelfServiceRecoveryToolAttemptMutationHookResult = ReturnType<typeof useBeginZHLSelfServiceRecoveryToolAttemptMutation>;
export type BeginZHLSelfServiceRecoveryToolAttemptMutationOptions = Apollo.BaseMutationOptions<BeginZHLSelfServiceRecoveryToolAttemptMutation, BeginZHLSelfServiceRecoveryToolAttemptMutationVariables>;
export const GenerateZHLDashboardUserActivationTokenForLeadDocument = gql `
    mutation GenerateZHLDashboardUserActivationTokenForLead(
        $salesforceLeadId: String!
        $participantEmail: String!
        $participantType: LfsParticipantType!
    ) {
        generateZHLDashboardUserActivationTokenForLead(
            salesforceLeadId: $salesforceLeadId
            participantEmail: $participantEmail
            participantType: $participantType
        ) {
            tokenGenerationStatus
            activationUrl
            activationToken {
                token
            }
        }
    }
`;
export type GenerateZHLDashboardUserActivationTokenForLeadMutationFn = Apollo.MutationFunction<GenerateZHLDashboardUserActivationTokenForLeadMutation, GenerateZHLDashboardUserActivationTokenForLeadMutationVariables>;
/**
 * __useGenerateZHLDashboardUserActivationTokenForLeadMutation__
 *
 * To run a mutation, you first call `useGenerateZHLDashboardUserActivationTokenForLeadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateZHLDashboardUserActivationTokenForLeadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateZhlDashboardUserActivationTokenForLeadMutation, { data, loading, error }] = useGenerateZHLDashboardUserActivationTokenForLeadMutation({
 *   variables: {
 *      salesforceLeadId: // value for 'salesforceLeadId'
 *      participantEmail: // value for 'participantEmail'
 *      participantType: // value for 'participantType'
 *   },
 * });
 */
export function useGenerateZHLDashboardUserActivationTokenForLeadMutation(baseOptions?: Apollo.MutationHookOptions<GenerateZHLDashboardUserActivationTokenForLeadMutation, GenerateZHLDashboardUserActivationTokenForLeadMutationVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<GenerateZHLDashboardUserActivationTokenForLeadMutation, GenerateZHLDashboardUserActivationTokenForLeadMutationVariables>(GenerateZHLDashboardUserActivationTokenForLeadDocument, options);
}
export type GenerateZHLDashboardUserActivationTokenForLeadMutationHookResult = ReturnType<typeof useGenerateZHLDashboardUserActivationTokenForLeadMutation>;
export type GenerateZHLDashboardUserActivationTokenForLeadMutationOptions = Apollo.BaseMutationOptions<GenerateZHLDashboardUserActivationTokenForLeadMutation, GenerateZHLDashboardUserActivationTokenForLeadMutationVariables>;
export const RequestCallbackSchedulerAppointmentDocument = gql `
    mutation RequestCallbackSchedulerAppointment($startDateTimeISO: String!, $timeZoneId: String!) {
        requestCallbackSchedulerAppointment(startDateTimeISO: $startDateTimeISO, timeZoneId: $timeZoneId) {
            ...CallbackAppointmentScheduled
            ...HomeLoansDashboardBaseErrorDetails
        }
    }
    ${CallbackAppointmentScheduledFragmentDoc}
    ${HomeLoansDashboardBaseErrorDetailsFragmentDoc}
`;
export type RequestCallbackSchedulerAppointmentMutationFn = Apollo.MutationFunction<RequestCallbackSchedulerAppointmentMutation, RequestCallbackSchedulerAppointmentMutationVariables>;
/**
 * __useRequestCallbackSchedulerAppointmentMutation__
 *
 * To run a mutation, you first call `useRequestCallbackSchedulerAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestCallbackSchedulerAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestCallbackSchedulerAppointmentMutation, { data, loading, error }] = useRequestCallbackSchedulerAppointmentMutation({
 *   variables: {
 *      startDateTimeISO: // value for 'startDateTimeISO'
 *      timeZoneId: // value for 'timeZoneId'
 *   },
 * });
 */
export function useRequestCallbackSchedulerAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<RequestCallbackSchedulerAppointmentMutation, RequestCallbackSchedulerAppointmentMutationVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<RequestCallbackSchedulerAppointmentMutation, RequestCallbackSchedulerAppointmentMutationVariables>(RequestCallbackSchedulerAppointmentDocument, options);
}
export type RequestCallbackSchedulerAppointmentMutationHookResult = ReturnType<typeof useRequestCallbackSchedulerAppointmentMutation>;
export type RequestCallbackSchedulerAppointmentMutationOptions = Apollo.BaseMutationOptions<RequestCallbackSchedulerAppointmentMutation, RequestCallbackSchedulerAppointmentMutationVariables>;
export const VerifyZHLSelfServiceRecoveryToolAttemptByLoanAttributesDocument = gql `
    mutation VerifyZHLSelfServiceRecoveryToolAttemptByLoanAttributes(
        $input: VerifyZHLSelfServiceRecoveryToolAttemptByLoanAttributesInput!
    ) {
        verifyZHLSelfServiceRecoveryToolAttemptByLoanAttributes(input: $input) {
            ... on VerifyZHLSelfServiceRecoveryToolAttempt {
                actionTaken
                blendLoginUrl
            }
            ... on VerifyZHLSelfServiceRecoveryToolAttemptErrorDetail {
                errorCode
                errorMessage
            }
        }
    }
`;
export type VerifyZHLSelfServiceRecoveryToolAttemptByLoanAttributesMutationFn = Apollo.MutationFunction<VerifyZHLSelfServiceRecoveryToolAttemptByLoanAttributesMutation, VerifyZHLSelfServiceRecoveryToolAttemptByLoanAttributesMutationVariables>;
/**
 * __useVerifyZHLSelfServiceRecoveryToolAttemptByLoanAttributesMutation__
 *
 * To run a mutation, you first call `useVerifyZHLSelfServiceRecoveryToolAttemptByLoanAttributesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyZHLSelfServiceRecoveryToolAttemptByLoanAttributesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyZhlSelfServiceRecoveryToolAttemptByLoanAttributesMutation, { data, loading, error }] = useVerifyZHLSelfServiceRecoveryToolAttemptByLoanAttributesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyZHLSelfServiceRecoveryToolAttemptByLoanAttributesMutation(baseOptions?: Apollo.MutationHookOptions<VerifyZHLSelfServiceRecoveryToolAttemptByLoanAttributesMutation, VerifyZHLSelfServiceRecoveryToolAttemptByLoanAttributesMutationVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<VerifyZHLSelfServiceRecoveryToolAttemptByLoanAttributesMutation, VerifyZHLSelfServiceRecoveryToolAttemptByLoanAttributesMutationVariables>(VerifyZHLSelfServiceRecoveryToolAttemptByLoanAttributesDocument, options);
}
export type VerifyZHLSelfServiceRecoveryToolAttemptByLoanAttributesMutationHookResult = ReturnType<typeof useVerifyZHLSelfServiceRecoveryToolAttemptByLoanAttributesMutation>;
export type VerifyZHLSelfServiceRecoveryToolAttemptByLoanAttributesMutationOptions = Apollo.BaseMutationOptions<VerifyZHLSelfServiceRecoveryToolAttemptByLoanAttributesMutation, VerifyZHLSelfServiceRecoveryToolAttemptByLoanAttributesMutationVariables>;
export const GetActivationFailurePageDataDocument = gql `
    query GetActivationFailurePageData {
        homeLoansDashboard {
            currentlySelectedLoan {
                id
                lead {
                    id
                }
                loanOfficer {
                    ...LoanOfficer
                }
                loanProcessor {
                    ...LoanProcessor
                }
            }
        }
    }
    ${LoanOfficerFragmentDoc}
    ${LoanProcessorFragmentDoc}
`;
/**
 * __useGetActivationFailurePageDataQuery__
 *
 * To run a query within a React component, call `useGetActivationFailurePageDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivationFailurePageDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivationFailurePageDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetActivationFailurePageDataQuery(baseOptions?: Apollo.QueryHookOptions<GetActivationFailurePageDataQuery, GetActivationFailurePageDataQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetActivationFailurePageDataQuery, GetActivationFailurePageDataQueryVariables>(GetActivationFailurePageDataDocument, options);
}
export function useGetActivationFailurePageDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActivationFailurePageDataQuery, GetActivationFailurePageDataQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetActivationFailurePageDataQuery, GetActivationFailurePageDataQueryVariables>(GetActivationFailurePageDataDocument, options);
}
export type GetActivationFailurePageDataQueryHookResult = ReturnType<typeof useGetActivationFailurePageDataQuery>;
export type GetActivationFailurePageDataLazyQueryHookResult = ReturnType<typeof useGetActivationFailurePageDataLazyQuery>;
export type GetActivationFailurePageDataQueryResult = Apollo.QueryResult<GetActivationFailurePageDataQuery, GetActivationFailurePageDataQueryVariables>;
export const GetAssignedTeamMembersDataDocument = gql `
    query GetAssignedTeamMembersData($id: ID!) {
        homeLoansDashboardByLoanId(loanId: $id) {
            personalizedNextSteps(version: V2) {
                currentState
            }
        }
        zhlLoan(zhlLoanId: $id) {
            id
            lead {
                id
            }
            loanOfficer {
                ...AssignedTeamMemberLoanOfficer
            }
            loanProcessor {
                ...AssignedTeamMemberLoanProcessor
            }
        }
    }
    ${AssignedTeamMemberLoanOfficerFragmentDoc}
    ${AssignedTeamMemberLoanProcessorFragmentDoc}
`;
/**
 * __useGetAssignedTeamMembersDataQuery__
 *
 * To run a query within a React component, call `useGetAssignedTeamMembersDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssignedTeamMembersDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssignedTeamMembersDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAssignedTeamMembersDataQuery(baseOptions: Apollo.QueryHookOptions<GetAssignedTeamMembersDataQuery, GetAssignedTeamMembersDataQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetAssignedTeamMembersDataQuery, GetAssignedTeamMembersDataQueryVariables>(GetAssignedTeamMembersDataDocument, options);
}
export function useGetAssignedTeamMembersDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssignedTeamMembersDataQuery, GetAssignedTeamMembersDataQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetAssignedTeamMembersDataQuery, GetAssignedTeamMembersDataQueryVariables>(GetAssignedTeamMembersDataDocument, options);
}
export type GetAssignedTeamMembersDataQueryHookResult = ReturnType<typeof useGetAssignedTeamMembersDataQuery>;
export type GetAssignedTeamMembersDataLazyQueryHookResult = ReturnType<typeof useGetAssignedTeamMembersDataLazyQuery>;
export type GetAssignedTeamMembersDataQueryResult = Apollo.QueryResult<GetAssignedTeamMembersDataQuery, GetAssignedTeamMembersDataQueryVariables>;
export const GetBlendAuthTrackingMetadataDocument = gql `
    query GetBlendAuthTrackingMetadata {
        zhlLoans {
            id
        }
        homeLoansDashboard {
            currentlySelectedLoan {
                id
                leadAttributes {
                    leadSource
                    leadType
                    program
                }
                quickAppFeatures {
                    isQuickApp
                }
            }
            personalizedNextSteps(version: V2) {
                currentState
                currentExperience
            }
        }
    }
`;
/**
 * __useGetBlendAuthTrackingMetadataQuery__
 *
 * To run a query within a React component, call `useGetBlendAuthTrackingMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBlendAuthTrackingMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBlendAuthTrackingMetadataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBlendAuthTrackingMetadataQuery(baseOptions?: Apollo.QueryHookOptions<GetBlendAuthTrackingMetadataQuery, GetBlendAuthTrackingMetadataQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetBlendAuthTrackingMetadataQuery, GetBlendAuthTrackingMetadataQueryVariables>(GetBlendAuthTrackingMetadataDocument, options);
}
export function useGetBlendAuthTrackingMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBlendAuthTrackingMetadataQuery, GetBlendAuthTrackingMetadataQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetBlendAuthTrackingMetadataQuery, GetBlendAuthTrackingMetadataQueryVariables>(GetBlendAuthTrackingMetadataDocument, options);
}
export type GetBlendAuthTrackingMetadataQueryHookResult = ReturnType<typeof useGetBlendAuthTrackingMetadataQuery>;
export type GetBlendAuthTrackingMetadataLazyQueryHookResult = ReturnType<typeof useGetBlendAuthTrackingMetadataLazyQuery>;
export type GetBlendAuthTrackingMetadataQueryResult = Apollo.QueryResult<GetBlendAuthTrackingMetadataQuery, GetBlendAuthTrackingMetadataQueryVariables>;
export const GetCallbackSchedulerLoanDetailsDocument = gql `
    query GetCallbackSchedulerLoanDetails {
        homeLoansDashboard {
            currentlySelectedLoan {
                id
                lead {
                    id
                }
                currentlyLoggedInBorrower {
                    attributes {
                        cellPhone
                    }
                }
            }
            personalizedNextSteps(version: V2) {
                currentState
                currentExperience
            }
        }
    }
`;
/**
 * __useGetCallbackSchedulerLoanDetailsQuery__
 *
 * To run a query within a React component, call `useGetCallbackSchedulerLoanDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCallbackSchedulerLoanDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCallbackSchedulerLoanDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCallbackSchedulerLoanDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GetCallbackSchedulerLoanDetailsQuery, GetCallbackSchedulerLoanDetailsQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetCallbackSchedulerLoanDetailsQuery, GetCallbackSchedulerLoanDetailsQueryVariables>(GetCallbackSchedulerLoanDetailsDocument, options);
}
export function useGetCallbackSchedulerLoanDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCallbackSchedulerLoanDetailsQuery, GetCallbackSchedulerLoanDetailsQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetCallbackSchedulerLoanDetailsQuery, GetCallbackSchedulerLoanDetailsQueryVariables>(GetCallbackSchedulerLoanDetailsDocument, options);
}
export type GetCallbackSchedulerLoanDetailsQueryHookResult = ReturnType<typeof useGetCallbackSchedulerLoanDetailsQuery>;
export type GetCallbackSchedulerLoanDetailsLazyQueryHookResult = ReturnType<typeof useGetCallbackSchedulerLoanDetailsLazyQuery>;
export type GetCallbackSchedulerLoanDetailsQueryResult = Apollo.QueryResult<GetCallbackSchedulerLoanDetailsQuery, GetCallbackSchedulerLoanDetailsQueryVariables>;
export const GetCallbackSchedulerSlotsForNDaysDocument = gql `
    query GetCallbackSchedulerSlotsForNDays(
        $startTimeUTCISO: String!
        $numberOfAvailableDays: Int!
        $includeTimeSlotsOnlyForFirstDay: Boolean!
    ) {
        homeLoansDashboardCallbackScheduler {
            ...HomeLoansDashboardCallbackScheduler
            ...HomeLoansDashboardCallbackSchedulerErrorDetails
        }
    }
    ${HomeLoansDashboardCallbackSchedulerFragmentDoc}
    ${HomeLoansDashboardCallbackSchedulerErrorDetailsFragmentDoc}
`;
/**
 * __useGetCallbackSchedulerSlotsForNDaysQuery__
 *
 * To run a query within a React component, call `useGetCallbackSchedulerSlotsForNDaysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCallbackSchedulerSlotsForNDaysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCallbackSchedulerSlotsForNDaysQuery({
 *   variables: {
 *      startTimeUTCISO: // value for 'startTimeUTCISO'
 *      numberOfAvailableDays: // value for 'numberOfAvailableDays'
 *      includeTimeSlotsOnlyForFirstDay: // value for 'includeTimeSlotsOnlyForFirstDay'
 *   },
 * });
 */
export function useGetCallbackSchedulerSlotsForNDaysQuery(baseOptions: Apollo.QueryHookOptions<GetCallbackSchedulerSlotsForNDaysQuery, GetCallbackSchedulerSlotsForNDaysQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetCallbackSchedulerSlotsForNDaysQuery, GetCallbackSchedulerSlotsForNDaysQueryVariables>(GetCallbackSchedulerSlotsForNDaysDocument, options);
}
export function useGetCallbackSchedulerSlotsForNDaysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCallbackSchedulerSlotsForNDaysQuery, GetCallbackSchedulerSlotsForNDaysQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetCallbackSchedulerSlotsForNDaysQuery, GetCallbackSchedulerSlotsForNDaysQueryVariables>(GetCallbackSchedulerSlotsForNDaysDocument, options);
}
export type GetCallbackSchedulerSlotsForNDaysQueryHookResult = ReturnType<typeof useGetCallbackSchedulerSlotsForNDaysQuery>;
export type GetCallbackSchedulerSlotsForNDaysLazyQueryHookResult = ReturnType<typeof useGetCallbackSchedulerSlotsForNDaysLazyQuery>;
export type GetCallbackSchedulerSlotsForNDaysQueryResult = Apollo.QueryResult<GetCallbackSchedulerSlotsForNDaysQuery, GetCallbackSchedulerSlotsForNDaysQueryVariables>;
export const GetEntryBounceModuleDataDocument = gql `
    query GetEntryBounceModuleData {
        homeLoansDashboard {
            currentlySelectedLoan {
                id
                lead {
                    id
                }
            }
            personalizedNextSteps(version: V2) {
                dashboardUrl
                currentState
                loanApplicationExperienceURL
            }
        }
    }
`;
/**
 * __useGetEntryBounceModuleDataQuery__
 *
 * To run a query within a React component, call `useGetEntryBounceModuleDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntryBounceModuleDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntryBounceModuleDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEntryBounceModuleDataQuery(baseOptions?: Apollo.QueryHookOptions<GetEntryBounceModuleDataQuery, GetEntryBounceModuleDataQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetEntryBounceModuleDataQuery, GetEntryBounceModuleDataQueryVariables>(GetEntryBounceModuleDataDocument, options);
}
export function useGetEntryBounceModuleDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEntryBounceModuleDataQuery, GetEntryBounceModuleDataQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetEntryBounceModuleDataQuery, GetEntryBounceModuleDataQueryVariables>(GetEntryBounceModuleDataDocument, options);
}
export type GetEntryBounceModuleDataQueryHookResult = ReturnType<typeof useGetEntryBounceModuleDataQuery>;
export type GetEntryBounceModuleDataLazyQueryHookResult = ReturnType<typeof useGetEntryBounceModuleDataLazyQuery>;
export type GetEntryBounceModuleDataQueryResult = Apollo.QueryResult<GetEntryBounceModuleDataQuery, GetEntryBounceModuleDataQueryVariables>;
export const GetHeroGraphicModuleDataDocument = gql `
    query GetHeroGraphicModuleData($id: ID!) {
        homeLoansDashboardByLoanId(loanId: $id) {
            id
            personalizedNextSteps(version: V2) {
                currentState
            }
        }
    }
`;
/**
 * __useGetHeroGraphicModuleDataQuery__
 *
 * To run a query within a React component, call `useGetHeroGraphicModuleDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHeroGraphicModuleDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHeroGraphicModuleDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetHeroGraphicModuleDataQuery(baseOptions: Apollo.QueryHookOptions<GetHeroGraphicModuleDataQuery, GetHeroGraphicModuleDataQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetHeroGraphicModuleDataQuery, GetHeroGraphicModuleDataQueryVariables>(GetHeroGraphicModuleDataDocument, options);
}
export function useGetHeroGraphicModuleDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHeroGraphicModuleDataQuery, GetHeroGraphicModuleDataQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetHeroGraphicModuleDataQuery, GetHeroGraphicModuleDataQueryVariables>(GetHeroGraphicModuleDataDocument, options);
}
export type GetHeroGraphicModuleDataQueryHookResult = ReturnType<typeof useGetHeroGraphicModuleDataQuery>;
export type GetHeroGraphicModuleDataLazyQueryHookResult = ReturnType<typeof useGetHeroGraphicModuleDataLazyQuery>;
export type GetHeroGraphicModuleDataQueryResult = Apollo.QueryResult<GetHeroGraphicModuleDataQuery, GetHeroGraphicModuleDataQueryVariables>;
export const GetHomeLoansDashboardPageDataDocument = gql `
    query GetHomeLoansDashboardPageData($id: ID!) {
        homeLoansDashboardByLoanId(loanId: $id) {
            id
            currentlySelectedLoan {
                id
                lead {
                    id
                }
            }
            personalizedNextSteps(version: V2) {
                currentState
            }
        }
    }
`;
/**
 * __useGetHomeLoansDashboardPageDataQuery__
 *
 * To run a query within a React component, call `useGetHomeLoansDashboardPageDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHomeLoansDashboardPageDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHomeLoansDashboardPageDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetHomeLoansDashboardPageDataQuery(baseOptions: Apollo.QueryHookOptions<GetHomeLoansDashboardPageDataQuery, GetHomeLoansDashboardPageDataQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetHomeLoansDashboardPageDataQuery, GetHomeLoansDashboardPageDataQueryVariables>(GetHomeLoansDashboardPageDataDocument, options);
}
export function useGetHomeLoansDashboardPageDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHomeLoansDashboardPageDataQuery, GetHomeLoansDashboardPageDataQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetHomeLoansDashboardPageDataQuery, GetHomeLoansDashboardPageDataQueryVariables>(GetHomeLoansDashboardPageDataDocument, options);
}
export type GetHomeLoansDashboardPageDataQueryHookResult = ReturnType<typeof useGetHomeLoansDashboardPageDataQuery>;
export type GetHomeLoansDashboardPageDataLazyQueryHookResult = ReturnType<typeof useGetHomeLoansDashboardPageDataLazyQuery>;
export type GetHomeLoansDashboardPageDataQueryResult = Apollo.QueryResult<GetHomeLoansDashboardPageDataQuery, GetHomeLoansDashboardPageDataQueryVariables>;
export const GetResourceCardModuleDataDocument = gql `
    query GetResourceCardModuleData($id: ID!) {
        homeLoansDashboardByLoanId(loanId: $id) {
            id
            personalizedNextSteps(version: V2) {
                currentState
                currentExperience
                loanApplicationExperienceURL
                loanId
                steps {
                    title
                    status
                }
            }
            currentlySelectedLoan {
                id
                quickAppFeatures {
                    ctaPreApprovalUrlWithDomain
                }
                lead {
                    id
                }
                preApprovalLetterURL {
                    downloadURL
                    documentURL
                }
                currentlyLoggedInBorrower {
                    id
                }
            }
        }
    }
`;
/**
 * __useGetResourceCardModuleDataQuery__
 *
 * To run a query within a React component, call `useGetResourceCardModuleDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResourceCardModuleDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResourceCardModuleDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetResourceCardModuleDataQuery(baseOptions: Apollo.QueryHookOptions<GetResourceCardModuleDataQuery, GetResourceCardModuleDataQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetResourceCardModuleDataQuery, GetResourceCardModuleDataQueryVariables>(GetResourceCardModuleDataDocument, options);
}
export function useGetResourceCardModuleDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetResourceCardModuleDataQuery, GetResourceCardModuleDataQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetResourceCardModuleDataQuery, GetResourceCardModuleDataQueryVariables>(GetResourceCardModuleDataDocument, options);
}
export type GetResourceCardModuleDataQueryHookResult = ReturnType<typeof useGetResourceCardModuleDataQuery>;
export type GetResourceCardModuleDataLazyQueryHookResult = ReturnType<typeof useGetResourceCardModuleDataLazyQuery>;
export type GetResourceCardModuleDataQueryResult = Apollo.QueryResult<GetResourceCardModuleDataQuery, GetResourceCardModuleDataQueryVariables>;
export const GetSelfServiceRecoveryToolEligibilityDocument = gql `
    query GetSelfServiceRecoveryToolEligibility($input: ZHLSelfServiceRecoveryToolEligibilityInput!) {
        zhlSelfServiceRecoveryToolEligibility(input: $input) {
            ... on ZHLSelfServiceRecoveryToolEligibility {
                isEligible
            }
            ... on ZHLSelfServiceRecoveryToolEligibilityErrorDetails {
                errorCode
            }
        }
    }
`;
/**
 * __useGetSelfServiceRecoveryToolEligibilityQuery__
 *
 * To run a query within a React component, call `useGetSelfServiceRecoveryToolEligibilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSelfServiceRecoveryToolEligibilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSelfServiceRecoveryToolEligibilityQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSelfServiceRecoveryToolEligibilityQuery(baseOptions: Apollo.QueryHookOptions<GetSelfServiceRecoveryToolEligibilityQuery, GetSelfServiceRecoveryToolEligibilityQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetSelfServiceRecoveryToolEligibilityQuery, GetSelfServiceRecoveryToolEligibilityQueryVariables>(GetSelfServiceRecoveryToolEligibilityDocument, options);
}
export function useGetSelfServiceRecoveryToolEligibilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSelfServiceRecoveryToolEligibilityQuery, GetSelfServiceRecoveryToolEligibilityQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetSelfServiceRecoveryToolEligibilityQuery, GetSelfServiceRecoveryToolEligibilityQueryVariables>(GetSelfServiceRecoveryToolEligibilityDocument, options);
}
export type GetSelfServiceRecoveryToolEligibilityQueryHookResult = ReturnType<typeof useGetSelfServiceRecoveryToolEligibilityQuery>;
export type GetSelfServiceRecoveryToolEligibilityLazyQueryHookResult = ReturnType<typeof useGetSelfServiceRecoveryToolEligibilityLazyQuery>;
export type GetSelfServiceRecoveryToolEligibilityQueryResult = Apollo.QueryResult<GetSelfServiceRecoveryToolEligibilityQuery, GetSelfServiceRecoveryToolEligibilityQueryVariables>;
export const GetUpsellModuleDataDocument = gql `
    query GetUpsellModuleData($id: ID!) {
        homeLoansDashboardByLoanId(loanId: $id) {
            id
            personalizedNextSteps(version: V2) {
                currentState
                currentExperience
                loanApplicationExperienceURL
                loanId
                steps {
                    title
                    status
                }
            }
            currentlySelectedLoan {
                id
                quickAppFeatures {
                    ctaPreApprovalUrlWithDomain
                }
                lead {
                    id
                }
                attributes {
                    valuation
                    purchaseLocation {
                        street
                    }
                }
                preApprovalLetterURL {
                    downloadURL
                    documentURL
                }
                currentlyLoggedInBorrower {
                    id
                }
                preApprovalLetters {
                    metaData {
                        purchasePrice
                        issueDate
                    }
                }
            }
        }
    }
`;
/**
 * __useGetUpsellModuleDataQuery__
 *
 * To run a query within a React component, call `useGetUpsellModuleDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUpsellModuleDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUpsellModuleDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUpsellModuleDataQuery(baseOptions: Apollo.QueryHookOptions<GetUpsellModuleDataQuery, GetUpsellModuleDataQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetUpsellModuleDataQuery, GetUpsellModuleDataQueryVariables>(GetUpsellModuleDataDocument, options);
}
export function useGetUpsellModuleDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUpsellModuleDataQuery, GetUpsellModuleDataQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetUpsellModuleDataQuery, GetUpsellModuleDataQueryVariables>(GetUpsellModuleDataDocument, options);
}
export type GetUpsellModuleDataQueryHookResult = ReturnType<typeof useGetUpsellModuleDataQuery>;
export type GetUpsellModuleDataLazyQueryHookResult = ReturnType<typeof useGetUpsellModuleDataLazyQuery>;
export type GetUpsellModuleDataQueryResult = Apollo.QueryResult<GetUpsellModuleDataQuery, GetUpsellModuleDataQueryVariables>;
export const GetViewSavedInformationModuleDataDocument = gql `
    query GetViewSavedInformationModuleData($id: ID!) {
        homeLoansDashboardByLoanId(loanId: $id) {
            id
            personalizedNextSteps(version: V2) {
                currentState
                currentExperience
                loanId
                loanApplicationExperienceURL
            }
            currentlySelectedLoan {
                id
                lead {
                    id
                }
                currentlyLoggedInBorrower {
                    id
                }
            }
        }
    }
`;
/**
 * __useGetViewSavedInformationModuleDataQuery__
 *
 * To run a query within a React component, call `useGetViewSavedInformationModuleDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetViewSavedInformationModuleDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetViewSavedInformationModuleDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetViewSavedInformationModuleDataQuery(baseOptions: Apollo.QueryHookOptions<GetViewSavedInformationModuleDataQuery, GetViewSavedInformationModuleDataQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetViewSavedInformationModuleDataQuery, GetViewSavedInformationModuleDataQueryVariables>(GetViewSavedInformationModuleDataDocument, options);
}
export function useGetViewSavedInformationModuleDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetViewSavedInformationModuleDataQuery, GetViewSavedInformationModuleDataQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetViewSavedInformationModuleDataQuery, GetViewSavedInformationModuleDataQueryVariables>(GetViewSavedInformationModuleDataDocument, options);
}
export type GetViewSavedInformationModuleDataQueryHookResult = ReturnType<typeof useGetViewSavedInformationModuleDataQuery>;
export type GetViewSavedInformationModuleDataLazyQueryHookResult = ReturnType<typeof useGetViewSavedInformationModuleDataLazyQuery>;
export type GetViewSavedInformationModuleDataQueryResult = Apollo.QueryResult<GetViewSavedInformationModuleDataQuery, GetViewSavedInformationModuleDataQueryVariables>;
export const GetWelcomeBannerModuleDataDocument = gql `
    query GetWelcomeBannerModuleData($loanID: ID!) {
        homeLoansDashboardByLoanId(loanId: $loanID) {
            id
            currentlySelectedLoan {
                currentlyLoggedInBorrower {
                    id
                    attributes {
                        names {
                            first
                            last
                        }
                        email
                    }
                }
            }
        }
    }
`;
/**
 * __useGetWelcomeBannerModuleDataQuery__
 *
 * To run a query within a React component, call `useGetWelcomeBannerModuleDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWelcomeBannerModuleDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWelcomeBannerModuleDataQuery({
 *   variables: {
 *      loanID: // value for 'loanID'
 *   },
 * });
 */
export function useGetWelcomeBannerModuleDataQuery(baseOptions: Apollo.QueryHookOptions<GetWelcomeBannerModuleDataQuery, GetWelcomeBannerModuleDataQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetWelcomeBannerModuleDataQuery, GetWelcomeBannerModuleDataQueryVariables>(GetWelcomeBannerModuleDataDocument, options);
}
export function useGetWelcomeBannerModuleDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWelcomeBannerModuleDataQuery, GetWelcomeBannerModuleDataQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetWelcomeBannerModuleDataQuery, GetWelcomeBannerModuleDataQueryVariables>(GetWelcomeBannerModuleDataDocument, options);
}
export type GetWelcomeBannerModuleDataQueryHookResult = ReturnType<typeof useGetWelcomeBannerModuleDataQuery>;
export type GetWelcomeBannerModuleDataLazyQueryHookResult = ReturnType<typeof useGetWelcomeBannerModuleDataLazyQuery>;
export type GetWelcomeBannerModuleDataQueryResult = Apollo.QueryResult<GetWelcomeBannerModuleDataQuery, GetWelcomeBannerModuleDataQueryVariables>;
export const GetZhlFirstPartyActivationEmailLoginHintDocument = gql `
    query GetZhlFirstPartyActivationEmailLoginHint($input: ZhlFirstPartyActivationEmailLoginHintInput!) {
        zhlFirstPartyActivationEmailLoginHint(inputs: $input) {
            email
        }
    }
`;
/**
 * __useGetZhlFirstPartyActivationEmailLoginHintQuery__
 *
 * To run a query within a React component, call `useGetZhlFirstPartyActivationEmailLoginHintQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetZhlFirstPartyActivationEmailLoginHintQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetZhlFirstPartyActivationEmailLoginHintQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetZhlFirstPartyActivationEmailLoginHintQuery(baseOptions: Apollo.QueryHookOptions<GetZhlFirstPartyActivationEmailLoginHintQuery, GetZhlFirstPartyActivationEmailLoginHintQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetZhlFirstPartyActivationEmailLoginHintQuery, GetZhlFirstPartyActivationEmailLoginHintQueryVariables>(GetZhlFirstPartyActivationEmailLoginHintDocument, options);
}
export function useGetZhlFirstPartyActivationEmailLoginHintLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetZhlFirstPartyActivationEmailLoginHintQuery, GetZhlFirstPartyActivationEmailLoginHintQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetZhlFirstPartyActivationEmailLoginHintQuery, GetZhlFirstPartyActivationEmailLoginHintQueryVariables>(GetZhlFirstPartyActivationEmailLoginHintDocument, options);
}
export type GetZhlFirstPartyActivationEmailLoginHintQueryHookResult = ReturnType<typeof useGetZhlFirstPartyActivationEmailLoginHintQuery>;
export type GetZhlFirstPartyActivationEmailLoginHintLazyQueryHookResult = ReturnType<typeof useGetZhlFirstPartyActivationEmailLoginHintLazyQuery>;
export type GetZhlFirstPartyActivationEmailLoginHintQueryResult = Apollo.QueryResult<GetZhlFirstPartyActivationEmailLoginHintQuery, GetZhlFirstPartyActivationEmailLoginHintQueryVariables>;